var Kh = Object.defineProperty;
var Qh = (e, t, n) => t in e ? Kh(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var E = (e, t, n) => (Qh(e, typeof t != "symbol" ? t + "" : t, n), n);
import { openBlock as _, createElementBlock as S, createElementVNode as k, resolveComponent as R, createBlock as I, ref as yt, computed as P, Fragment as st, renderList as _t, normalizeClass as W, toDisplayString as L, createCommentVNode as rt, createVNode as Y, renderSlot as jt, getCurrentInstance as Da, withCtx as N, toRaw as Jh, normalizeStyle as vt, createTextVNode as Ye, resolveDynamicComponent as es, mergeProps as B, toRefs as Oc, unref as T, normalizeProps as ce, reactive as qt, createSlots as Zh, watch as Us, onMounted as Tc, onBeforeUnmount as tu } from "vue";
import { toDate as eu, parse as nu, parseISO as su, isValid as iu, format as au, addYears as ru, addQuarters as ou, addMonths as lu, addWeeks as cu, addDays as du, addHours as hu, addMinutes as uu, addSeconds as fu, addMilliseconds as gu, differenceInYears as pu, differenceInQuarters as mu, differenceInMonths as bu, differenceInWeeks as yu, differenceInDays as _u, differenceInHours as vu, differenceInMinutes as xu, differenceInSeconds as wu, differenceInMilliseconds as ku, startOfYear as Cu, startOfQuarter as Su, startOfMonth as Mu, startOfWeek as Ar, startOfDay as Ou, startOfHour as Tu, startOfMinute as Pu, startOfSecond as Au, endOfYear as $u, endOfQuarter as Du, endOfMonth as Lu, endOfWeek as Eu, endOfDay as Iu, endOfHour as Ru, endOfMinute as Bu, endOfSecond as Fu } from "date-fns";
const Wu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, Nu = /* @__PURE__ */ k("path", { d: "M256 256c39.879 0 72.5-32.626 72.5-72.5S295.879 111 256 111s-72.5 32.626-72.5 72.5S216.121 256 256 256m0 36.25c-48.03 0-145 24.47-145 72.5V401h290v-36.25c0-48.03-96.97-72.5-145-72.5" }, null, -1), zu = [
  Nu
];
function ju(e, t) {
  return _(), S("svg", Wu, [...zu]);
}
const Hu = { render: ju }, X = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, i] of t)
    n[s] = i;
  return n;
}, Vu = {
  name: "PlatformAvatar",
  components: {
    IconAvatar: Hu
  },
  i18n: {
    messages: {
      "en-AU": {
        imageAlt: "{platform} avatar"
      },
      "en-US": {
        imageAlt: "{platform} avatar"
      },
      "en-GB": {
        imageAlt: "{platform} avatar"
      },
      es: {
        imageAlt: "{platform} avatar"
      },
      "fr-CA": {
        imageAlt: "{platform} avatar"
      },
      fr: {
        imageAlt: "{platform} avatar"
      },
      "zh-CN": {
        imageAlt: "{platform} 头像"
      }
    }
  },
  props: {
    platform: {
      type: String,
      required: !0
    },
    avatarUrl: {
      type: String,
      default: null
    },
    username: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      imageError: !1
    };
  },
  computed: {
    imageUrl() {
      return this.platform === "facebook" ? `https://graph.facebook.com/${this.username}/picture` : this.avatarUrl || "no-image";
    }
  }
}, Yu = { class: "platform-avatar" }, Gu = ["src", "alt"];
function Uu(e, t, n, s, i, a) {
  const r = R("IconAvatar");
  return _(), S("div", Yu, [
    i.imageError ? (_(), I(r, { key: 0 })) : (_(), S("img", {
      key: 1,
      src: a.imageUrl,
      alt: e.$t("imageAlt", { platform: n.platform }),
      onError: t[0] || (t[0] = (o) => i.imageError = !0)
    }, null, 40, Gu))
  ]);
}
const hi = /* @__PURE__ */ X(Vu, [["render", Uu]]), Xu = { class: "c-button-group" }, qu = ["onClick"], Pc = {
  __name: "ButtonGroup",
  props: {
    /**
     * { value: string, label: string }[]
     */
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: [String, Number],
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, s = t, i = yt(n.modelValue), a = P({
      get: () => i.value,
      set: (r) => {
        i.value = r, s("update:modelValue", r);
      }
    });
    return (r, o) => (_(), S("div", Xu, [
      (_(!0), S(st, null, _t(e.options, (l) => (_(), S("button", {
        key: l.value,
        class: W({
          selected: a.value === l.value
        }),
        onClick: (c) => a.value = l.value
      }, L(l.label), 11, qu))), 128))
    ]));
  }
}, Ku = ["zero", "one", "two", "three", "four"], fs = 5, Qu = {
  name: "SocialEngageComposeImageGrid",
  i18n: {
    messages: {
      "en-AU": {
        attachmentAltText: "attachment"
      },
      "en-US": {
        attachmentAltText: "attachment"
      },
      "en-GB": {
        attachmentAltText: "attachment"
      },
      es: {
        attachmentAltText: "adjunto"
      },
      "fr-CA": {
        attachmentAltText: "pièce jointe"
      },
      fr: {
        attachmentAltText: "pièce jointe"
      },
      "zh-CN": {
        attachmentAltText: "依恋"
      }
    }
  },
  props: {
    attachments: {
      type: Array,
      required: !0
    },
    videoPlayable: {
      type: Boolean
    }
  },
  computed: {
    hasHiddenAttachments() {
      return this.attachments.length > fs;
    },
    numberOfHiddenAttachments() {
      return this.attachments.length - fs;
    },
    filteredAttachments() {
      return this.attachments.slice(0, fs);
    },
    gridClass() {
      const e = this.attachments.length;
      return e === 1 ? "one-attachment" : e >= 5 ? "five-or-more-attachments" : `${Ku[e]}-attachments`;
    }
  },
  methods: {
    displayNumberOfHiddenAttachments(e) {
      const t = fs - 1;
      return this.hasHiddenAttachments && e === t;
    }
  }
}, Ju = { key: 0 }, Zu = ["src", "controls", "preload"], tf = {
  key: 0,
  class: "c-grid__play-icon",
  src: "https://cdn.streem.com.au/icons/play_arrow.svg"
}, ef = ["src", "alt"], nf = {
  key: 2,
  class: "c-grid__number"
};
function sf(e, t, n, s, i, a) {
  return _(), S("div", {
    class: W(["c-grid", a.gridClass])
  }, [
    (_(!0), S(st, null, _t(a.filteredAttachments, (r, o) => (_(), S("div", {
      key: o,
      class: "c-grid__content"
    }, [
      r.video ? (_(), S("div", Ju, [
        k("video", {
          src: r.url,
          controls: n.videoPlayable,
          preload: n.videoPlayable ? "auto" : "metadata",
          class: "c-grid__attachment"
        }, null, 8, Zu),
        n.videoPlayable ? rt("", !0) : (_(), S("img", tf))
      ])) : (_(), S("img", {
        key: 1,
        src: r.url,
        class: "c-grid__attachment",
        alt: e.$t("attachmentAltText")
      }, null, 8, ef)),
      a.displayNumberOfHiddenAttachments(o) ? (_(), S("div", nf, " +" + L(a.numberOfHiddenAttachments), 1)) : rt("", !0)
    ]))), 128))
  ], 2);
}
const af = /* @__PURE__ */ X(Qu, [["render", sf], ["__scopeId", "data-v-51dd9827"]]), rf = {
  name: "SocialEngagePostPerformanceMedia",
  components: {
    SocialEngageComposeImageGrid: af
  },
  i18n: {
    messages: {
      "en-AU": {
        noMedia: "No media"
      },
      "en-US": {
        noMedia: "No media"
      },
      "en-GB": {
        noMedia: "No media"
      },
      es: {
        noMedia: "Sin multimedia"
      },
      "fr-CA": {
        noMedia: "Aucun média"
      },
      fr: {
        noMedia: "Aucun média"
      },
      "zh-CN": {
        noMedia: "不平均"
      }
    }
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    shouldApplyBackground() {
      return this.attachments.length === 1;
    }
  }
}, of = {
  key: 0,
  class: "c-no-media"
};
function lf(e, t, n, s, i, a) {
  const r = R("SocialEngageComposeImageGrid");
  return n.attachments.length ? (_(), S("div", {
    key: 1,
    class: W(["c-attachments", { "c-attachments__fill-background": a.shouldApplyBackground }])
  }, [
    Y(r, { attachments: n.attachments }, null, 8, ["attachments"])
  ], 2)) : (_(), S("div", of, L(e.$t("noMedia")), 1));
}
const cf = /* @__PURE__ */ X(rf, [["render", lf], ["__scopeId", "data-v-922238a9"]]), df = {
  name: "SocialEngagePostType",
  props: {
    postTypeIcon: {
      type: String,
      required: !0
    },
    postTypeText: {
      type: String,
      required: !0
    }
  }
}, hf = ["src"];
function uf(e, t, n, s, i, a) {
  return _(), S("div", null, [
    k("img", { src: n.postTypeIcon }, null, 8, hf),
    jt(e.$slots, "tooltipSlot", {}, void 0, !0)
  ]);
}
const ff = /* @__PURE__ */ X(df, [["render", uf], ["__scopeId", "data-v-7861b0a3"]]), Xn = (e) => e.toLocaleString(), Ac = (e) => Intl.NumberFormat("en-AU", {
  notation: "compact",
  maximumFractionDigits: 1
}).format(e).toLowerCase();
function ui(e) {
  return new DOMParser().parseFromString(e, "text/html").documentElement.textContent;
}
function an(e, t, n = 0) {
  return ui(
    e.length > t && e.length > n ? `${e.substr(0, t - 1)}…` : e
  );
}
function La(e, t) {
  const n = [];
  return e && n.push(e), n.push(Xn(t)), n.join(": ");
}
const gf = {
  border: "1px solid",
  borderRadius: "50%",
  width: ".7em",
  height: ".7em",
  display: "inline-block",
  marginRight: ".3em"
}, $r = {
  opacity: 1,
  position: "absolute",
  pointerEvents: "none",
  borderStyle: "solid",
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)",
  transition: "left .25s, top .25s, opacity .25s",
  zIndex: 99999
};
function pf(e) {
  const t = document.createElement("span"), n = { ...e };
  return e.backgroundColor instanceof CanvasGradient && (n.backgroundColor = e.borderColor), Object.assign(t.style, {
    ...gf,
    ...n
  }), t.outerHTML;
}
function mf(e) {
  const t = e.tooltip.title || [];
  if (t.length) {
    let n = "<thead>";
    return t.forEach((s) => {
      n += `<tr><th style="text-align: left">${s}</th></tr>`;
    }), n += "</thead>", n;
  }
  return "";
}
function bf(e) {
  const t = e.tooltip.options.displayColors, n = e.tooltip.body.map(({ lines: i }) => i).filter((i) => i.length);
  let s = "<tbody>";
  return n.forEach((i, a) => {
    const r = t ? pf(e.tooltip.labelColors[a]) : "";
    s += `<tr><td>${r + i}</td></tr>`;
  }), s += "</tbody>", s;
}
function yf(e, t) {
  const n = [
    mf(t),
    bf(t)
  ].join(""), s = e.querySelector("table");
  s.innerHTML = n;
  const i = e;
  t.tooltip.body.length ? i.classList.remove("hide-empty-tooltip") : i.classList.add("hide-empty-tooltip");
}
function $c(e = null) {
  const t = "chartjs-tooltip";
  let n = document.getElementById(t);
  return n || (n = document.createElement("div"), n.id = t, n.innerHTML = "<table></table>", document.body.appendChild(n)), e && (n.chartObj = e), n;
}
function _f() {
  return Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
}
function vf(e, t) {
  const n = this.chart.canvas.getBoundingClientRect();
  let { transition: s } = $r;
  e.style.opacity === "0" && (s = "opacity .25s");
  let i = n.left + window.scrollX + t.tooltip.caretX;
  const a = e.getBoundingClientRect();
  i + a.width > _f() && (i -= a.width);
  let r = n.top + window.scrollY + t.tooltip.caretY;
  t.centerY && (r -= a.height / 2), Object.assign(e.style, {
    ...$r,
    transition: s,
    left: `${i}px`,
    top: `${r}px`,
    backgroundColor: t.tooltip.options.backgroundColor,
    borderColor: t.tooltip.options.borderColor,
    borderRadius: `${t.tooltip.options.cornerRadius}px`,
    borderWidth: `${t.tooltip.options.borderWidth}px`,
    color: t.tooltip.options.bodyFont.color,
    fontFamily: t.tooltip.options.bodyFont.family,
    fontSize: `${t.tooltip.options.bodyFont.size}px`,
    fontStyle: t.tooltip.options.bodyFont.style,
    maxWidth: t.tooltip.options.maxWidth ? `${t.tooltip.options.maxWidth}px` : "auto",
    padding: `${t.tooltip.options.padding.y}px ${t.tooltip.options.padding.x}px`
  });
  const o = e.querySelector("thead");
  o && Object.assign(o.style, {
    color: t.tooltip.options.titleFont.color,
    fontFamily: t.tooltip.options.titleFont.family,
    fontStyle: t.tooltip.options.titleFont.style,
    fontSize: `${t.tooltip.options.titleFont.size}px`,
    textAlign: t.tooltip.options.titleAlign
  });
}
function xf(e, t) {
  e.classList.remove("above", "below", "no-transform"), t.yAlign ? e.classList.add(t.yAlign) : e.classList.add("no-transform");
}
const Dr = function e(t) {
  var s, i, a;
  if (t.target.classList.contains("chartjs-render-monitor") || /chart/.test(t.target.id) && t.target.localName === "canvas")
    return;
  const n = $c();
  if (n.style.opacity = 0, n.style.transition = "opacity 0.25s", (i = (s = n.chartObj) == null ? void 0 : s.tooltip) != null && i._active && document.body.contains((a = n.chartObj) == null ? void 0 : a.canvas))
    try {
      n.chartObj.updateHoverStyle(
        [],
        n.chartObj.tooltip._active
      ), n.chartObj.update();
    } catch {
      delete n.chartObj;
    }
  document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
};
function Dc(e) {
  const t = $c(this.chart);
  if (e.tooltip.opacity === 0) {
    t.style.opacity = 0, t.style.transition = "opacity 0.25s";
    return;
  }
  xf(t, e), e.tooltip.body && yf(t, e), vf.call(this, t, e), setTimeout(() => {
    document.addEventListener("mousedown", Dr), document.addEventListener("touchstart", Dr);
  }, 10);
}
function wf(e) {
  const t = e.dataset.label || "", n = e.dataset.data[e.dataIndex];
  return La(t, n);
}
function kf(e) {
  const t = e.label || "", n = e.dataset.data[e.dataIndex];
  return La(t, n);
}
const Lc = {
  mode: "index",
  external: Dc,
  enabled: !1,
  intersect: !1,
  backgroundColor: "white",
  borderWidth: 1,
  padding: {
    x: 2,
    y: 2
  },
  borderColor: "#E5EAEF",
  titleColor: "#3E475E",
  bodyColor: "#3E475E",
  labelColor: "#3E475E",
  cornerRadius: 3,
  titleFont: {
    family: "'Roboto', sans-serif",
    size: 13,
    style: "normal",
    weight: "bold"
  },
  bodyFont: {
    family: "'Roboto', sans-serif",
    size: 11,
    style: "normal"
  },
  callbacks: {
    label: wf
  }
}, Cf = 8;
function Ea() {
  const e = Da(), t = {
    chart: {
      get canvas() {
        return e.proxy.$el;
      }
    }
  }, n = Dc.bind(t);
  function s(a, r) {
    if (!(r != null && r.text))
      return;
    const { x: o, y: l } = e.proxy.$el.getBoundingClientRect(), c = a.target.getBoundingClientRect(), d = (r == null ? void 0 : r.options) || {}, h = (r == null ? void 0 : r.offsetY) || 0, u = {
      tooltip: {
        title: r != null && r.title ? [r.title] : [],
        body: [{ lines: [r.text] }],
        caretX: c.right - o + Cf,
        caretY: c.y - l - c.height / 2 + h,
        options: { ...Lc, ...d }
      }
    };
    n(u);
  }
  function i() {
    n({ tooltip: { opacity: 0 } });
  }
  return {
    showTooltip: s,
    hideTooltip: i
  };
}
const Sf = {
  name: "SocialEngageCard",
  components: {
    SocialEngagePostPerformanceMedia: cf,
    SocialEngagePostType: ff
  },
  props: {
    postIntegration: {
      type: Object,
      required: !0
    },
    platformIcon: {
      type: String,
      required: !0
    },
    platformText: {
      type: String,
      required: !0
    },
    postType: {
      type: Object,
      required: !0
    },
    metricsList: {
      type: Array,
      required: !0
    },
    scheduledAt: {
      type: String,
      required: !0
    },
    attachments: {
      type: Array,
      default: () => []
    },
    selectedOrderFilter: {
      type: String,
      default: ""
    }
  },
  setup() {
    const { showTooltip: e, hideTooltip: t } = Ea();
    return {
      showTooltip: e,
      hideTooltip: t
    };
  },
  computed: {
    orderedMetricsOptions() {
      const e = this.metricsList.filter(
        ({ key: n }) => n !== this.selectedOrderFilter
      ), t = this.metricsList.find(
        ({ key: n }) => n === this.selectedOrderFilter
      );
      return t && e.unshift(t), e;
    },
    socialEngagePost() {
      return this.postIntegration.socialEngagePost;
    }
  },
  methods: {
    shouldShowTooltip(e, t) {
      t.applicable || this.showTooltip(e, {
        text: t.tooltip_text
      });
    }
  }
}, Mf = { class: "c-card" }, Of = { class: "c-card__header" }, Tf = { class: "c-card__title" }, Pf = { class: "c-card__date-time" }, Af = { class: "c-card__info" }, $f = { class: "c-card__content" }, Df = { class: "c-card__picture" }, Lf = { class: "c-card__type-overlay" }, Ef = { class: "c-card__integrations" }, If = ["src"], Rf = { class: "c-card__integrations-label" }, Bf = { class: "c-card__metrics-column" }, Ff = ["onMouseenter"];
function Wf(e, t, n, s, i, a) {
  const r = R("SocialEngagePostType"), o = R("SocialEngagePostPerformanceMedia");
  return _(), S("div", Mf, [
    k("div", Of, [
      k("div", Tf, L(a.socialEngagePost.title), 1),
      k("div", Pf, L(n.scheduledAt), 1)
    ]),
    k("div", Af, [
      k("div", $f, L(a.socialEngagePost.content), 1),
      k("div", Df, [
        k("div", Lf, [
          Y(r, {
            class: "c-card__type-size",
            "post-type-icon": n.postType.icon,
            "post-type-text": n.postType.text
          }, {
            tooltipSlot: N(() => [
              jt(e.$slots, "tooltipSlot", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["post-type-icon", "post-type-text"])
        ]),
        Y(o, { attachments: n.attachments }, null, 8, ["attachments"])
      ]),
      k("div", Ef, [
        k("img", {
          class: "c-card__integrations-icon",
          src: n.platformIcon
        }, null, 8, If),
        k("div", Rf, L(n.postIntegration.label), 1)
      ]),
      k("div", Bf, [
        (_(!0), S(st, null, _t(a.orderedMetricsOptions, (l) => (_(), S("div", {
          key: l.key,
          class: "c-card__metrics-row"
        }, [
          k("div", {
            class: W({ bold: l.key === n.selectedOrderFilter })
          }, L(l.label), 3),
          k("div", {
            class: W({
              pointer: !l.applicable,
              bold: l.key === n.selectedOrderFilter
            }),
            onMouseenter: (c) => a.shouldShowTooltip(c, l),
            onMouseleave: t[0] || (t[0] = (...c) => s.hideTooltip && s.hideTooltip(...c))
          }, L(l.value), 43, Ff)
        ]))), 128))
      ])
    ])
  ]);
}
const Nf = /* @__PURE__ */ X(Sf, [["render", Wf], ["__scopeId", "data-v-f024a37d"]]), zf = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, jf = (e, t, n) => {
  let s;
  const i = zf[e];
  return typeof i == "string" ? s = i : t === 1 ? s = i.one : s = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + s : s + " ago" : s;
};
function $i(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Hf = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Vf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Yf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Gf = {
  date: $i({
    formats: Hf,
    defaultWidth: "full"
  }),
  time: $i({
    formats: Vf,
    defaultWidth: "full"
  }),
  dateTime: $i({
    formats: Yf,
    defaultWidth: "full"
  })
}, Uf = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Xf = (e, t, n, s) => Uf[e];
function xn(e) {
  return (t, n) => {
    const s = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (s === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, o = n != null && n.width ? String(n.width) : r;
      i = e.formattingValues[o] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, o = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[o] || e.values[r];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[a];
  };
}
const qf = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Kf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Qf = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Jf = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Zf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, tg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, eg = (e, t) => {
  const n = Number(e), s = n % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ng = {
  ordinalNumber: eg,
  era: xn({
    values: qf,
    defaultWidth: "wide"
  }),
  quarter: xn({
    values: Kf,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: xn({
    values: Qf,
    defaultWidth: "wide"
  }),
  day: xn({
    values: Jf,
    defaultWidth: "wide"
  }),
  dayPeriod: xn({
    values: Zf,
    defaultWidth: "wide",
    formattingValues: tg,
    defaultFormattingWidth: "wide"
  })
};
function wn(e) {
  return (t, n = {}) => {
    const s = n.width, i = s && e.matchPatterns[s] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    const r = a[0], o = s && e.parsePatterns[s] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(o) ? ig(o, (h) => h.test(r)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      sg(o, (h) => h.test(r))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const d = t.slice(r.length);
    return { value: c, rest: d };
  };
}
function sg(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function ig(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ag(e) {
  return (t, n = {}) => {
    const s = t.match(e.matchPattern);
    if (!s)
      return null;
    const i = s[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    let r = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    r = n.valueCallback ? n.valueCallback(r) : r;
    const o = t.slice(i.length);
    return { value: r, rest: o };
  };
}
const rg = /^(\d+)(th|st|nd|rd)?/i, og = /\d+/i, lg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, cg = {
  any: [/^b/i, /^(a|c)/i]
}, dg = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, hg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ug = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, fg = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, gg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, pg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, mg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, bg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yg = {
  ordinalNumber: ag({
    matchPattern: rg,
    parsePattern: og,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: wn({
    matchPatterns: lg,
    defaultMatchWidth: "wide",
    parsePatterns: cg,
    defaultParseWidth: "any"
  }),
  quarter: wn({
    matchPatterns: dg,
    defaultMatchWidth: "wide",
    parsePatterns: hg,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: wn({
    matchPatterns: ug,
    defaultMatchWidth: "wide",
    parsePatterns: fg,
    defaultParseWidth: "any"
  }),
  day: wn({
    matchPatterns: gg,
    defaultMatchWidth: "wide",
    parsePatterns: pg,
    defaultParseWidth: "any"
  }),
  dayPeriod: wn({
    matchPatterns: mg,
    defaultMatchWidth: "any",
    parsePatterns: bg,
    defaultParseWidth: "any"
  })
}, _g = {
  code: "en-US",
  formatDistance: jf,
  formatLong: Gf,
  formatRelative: Xf,
  localize: ng,
  match: yg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let vg = {};
function fi() {
  return vg;
}
const Ec = 6048e5, xg = 864e5, wg = 36e5;
function Bt(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Lr(e) {
  const t = Bt(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Er(e) {
  const t = Bt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function kg(e, t) {
  const n = Lr(e), s = Lr(t), i = +n - Er(n), a = +s - Er(s);
  return Math.round((i - a) / xg);
}
function ze(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Cg(e) {
  const t = Bt(e), n = ze(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Sg(e) {
  const t = Bt(e);
  return kg(t, Cg(t)) + 1;
}
function qn(e, t) {
  var o, l, c, d;
  const n = fi(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (o = t == null ? void 0 : t.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = Bt(e), a = i.getDay(), r = (a < s ? 7 : 0) + a - s;
  return i.setDate(i.getDate() - r), i.setHours(0, 0, 0, 0), i;
}
function Xs(e) {
  return qn(e, { weekStartsOn: 1 });
}
function Ic(e) {
  const t = Bt(e), n = t.getFullYear(), s = ze(e, 0);
  s.setFullYear(n + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = Xs(s), a = ze(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const r = Xs(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= r.getTime() ? n : n - 1;
}
function Mg(e) {
  const t = Ic(e), n = ze(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Xs(n);
}
function Og(e) {
  const t = Bt(e), n = +Xs(t) - +Mg(t);
  return Math.round(n / Ec) + 1;
}
function Rc(e, t) {
  var d, h, u, f;
  const n = Bt(e), s = n.getFullYear(), i = fi(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((f = (u = i.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, r = ze(e, 0);
  r.setFullYear(s + 1, 0, a), r.setHours(0, 0, 0, 0);
  const o = qn(r, t), l = ze(e, 0);
  l.setFullYear(s, 0, a), l.setHours(0, 0, 0, 0);
  const c = qn(l, t);
  return n.getTime() >= o.getTime() ? s + 1 : n.getTime() >= c.getTime() ? s : s - 1;
}
function Tg(e, t) {
  var o, l, c, d;
  const n = fi(), s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (o = t == null ? void 0 : t.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, i = Rc(e, t), a = ze(e, 0);
  return a.setFullYear(i, 0, s), a.setHours(0, 0, 0, 0), qn(a, t);
}
function Pg(e, t) {
  const n = Bt(e), s = +qn(n, t) - +Tg(n, t);
  return Math.round(s / Ec) + 1;
}
function it(e, t) {
  const n = e < 0 ? "-" : "", s = Math.abs(e).toString().padStart(t, "0");
  return n + s;
}
const ue = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), s = n > 0 ? n : 1 - n;
    return it(t === "yy" ? s % 100 : s, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : it(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return it(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return it(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return it(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return it(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return it(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, s = e.getMilliseconds(), i = Math.trunc(
      s * Math.pow(10, n - 3)
    );
    return it(i, t.length);
  }
}, Je = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ir = {
  // Era
  G: function(e, t, n) {
    const s = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(s, { width: "abbreviated" });
      case "GGGGG":
        return n.era(s, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(s, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const s = e.getFullYear(), i = s > 0 ? s : 1 - s;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return ue.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, s) {
    const i = Rc(e, s), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const r = a % 100;
      return it(r, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : it(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Ic(e);
    return it(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return it(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const s = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(s);
      case "QQ":
        return it(s, 2);
      case "Qo":
        return n.ordinalNumber(s, { unit: "quarter" });
      case "QQQ":
        return n.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const s = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(s);
      case "qq":
        return it(s, 2);
      case "qo":
        return n.ordinalNumber(s, { unit: "quarter" });
      case "qqq":
        return n.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const s = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ue.M(e, t);
      case "Mo":
        return n.ordinalNumber(s + 1, { unit: "month" });
      case "MMM":
        return n.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(s, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const s = e.getMonth();
    switch (t) {
      case "L":
        return String(s + 1);
      case "LL":
        return it(s + 1, 2);
      case "Lo":
        return n.ordinalNumber(s + 1, { unit: "month" });
      case "LLL":
        return n.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(s, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, s) {
    const i = Pg(e, s);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : it(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const s = Og(e);
    return t === "Io" ? n.ordinalNumber(s, { unit: "week" }) : it(s, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ue.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const s = Sg(e);
    return t === "Do" ? n.ordinalNumber(s, { unit: "dayOfYear" }) : it(s, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const s = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, s) {
    const i = e.getDay(), a = (i - s.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return it(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, s) {
    const i = e.getDay(), a = (i - s.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return it(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const s = e.getDay(), i = s === 0 ? 7 : s;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return it(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const s = e.getHours();
    let i;
    switch (s === 12 ? i = Je.noon : s === 0 ? i = Je.midnight : i = s / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const s = e.getHours();
    let i;
    switch (s >= 17 ? i = Je.evening : s >= 12 ? i = Je.afternoon : s >= 4 ? i = Je.morning : i = Je.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let s = e.getHours() % 12;
      return s === 0 && (s = 12), n.ordinalNumber(s, { unit: "hour" });
    }
    return ue.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ue.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const s = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(s, { unit: "hour" }) : it(s, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let s = e.getHours();
    return s === 0 && (s = 24), t === "ko" ? n.ordinalNumber(s, { unit: "hour" }) : it(s, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ue.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ue.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return ue.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const s = e.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (t) {
      case "X":
        return Br(s);
      case "XXXX":
      case "XX":
        return De(s);
      case "XXXXX":
      case "XXX":
      default:
        return De(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const s = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Br(s);
      case "xxxx":
      case "xx":
        return De(s);
      case "xxxxx":
      case "xxx":
      default:
        return De(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const s = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Rr(s, ":");
      case "OOOO":
      default:
        return "GMT" + De(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const s = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Rr(s, ":");
      case "zzzz":
      default:
        return "GMT" + De(s, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const s = Math.trunc(e.getTime() / 1e3);
    return it(s, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const s = e.getTime();
    return it(s, t.length);
  }
};
function Rr(e, t = "") {
  const n = e > 0 ? "-" : "+", s = Math.abs(e), i = Math.trunc(s / 60), a = s % 60;
  return a === 0 ? n + String(i) : n + String(i) + t + it(a, 2);
}
function Br(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + it(Math.abs(e) / 60, 2) : De(e, t);
}
function De(e, t = "") {
  const n = e > 0 ? "-" : "+", s = Math.abs(e), i = it(Math.trunc(s / 60), 2), a = it(s % 60, 2);
  return n + i + t + a;
}
const Fr = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Bc = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Ag = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], s = n[1], i = n[2];
  if (!i)
    return Fr(e, t);
  let a;
  switch (s) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Fr(s, t)).replace("{{time}}", Bc(i, t));
}, $g = {
  p: Bc,
  P: Ag
}, Dg = /^D+$/, Lg = /^Y+$/, Eg = ["D", "DD", "YY", "YYYY"];
function Ig(e) {
  return Dg.test(e);
}
function Rg(e) {
  return Lg.test(e);
}
function Bg(e, t, n) {
  const s = Fg(e, t, n);
  if (console.warn(s), Eg.includes(e))
    throw new RangeError(s);
}
function Fg(e, t, n) {
  const s = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${s} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Fc(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Wg(e) {
  if (!Fc(e) && typeof e != "number")
    return !1;
  const t = Bt(e);
  return !isNaN(Number(t));
}
const Ng = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, zg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jg = /^'([^]*?)'?$/, Hg = /''/g, Vg = /[a-zA-Z]/;
function Wc(e, t, n) {
  var d, h, u, f, g, m, p, b;
  const s = fi(), i = (n == null ? void 0 : n.locale) ?? s.locale ?? _g, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((h = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((f = (u = s.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, r = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : m.weekStartsOn) ?? s.weekStartsOn ?? ((b = (p = s.locale) == null ? void 0 : p.options) == null ? void 0 : b.weekStartsOn) ?? 0, o = Bt(e);
  if (!Wg(o))
    throw new RangeError("Invalid time value");
  let l = t.match(zg).map((y) => {
    const v = y[0];
    if (v === "p" || v === "P") {
      const w = $g[v];
      return w(y, i.formatLong);
    }
    return y;
  }).join("").match(Ng).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const v = y[0];
    if (v === "'")
      return { isToken: !1, value: Yg(y) };
    if (Ir[v])
      return { isToken: !0, value: y };
    if (v.match(Vg))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + v + "`"
      );
    return { isToken: !1, value: y };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(o, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: r,
    locale: i
  };
  return l.map((y) => {
    if (!y.isToken)
      return y.value;
    const v = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Rg(v) || !(n != null && n.useAdditionalDayOfYearTokens) && Ig(v)) && Bg(v, t, String(e));
    const w = Ir[v[0]];
    return w(o, v, i.localize, c);
  }).join("");
}
function Yg(e) {
  const t = e.match(jg);
  return t ? t[1].replace(Hg, "'") : e;
}
const Gg = { class: "c-outreach-coverage-card" }, Ug = { class: "c-outreach-coverage-card__category" }, Xg = { class: "c-outreach-coverage-card__list" }, qg = ["href"], Kg = ["onClick"], Nc = {
  __name: "OutreachCoverageCard",
  props: {
    sentAt: {
      type: String,
      required: !0
    },
    /**
     * {id, mediaReleaseType, name}[]
     */
    items: {
      type: Array,
      required: !0
    }
  },
  emits: ["releaseClick"],
  setup(e, { expose: t, emit: n }) {
    const s = e, i = n, a = yt(), r = yt(), o = P(() => Wc(new Date(s.sentAt), "MMM dd, yyyy")), l = P(
      () => s.items.filter((u) => u.mediaReleaseType === "media_release")
    ), c = P(
      () => s.items.filter((u) => u.mediaReleaseType === "pitch")
    ), d = P(
      () => [
        {
          title: "Media Release",
          items: l.value
        },
        {
          title: "Pitches",
          items: c.value
        }
      ].filter((u) => u.items.length > 0)
    );
    function h(u) {
      i("releaseClick", u);
    }
    return t({
      releasesElement: r,
      titleElement: a
    }), (u, f) => (_(), S("div", Gg, [
      k("div", {
        ref_key: "titleElement",
        ref: a,
        class: "c-outreach-coverage-card__title"
      }, L(o.value), 513),
      k("div", {
        ref_key: "releasesElement",
        ref: r,
        class: "c-outreach-coverage-card__releases"
      }, [
        (_(!0), S(st, null, _t(d.value, (g) => (_(), S("div", {
          key: g.title,
          class: "c-outreach-coverage-card__release"
        }, [
          k("div", Ug, L(g.title), 1),
          k("ul", Xg, [
            (_(!0), S(st, null, _t(g.items, (m) => (_(), S("li", {
              key: m.id,
              class: "c-outreach-coverage-card__list-item"
            }, [
              m.url ? (_(), S("a", {
                key: 0,
                rel: "noopener noreferrer",
                target: "_blank",
                href: m.url,
                class: "c-outreach-coverage-card__list-item__link"
              }, L(m.name), 9, qg)) : (_(), S("div", {
                key: 1,
                class: "c-outreach-coverage-card__list-item__link",
                onClick: (p) => h(m)
              }, L(m.name), 9, Kg))
            ]))), 128))
          ])
        ]))), 128))
      ], 512)
    ]));
  }
};
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function ns(e) {
  return e + 0.5 | 0;
}
const pe = (e, t, n) => Math.max(Math.min(e, n), t);
function Dn(e) {
  return pe(ns(e * 2.55), 0, 255);
}
function _e(e) {
  return pe(ns(e * 255), 0, 255);
}
function ie(e) {
  return pe(ns(e / 2.55) / 100, 0, 1);
}
function Wr(e) {
  return pe(ns(e * 100), 0, 100);
}
const Wt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, ia = [..."0123456789ABCDEF"], Qg = (e) => ia[e & 15], Jg = (e) => ia[(e & 240) >> 4] + ia[e & 15], gs = (e) => (e & 240) >> 4 === (e & 15), Zg = (e) => gs(e.r) && gs(e.g) && gs(e.b) && gs(e.a);
function tp(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & Wt[e[1]] * 17,
    g: 255 & Wt[e[2]] * 17,
    b: 255 & Wt[e[3]] * 17,
    a: t === 5 ? Wt[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: Wt[e[1]] << 4 | Wt[e[2]],
    g: Wt[e[3]] << 4 | Wt[e[4]],
    b: Wt[e[5]] << 4 | Wt[e[6]],
    a: t === 9 ? Wt[e[7]] << 4 | Wt[e[8]] : 255
  })), n;
}
const ep = (e, t) => e < 255 ? t(e) : "";
function np(e) {
  var t = Zg(e) ? Qg : Jg;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + ep(e.a, t) : void 0;
}
const sp = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function zc(e, t, n) {
  const s = t * Math.min(n, 1 - n), i = (a, r = (a + e / 30) % 12) => n - s * Math.max(Math.min(r - 3, 9 - r, 1), -1);
  return [i(0), i(8), i(4)];
}
function ip(e, t, n) {
  const s = (i, a = (i + e / 60) % 6) => n - n * t * Math.max(Math.min(a, 4 - a, 1), 0);
  return [s(5), s(3), s(1)];
}
function ap(e, t, n) {
  const s = zc(e, 1, 0.5);
  let i;
  for (t + n > 1 && (i = 1 / (t + n), t *= i, n *= i), i = 0; i < 3; i++)
    s[i] *= 1 - t - n, s[i] += t;
  return s;
}
function rp(e, t, n, s, i) {
  return e === i ? (t - n) / s + (t < n ? 6 : 0) : t === i ? (n - e) / s + 2 : (e - t) / s + 4;
}
function Ia(e) {
  const n = e.r / 255, s = e.g / 255, i = e.b / 255, a = Math.max(n, s, i), r = Math.min(n, s, i), o = (a + r) / 2;
  let l, c, d;
  return a !== r && (d = a - r, c = o > 0.5 ? d / (2 - a - r) : d / (a + r), l = rp(n, s, i, d, a), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function Ra(e, t, n, s) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, s)).map(_e);
}
function Ba(e, t, n) {
  return Ra(zc, e, t, n);
}
function op(e, t, n) {
  return Ra(ap, e, t, n);
}
function lp(e, t, n) {
  return Ra(ip, e, t, n);
}
function jc(e) {
  return (e % 360 + 360) % 360;
}
function cp(e) {
  const t = sp.exec(e);
  let n = 255, s;
  if (!t)
    return;
  t[5] !== s && (n = t[6] ? Dn(+t[5]) : _e(+t[5]));
  const i = jc(+t[2]), a = +t[3] / 100, r = +t[4] / 100;
  return t[1] === "hwb" ? s = op(i, a, r) : t[1] === "hsv" ? s = lp(i, a, r) : s = Ba(i, a, r), {
    r: s[0],
    g: s[1],
    b: s[2],
    a: n
  };
}
function dp(e, t) {
  var n = Ia(e);
  n[0] = jc(n[0] + t), n = Ba(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function hp(e) {
  if (!e)
    return;
  const t = Ia(e), n = t[0], s = Wr(t[1]), i = Wr(t[2]);
  return e.a < 255 ? `hsla(${n}, ${s}%, ${i}%, ${ie(e.a)})` : `hsl(${n}, ${s}%, ${i}%)`;
}
const Nr = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, zr = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function up() {
  const e = {}, t = Object.keys(zr), n = Object.keys(Nr);
  let s, i, a, r, o;
  for (s = 0; s < t.length; s++) {
    for (r = o = t[s], i = 0; i < n.length; i++)
      a = n[i], o = o.replace(a, Nr[a]);
    a = parseInt(zr[r], 16), e[o] = [a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  return e;
}
let ps;
function fp(e) {
  ps || (ps = up(), ps.transparent = [0, 0, 0, 0]);
  const t = ps[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const gp = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function pp(e) {
  const t = gp.exec(e);
  let n = 255, s, i, a;
  if (t) {
    if (t[7] !== s) {
      const r = +t[7];
      n = t[8] ? Dn(r) : pe(r * 255, 0, 255);
    }
    return s = +t[1], i = +t[3], a = +t[5], s = 255 & (t[2] ? Dn(s) : pe(s, 0, 255)), i = 255 & (t[4] ? Dn(i) : pe(i, 0, 255)), a = 255 & (t[6] ? Dn(a) : pe(a, 0, 255)), {
      r: s,
      g: i,
      b: a,
      a: n
    };
  }
}
function mp(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${ie(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Di = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Ze = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function bp(e, t, n) {
  const s = Ze(ie(e.r)), i = Ze(ie(e.g)), a = Ze(ie(e.b));
  return {
    r: _e(Di(s + n * (Ze(ie(t.r)) - s))),
    g: _e(Di(i + n * (Ze(ie(t.g)) - i))),
    b: _e(Di(a + n * (Ze(ie(t.b)) - a))),
    a: e.a + n * (t.a - e.a)
  };
}
function ms(e, t, n) {
  if (e) {
    let s = Ia(e);
    s[t] = Math.max(0, Math.min(s[t] + s[t] * n, t === 0 ? 360 : 1)), s = Ba(s), e.r = s[0], e.g = s[1], e.b = s[2];
  }
}
function Hc(e, t) {
  return e && Object.assign(t || {}, e);
}
function jr(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = _e(e[3]))) : (t = Hc(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = _e(t.a)), t;
}
function yp(e) {
  return e.charAt(0) === "r" ? pp(e) : cp(e);
}
class Kn {
  constructor(t) {
    if (t instanceof Kn)
      return t;
    const n = typeof t;
    let s;
    n === "object" ? s = jr(t) : n === "string" && (s = tp(t) || fp(t) || yp(t)), this._rgb = s, this._valid = !!s;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = Hc(this._rgb);
    return t && (t.a = ie(t.a)), t;
  }
  set rgb(t) {
    this._rgb = jr(t);
  }
  rgbString() {
    return this._valid ? mp(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? np(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hp(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const s = this.rgb, i = t.rgb;
      let a;
      const r = n === a ? 0.5 : n, o = 2 * r - 1, l = s.a - i.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      a = 1 - c, s.r = 255 & c * s.r + a * i.r + 0.5, s.g = 255 & c * s.g + a * i.g + 0.5, s.b = 255 & c * s.b + a * i.b + 0.5, s.a = r * s.a + (1 - r) * i.a, this.rgb = s;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = bp(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new Kn(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = _e(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = ns(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return ms(this._rgb, 2, t), this;
  }
  darken(t) {
    return ms(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return ms(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return ms(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return dp(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function te() {
}
const _p = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function U(e) {
  return e === null || typeof e > "u";
}
function tt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function H(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function pt(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function It(e, t) {
  return pt(e) ? e : t;
}
function j(e, t) {
  return typeof e > "u" ? t : e;
}
const vp = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, Vc = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function et(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function nt(e, t, n, s) {
  let i, a, r;
  if (tt(e))
    if (a = e.length, s)
      for (i = a - 1; i >= 0; i--)
        t.call(n, e[i], i);
    else
      for (i = 0; i < a; i++)
        t.call(n, e[i], i);
  else if (H(e))
    for (r = Object.keys(e), a = r.length, i = 0; i < a; i++)
      t.call(n, e[r[i]], r[i]);
}
function qs(e, t) {
  let n, s, i, a;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, s = e.length; n < s; ++n)
    if (i = e[n], a = t[n], i.datasetIndex !== a.datasetIndex || i.index !== a.index)
      return !1;
  return !0;
}
function Ks(e) {
  if (tt(e))
    return e.map(Ks);
  if (H(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), s = n.length;
    let i = 0;
    for (; i < s; ++i)
      t[n[i]] = Ks(e[n[i]]);
    return t;
  }
  return e;
}
function Yc(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function xp(e, t, n, s) {
  if (!Yc(e))
    return;
  const i = t[e], a = n[e];
  H(i) && H(a) ? Xt(i, a, s) : t[e] = Ks(a);
}
function Xt(e, t, n) {
  const s = tt(t) ? t : [
    t
  ], i = s.length;
  if (!H(e))
    return e;
  n = n || {};
  const a = n.merger || xp;
  let r;
  for (let o = 0; o < i; ++o) {
    if (r = s[o], !H(r))
      continue;
    const l = Object.keys(r);
    for (let c = 0, d = l.length; c < d; ++c)
      a(l[c], e, r, n);
  }
  return e;
}
function Fn(e, t) {
  return Xt(e, t, {
    merger: wp
  });
}
function wp(e, t, n) {
  if (!Yc(e))
    return;
  const s = t[e], i = n[e];
  H(s) && H(i) ? Fn(s, i) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Ks(i));
}
const Hr = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function kp(e) {
  const t = e.split("."), n = [];
  let s = "";
  for (const i of t)
    s += i, s.endsWith("\\") ? s = s.slice(0, -1) + "." : (n.push(s), s = "");
  return n;
}
function Cp(e) {
  const t = kp(e);
  return (n) => {
    for (const s of t) {
      if (s === "")
        break;
      n = n && n[s];
    }
    return n;
  };
}
function we(e, t) {
  return (Hr[t] || (Hr[t] = Cp(t)))(e);
}
function Fa(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Et = (e) => typeof e < "u", Lt = (e) => typeof e == "function", Vr = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function Sp(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const K = Math.PI, ot = 2 * K, Mp = ot + K, Qs = Number.POSITIVE_INFINITY, Wa = K / 180, ht = K / 2, zt = K / 4, Js = K * 2 / 3, me = Math.log10, Ut = Math.sign;
function Wn(e, t, n) {
  return Math.abs(e - t) < n;
}
function Yr(e) {
  const t = Math.round(e);
  e = Wn(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(me(e))), s = e / n;
  return (s <= 1 ? 1 : s <= 2 ? 2 : s <= 5 ? 5 : 10) * n;
}
function Op(e) {
  const t = [], n = Math.sqrt(e);
  let s;
  for (s = 1; s < n; s++)
    e % s === 0 && (t.push(s), t.push(e / s));
  return n === (n | 0) && t.push(n), t.sort((i, a) => i - a).pop(), t;
}
function ke(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function Tp(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function Gc(e, t, n) {
  let s, i, a;
  for (s = 0, i = e.length; s < i; s++)
    a = e[s][n], isNaN(a) || (t.min = Math.min(t.min, a), t.max = Math.max(t.max, a));
}
function St(e) {
  return e * (K / 180);
}
function gi(e) {
  return e * (180 / K);
}
function Gr(e) {
  if (!pt(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function Uc(e, t) {
  const n = t.x - e.x, s = t.y - e.y, i = Math.sqrt(n * n + s * s);
  let a = Math.atan2(s, n);
  return a < -0.5 * K && (a += ot), {
    angle: a,
    distance: i
  };
}
function rn(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function Pp(e, t) {
  return (e - t + Mp) % ot - K;
}
function Rt(e) {
  return (e % ot + ot) % ot;
}
function Qn(e, t, n, s) {
  const i = Rt(e), a = Rt(t), r = Rt(n), o = Rt(a - i), l = Rt(r - i), c = Rt(i - a), d = Rt(i - r);
  return i === a || i === r || s && a === r || o > l && c < d;
}
function Mt(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function Ap(e) {
  return Mt(e, -32768, 32767);
}
function ae(e, t, n, s = 1e-6) {
  return e >= Math.min(t, n) - s && e <= Math.max(t, n) + s;
}
function Na(e, t, n) {
  n = n || ((r) => e[r] < t);
  let s = e.length - 1, i = 0, a;
  for (; s - i > 1; )
    a = i + s >> 1, n(a) ? i = a : s = a;
  return {
    lo: i,
    hi: s
  };
}
const re = (e, t, n, s) => Na(e, n, s ? (i) => {
  const a = e[i][t];
  return a < n || a === n && e[i + 1][t] === n;
} : (i) => e[i][t] < n), $p = (e, t, n) => Na(e, n, (s) => e[s][t] >= n);
function Dp(e, t, n) {
  let s = 0, i = e.length;
  for (; s < i && e[s] < t; )
    s++;
  for (; i > s && e[i - 1] > n; )
    i--;
  return s > 0 || i < e.length ? e.slice(s, i) : e;
}
const Xc = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function Lp(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), Xc.forEach((n) => {
    const s = "_onData" + Fa(n), i = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...a) {
        const r = i.apply(this, a);
        return e._chartjs.listeners.forEach((o) => {
          typeof o[s] == "function" && o[s](...a);
        }), r;
      }
    });
  });
}
function Ur(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const s = n.listeners, i = s.indexOf(t);
  i !== -1 && s.splice(i, 1), !(s.length > 0) && (Xc.forEach((a) => {
    delete e[a];
  }), delete e._chartjs);
}
function qc(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const Kc = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function Qc(e, t) {
  let n = [], s = !1;
  return function(...i) {
    n = i, s || (s = !0, Kc.call(window, () => {
      s = !1, e.apply(t, n);
    }));
  };
}
function Ep(e, t) {
  let n;
  return function(...s) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, s)) : e.apply(this, s), t;
  };
}
const za = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", Tt = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, Ip = (e, t, n, s) => e === (s ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function Jc(e, t, n) {
  const s = t.length;
  let i = 0, a = s;
  if (e._sorted) {
    const { iScale: r, _parsed: o } = e, l = r.axis, { min: c, max: d, minDefined: h, maxDefined: u } = r.getUserBounds();
    h && (i = Mt(Math.min(
      // @ts-expect-error Need to type _parsed
      re(o, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? s : re(t, l, r.getPixelForValue(c)).lo
    ), 0, s - 1)), u ? a = Mt(Math.max(
      // @ts-expect-error Need to type _parsed
      re(o, r.axis, d, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : re(t, l, r.getPixelForValue(d), !0).hi + 1
    ), i, s) - i : a = s - i;
  }
  return {
    start: i,
    count: a
  };
}
function Zc(e) {
  const { xScale: t, yScale: n, _scaleRanges: s } = e, i = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!s)
    return e._scaleRanges = i, !0;
  const a = s.xmin !== t.min || s.xmax !== t.max || s.ymin !== n.min || s.ymax !== n.max;
  return Object.assign(s, i), a;
}
const bs = (e) => e === 0 || e === 1, Xr = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * ot / n)), qr = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * ot / n) + 1, Nn = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * ht) + 1,
  easeOutSine: (e) => Math.sin(e * ht),
  easeInOutSine: (e) => -0.5 * (Math.cos(K * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => bs(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => bs(e) ? e : Xr(e, 0.075, 0.3),
  easeOutElastic: (e) => bs(e) ? e : qr(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return bs(e) ? e : e < 0.5 ? 0.5 * Xr(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * qr(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Nn.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Nn.easeInBounce(e * 2) * 0.5 : Nn.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function ja(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Zs(e) {
  return ja(e) ? e : new Kn(e);
}
function Li(e) {
  return ja(e) ? e : new Kn(e).saturate(0.5).darken(0.1).hexString();
}
const Rp = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Bp = [
  "color",
  "borderColor",
  "backgroundColor"
];
function Fp(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: Bp
    },
    numbers: {
      type: "number",
      properties: Rp
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function Wp(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Kr = /* @__PURE__ */ new Map();
function Np(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let s = Kr.get(n);
  return s || (s = new Intl.NumberFormat(e, t), Kr.set(n, s)), s;
}
function ss(e, t, n) {
  return Np(t, n).format(e);
}
const td = {
  values(e) {
    return tt(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const s = this.chart.options.locale;
    let i, a = e;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (i = "scientific"), a = zp(e, n);
    }
    const r = me(Math.abs(a)), o = isNaN(r) ? 1 : Math.max(Math.min(-1 * Math.floor(r), 20), 0), l = {
      notation: i,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), ss(e, s, l);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const s = n[t].significand || e / Math.pow(10, Math.floor(me(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(s) || t > 0.8 * n.length ? td.numeric.call(this, e, t, n) : "";
  }
};
function zp(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var pi = {
  formatters: td
};
function jp(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: pi.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const je = /* @__PURE__ */ Object.create(null), aa = /* @__PURE__ */ Object.create(null);
function zn(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let s = 0, i = n.length; s < i; ++s) {
    const a = n[s];
    e = e[a] || (e[a] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Ei(e, t, n) {
  return typeof t == "string" ? Xt(zn(e, t), n) : Xt(zn(e, ""), t);
}
class Hp {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (s) => s.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (s, i) => Li(i.backgroundColor), this.hoverBorderColor = (s, i) => Li(i.borderColor), this.hoverColor = (s, i) => Li(i.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Ei(this, t, n);
  }
  get(t) {
    return zn(this, t);
  }
  describe(t, n) {
    return Ei(aa, t, n);
  }
  override(t, n) {
    return Ei(je, t, n);
  }
  route(t, n, s, i) {
    const a = zn(this, t), r = zn(this, s), o = "_" + n;
    Object.defineProperties(a, {
      [o]: {
        value: a[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[o], c = r[i];
          return H(l) ? Object.assign({}, c, l) : j(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var mt = /* @__PURE__ */ new Hp({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  Fp,
  Wp,
  jp
]);
function Vp(e) {
  return !e || U(e.size) || U(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function ti(e, t, n, s, i) {
  let a = t[i];
  return a || (a = t[i] = e.measureText(i).width, n.push(i)), a > s && (s = a), s;
}
function Yp(e, t, n, s) {
  s = s || {};
  let i = s.data = s.data || {}, a = s.garbageCollect = s.garbageCollect || [];
  s.font !== t && (i = s.data = {}, a = s.garbageCollect = [], s.font = t), e.save(), e.font = t;
  let r = 0;
  const o = n.length;
  let l, c, d, h, u;
  for (l = 0; l < o; l++)
    if (h = n[l], h != null && !tt(h))
      r = ti(e, i, a, r, h);
    else if (tt(h))
      for (c = 0, d = h.length; c < d; c++)
        u = h[c], u != null && !tt(u) && (r = ti(e, i, a, r, u));
  e.restore();
  const f = a.length / 2;
  if (f > n.length) {
    for (l = 0; l < f; l++)
      delete i[a[l]];
    a.splice(0, f);
  }
  return r;
}
function Pe(e, t, n) {
  const s = e.currentDevicePixelRatio, i = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - i) * s) / s + i;
}
function Qr(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function ra(e, t, n, s) {
  ed(e, t, n, s, null);
}
function ed(e, t, n, s, i) {
  let a, r, o, l, c, d, h, u;
  const f = t.pointStyle, g = t.rotation, m = t.radius;
  let p = (g || 0) * Wa;
  if (f && typeof f == "object" && (a = f.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, s), e.rotate(p), e.drawImage(f, -f.width / 2, -f.height / 2, f.width, f.height), e.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (e.beginPath(), f) {
      default:
        i ? e.ellipse(n, s, i / 2, m, 0, 0, ot) : e.arc(n, s, m, 0, ot), e.closePath();
        break;
      case "triangle":
        d = i ? i / 2 : m, e.moveTo(n + Math.sin(p) * d, s - Math.cos(p) * m), p += Js, e.lineTo(n + Math.sin(p) * d, s - Math.cos(p) * m), p += Js, e.lineTo(n + Math.sin(p) * d, s - Math.cos(p) * m), e.closePath();
        break;
      case "rectRounded":
        c = m * 0.516, l = m - c, r = Math.cos(p + zt) * l, h = Math.cos(p + zt) * (i ? i / 2 - c : l), o = Math.sin(p + zt) * l, u = Math.sin(p + zt) * (i ? i / 2 - c : l), e.arc(n - h, s - o, c, p - K, p - ht), e.arc(n + u, s - r, c, p - ht, p), e.arc(n + h, s + o, c, p, p + ht), e.arc(n - u, s + r, c, p + ht, p + K), e.closePath();
        break;
      case "rect":
        if (!g) {
          l = Math.SQRT1_2 * m, d = i ? i / 2 : l, e.rect(n - d, s - l, 2 * d, 2 * l);
          break;
        }
        p += zt;
      case "rectRot":
        h = Math.cos(p) * (i ? i / 2 : m), r = Math.cos(p) * m, o = Math.sin(p) * m, u = Math.sin(p) * (i ? i / 2 : m), e.moveTo(n - h, s - o), e.lineTo(n + u, s - r), e.lineTo(n + h, s + o), e.lineTo(n - u, s + r), e.closePath();
        break;
      case "crossRot":
        p += zt;
      case "cross":
        h = Math.cos(p) * (i ? i / 2 : m), r = Math.cos(p) * m, o = Math.sin(p) * m, u = Math.sin(p) * (i ? i / 2 : m), e.moveTo(n - h, s - o), e.lineTo(n + h, s + o), e.moveTo(n + u, s - r), e.lineTo(n - u, s + r);
        break;
      case "star":
        h = Math.cos(p) * (i ? i / 2 : m), r = Math.cos(p) * m, o = Math.sin(p) * m, u = Math.sin(p) * (i ? i / 2 : m), e.moveTo(n - h, s - o), e.lineTo(n + h, s + o), e.moveTo(n + u, s - r), e.lineTo(n - u, s + r), p += zt, h = Math.cos(p) * (i ? i / 2 : m), r = Math.cos(p) * m, o = Math.sin(p) * m, u = Math.sin(p) * (i ? i / 2 : m), e.moveTo(n - h, s - o), e.lineTo(n + h, s + o), e.moveTo(n + u, s - r), e.lineTo(n - u, s + r);
        break;
      case "line":
        r = i ? i / 2 : Math.cos(p) * m, o = Math.sin(p) * m, e.moveTo(n - r, s - o), e.lineTo(n + r, s + o);
        break;
      case "dash":
        e.moveTo(n, s), e.lineTo(n + Math.cos(p) * (i ? i / 2 : m), s + Math.sin(p) * m);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function oe(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function is(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function as(e) {
  e.restore();
}
function Gp(e, t, n, s, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (i === "middle") {
    const a = (t.x + n.x) / 2;
    e.lineTo(a, t.y), e.lineTo(a, n.y);
  } else
    i === "after" != !!s ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function Up(e, t, n, s) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(s ? t.cp1x : t.cp2x, s ? t.cp1y : t.cp2y, s ? n.cp2x : n.cp1x, s ? n.cp2y : n.cp1y, n.x, n.y);
}
function Xp(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), U(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function qp(e, t, n, s, i) {
  if (i.strikethrough || i.underline) {
    const a = e.measureText(s), r = t - a.actualBoundingBoxLeft, o = t + a.actualBoundingBoxRight, l = n - a.actualBoundingBoxAscent, c = n + a.actualBoundingBoxDescent, d = i.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(r, d), e.lineTo(o, d), e.stroke();
  }
}
function Kp(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function He(e, t, n, s, i, a = {}) {
  const r = tt(t) ? t : [
    t
  ], o = a.strokeWidth > 0 && a.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = i.string, Xp(e, a), l = 0; l < r.length; ++l)
    c = r[l], a.backdrop && Kp(e, a.backdrop), o && (a.strokeColor && (e.strokeStyle = a.strokeColor), U(a.strokeWidth) || (e.lineWidth = a.strokeWidth), e.strokeText(c, n, s, a.maxWidth)), e.fillText(c, n, s, a.maxWidth), qp(e, n, s, c, a), s += Number(i.lineHeight);
  e.restore();
}
function on(e, t) {
  const { x: n, y: s, w: i, h: a, radius: r } = t;
  e.arc(n + r.topLeft, s + r.topLeft, r.topLeft, 1.5 * K, K, !0), e.lineTo(n, s + a - r.bottomLeft), e.arc(n + r.bottomLeft, s + a - r.bottomLeft, r.bottomLeft, K, ht, !0), e.lineTo(n + i - r.bottomRight, s + a), e.arc(n + i - r.bottomRight, s + a - r.bottomRight, r.bottomRight, ht, 0, !0), e.lineTo(n + i, s + r.topRight), e.arc(n + i - r.topRight, s + r.topRight, r.topRight, 0, -ht, !0), e.lineTo(n + r.topLeft, s);
}
const Qp = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Jp = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Zp(e, t) {
  const n = ("" + e).match(Qp);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const tm = (e) => +e || 0;
function Ha(e, t) {
  const n = {}, s = H(t), i = s ? Object.keys(t) : t, a = H(e) ? s ? (r) => j(e[r], e[t[r]]) : (r) => e[r] : () => e;
  for (const r of i)
    n[r] = tm(a(r));
  return n;
}
function nd(e) {
  return Ha(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function ve(e) {
  return Ha(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function kt(e) {
  const t = nd(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function bt(e, t) {
  e = e || {}, t = t || mt.font;
  let n = j(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let s = j(e.style, t.style);
  s && !("" + s).match(Jp) && (console.warn('Invalid font style specified: "' + s + '"'), s = void 0);
  const i = {
    family: j(e.family, t.family),
    lineHeight: Zp(j(e.lineHeight, t.lineHeight), n),
    size: n,
    style: s,
    weight: j(e.weight, t.weight),
    string: ""
  };
  return i.string = Vp(i), i;
}
function ct(e, t, n, s) {
  let i = !0, a, r, o;
  for (a = 0, r = e.length; a < r; ++a)
    if (o = e[a], o !== void 0 && (t !== void 0 && typeof o == "function" && (o = o(t), i = !1), n !== void 0 && tt(o) && (o = o[n % o.length], i = !1), o !== void 0))
      return s && !i && (s.cacheable = !1), o;
}
function em(e, t, n) {
  const { min: s, max: i } = e, a = Vc(t, (i - s) / 2), r = (o, l) => n && o === 0 ? 0 : o + l;
  return {
    min: r(s, -Math.abs(a)),
    max: r(i, a)
  };
}
function Me(e, t) {
  return Object.assign(Object.create(e), t);
}
function Va(e, t = [
  ""
], n, s, i = () => e[0]) {
  const a = n || e;
  typeof s > "u" && (s = rd("_fallback", e));
  const r = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: a,
    _fallback: s,
    _getTarget: i,
    override: (o) => Va([
      o,
      ...e
    ], t, a, s)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return id(o, l, () => cm(l, t, e, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return Zr(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return Zr(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, c) {
      const d = o._storage || (o._storage = i());
      return o[l] = d[l] = c, delete o._keys, !0;
    }
  });
}
function ln(e, t, n, s) {
  const i = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: sd(e, s),
    setContext: (a) => ln(e, a, n, s),
    override: (a) => ln(e.override(a), t, n, s)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, r) {
      return delete a[r], delete e[r], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, r, o) {
      return id(a, r, () => sm(a, r, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, r) {
      return a._descriptors.allKeys ? Reflect.has(e, r) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, r);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(a, r) {
      return Reflect.has(e, r);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(a, r, o) {
      return e[r] = o, delete a[r], !0;
    }
  });
}
function sd(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: s = t.indexable, _allKeys: i = t.allKeys } = e;
  return {
    allKeys: i,
    scriptable: n,
    indexable: s,
    isScriptable: Lt(n) ? n : () => n,
    isIndexable: Lt(s) ? s : () => s
  };
}
const nm = (e, t) => e ? e + Fa(t) : t, Ya = (e, t) => H(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function id(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const s = n();
  return e[t] = s, s;
}
function sm(e, t, n) {
  const { _proxy: s, _context: i, _subProxy: a, _descriptors: r } = e;
  let o = s[t];
  return Lt(o) && r.isScriptable(t) && (o = im(t, o, e, n)), tt(o) && o.length && (o = am(t, o, e, r.isIndexable)), Ya(t, o) && (o = ln(o, i, a && a[t], r)), o;
}
function im(e, t, n, s) {
  const { _proxy: i, _context: a, _subProxy: r, _stack: o } = n;
  if (o.has(e))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + e);
  o.add(e);
  let l = t(a, r || s);
  return o.delete(e), Ya(e, l) && (l = Ga(i._scopes, i, e, l)), l;
}
function am(e, t, n, s) {
  const { _proxy: i, _context: a, _subProxy: r, _descriptors: o } = n;
  if (typeof a.index < "u" && s(e))
    return t[a.index % t.length];
  if (H(t[0])) {
    const l = t, c = i._scopes.filter((d) => d !== l);
    t = [];
    for (const d of l) {
      const h = Ga(c, i, e, d);
      t.push(ln(h, a, r && r[e], o));
    }
  }
  return t;
}
function ad(e, t, n) {
  return Lt(e) ? e(t, n) : e;
}
const rm = (e, t) => e === !0 ? t : typeof e == "string" ? we(t, e) : void 0;
function om(e, t, n, s, i) {
  for (const a of t) {
    const r = rm(n, a);
    if (r) {
      e.add(r);
      const o = ad(r._fallback, n, i);
      if (typeof o < "u" && o !== n && o !== s)
        return o;
    } else if (r === !1 && typeof s < "u" && n !== s)
      return null;
  }
  return !1;
}
function Ga(e, t, n, s) {
  const i = t._rootScopes, a = ad(t._fallback, n, s), r = [
    ...e,
    ...i
  ], o = /* @__PURE__ */ new Set();
  o.add(s);
  let l = Jr(o, r, n, a || n, s);
  return l === null || typeof a < "u" && a !== n && (l = Jr(o, r, a, l, s), l === null) ? !1 : Va(Array.from(o), [
    ""
  ], i, a, () => lm(t, n, s));
}
function Jr(e, t, n, s, i) {
  for (; n; )
    n = om(e, t, n, s, i);
  return n;
}
function lm(e, t, n) {
  const s = e._getTarget();
  t in s || (s[t] = {});
  const i = s[t];
  return tt(i) && H(n) ? n : i || {};
}
function cm(e, t, n, s) {
  let i;
  for (const a of t)
    if (i = rd(nm(a, e), n), typeof i < "u")
      return Ya(e, i) ? Ga(n, s, e, i) : i;
}
function rd(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const s = n[e];
    if (typeof s < "u")
      return s;
  }
}
function Zr(e) {
  let t = e._keys;
  return t || (t = e._keys = dm(e._scopes)), t;
}
function dm(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const s of Object.keys(n).filter((i) => !i.startsWith("_")))
      t.add(s);
  return Array.from(t);
}
function od(e, t, n, s) {
  const { iScale: i } = e, { key: a = "r" } = this._parsing, r = new Array(s);
  let o, l, c, d;
  for (o = 0, l = s; o < l; ++o)
    c = o + n, d = t[c], r[o] = {
      r: i.parse(we(d, a), c)
    };
  return r;
}
const hm = Number.EPSILON || 1e-14, cn = (e, t) => t < e.length && !e[t].skip && e[t], ld = (e) => e === "x" ? "y" : "x";
function um(e, t, n, s) {
  const i = e.skip ? t : e, a = t, r = n.skip ? t : n, o = rn(a, i), l = rn(r, a);
  let c = o / (o + l), d = l / (o + l);
  c = isNaN(c) ? 0 : c, d = isNaN(d) ? 0 : d;
  const h = s * c, u = s * d;
  return {
    previous: {
      x: a.x - h * (r.x - i.x),
      y: a.y - h * (r.y - i.y)
    },
    next: {
      x: a.x + u * (r.x - i.x),
      y: a.y + u * (r.y - i.y)
    }
  };
}
function fm(e, t, n) {
  const s = e.length;
  let i, a, r, o, l, c = cn(e, 0);
  for (let d = 0; d < s - 1; ++d)
    if (l = c, c = cn(e, d + 1), !(!l || !c)) {
      if (Wn(t[d], 0, hm)) {
        n[d] = n[d + 1] = 0;
        continue;
      }
      i = n[d] / t[d], a = n[d + 1] / t[d], o = Math.pow(i, 2) + Math.pow(a, 2), !(o <= 9) && (r = 3 / Math.sqrt(o), n[d] = i * r * t[d], n[d + 1] = a * r * t[d]);
    }
}
function gm(e, t, n = "x") {
  const s = ld(n), i = e.length;
  let a, r, o, l = cn(e, 0);
  for (let c = 0; c < i; ++c) {
    if (r = o, o = l, l = cn(e, c + 1), !o)
      continue;
    const d = o[n], h = o[s];
    r && (a = (d - r[n]) / 3, o[`cp1${n}`] = d - a, o[`cp1${s}`] = h - a * t[c]), l && (a = (l[n] - d) / 3, o[`cp2${n}`] = d + a, o[`cp2${s}`] = h + a * t[c]);
  }
}
function pm(e, t = "x") {
  const n = ld(t), s = e.length, i = Array(s).fill(0), a = Array(s);
  let r, o, l, c = cn(e, 0);
  for (r = 0; r < s; ++r)
    if (o = l, l = c, c = cn(e, r + 1), !!l) {
      if (c) {
        const d = c[t] - l[t];
        i[r] = d !== 0 ? (c[n] - l[n]) / d : 0;
      }
      a[r] = o ? c ? Ut(i[r - 1]) !== Ut(i[r]) ? 0 : (i[r - 1] + i[r]) / 2 : i[r - 1] : i[r];
    }
  fm(e, i, a), gm(e, a, t);
}
function ys(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function mm(e, t) {
  let n, s, i, a, r, o = oe(e[0], t);
  for (n = 0, s = e.length; n < s; ++n)
    r = a, a = o, o = n < s - 1 && oe(e[n + 1], t), a && (i = e[n], r && (i.cp1x = ys(i.cp1x, t.left, t.right), i.cp1y = ys(i.cp1y, t.top, t.bottom)), o && (i.cp2x = ys(i.cp2x, t.left, t.right), i.cp2y = ys(i.cp2y, t.top, t.bottom)));
}
function bm(e, t, n, s, i) {
  let a, r, o, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    pm(e, i);
  else {
    let c = s ? e[e.length - 1] : e[0];
    for (a = 0, r = e.length; a < r; ++a)
      o = e[a], l = um(c, o, e[Math.min(a + 1, r - (s ? 0 : 1)) % r], t.tension), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && mm(e, n);
}
function Ua() {
  return typeof window < "u" && typeof document < "u";
}
function Xa(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function ei(e, t, n) {
  let s;
  return typeof e == "string" ? (s = parseInt(e, 10), e.indexOf("%") !== -1 && (s = s / 100 * t.parentNode[n])) : s = e, s;
}
const mi = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function ym(e, t) {
  return mi(e).getPropertyValue(t);
}
const _m = [
  "top",
  "right",
  "bottom",
  "left"
];
function We(e, t, n) {
  const s = {};
  n = n ? "-" + n : "";
  for (let i = 0; i < 4; i++) {
    const a = _m[i];
    s[a] = parseFloat(e[t + "-" + a + n]) || 0;
  }
  return s.width = s.left + s.right, s.height = s.top + s.bottom, s;
}
const vm = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function xm(e, t) {
  const n = e.touches, s = n && n.length ? n[0] : e, { offsetX: i, offsetY: a } = s;
  let r = !1, o, l;
  if (vm(i, a, e.target))
    o = i, l = a;
  else {
    const c = t.getBoundingClientRect();
    o = s.clientX - c.left, l = s.clientY - c.top, r = !0;
  }
  return {
    x: o,
    y: l,
    box: r
  };
}
function Le(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: s } = t, i = mi(n), a = i.boxSizing === "border-box", r = We(i, "padding"), o = We(i, "border", "width"), { x: l, y: c, box: d } = xm(e, n), h = r.left + (d && o.left), u = r.top + (d && o.top);
  let { width: f, height: g } = t;
  return a && (f -= r.width + o.width, g -= r.height + o.height), {
    x: Math.round((l - h) / f * n.width / s),
    y: Math.round((c - u) / g * n.height / s)
  };
}
function wm(e, t, n) {
  let s, i;
  if (t === void 0 || n === void 0) {
    const a = Xa(e);
    if (!a)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const r = a.getBoundingClientRect(), o = mi(a), l = We(o, "border", "width"), c = We(o, "padding");
      t = r.width - c.width - l.width, n = r.height - c.height - l.height, s = ei(o.maxWidth, a, "clientWidth"), i = ei(o.maxHeight, a, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: s || Qs,
    maxHeight: i || Qs
  };
}
const _s = (e) => Math.round(e * 10) / 10;
function km(e, t, n, s) {
  const i = mi(e), a = We(i, "margin"), r = ei(i.maxWidth, e, "clientWidth") || Qs, o = ei(i.maxHeight, e, "clientHeight") || Qs, l = wm(e, t, n);
  let { width: c, height: d } = l;
  if (i.boxSizing === "content-box") {
    const u = We(i, "border", "width"), f = We(i, "padding");
    c -= f.width + u.width, d -= f.height + u.height;
  }
  return c = Math.max(0, c - a.width), d = Math.max(0, s ? c / s : d - a.height), c = _s(Math.min(c, r, l.maxWidth)), d = _s(Math.min(d, o, l.maxHeight)), c && !d && (d = _s(c / 2)), (t !== void 0 || n !== void 0) && s && l.height && d > l.height && (d = l.height, c = _s(Math.floor(d * s))), {
    width: c,
    height: d
  };
}
function to(e, t, n) {
  const s = t || 1, i = Math.floor(e.height * s), a = Math.floor(e.width * s);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const r = e.canvas;
  return r.style && (n || !r.style.height && !r.style.width) && (r.style.height = `${e.height}px`, r.style.width = `${e.width}px`), e.currentDevicePixelRatio !== s || r.height !== i || r.width !== a ? (e.currentDevicePixelRatio = s, r.height = i, r.width = a, e.ctx.setTransform(s, 0, 0, s, 0, 0), !0) : !1;
}
const Cm = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    Ua() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function eo(e, t) {
  const n = ym(e, t), s = n && n.match(/^(\d+)(\.\d+)?px$/);
  return s ? +s[1] : void 0;
}
function Ee(e, t, n, s) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function Sm(e, t, n, s) {
  return {
    x: e.x + n * (t.x - e.x),
    y: s === "middle" ? n < 0.5 ? e.y : t.y : s === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function Mm(e, t, n, s) {
  const i = {
    x: e.cp2x,
    y: e.cp2y
  }, a = {
    x: t.cp1x,
    y: t.cp1y
  }, r = Ee(e, i, n), o = Ee(i, a, n), l = Ee(a, t, n), c = Ee(r, o, n), d = Ee(o, l, n);
  return Ee(c, d, n);
}
const Om = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, s) {
      return n - s;
    },
    leftForLtr(n, s) {
      return n - s;
    }
  };
}, Tm = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function sn(e, t, n) {
  return e ? Om(t, n) : Tm();
}
function cd(e, t) {
  let n, s;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, s = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = s);
}
function dd(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function hd(e) {
  return e === "angle" ? {
    between: Qn,
    compare: Pp,
    normalize: Rt
  } : {
    between: ae,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function no({ start: e, end: t, count: n, loop: s, style: i }) {
  return {
    start: e % n,
    end: t % n,
    loop: s && (t - e + 1) % n === 0,
    style: i
  };
}
function Pm(e, t, n) {
  const { property: s, start: i, end: a } = n, { between: r, normalize: o } = hd(s), l = t.length;
  let { start: c, end: d, loop: h } = e, u, f;
  if (h) {
    for (c += l, d += l, u = 0, f = l; u < f && r(o(t[c % l][s]), i, a); ++u)
      c--, d--;
    c %= l, d %= l;
  }
  return d < c && (d += l), {
    start: c,
    end: d,
    loop: h,
    style: e.style
  };
}
function ud(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: s, start: i, end: a } = n, r = t.length, { compare: o, between: l, normalize: c } = hd(s), { start: d, end: h, loop: u, style: f } = Pm(e, t, n), g = [];
  let m = !1, p = null, b, y, v;
  const w = () => l(i, v, b) && o(i, v) !== 0, x = () => o(a, b) === 0 || l(a, v, b), C = () => m || w(), O = () => !m || x();
  for (let M = d, A = d; M <= h; ++M)
    y = t[M % r], !y.skip && (b = c(y[s]), b !== v && (m = l(b, i, a), p === null && C() && (p = o(b, i) === 0 ? M : A), p !== null && O() && (g.push(no({
      start: p,
      end: M,
      loop: u,
      count: r,
      style: f
    })), p = null), A = M, v = b));
  return p !== null && g.push(no({
    start: p,
    end: h,
    loop: u,
    count: r,
    style: f
  })), g;
}
function fd(e, t) {
  const n = [], s = e.segments;
  for (let i = 0; i < s.length; i++) {
    const a = ud(s[i], e.points, t);
    a.length && n.push(...a);
  }
  return n;
}
function Am(e, t, n, s) {
  let i = 0, a = t - 1;
  if (n && !s)
    for (; i < t && !e[i].skip; )
      i++;
  for (; i < t && e[i].skip; )
    i++;
  for (i %= t, n && (a += i); a > i && e[a % t].skip; )
    a--;
  return a %= t, {
    start: i,
    end: a
  };
}
function $m(e, t, n, s) {
  const i = e.length, a = [];
  let r = t, o = e[t], l;
  for (l = t + 1; l <= n; ++l) {
    const c = e[l % i];
    c.skip || c.stop ? o.skip || (s = !1, a.push({
      start: t % i,
      end: (l - 1) % i,
      loop: s
    }), t = r = c.stop ? l : null) : (r = l, o.skip && (t = l)), o = c;
  }
  return r !== null && a.push({
    start: t % i,
    end: r % i,
    loop: s
  }), a;
}
function Dm(e, t) {
  const n = e.points, s = e.options.spanGaps, i = n.length;
  if (!i)
    return [];
  const a = !!e._loop, { start: r, end: o } = Am(n, i, a, s);
  if (s === !0)
    return so(e, [
      {
        start: r,
        end: o,
        loop: a
      }
    ], n, t);
  const l = o < r ? o + i : o, c = !!e._fullLoop && r === 0 && o === i - 1;
  return so(e, $m(n, r, l, c), n, t);
}
function so(e, t, n, s) {
  return !s || !s.setContext || !n ? t : Lm(e, t, n, s);
}
function Lm(e, t, n, s) {
  const i = e._chart.getContext(), a = io(e.options), { _datasetIndex: r, options: { spanGaps: o } } = e, l = n.length, c = [];
  let d = a, h = t[0].start, u = h;
  function f(g, m, p, b) {
    const y = o ? -1 : 1;
    if (g !== m) {
      for (g += l; n[g % l].skip; )
        g -= y;
      for (; n[m % l].skip; )
        m += y;
      g % l !== m % l && (c.push({
        start: g % l,
        end: m % l,
        loop: p,
        style: b
      }), d = b, h = m % l);
    }
  }
  for (const g of t) {
    h = o ? h : g.start;
    let m = n[h % l], p;
    for (u = h + 1; u <= g.end; u++) {
      const b = n[u % l];
      p = io(s.setContext(Me(i, {
        type: "segment",
        p0: m,
        p1: b,
        p0DataIndex: (u - 1) % l,
        p1DataIndex: u % l,
        datasetIndex: r
      }))), Em(p, d) && f(h, u - 1, g.loop, d), m = b, d = p;
    }
    h < u - 1 && f(h, u - 1, g.loop, d);
  }
  return c;
}
function io(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function Em(e, t) {
  if (!t)
    return !1;
  const n = [], s = function(i, a) {
    return ja(a) ? (n.includes(a) || n.push(a), n.indexOf(a)) : a;
  };
  return JSON.stringify(e, s) !== JSON.stringify(t, s);
}
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class Im {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, s, i) {
    const a = n.listeners[i], r = n.duration;
    a.forEach((o) => o({
      chart: t,
      initial: n.initial,
      numSteps: r,
      currentStep: Math.min(s - n.start, r)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Kc.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((s, i) => {
      if (!s.running || !s.items.length)
        return;
      const a = s.items;
      let r = a.length - 1, o = !1, l;
      for (; r >= 0; --r)
        l = a[r], l._active ? (l._total > s.duration && (s.duration = l._total), l.tick(t), o = !0) : (a[r] = a[a.length - 1], a.pop());
      o && (i.draw(), this._notify(i, s, t, "progress")), a.length || (s.running = !1, this._notify(i, s, t, "complete"), s.initial = !1), n += a.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let s = n.get(t);
    return s || (s = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, s)), s;
  }
  listen(t, n, s) {
    this._getAnims(t).listeners[n].push(s);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((s, i) => Math.max(s, i._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const s = n.items;
    let i = s.length - 1;
    for (; i >= 0; --i)
      s[i].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var ee = /* @__PURE__ */ new Im();
const ao = "transparent", Rm = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const s = Zs(e || ao), i = s.valid && Zs(t || ao);
    return i && i.valid ? i.mix(s, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class Bm {
  constructor(t, n, s, i) {
    const a = n[s];
    i = ct([
      t.to,
      i,
      a,
      t.from
    ]);
    const r = ct([
      t.from,
      a,
      i
    ]);
    this._active = !0, this._fn = t.fn || Rm[t.type || typeof r], this._easing = Nn[t.easing] || Nn.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = s, this._from = r, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, s) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], a = s - this._start, r = this._duration - a;
      this._start = s, this._duration = Math.floor(Math.max(r, t.duration)), this._total += a, this._loop = !!t.loop, this._to = ct([
        t.to,
        n,
        i,
        t.from
      ]), this._from = ct([
        t.from,
        i,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, s = this._duration, i = this._prop, a = this._from, r = this._loop, o = this._to;
    let l;
    if (this._active = a !== o && (r || n < s), !this._active) {
      this._target[i] = o, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[i] = a;
      return;
    }
    l = n / s % 2, l = r && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[i] = this._fn(a, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, s) => {
      t.push({
        res: n,
        rej: s
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", s = this._promises || [];
    for (let i = 0; i < s.length; i++)
      s[i][n]();
  }
}
class qa {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!H(t))
      return;
    const n = Object.keys(mt.animation), s = this._properties;
    Object.getOwnPropertyNames(t).forEach((i) => {
      const a = t[i];
      if (!H(a))
        return;
      const r = {};
      for (const o of n)
        r[o] = a[o];
      (tt(a.properties) && a.properties || [
        i
      ]).forEach((o) => {
        (o === i || !s.has(o)) && s.set(o, r);
      });
    });
  }
  _animateOptions(t, n) {
    const s = n.options, i = Wm(t, s);
    if (!i)
      return [];
    const a = this._createAnimations(i, s);
    return s.$shared && Fm(t.options.$animations, s).then(() => {
      t.options = s;
    }, () => {
    }), a;
  }
  _createAnimations(t, n) {
    const s = this._properties, i = [], a = t.$animations || (t.$animations = {}), r = Object.keys(n), o = Date.now();
    let l;
    for (l = r.length - 1; l >= 0; --l) {
      const c = r[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        i.push(...this._animateOptions(t, n));
        continue;
      }
      const d = n[c];
      let h = a[c];
      const u = s.get(c);
      if (h)
        if (u && h.active()) {
          h.update(u, d, o);
          continue;
        } else
          h.cancel();
      if (!u || !u.duration) {
        t[c] = d;
        continue;
      }
      a[c] = h = new Bm(u, t, c, d), i.push(h);
    }
    return i;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const s = this._createAnimations(t, n);
    if (s.length)
      return ee.add(this._chart, s), !0;
  }
}
function Fm(e, t) {
  const n = [], s = Object.keys(t);
  for (let i = 0; i < s.length; i++) {
    const a = e[s[i]];
    a && a.active() && n.push(a.wait());
  }
  return Promise.all(n);
}
function Wm(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function ro(e, t) {
  const n = e && e.options || {}, s = n.reverse, i = n.min === void 0 ? t : 0, a = n.max === void 0 ? t : 0;
  return {
    start: s ? a : i,
    end: s ? i : a
  };
}
function Nm(e, t, n) {
  if (n === !1)
    return !1;
  const s = ro(e, n), i = ro(t, n);
  return {
    top: i.end,
    right: s.end,
    bottom: i.start,
    left: s.start
  };
}
function zm(e) {
  let t, n, s, i;
  return H(e) ? (t = e.top, n = e.right, s = e.bottom, i = e.left) : t = n = s = i = e, {
    top: t,
    right: n,
    bottom: s,
    left: i,
    disabled: e === !1
  };
}
function gd(e, t) {
  const n = [], s = e._getSortedDatasetMetas(t);
  let i, a;
  for (i = 0, a = s.length; i < a; ++i)
    n.push(s[i].index);
  return n;
}
function oo(e, t, n, s = {}) {
  const i = e.keys, a = s.mode === "single";
  let r, o, l, c;
  if (t !== null) {
    for (r = 0, o = i.length; r < o; ++r) {
      if (l = +i[r], l === n) {
        if (s.all)
          continue;
        break;
      }
      c = e.values[l], pt(c) && (a || t === 0 || Ut(t) === Ut(c)) && (t += c);
    }
    return t;
  }
}
function jm(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let s, i, a;
  for (s = 0, i = t.length; s < i; ++s)
    a = t[s], n[s] = {
      x: a,
      y: e[a]
    };
  return n;
}
function lo(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function Hm(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function Vm(e) {
  const { min: t, max: n, minDefined: s, maxDefined: i } = e.getUserBounds();
  return {
    min: s ? t : Number.NEGATIVE_INFINITY,
    max: i ? n : Number.POSITIVE_INFINITY
  };
}
function Ym(e, t, n) {
  const s = e[t] || (e[t] = {});
  return s[n] || (s[n] = {});
}
function co(e, t, n, s) {
  for (const i of t.getMatchingVisibleMetas(s).reverse()) {
    const a = e[i.index];
    if (n && a > 0 || !n && a < 0)
      return i.index;
  }
  return null;
}
function ho(e, t) {
  const { chart: n, _cachedMeta: s } = e, i = n._stacks || (n._stacks = {}), { iScale: a, vScale: r, index: o } = s, l = a.axis, c = r.axis, d = Hm(a, r, s), h = t.length;
  let u;
  for (let f = 0; f < h; ++f) {
    const g = t[f], { [l]: m, [c]: p } = g, b = g._stacks || (g._stacks = {});
    u = b[c] = Ym(i, d, m), u[o] = p, u._top = co(u, r, !0, s.type), u._bottom = co(u, r, !1, s.type);
    const y = u._visualValues || (u._visualValues = {});
    y[o] = p;
  }
}
function Ii(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((s) => n[s].axis === t).shift();
}
function Gm(e, t) {
  return Me(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function Um(e, t, n) {
  return Me(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function kn(e, t) {
  const n = e.controller.index, s = e.vScale && e.vScale.axis;
  if (s) {
    t = t || e._parsed;
    for (const i of t) {
      const a = i._stacks;
      if (!a || a[s] === void 0 || a[s][n] === void 0)
        return;
      delete a[s][n], a[s]._visualValues !== void 0 && a[s]._visualValues[n] !== void 0 && delete a[s]._visualValues[n];
    }
  }
}
const Ri = (e) => e === "reset" || e === "none", uo = (e, t) => t ? e : Object.assign({}, e), Xm = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: gd(n, !0),
  values: null
};
class Ht {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = lo(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && kn(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, s = this.getDataset(), i = (h, u, f, g) => h === "x" ? u : h === "r" ? g : f, a = n.xAxisID = j(s.xAxisID, Ii(t, "x")), r = n.yAxisID = j(s.yAxisID, Ii(t, "y")), o = n.rAxisID = j(s.rAxisID, Ii(t, "r")), l = n.indexAxis, c = n.iAxisID = i(l, a, r, o), d = n.vAxisID = i(l, r, a, o);
    n.xScale = this.getScaleForId(a), n.yScale = this.getScaleForId(r), n.rScale = this.getScaleForId(o), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Ur(this._data, this), t._stacked && kn(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), s = this._data;
    if (H(n))
      this._data = jm(n);
    else if (s !== n) {
      if (s) {
        Ur(s, this);
        const i = this._cachedMeta;
        kn(i), i._parsed = [];
      }
      n && Object.isExtensible(n) && Lp(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, s = this.getDataset();
    let i = !1;
    this._dataCheck();
    const a = n._stacked;
    n._stacked = lo(n.vScale, n), n.stack !== s.stack && (i = !0, kn(n), n.stack = s.stack), this._resyncElements(t), (i || a !== n._stacked) && ho(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), s = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(s, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: s, _data: i } = this, { iScale: a, _stacked: r } = s, o = a.axis;
    let l = t === 0 && n === i.length ? !0 : s._sorted, c = t > 0 && s._parsed[t - 1], d, h, u;
    if (this._parsing === !1)
      s._parsed = i, s._sorted = !0, u = i;
    else {
      tt(i[t]) ? u = this.parseArrayData(s, i, t, n) : H(i[t]) ? u = this.parseObjectData(s, i, t, n) : u = this.parsePrimitiveData(s, i, t, n);
      const f = () => h[o] === null || c && h[o] < c[o];
      for (d = 0; d < n; ++d)
        s._parsed[d + t] = h = u[d], l && (f() && (l = !1), c = h);
      s._sorted = l;
    }
    r && ho(this, u);
  }
  parsePrimitiveData(t, n, s, i) {
    const { iScale: a, vScale: r } = t, o = a.axis, l = r.axis, c = a.getLabels(), d = a === r, h = new Array(i);
    let u, f, g;
    for (u = 0, f = i; u < f; ++u)
      g = u + s, h[u] = {
        [o]: d || a.parse(c[g], g),
        [l]: r.parse(n[g], g)
      };
    return h;
  }
  parseArrayData(t, n, s, i) {
    const { xScale: a, yScale: r } = t, o = new Array(i);
    let l, c, d, h;
    for (l = 0, c = i; l < c; ++l)
      d = l + s, h = n[d], o[l] = {
        x: a.parse(h[0], d),
        y: r.parse(h[1], d)
      };
    return o;
  }
  parseObjectData(t, n, s, i) {
    const { xScale: a, yScale: r } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(i);
    let d, h, u, f;
    for (d = 0, h = i; d < h; ++d)
      u = d + s, f = n[u], c[d] = {
        x: a.parse(we(f, o), u),
        y: r.parse(we(f, l), u)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, s) {
    const i = this.chart, a = this._cachedMeta, r = n[t.axis], o = {
      keys: gd(i, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return oo(o, r, a.index, {
      mode: s
    });
  }
  updateRangeFromParsed(t, n, s, i) {
    const a = s[n.axis];
    let r = a === null ? NaN : a;
    const o = i && s._stacks[n.axis];
    i && o && (i.values = o, r = oo(i, a, this._cachedMeta.index)), t.min = Math.min(t.min, r), t.max = Math.max(t.max, r);
  }
  getMinMax(t, n) {
    const s = this._cachedMeta, i = s._parsed, a = s._sorted && t === s.iScale, r = i.length, o = this._getOtherScale(t), l = Xm(n, s, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: h } = Vm(o);
    let u, f;
    function g() {
      f = i[u];
      const m = f[o.axis];
      return !pt(f[t.axis]) || d > m || h < m;
    }
    for (u = 0; u < r && !(!g() && (this.updateRangeFromParsed(c, t, f, l), a)); ++u)
      ;
    if (a) {
      for (u = r - 1; u >= 0; --u)
        if (!g()) {
          this.updateRangeFromParsed(c, t, f, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, s = [];
    let i, a, r;
    for (i = 0, a = n.length; i < a; ++i)
      r = n[i][t.axis], pt(r) && s.push(r);
    return s;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, s = n.iScale, i = n.vScale, a = this.getParsed(t);
    return {
      label: s ? "" + s.getLabelForValue(a[s.axis]) : "",
      value: i ? "" + i.getLabelForValue(a[i.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = zm(j(this.options.clip, Nm(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, s = this._cachedMeta, i = s.data || [], a = n.chartArea, r = [], o = this._drawStart || 0, l = this._drawCount || i.length - o, c = this.options.drawActiveElementsOnTop;
    let d;
    for (s.dataset && s.dataset.draw(t, a, o, l), d = o; d < o + l; ++d) {
      const h = i[d];
      h.hidden || (h.active && c ? r.push(h) : h.draw(t, a));
    }
    for (d = 0; d < r.length; ++d)
      r[d].draw(t, a);
  }
  getStyle(t, n) {
    const s = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(s) : this.resolveDataElementOptions(t || 0, s);
  }
  getContext(t, n, s) {
    const i = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const r = this._cachedMeta.data[t];
      a = r.$context || (r.$context = Um(this.getContext(), t, r)), a.parsed = this.getParsed(t), a.raw = i.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = Gm(this.chart.getContext(), this.index)), a.dataset = i, a.index = a.datasetIndex = this.index;
    return a.active = !!n, a.mode = s, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", s) {
    const i = n === "active", a = this._cachedDataOpts, r = t + "-" + n, o = a[r], l = this.enableOptionSharing && Et(s);
    if (o)
      return uo(o, l);
    const c = this.chart.config, d = c.datasetElementScopeKeys(this._type, t), h = i ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], u = c.getOptionScopes(this.getDataset(), d), f = Object.keys(mt.elements[t]), g = () => this.getContext(s, i, n), m = c.resolveNamedOptions(u, f, g, h);
    return m.$shared && (m.$shared = l, a[r] = Object.freeze(uo(m, l))), m;
  }
  _resolveAnimations(t, n, s) {
    const i = this.chart, a = this._cachedDataOpts, r = `animation-${n}`, o = a[r];
    if (o)
      return o;
    let l;
    if (i.options.animation !== !1) {
      const d = this.chart.config, h = d.datasetAnimationScopeKeys(this._type, n), u = d.getOptionScopes(this.getDataset(), h);
      l = d.createResolver(u, this.getContext(t, s, n));
    }
    const c = new qa(i, l && l.animations);
    return l && l._cacheable && (a[r] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Ri(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const s = this.resolveDataElementOptions(t, n), i = this._sharedOptions, a = this.getSharedOptions(s), r = this.includeOptions(n, a) || a !== i;
    return this.updateSharedOptions(a, n, s), {
      sharedOptions: a,
      includeOptions: r
    };
  }
  updateElement(t, n, s, i) {
    Ri(i) ? Object.assign(t, s) : this._resolveAnimations(n, i).update(t, s);
  }
  updateSharedOptions(t, n, s) {
    t && !Ri(n) && this._resolveAnimations(void 0, n).update(t, s);
  }
  _setStyle(t, n, s, i) {
    t.active = i;
    const a = this.getStyle(n, i);
    this._resolveAnimations(n, s, i).update(t, {
      options: !i && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, n, s) {
    this._setStyle(t, s, "active", !1);
  }
  setHoverStyle(t, n, s) {
    this._setStyle(t, s, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, s = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const i = s.length, a = n.length, r = Math.min(a, i);
    r && this.parse(0, r), a > i ? this._insertElements(i, a - i, t) : a < i && this._removeElements(a, i - a);
  }
  _insertElements(t, n, s = !0) {
    const i = this._cachedMeta, a = i.data, r = t + n;
    let o;
    const l = (c) => {
      for (c.length += n, o = c.length - 1; o >= r; o--)
        c[o] = c[o - n];
    };
    for (l(a), o = t; o < r; ++o)
      a[o] = new this.dataElementType();
    this._parsing && l(i._parsed), this.parse(t, n), s && this.updateElements(a, t, n, "reset");
  }
  updateElements(t, n, s, i) {
  }
  _removeElements(t, n) {
    const s = this._cachedMeta;
    if (this._parsing) {
      const i = s._parsed.splice(t, n);
      s._stacked && kn(s, i);
    }
    s.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, s, i] = t;
      this[n](s, i);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const s = arguments.length - 2;
    s && this._sync([
      "_insertElements",
      t,
      s
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
E(Ht, "defaults", {}), E(Ht, "datasetElementType", null), E(Ht, "dataElementType", null);
function qm(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let s = [];
    for (let i = 0, a = n.length; i < a; i++)
      s = s.concat(n[i].controller.getAllParsedValues(e));
    e._cache.$bar = qc(s.sort((i, a) => i - a));
  }
  return e._cache.$bar;
}
function Km(e) {
  const t = e.iScale, n = qm(t, e.type);
  let s = t._length, i, a, r, o;
  const l = () => {
    r === 32767 || r === -32768 || (Et(o) && (s = Math.min(s, Math.abs(r - o) || s)), o = r);
  };
  for (i = 0, a = n.length; i < a; ++i)
    r = t.getPixelForValue(n[i]), l();
  for (o = void 0, i = 0, a = t.ticks.length; i < a; ++i)
    r = t.getPixelForTick(i), l();
  return s;
}
function Qm(e, t, n, s) {
  const i = n.barThickness;
  let a, r;
  return U(i) ? (a = t.min * n.categoryPercentage, r = n.barPercentage) : (a = i * s, r = 1), {
    chunk: a / s,
    ratio: r,
    start: t.pixels[e] - a / 2
  };
}
function Jm(e, t, n, s) {
  const i = t.pixels, a = i[e];
  let r = e > 0 ? i[e - 1] : null, o = e < i.length - 1 ? i[e + 1] : null;
  const l = n.categoryPercentage;
  r === null && (r = a - (o === null ? t.end - t.start : o - a)), o === null && (o = a + a - r);
  const c = a - (a - Math.min(r, o)) / 2 * l;
  return {
    chunk: Math.abs(o - r) / 2 * l / s,
    ratio: n.barPercentage,
    start: c
  };
}
function Zm(e, t, n, s) {
  const i = n.parse(e[0], s), a = n.parse(e[1], s), r = Math.min(i, a), o = Math.max(i, a);
  let l = r, c = o;
  Math.abs(r) > Math.abs(o) && (l = o, c = r), t[n.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: i,
    end: a,
    min: r,
    max: o
  };
}
function pd(e, t, n, s) {
  return tt(e) ? Zm(e, t, n, s) : t[n.axis] = n.parse(e, s), t;
}
function fo(e, t, n, s) {
  const i = e.iScale, a = e.vScale, r = i.getLabels(), o = i === a, l = [];
  let c, d, h, u;
  for (c = n, d = n + s; c < d; ++c)
    u = t[c], h = {}, h[i.axis] = o || i.parse(r[c], c), l.push(pd(u, h, a, c));
  return l;
}
function Bi(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function tb(e, t, n) {
  return e !== 0 ? Ut(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function eb(e) {
  let t, n, s, i, a;
  return e.horizontal ? (t = e.base > e.x, n = "left", s = "right") : (t = e.base < e.y, n = "bottom", s = "top"), t ? (i = "end", a = "start") : (i = "start", a = "end"), {
    start: n,
    end: s,
    reverse: t,
    top: i,
    bottom: a
  };
}
function nb(e, t, n, s) {
  let i = t.borderSkipped;
  const a = {};
  if (!i) {
    e.borderSkipped = a;
    return;
  }
  if (i === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: r, end: o, reverse: l, top: c, bottom: d } = eb(e);
  i === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === s ? i = c : (n._bottom || 0) === s ? i = d : (a[go(d, r, o, l)] = !0, i = c)), a[go(i, r, o, l)] = !0, e.borderSkipped = a;
}
function go(e, t, n, s) {
  return s ? (e = sb(e, t, n), e = po(e, n, t)) : e = po(e, t, n), e;
}
function sb(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function po(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function ib(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class Fs extends Ht {
  parsePrimitiveData(t, n, s, i) {
    return fo(t, n, s, i);
  }
  parseArrayData(t, n, s, i) {
    return fo(t, n, s, i);
  }
  parseObjectData(t, n, s, i) {
    const { iScale: a, vScale: r } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = a.axis === "x" ? o : l, d = r.axis === "x" ? o : l, h = [];
    let u, f, g, m;
    for (u = s, f = s + i; u < f; ++u)
      m = n[u], g = {}, g[a.axis] = a.parse(we(m, c), u), h.push(pd(we(m, d), g, r, u));
    return h;
  }
  updateRangeFromParsed(t, n, s, i) {
    super.updateRangeFromParsed(t, n, s, i);
    const a = s._custom;
    a && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, a.min), t.max = Math.max(t.max, a.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: s, vScale: i } = n, a = this.getParsed(t), r = a._custom, o = Bi(r) ? "[" + r.start + ", " + r.end + "]" : "" + i.getLabelForValue(a[i.axis]);
    return {
      label: "" + s.getLabelForValue(a[s.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", { index: r, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), d = this._getRuler(), { sharedOptions: h, includeOptions: u } = this._getSharedOptions(n, i);
    for (let f = n; f < n + s; f++) {
      const g = this.getParsed(f), m = a || U(g[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(f), p = this._calculateBarIndexPixels(f, d), b = (g._stacks || {})[o.axis], y = {
        horizontal: c,
        base: m.base,
        enableBorderRadius: !b || Bi(g._custom) || r === b._top || r === b._bottom,
        x: c ? m.head : p.center,
        y: c ? p.center : m.head,
        height: c ? p.size : Math.abs(m.size),
        width: c ? Math.abs(m.size) : p.size
      };
      u && (y.options = h || this.resolveDataElementOptions(f, t[f].active ? "active" : i));
      const v = y.options || t[f].options;
      nb(y, v, b, r), ib(y, v, d.ratio), this.updateElement(t[f], f, y, i);
    }
  }
  _getStacks(t, n) {
    const { iScale: s } = this._cachedMeta, i = s.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), a = s.options.stacked, r = [], o = (l) => {
      const c = l.controller.getParsed(n), d = c && c[l.vScale.axis];
      if (U(d) || isNaN(d))
        return !0;
    };
    for (const l of i)
      if (!(n !== void 0 && o(l)) && ((a === !1 || r.indexOf(l.stack) === -1 || a === void 0 && l.stack === void 0) && r.push(l.stack), l.index === t))
        break;
    return r.length || r.push(void 0), r;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, s) {
    const i = this._getStacks(t, s), a = n !== void 0 ? i.indexOf(n) : -1;
    return a === -1 ? i.length - 1 : a;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, s = n.iScale, i = [];
    let a, r;
    for (a = 0, r = n.data.length; a < r; ++a)
      i.push(s.getPixelForValue(this.getParsed(a)[s.axis], a));
    const o = t.barThickness;
    return {
      min: o || Km(n),
      pixels: i,
      start: s._startPixel,
      end: s._endPixel,
      stackCount: this._getStackCount(),
      scale: s,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: s, index: i }, options: { base: a, minBarLength: r } } = this, o = a || 0, l = this.getParsed(t), c = l._custom, d = Bi(c);
    let h = l[n.axis], u = 0, f = s ? this.applyStack(n, l, s) : h, g, m;
    f !== h && (u = f - h, f = h), d && (h = c.barStart, f = c.barEnd - c.barStart, h !== 0 && Ut(h) !== Ut(c.barEnd) && (u = 0), u += h);
    const p = !U(a) && !d ? a : u;
    let b = n.getPixelForValue(p);
    if (this.chart.getDataVisibility(t) ? g = n.getPixelForValue(u + f) : g = b, m = g - b, Math.abs(m) < r) {
      m = tb(m, n, o) * r, h === o && (b -= m / 2);
      const y = n.getPixelForDecimal(0), v = n.getPixelForDecimal(1), w = Math.min(y, v), x = Math.max(y, v);
      b = Math.max(Math.min(b, x), w), g = b + m, s && !d && (l._stacks[n.axis]._visualValues[i] = n.getValueForPixel(g) - n.getValueForPixel(b));
    }
    if (b === n.getPixelForValue(o)) {
      const y = Ut(m) * n.getLineWidthForValue(o) / 2;
      b += y, m -= y;
    }
    return {
      size: m,
      base: b,
      head: g,
      center: g + m / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const s = n.scale, i = this.options, a = i.skipNull, r = j(i.maxBarThickness, 1 / 0);
    let o, l;
    if (n.grouped) {
      const c = a ? this._getStackCount(t) : n.stackCount, d = i.barThickness === "flex" ? Jm(t, n, i, c) : Qm(t, n, i, c), h = this._getStackIndex(this.index, this._cachedMeta.stack, a ? t : void 0);
      o = d.start + d.chunk * h + d.chunk / 2, l = Math.min(r, d.chunk * d.ratio);
    } else
      o = s.getPixelForValue(this.getParsed(t)[s.axis], t), l = Math.min(r, n.min * n.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, s = t.data, i = s.length;
    let a = 0;
    for (; a < i; ++a)
      this.getParsed(a)[n.axis] !== null && s[a].draw(this._ctx);
  }
}
E(Fs, "id", "bar"), E(Fs, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), E(Fs, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class Ws extends Ht {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, n, s, i) {
    const a = super.parsePrimitiveData(t, n, s, i);
    for (let r = 0; r < a.length; r++)
      a[r]._custom = this.resolveDataElementOptions(r + s).radius;
    return a;
  }
  parseArrayData(t, n, s, i) {
    const a = super.parseArrayData(t, n, s, i);
    for (let r = 0; r < a.length; r++) {
      const o = n[s + r];
      a[r]._custom = j(o[2], this.resolveDataElementOptions(r + s).radius);
    }
    return a;
  }
  parseObjectData(t, n, s, i) {
    const a = super.parseObjectData(t, n, s, i);
    for (let r = 0; r < a.length; r++) {
      const o = n[s + r];
      a[r]._custom = j(o && o.r && +o.r, this.resolveDataElementOptions(r + s).radius);
    }
    return a;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let n = 0;
    for (let s = t.length - 1; s >= 0; --s)
      n = Math.max(n, t[s].size(this.resolveDataElementOptions(s)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, s = this.chart.data.labels || [], { xScale: i, yScale: a } = n, r = this.getParsed(t), o = i.getLabelForValue(r.x), l = a.getLabelForValue(r.y), c = r._custom;
    return {
      label: s[t] || "",
      value: "(" + o + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", { iScale: r, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(n, i), d = r.axis, h = o.axis;
    for (let u = n; u < n + s; u++) {
      const f = t[u], g = !a && this.getParsed(u), m = {}, p = m[d] = a ? r.getPixelForDecimal(0.5) : r.getPixelForValue(g[d]), b = m[h] = a ? o.getBasePixel() : o.getPixelForValue(g[h]);
      m.skip = isNaN(p) || isNaN(b), c && (m.options = l || this.resolveDataElementOptions(u, f.active ? "active" : i), a && (m.options.radius = 0)), this.updateElement(f, u, m, i);
    }
  }
  resolveDataElementOptions(t, n) {
    const s = this.getParsed(t);
    let i = super.resolveDataElementOptions(t, n);
    i.$shared && (i = Object.assign({}, i, {
      $shared: !1
    }));
    const a = i.radius;
    return n !== "active" && (i.radius = 0), i.radius += j(s && s._custom, a), i;
  }
}
E(Ws, "id", "bubble"), E(Ws, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), E(Ws, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function ab(e, t, n) {
  let s = 1, i = 1, a = 0, r = 0;
  if (t < ot) {
    const o = e, l = o + t, c = Math.cos(o), d = Math.sin(o), h = Math.cos(l), u = Math.sin(l), f = (v, w, x) => Qn(v, o, l, !0) ? 1 : Math.max(w, w * n, x, x * n), g = (v, w, x) => Qn(v, o, l, !0) ? -1 : Math.min(w, w * n, x, x * n), m = f(0, c, h), p = f(ht, d, u), b = g(K, c, h), y = g(K + ht, d, u);
    s = (m - b) / 2, i = (p - y) / 2, a = -(m + b) / 2, r = -(p + y) / 2;
  }
  return {
    ratioX: s,
    ratioY: i,
    offsetX: a,
    offsetY: r
  };
}
class Be extends Ht {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const s = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = s;
    else {
      let a = (l) => +s[l];
      if (H(s[t])) {
        const { key: l = "value" } = this._parsing;
        a = (c) => +we(s[c], l);
      }
      let r, o;
      for (r = t, o = t + n; r < o; ++r)
        i._parsed[r] = a(r);
    }
  }
  _getRotation() {
    return St(this.options.rotation - 90);
  }
  _getCircumference() {
    return St(this.options.circumference);
  }
  _getRotationExtents() {
    let t = ot, n = -ot;
    for (let s = 0; s < this.chart.data.datasets.length; ++s)
      if (this.chart.isDatasetVisible(s) && this.chart.getDatasetMeta(s).type === this._type) {
        const i = this.chart.getDatasetMeta(s).controller, a = i._getRotation(), r = i._getCircumference();
        t = Math.min(t, a), n = Math.max(n, a + r);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: s } = n, i = this._cachedMeta, a = i.data, r = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, o = Math.max((Math.min(s.width, s.height) - r) / 2, 0), l = Math.min(vp(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: d, rotation: h } = this._getRotationExtents(), { ratioX: u, ratioY: f, offsetX: g, offsetY: m } = ab(h, d, l), p = (s.width - r) / u, b = (s.height - r) / f, y = Math.max(Math.min(p, b) / 2, 0), v = Vc(this.options.radius, y), w = Math.max(v * l, 0), x = (v - w) / this._getVisibleDatasetWeightTotal();
    this.offsetX = g * v, this.offsetY = m * v, i.total = this.calculateTotal(), this.outerRadius = v - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * c, 0), this.updateElements(a, 0, a.length, t);
  }
  _circumference(t, n) {
    const s = this.options, i = this._cachedMeta, a = this._getCircumference();
    return n && s.animation.animateRotate || !this.chart.getDataVisibility(t) || i._parsed[t] === null || i.data[t].hidden ? 0 : this.calculateCircumference(i._parsed[t] * a / ot);
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", r = this.chart, o = r.chartArea, c = r.options.animation, d = (o.left + o.right) / 2, h = (o.top + o.bottom) / 2, u = a && c.animateScale, f = u ? 0 : this.innerRadius, g = u ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: p } = this._getSharedOptions(n, i);
    let b = this._getRotation(), y;
    for (y = 0; y < n; ++y)
      b += this._circumference(y, a);
    for (y = n; y < n + s; ++y) {
      const v = this._circumference(y, a), w = t[y], x = {
        x: d + this.offsetX,
        y: h + this.offsetY,
        startAngle: b,
        endAngle: b + v,
        circumference: v,
        outerRadius: g,
        innerRadius: f
      };
      p && (x.options = m || this.resolveDataElementOptions(y, w.active ? "active" : i)), b += v, this.updateElement(w, y, x, i);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let s = 0, i;
    for (i = 0; i < n.length; i++) {
      const a = t._parsed[i];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(i) && !n[i].hidden && (s += Math.abs(a));
    }
    return s;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? ot * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, s = this.chart, i = s.data.labels || [], a = ss(n._parsed[t], s.options.locale);
    return {
      label: i[t] || "",
      value: a
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const s = this.chart;
    let i, a, r, o, l;
    if (!t) {
      for (i = 0, a = s.data.datasets.length; i < a; ++i)
        if (s.isDatasetVisible(i)) {
          r = s.getDatasetMeta(i), t = r.data, o = r.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (i = 0, a = t.length; i < a; ++i)
      l = o.resolveDataElementOptions(i), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let s = 0, i = t.length; s < i; ++s) {
      const a = this.resolveDataElementOptions(s);
      n = Math.max(n, a.offset || 0, a.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let s = 0; s < t; ++s)
      this.chart.isDatasetVisible(s) && (n += this._getRingWeight(s));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(j(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
E(Be, "id", "doughnut"), E(Be, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), E(Be, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), E(Be, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: s, color: i } } = t.legend.options;
            return n.labels.map((a, r) => {
              const l = t.getDatasetMeta(0).controller.getStyle(r);
              return {
                text: a,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: i,
                lineWidth: l.borderWidth,
                pointStyle: s,
                hidden: !t.getDataVisibility(r),
                index: r
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, s) {
        s.chart.toggleDataVisibility(n.index), s.chart.update();
      }
    }
  }
});
class Ns extends Ht {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: s, data: i = [], _dataset: a } = n, r = this.chart._animationsDisabled;
    let { start: o, count: l } = Jc(n, i, r);
    this._drawStart = o, this._drawCount = l, Zc(n) && (o = 0, l = i.length), s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!a._decimated, s.points = i;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(s, void 0, {
      animated: !r,
      options: c
    }, t), this.updateElements(i, o, l, t);
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", { iScale: r, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: d, includeOptions: h } = this._getSharedOptions(n, i), u = r.axis, f = o.axis, { spanGaps: g, segment: m } = this.options, p = ke(g) ? g : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || a || i === "none", y = n + s, v = t.length;
    let w = n > 0 && this.getParsed(n - 1);
    for (let x = 0; x < v; ++x) {
      const C = t[x], O = b ? C : {};
      if (x < n || x >= y) {
        O.skip = !0;
        continue;
      }
      const M = this.getParsed(x), A = U(M[f]), $ = O[u] = r.getPixelForValue(M[u], x), D = O[f] = a || A ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, M, l) : M[f], x);
      O.skip = isNaN($) || isNaN(D) || A, O.stop = x > 0 && Math.abs(M[u] - w[u]) > p, m && (O.parsed = M, O.raw = c.data[x]), h && (O.options = d || this.resolveDataElementOptions(x, C.active ? "active" : i)), b || this.updateElement(C, x, O, i), w = M;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, s = n.options && n.options.borderWidth || 0, i = t.data || [];
    if (!i.length)
      return s;
    const a = i[0].size(this.resolveDataElementOptions(0)), r = i[i.length - 1].size(this.resolveDataElementOptions(i.length - 1));
    return Math.max(s, a, r) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
E(Ns, "id", "line"), E(Ns, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), E(Ns, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class jn extends Ht {
  constructor(t, n) {
    super(t, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, s = this.chart, i = s.data.labels || [], a = ss(n._parsed[t].r, s.options.locale);
    return {
      label: i[t] || "",
      value: a
    };
  }
  parseObjectData(t, n, s, i) {
    return od.bind(this)(t, n, s, i);
  }
  update(t) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, n = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((s, i) => {
      const a = this.getParsed(i).r;
      !isNaN(a) && this.chart.getDataVisibility(i) && (a < n.min && (n.min = a), a > n.max && (n.max = a));
    }), n;
  }
  _updateRadius() {
    const t = this.chart, n = t.chartArea, s = t.options, i = Math.min(n.right - n.left, n.bottom - n.top), a = Math.max(i / 2, 0), r = Math.max(s.cutoutPercentage ? a / 100 * s.cutoutPercentage : 1, 0), o = (a - r) / t.getVisibleDatasetCount();
    this.outerRadius = a - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", r = this.chart, l = r.options.animation, c = this._cachedMeta.rScale, d = c.xCenter, h = c.yCenter, u = c.getIndexAngle(0) - 0.5 * K;
    let f = u, g;
    const m = 360 / this.countVisibleElements();
    for (g = 0; g < n; ++g)
      f += this._computeAngle(g, i, m);
    for (g = n; g < n + s; g++) {
      const p = t[g];
      let b = f, y = f + this._computeAngle(g, i, m), v = r.getDataVisibility(g) ? c.getDistanceFromCenterForValue(this.getParsed(g).r) : 0;
      f = y, a && (l.animateScale && (v = 0), l.animateRotate && (b = y = u));
      const w = {
        x: d,
        y: h,
        innerRadius: 0,
        outerRadius: v,
        startAngle: b,
        endAngle: y,
        options: this.resolveDataElementOptions(g, p.active ? "active" : i)
      };
      this.updateElement(p, g, w, i);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let n = 0;
    return t.data.forEach((s, i) => {
      !isNaN(this.getParsed(i).r) && this.chart.getDataVisibility(i) && n++;
    }), n;
  }
  _computeAngle(t, n, s) {
    return this.chart.getDataVisibility(t) ? St(this.resolveDataElementOptions(t, n).angle || s) : 0;
  }
}
E(jn, "id", "polarArea"), E(jn, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), E(jn, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: s, color: i } } = t.legend.options;
            return n.labels.map((a, r) => {
              const l = t.getDatasetMeta(0).controller.getStyle(r);
              return {
                text: a,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: i,
                lineWidth: l.borderWidth,
                pointStyle: s,
                hidden: !t.getDataVisibility(r),
                index: r
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, s) {
        s.chart.toggleDataVisibility(n.index), s.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class oa extends Be {
}
E(oa, "id", "pie"), E(oa, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class zs extends Ht {
  getLabelAndValue(t) {
    const n = this._cachedMeta.vScale, s = this.getParsed(t);
    return {
      label: n.getLabels()[t],
      value: "" + n.getLabelForValue(s[n.axis])
    };
  }
  parseObjectData(t, n, s, i) {
    return od.bind(this)(t, n, s, i);
  }
  update(t) {
    const n = this._cachedMeta, s = n.dataset, i = n.data || [], a = n.iScale.getLabels();
    if (s.points = i, t !== "resize") {
      const r = this.resolveDatasetElementOptions(t);
      this.options.showLine || (r.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: a.length === i.length,
        options: r
      };
      this.updateElement(s, void 0, o, t);
    }
    this.updateElements(i, 0, i.length, t);
  }
  updateElements(t, n, s, i) {
    const a = this._cachedMeta.rScale, r = i === "reset";
    for (let o = n; o < n + s; o++) {
      const l = t[o], c = this.resolveDataElementOptions(o, l.active ? "active" : i), d = a.getPointPositionForValue(o, this.getParsed(o).r), h = r ? a.xCenter : d.x, u = r ? a.yCenter : d.y, f = {
        x: h,
        y: u,
        angle: d.angle,
        skip: isNaN(h) || isNaN(u),
        options: c
      };
      this.updateElement(l, o, f, i);
    }
  }
}
E(zs, "id", "radar"), E(zs, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), E(zs, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class js extends Ht {
  getLabelAndValue(t) {
    const n = this._cachedMeta, s = this.chart.data.labels || [], { xScale: i, yScale: a } = n, r = this.getParsed(t), o = i.getLabelForValue(r.x), l = a.getLabelForValue(r.y);
    return {
      label: s[t] || "",
      value: "(" + o + ", " + l + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta, { data: s = [] } = n, i = this.chart._animationsDisabled;
    let { start: a, count: r } = Jc(n, s, i);
    if (this._drawStart = a, this._drawCount = r, Zc(n) && (a = 0, r = s.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: o, _dataset: l } = n;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = s;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !i,
        options: c
      }, t);
    } else
      this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(s, a, r, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", { iScale: r, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, d = this.resolveDataElementOptions(n, i), h = this.getSharedOptions(d), u = this.includeOptions(i, h), f = r.axis, g = o.axis, { spanGaps: m, segment: p } = this.options, b = ke(m) ? m : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || a || i === "none";
    let v = n > 0 && this.getParsed(n - 1);
    for (let w = n; w < n + s; ++w) {
      const x = t[w], C = this.getParsed(w), O = y ? x : {}, M = U(C[g]), A = O[f] = r.getPixelForValue(C[f], w), $ = O[g] = a || M ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, C, l) : C[g], w);
      O.skip = isNaN(A) || isNaN($) || M, O.stop = w > 0 && Math.abs(C[f] - v[f]) > b, p && (O.parsed = C, O.raw = c.data[w]), u && (O.options = h || this.resolveDataElementOptions(w, x.active ? "active" : i)), y || this.updateElement(x, w, O, i), v = C;
    }
    this.updateSharedOptions(h, i, d);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = n.length - 1; l >= 0; --l)
        o = Math.max(o, n[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const s = t.dataset, i = s.options && s.options.borderWidth || 0;
    if (!n.length)
      return i;
    const a = n[0].size(this.resolveDataElementOptions(0)), r = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(i, a, r) / 2;
  }
}
E(js, "id", "scatter"), E(js, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), E(js, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var rb = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Fs,
  BubbleController: Ws,
  DoughnutController: Be,
  LineController: Ns,
  PieController: oa,
  PolarAreaController: jn,
  RadarController: zs,
  ScatterController: js
});
function Ae() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Ka {
  constructor(t) {
    E(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Ka.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Ae();
  }
  parse() {
    return Ae();
  }
  format() {
    return Ae();
  }
  add() {
    return Ae();
  }
  diff() {
    return Ae();
  }
  startOf() {
    return Ae();
  }
  endOf() {
    return Ae();
  }
}
var md = {
  _date: Ka
};
function ob(e, t, n, s) {
  const { controller: i, data: a, _sorted: r } = e, o = i._cachedMeta.iScale;
  if (o && t === o.axis && t !== "r" && r && a.length) {
    const l = o._reversePixels ? $p : re;
    if (s) {
      if (i._sharedOptions) {
        const c = a[0], d = typeof c.getRange == "function" && c.getRange(t);
        if (d) {
          const h = l(a, t, n - d), u = l(a, t, n + d);
          return {
            lo: h.lo,
            hi: u.hi
          };
        }
      }
    } else
      return l(a, t, n);
  }
  return {
    lo: 0,
    hi: a.length - 1
  };
}
function rs(e, t, n, s, i) {
  const a = e.getSortedVisibleDatasetMetas(), r = n[t];
  for (let o = 0, l = a.length; o < l; ++o) {
    const { index: c, data: d } = a[o], { lo: h, hi: u } = ob(a[o], t, r, i);
    for (let f = h; f <= u; ++f) {
      const g = d[f];
      g.skip || s(g, c, f);
    }
  }
}
function lb(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(s, i) {
    const a = t ? Math.abs(s.x - i.x) : 0, r = n ? Math.abs(s.y - i.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(r, 2));
  };
}
function Fi(e, t, n, s, i) {
  const a = [];
  return !i && !e.isPointInArea(t) || rs(e, n, t, function(o, l, c) {
    !i && !oe(o, e.chartArea, 0) || o.inRange(t.x, t.y, s) && a.push({
      element: o,
      datasetIndex: l,
      index: c
    });
  }, !0), a;
}
function cb(e, t, n, s) {
  let i = [];
  function a(r, o, l) {
    const { startAngle: c, endAngle: d } = r.getProps([
      "startAngle",
      "endAngle"
    ], s), { angle: h } = Uc(r, {
      x: t.x,
      y: t.y
    });
    Qn(h, c, d) && i.push({
      element: r,
      datasetIndex: o,
      index: l
    });
  }
  return rs(e, n, t, a), i;
}
function db(e, t, n, s, i, a) {
  let r = [];
  const o = lb(n);
  let l = Number.POSITIVE_INFINITY;
  function c(d, h, u) {
    const f = d.inRange(t.x, t.y, i);
    if (s && !f)
      return;
    const g = d.getCenterPoint(i);
    if (!(!!a || e.isPointInArea(g)) && !f)
      return;
    const p = o(t, g);
    p < l ? (r = [
      {
        element: d,
        datasetIndex: h,
        index: u
      }
    ], l = p) : p === l && r.push({
      element: d,
      datasetIndex: h,
      index: u
    });
  }
  return rs(e, n, t, c), r;
}
function Wi(e, t, n, s, i, a) {
  return !a && !e.isPointInArea(t) ? [] : n === "r" && !s ? cb(e, t, n, i) : db(e, t, n, s, i, a);
}
function mo(e, t, n, s, i) {
  const a = [], r = n === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return rs(e, n, t, (l, c, d) => {
    l[r](t[n], i) && (a.push({
      element: l,
      datasetIndex: c,
      index: d
    }), o = o || l.inRange(t.x, t.y, i));
  }), s && !o ? [] : a;
}
var hb = {
  evaluateInteractionItems: rs,
  modes: {
    index(e, t, n, s) {
      const i = Le(t, e), a = n.axis || "x", r = n.includeInvisible || !1, o = n.intersect ? Fi(e, i, a, s, r) : Wi(e, i, a, !1, s, r), l = [];
      return o.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const d = o[0].index, h = c.data[d];
        h && !h.skip && l.push({
          element: h,
          datasetIndex: c.index,
          index: d
        });
      }), l) : [];
    },
    dataset(e, t, n, s) {
      const i = Le(t, e), a = n.axis || "xy", r = n.includeInvisible || !1;
      let o = n.intersect ? Fi(e, i, a, s, r) : Wi(e, i, a, !1, s, r);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = e.getDatasetMeta(l).data;
        o = [];
        for (let d = 0; d < c.length; ++d)
          o.push({
            element: c[d],
            datasetIndex: l,
            index: d
          });
      }
      return o;
    },
    point(e, t, n, s) {
      const i = Le(t, e), a = n.axis || "xy", r = n.includeInvisible || !1;
      return Fi(e, i, a, s, r);
    },
    nearest(e, t, n, s) {
      const i = Le(t, e), a = n.axis || "xy", r = n.includeInvisible || !1;
      return Wi(e, i, a, n.intersect, s, r);
    },
    x(e, t, n, s) {
      const i = Le(t, e);
      return mo(e, i, "x", n.intersect, s);
    },
    y(e, t, n, s) {
      const i = Le(t, e);
      return mo(e, i, "y", n.intersect, s);
    }
  }
};
const bd = [
  "left",
  "top",
  "right",
  "bottom"
];
function Cn(e, t) {
  return e.filter((n) => n.pos === t);
}
function bo(e, t) {
  return e.filter((n) => bd.indexOf(n.pos) === -1 && n.box.axis === t);
}
function Sn(e, t) {
  return e.sort((n, s) => {
    const i = t ? s : n, a = t ? n : s;
    return i.weight === a.weight ? i.index - a.index : i.weight - a.weight;
  });
}
function ub(e) {
  const t = [];
  let n, s, i, a, r, o;
  for (n = 0, s = (e || []).length; n < s; ++n)
    i = e[n], { position: a, options: { stack: r, stackWeight: o = 1 } } = i, t.push({
      index: n,
      box: i,
      pos: a,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: r && a + r,
      stackWeight: o
    });
  return t;
}
function fb(e) {
  const t = {};
  for (const n of e) {
    const { stack: s, pos: i, stackWeight: a } = n;
    if (!s || !bd.includes(i))
      continue;
    const r = t[s] || (t[s] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    r.count++, r.weight += a;
  }
  return t;
}
function gb(e, t) {
  const n = fb(e), { vBoxMaxWidth: s, hBoxMaxHeight: i } = t;
  let a, r, o;
  for (a = 0, r = e.length; a < r; ++a) {
    o = e[a];
    const { fullSize: l } = o.box, c = n[o.stack], d = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = d ? d * s : l && t.availableWidth, o.height = i) : (o.width = s, o.height = d ? d * i : l && t.availableHeight);
  }
  return n;
}
function pb(e) {
  const t = ub(e), n = Sn(t.filter((c) => c.box.fullSize), !0), s = Sn(Cn(t, "left"), !0), i = Sn(Cn(t, "right")), a = Sn(Cn(t, "top"), !0), r = Sn(Cn(t, "bottom")), o = bo(t, "x"), l = bo(t, "y");
  return {
    fullSize: n,
    leftAndTop: s.concat(a),
    rightAndBottom: i.concat(l).concat(r).concat(o),
    chartArea: Cn(t, "chartArea"),
    vertical: s.concat(i).concat(l),
    horizontal: a.concat(r).concat(o)
  };
}
function yo(e, t, n, s) {
  return Math.max(e[n], t[n]) + Math.max(e[s], t[s]);
}
function yd(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function mb(e, t, n, s) {
  const { pos: i, box: a } = n, r = e.maxPadding;
  if (!H(i)) {
    n.size && (e[i] -= n.size);
    const h = s[n.stack] || {
      size: 0,
      count: 1
    };
    h.size = Math.max(h.size, n.horizontal ? a.height : a.width), n.size = h.size / h.count, e[i] += n.size;
  }
  a.getPadding && yd(r, a.getPadding());
  const o = Math.max(0, t.outerWidth - yo(r, e, "left", "right")), l = Math.max(0, t.outerHeight - yo(r, e, "top", "bottom")), c = o !== e.w, d = l !== e.h;
  return e.w = o, e.h = l, n.horizontal ? {
    same: c,
    other: d
  } : {
    same: d,
    other: c
  };
}
function bb(e) {
  const t = e.maxPadding;
  function n(s) {
    const i = Math.max(t[s] - e[s], 0);
    return e[s] += i, i;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function yb(e, t) {
  const n = t.maxPadding;
  function s(i) {
    const a = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return i.forEach((r) => {
      a[r] = Math.max(t[r], n[r]);
    }), a;
  }
  return s(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Ln(e, t, n, s) {
  const i = [];
  let a, r, o, l, c, d;
  for (a = 0, r = e.length, c = 0; a < r; ++a) {
    o = e[a], l = o.box, l.update(o.width || t.w, o.height || t.h, yb(o.horizontal, t));
    const { same: h, other: u } = mb(t, n, o, s);
    c |= h && i.length, d = d || u, l.fullSize || i.push(o);
  }
  return c && Ln(i, t, n, s) || d;
}
function vs(e, t, n, s, i) {
  e.top = n, e.left = t, e.right = t + s, e.bottom = n + i, e.width = s, e.height = i;
}
function _o(e, t, n, s) {
  const i = n.padding;
  let { x: a, y: r } = t;
  for (const o of e) {
    const l = o.box, c = s[o.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, d = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const h = t.w * d, u = c.size || l.height;
      Et(c.start) && (r = c.start), l.fullSize ? vs(l, i.left, r, n.outerWidth - i.right - i.left, u) : vs(l, t.left + c.placed, r, h, u), c.start = r, c.placed += h, r = l.bottom;
    } else {
      const h = t.h * d, u = c.size || l.width;
      Et(c.start) && (a = c.start), l.fullSize ? vs(l, a, i.top, u, n.outerHeight - i.bottom - i.top) : vs(l, a, t.top + c.placed, u, h), c.start = a, c.placed += h, a = l.right;
    }
  }
  t.x = a, t.y = r;
}
var Pt = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, s) {
    if (!e)
      return;
    const i = kt(e.options.layout.padding), a = Math.max(t - i.width, 0), r = Math.max(n - i.height, 0), o = pb(e.boxes), l = o.vertical, c = o.horizontal;
    nt(e.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const d = l.reduce((m, p) => p.box.options && p.box.options.display === !1 ? m : m + 1, 0) || 1, h = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: i,
      availableWidth: a,
      availableHeight: r,
      vBoxMaxWidth: a / 2 / d,
      hBoxMaxHeight: r / 2
    }), u = Object.assign({}, i);
    yd(u, kt(s));
    const f = Object.assign({
      maxPadding: u,
      w: a,
      h: r,
      x: i.left,
      y: i.top
    }, i), g = gb(l.concat(c), h);
    Ln(o.fullSize, f, h, g), Ln(l, f, h, g), Ln(c, f, h, g) && Ln(l, f, h, g), bb(f), _o(o.leftAndTop, f, h, g), f.x += f.w, f.y += f.h, _o(o.rightAndBottom, f, h, g), e.chartArea = {
      left: f.left,
      top: f.top,
      right: f.left + f.w,
      bottom: f.top + f.h,
      height: f.h,
      width: f.w
    }, nt(o.chartArea, (m) => {
      const p = m.box;
      Object.assign(p, e.chartArea), p.update(f.w, f.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class _d {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, s) {
  }
  removeEventListener(t, n, s) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, s, i) {
    return n = Math.max(0, n || t.width), s = s || t.height, {
      width: n,
      height: Math.max(0, i ? Math.floor(n / i) : s)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class _b extends _d {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Hs = "$chartjs", vb = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, vo = (e) => e === null || e === "";
function xb(e, t) {
  const n = e.style, s = e.getAttribute("height"), i = e.getAttribute("width");
  if (e[Hs] = {
    initial: {
      height: s,
      width: i,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", vo(i)) {
    const a = eo(e, "width");
    a !== void 0 && (e.width = a);
  }
  if (vo(s))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const a = eo(e, "height");
      a !== void 0 && (e.height = a);
    }
  return e;
}
const vd = Cm ? {
  passive: !0
} : !1;
function wb(e, t, n) {
  e && e.addEventListener(t, n, vd);
}
function kb(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, vd);
}
function Cb(e, t) {
  const n = vb[e.type] || e.type, { x: s, y: i } = Le(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: s !== void 0 ? s : null,
    y: i !== void 0 ? i : null
  };
}
function ni(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function Sb(e, t, n) {
  const s = e.canvas, i = new MutationObserver((a) => {
    let r = !1;
    for (const o of a)
      r = r || ni(o.addedNodes, s), r = r && !ni(o.removedNodes, s);
    r && n();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
function Mb(e, t, n) {
  const s = e.canvas, i = new MutationObserver((a) => {
    let r = !1;
    for (const o of a)
      r = r || ni(o.removedNodes, s), r = r && !ni(o.addedNodes, s);
    r && n();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
const Jn = /* @__PURE__ */ new Map();
let xo = 0;
function xd() {
  const e = window.devicePixelRatio;
  e !== xo && (xo = e, Jn.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function Ob(e, t) {
  Jn.size || window.addEventListener("resize", xd), Jn.set(e, t);
}
function Tb(e) {
  Jn.delete(e), Jn.size || window.removeEventListener("resize", xd);
}
function Pb(e, t, n) {
  const s = e.canvas, i = s && Xa(s);
  if (!i)
    return;
  const a = Qc((o, l) => {
    const c = i.clientWidth;
    n(o, l), c < i.clientWidth && n();
  }, window), r = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, d = l.contentRect.height;
    c === 0 && d === 0 || a(c, d);
  });
  return r.observe(i), Ob(e, a), r;
}
function Ni(e, t, n) {
  n && n.disconnect(), t === "resize" && Tb(e);
}
function Ab(e, t, n) {
  const s = e.canvas, i = Qc((a) => {
    e.ctx !== null && n(Cb(a, e));
  }, e);
  return wb(s, t, i), i;
}
class $b extends _d {
  acquireContext(t, n) {
    const s = t && t.getContext && t.getContext("2d");
    return s && s.canvas === t ? (xb(t, n), s) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[Hs])
      return !1;
    const s = n[Hs].initial;
    [
      "height",
      "width"
    ].forEach((a) => {
      const r = s[a];
      U(r) ? n.removeAttribute(a) : n.setAttribute(a, r);
    });
    const i = s.style || {};
    return Object.keys(i).forEach((a) => {
      n.style[a] = i[a];
    }), n.width = n.width, delete n[Hs], !0;
  }
  addEventListener(t, n, s) {
    this.removeEventListener(t, n);
    const i = t.$proxies || (t.$proxies = {}), r = {
      attach: Sb,
      detach: Mb,
      resize: Pb
    }[n] || Ab;
    i[n] = r(t, n, s);
  }
  removeEventListener(t, n) {
    const s = t.$proxies || (t.$proxies = {}), i = s[n];
    if (!i)
      return;
    ({
      attach: Ni,
      detach: Ni,
      resize: Ni
    }[n] || kb)(t, n, i), s[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, s, i) {
    return km(t, n, s, i);
  }
  isAttached(t) {
    const n = Xa(t);
    return !!(n && n.isConnected);
  }
}
function Db(e) {
  return !Ua() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? _b : $b;
}
class Ot {
  constructor() {
    E(this, "x");
    E(this, "y");
    E(this, "active", !1);
    E(this, "options");
    E(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: s } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: s
    };
  }
  hasValue() {
    return ke(this.x) && ke(this.y);
  }
  getProps(t, n) {
    const s = this.$animations;
    if (!n || !s)
      return this;
    const i = {};
    return t.forEach((a) => {
      i[a] = s[a] && s[a].active() ? s[a]._to : this[a];
    }), i;
  }
}
E(Ot, "defaults", {}), E(Ot, "defaultRoutes");
function Lb(e, t) {
  const n = e.options.ticks, s = Eb(e), i = Math.min(n.maxTicksLimit || s, s), a = n.major.enabled ? Rb(t) : [], r = a.length, o = a[0], l = a[r - 1], c = [];
  if (r > i)
    return Bb(t, c, a, r / i), c;
  const d = Ib(a, t, i);
  if (r > 0) {
    let h, u;
    const f = r > 1 ? Math.round((l - o) / (r - 1)) : null;
    for (xs(t, c, d, U(f) ? 0 : o - f, o), h = 0, u = r - 1; h < u; h++)
      xs(t, c, d, a[h], a[h + 1]);
    return xs(t, c, d, l, U(f) ? t.length : l + f), c;
  }
  return xs(t, c, d), c;
}
function Eb(e) {
  const t = e.options.offset, n = e._tickSize(), s = e._length / n + (t ? 0 : 1), i = e._maxLength / n;
  return Math.floor(Math.min(s, i));
}
function Ib(e, t, n) {
  const s = Fb(e), i = t.length / n;
  if (!s)
    return Math.max(i, 1);
  const a = Op(s);
  for (let r = 0, o = a.length - 1; r < o; r++) {
    const l = a[r];
    if (l > i)
      return l;
  }
  return Math.max(i, 1);
}
function Rb(e) {
  const t = [];
  let n, s;
  for (n = 0, s = e.length; n < s; n++)
    e[n].major && t.push(n);
  return t;
}
function Bb(e, t, n, s) {
  let i = 0, a = n[0], r;
  for (s = Math.ceil(s), r = 0; r < e.length; r++)
    r === a && (t.push(e[r]), i++, a = n[i * s]);
}
function xs(e, t, n, s, i) {
  const a = j(s, 0), r = Math.min(j(i, e.length), e.length);
  let o = 0, l, c, d;
  for (n = Math.ceil(n), i && (l = i - s, n = l / Math.floor(l / n)), d = a; d < 0; )
    o++, d = Math.round(a + o * n);
  for (c = Math.max(a, 0); c < r; c++)
    c === d && (t.push(e[c]), o++, d = Math.round(a + o * n));
}
function Fb(e) {
  const t = e.length;
  let n, s;
  if (t < 2)
    return !1;
  for (s = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== s)
      return !1;
  return s;
}
const Wb = (e) => e === "left" ? "right" : e === "right" ? "left" : e, wo = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, ko = (e, t) => Math.min(t || e, e);
function Co(e, t) {
  const n = [], s = e.length / t, i = e.length;
  let a = 0;
  for (; a < i; a += s)
    n.push(e[Math.floor(a)]);
  return n;
}
function Nb(e, t, n) {
  const s = e.ticks.length, i = Math.min(t, s - 1), a = e._startPixel, r = e._endPixel, o = 1e-6;
  let l = e.getPixelForTick(i), c;
  if (!(n && (s === 1 ? c = Math.max(l - a, r - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(i - 1)) / 2, l += i < t ? c : -c, l < a - o || l > r + o)))
    return l;
}
function zb(e, t) {
  nt(e, (n) => {
    const s = n.gc, i = s.length / 2;
    let a;
    if (i > t) {
      for (a = 0; a < i; ++a)
        delete n.data[s[a]];
      s.splice(0, i);
    }
  });
}
function Mn(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function So(e, t) {
  if (!e.display)
    return 0;
  const n = bt(e.font, t), s = kt(e.padding);
  return (tt(e.text) ? e.text.length : 1) * n.lineHeight + s.height;
}
function jb(e, t) {
  return Me(e, {
    scale: t,
    type: "scale"
  });
}
function Hb(e, t, n) {
  return Me(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function Vb(e, t, n) {
  let s = za(e);
  return (n && t !== "right" || !n && t === "right") && (s = Wb(s)), s;
}
function Yb(e, t, n, s) {
  const { top: i, left: a, bottom: r, right: o, chart: l } = e, { chartArea: c, scales: d } = l;
  let h = 0, u, f, g;
  const m = r - i, p = o - a;
  if (e.isHorizontal()) {
    if (f = Tt(s, a, o), H(n)) {
      const b = Object.keys(n)[0], y = n[b];
      g = d[b].getPixelForValue(y) + m - t;
    } else
      n === "center" ? g = (c.bottom + c.top) / 2 + m - t : g = wo(e, n, t);
    u = o - a;
  } else {
    if (H(n)) {
      const b = Object.keys(n)[0], y = n[b];
      f = d[b].getPixelForValue(y) - p + t;
    } else
      n === "center" ? f = (c.left + c.right) / 2 - p + t : f = wo(e, n, t);
    g = Tt(s, r, i), h = n === "left" ? -ht : ht;
  }
  return {
    titleX: f,
    titleY: g,
    maxWidth: u,
    rotation: h
  };
}
class Ge extends Ot {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: s, _suggestedMax: i } = this;
    return t = It(t, Number.POSITIVE_INFINITY), n = It(n, Number.NEGATIVE_INFINITY), s = It(s, Number.POSITIVE_INFINITY), i = It(i, Number.NEGATIVE_INFINITY), {
      min: It(t, s),
      max: It(n, i),
      minDefined: pt(t),
      maxDefined: pt(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: s, minDefined: i, maxDefined: a } = this.getUserBounds(), r;
    if (i && a)
      return {
        min: n,
        max: s
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      r = o[l].controller.getMinMax(this, t), i || (n = Math.min(n, r.min)), a || (s = Math.max(s, r.max));
    return n = a && n > s ? s : n, s = i && n > s ? n : s, {
      min: It(n, It(s, n)),
      max: It(s, It(n, s))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    et(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, s) {
    const { beginAtZero: i, grace: a, ticks: r } = this.options, o = r.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = s = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, s), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + s.left + s.right : this.height + s.top + s.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = em(this, a, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? Co(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), r.display && (r.autoSkip || r.source === "auto") && (this.ticks = Lb(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, s;
    this.isHorizontal() ? (n = this.left, s = this.right) : (n = this.top, s = this.bottom, t = !t), this._startPixel = n, this._endPixel = s, this._reversePixels = t, this._length = s - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    et(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    et(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    et(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), et(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    et(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let s, i, a;
    for (s = 0, i = t.length; s < i; s++)
      a = t[s], a.label = et(n.callback, [
        a.value,
        s,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    et(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    et(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, s = ko(this.ticks.length, t.ticks.maxTicksLimit), i = n.minRotation || 0, a = n.maxRotation;
    let r = i, o, l, c;
    if (!this._isVisible() || !n.display || i >= a || s <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const d = this._getLabelSizes(), h = d.widest.width, u = d.highest.height, f = Mt(this.chart.width - h, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / s : f / (s - 1), h + 6 > o && (o = f / (s - (t.offset ? 0.5 : 1)), l = this.maxHeight - Mn(t.grid) - n.padding - So(t.title, this.chart.options.font), c = Math.sqrt(h * h + u * u), r = gi(Math.min(Math.asin(Mt((d.highest.height + 6) / o, -1, 1)), Math.asin(Mt(l / c, -1, 1)) - Math.asin(Mt(u / c, -1, 1)))), r = Math.max(i, Math.min(a, r))), this.labelRotation = r;
  }
  afterCalculateLabelRotation() {
    et(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    et(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: s, title: i, grid: a } } = this, r = this._isVisible(), o = this.isHorizontal();
    if (r) {
      const l = So(i, n.options.font);
      if (o ? (t.width = this.maxWidth, t.height = Mn(a) + l) : (t.height = this.maxHeight, t.width = Mn(a) + l), s.display && this.ticks.length) {
        const { first: c, last: d, widest: h, highest: u } = this._getLabelSizes(), f = s.padding * 2, g = St(this.labelRotation), m = Math.cos(g), p = Math.sin(g);
        if (o) {
          const b = s.mirror ? 0 : p * h.width + m * u.height;
          t.height = Math.min(this.maxHeight, t.height + b + f);
        } else {
          const b = s.mirror ? 0 : m * h.width + p * u.height;
          t.width = Math.min(this.maxWidth, t.width + b + f);
        }
        this._calculatePadding(c, d, p, m);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, s, i) {
    const { ticks: { align: a, padding: r }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, h = this.right - this.getPixelForTick(this.ticks.length - 1);
      let u = 0, f = 0;
      l ? c ? (u = i * t.width, f = s * n.height) : (u = s * t.height, f = i * n.width) : a === "start" ? f = n.width : a === "end" ? u = t.width : a !== "inner" && (u = t.width / 2, f = n.width / 2), this.paddingLeft = Math.max((u - d + r) * this.width / (this.width - d), 0), this.paddingRight = Math.max((f - h + r) * this.width / (this.width - h), 0);
    } else {
      let d = n.height / 2, h = t.height / 2;
      a === "start" ? (d = 0, h = t.height) : a === "end" && (d = n.height, h = 0), this.paddingTop = d + r, this.paddingBottom = h + r;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    et(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, s;
    for (n = 0, s = t.length; n < s; n++)
      U(t[n].label) && (t.splice(n, 1), s--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let s = this.ticks;
      n < s.length && (s = Co(s, n)), this._labelSizes = t = this._computeLabelSizes(s, s.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, s) {
    const { ctx: i, _longestTextCache: a } = this, r = [], o = [], l = Math.floor(n / ko(n, s));
    let c = 0, d = 0, h, u, f, g, m, p, b, y, v, w, x;
    for (h = 0; h < n; h += l) {
      if (g = t[h].label, m = this._resolveTickFontOptions(h), i.font = p = m.string, b = a[p] = a[p] || {
        data: {},
        gc: []
      }, y = m.lineHeight, v = w = 0, !U(g) && !tt(g))
        v = ti(i, b.data, b.gc, v, g), w = y;
      else if (tt(g))
        for (u = 0, f = g.length; u < f; ++u)
          x = g[u], !U(x) && !tt(x) && (v = ti(i, b.data, b.gc, v, x), w += y);
      r.push(v), o.push(w), c = Math.max(v, c), d = Math.max(w, d);
    }
    zb(a, n);
    const C = r.indexOf(c), O = o.indexOf(d), M = (A) => ({
      width: r[A] || 0,
      height: o[A] || 0
    });
    return {
      first: M(0),
      last: M(n - 1),
      widest: M(C),
      highest: M(O),
      widths: r,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return Ap(this._alignToPixels ? Pe(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const s = n[t];
      return s.$context || (s.$context = Hb(this.getContext(), t, s));
    }
    return this.$context || (this.$context = jb(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = St(this.labelRotation), s = Math.abs(Math.cos(n)), i = Math.abs(Math.sin(n)), a = this._getLabelSizes(), r = t.autoSkipPadding || 0, o = a ? a.widest.width + r : 0, l = a ? a.highest.height + r : 0;
    return this.isHorizontal() ? l * s > o * i ? o / s : l / i : l * i < o * s ? l / s : o / i;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, s = this.chart, i = this.options, { grid: a, position: r, border: o } = i, l = a.offset, c = this.isHorizontal(), h = this.ticks.length + (l ? 1 : 0), u = Mn(a), f = [], g = o.setContext(this.getContext()), m = g.display ? g.width : 0, p = m / 2, b = function(q) {
      return Pe(s, q, m);
    };
    let y, v, w, x, C, O, M, A, $, D, F, z;
    if (r === "top")
      y = b(this.bottom), O = this.bottom - u, A = y - p, D = b(t.top) + p, z = t.bottom;
    else if (r === "bottom")
      y = b(this.top), D = t.top, z = b(t.bottom) - p, O = y + p, A = this.top + u;
    else if (r === "left")
      y = b(this.right), C = this.right - u, M = y - p, $ = b(t.left) + p, F = t.right;
    else if (r === "right")
      y = b(this.left), $ = t.left, F = b(t.right) - p, C = y + p, M = this.left + u;
    else if (n === "x") {
      if (r === "center")
        y = b((t.top + t.bottom) / 2 + 0.5);
      else if (H(r)) {
        const q = Object.keys(r)[0], Z = r[q];
        y = b(this.chart.scales[q].getPixelForValue(Z));
      }
      D = t.top, z = t.bottom, O = y + p, A = O + u;
    } else if (n === "y") {
      if (r === "center")
        y = b((t.left + t.right) / 2);
      else if (H(r)) {
        const q = Object.keys(r)[0], Z = r[q];
        y = b(this.chart.scales[q].getPixelForValue(Z));
      }
      C = y - p, M = C - u, $ = t.left, F = t.right;
    }
    const Q = j(i.ticks.maxTicksLimit, h), G = Math.max(1, Math.ceil(h / Q));
    for (v = 0; v < h; v += G) {
      const q = this.getContext(v), Z = a.setContext(q), wt = o.setContext(q), Ct = Z.lineWidth, de = Z.color, Ke = wt.dash || [], he = wt.dashOffset, Oe = Z.tickWidth, Jt = Z.tickColor, Te = Z.tickBorderDash || [], Zt = Z.tickBorderDashOffset;
      w = Nb(this, v, l), w !== void 0 && (x = Pe(s, w, Ct), c ? C = M = $ = F = x : O = A = D = z = x, f.push({
        tx1: C,
        ty1: O,
        tx2: M,
        ty2: A,
        x1: $,
        y1: D,
        x2: F,
        y2: z,
        width: Ct,
        color: de,
        borderDash: Ke,
        borderDashOffset: he,
        tickWidth: Oe,
        tickColor: Jt,
        tickBorderDash: Te,
        tickBorderDashOffset: Zt
      }));
    }
    return this._ticksLength = h, this._borderValue = y, f;
  }
  _computeLabelItems(t) {
    const n = this.axis, s = this.options, { position: i, ticks: a } = s, r = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: d, mirror: h } = a, u = Mn(s.grid), f = u + d, g = h ? -d : f, m = -St(this.labelRotation), p = [];
    let b, y, v, w, x, C, O, M, A, $, D, F, z = "middle";
    if (i === "top")
      C = this.bottom - g, O = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      C = this.top + g, O = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const G = this._getYAxisLabelAlignment(u);
      O = G.textAlign, x = G.x;
    } else if (i === "right") {
      const G = this._getYAxisLabelAlignment(u);
      O = G.textAlign, x = G.x;
    } else if (n === "x") {
      if (i === "center")
        C = (t.top + t.bottom) / 2 + f;
      else if (H(i)) {
        const G = Object.keys(i)[0], q = i[G];
        C = this.chart.scales[G].getPixelForValue(q) + f;
      }
      O = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (i === "center")
        x = (t.left + t.right) / 2 - f;
      else if (H(i)) {
        const G = Object.keys(i)[0], q = i[G];
        x = this.chart.scales[G].getPixelForValue(q);
      }
      O = this._getYAxisLabelAlignment(u).textAlign;
    }
    n === "y" && (l === "start" ? z = "top" : l === "end" && (z = "bottom"));
    const Q = this._getLabelSizes();
    for (b = 0, y = o.length; b < y; ++b) {
      v = o[b], w = v.label;
      const G = a.setContext(this.getContext(b));
      M = this.getPixelForTick(b) + a.labelOffset, A = this._resolveTickFontOptions(b), $ = A.lineHeight, D = tt(w) ? w.length : 1;
      const q = D / 2, Z = G.color, wt = G.textStrokeColor, Ct = G.textStrokeWidth;
      let de = O;
      r ? (x = M, O === "inner" && (b === y - 1 ? de = this.options.reverse ? "left" : "right" : b === 0 ? de = this.options.reverse ? "right" : "left" : de = "center"), i === "top" ? c === "near" || m !== 0 ? F = -D * $ + $ / 2 : c === "center" ? F = -Q.highest.height / 2 - q * $ + $ : F = -Q.highest.height + $ / 2 : c === "near" || m !== 0 ? F = $ / 2 : c === "center" ? F = Q.highest.height / 2 - q * $ : F = Q.highest.height - D * $, h && (F *= -1), m !== 0 && !G.showLabelBackdrop && (x += $ / 2 * Math.sin(m))) : (C = M, F = (1 - D) * $ / 2);
      let Ke;
      if (G.showLabelBackdrop) {
        const he = kt(G.backdropPadding), Oe = Q.heights[b], Jt = Q.widths[b];
        let Te = F - he.top, Zt = 0 - he.left;
        switch (z) {
          case "middle":
            Te -= Oe / 2;
            break;
          case "bottom":
            Te -= Oe;
            break;
        }
        switch (O) {
          case "center":
            Zt -= Jt / 2;
            break;
          case "right":
            Zt -= Jt;
            break;
          case "inner":
            b === y - 1 ? Zt -= Jt : b > 0 && (Zt -= Jt / 2);
            break;
        }
        Ke = {
          left: Zt,
          top: Te,
          width: Jt + he.width,
          height: Oe + he.height,
          color: G.backdropColor
        };
      }
      p.push({
        label: w,
        font: A,
        textOffset: F,
        options: {
          rotation: m,
          color: Z,
          strokeColor: wt,
          strokeWidth: Ct,
          textAlign: de,
          textBaseline: z,
          translation: [
            x,
            C
          ],
          backdrop: Ke
        }
      });
    }
    return p;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-St(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return n.align === "start" ? i = "left" : n.align === "end" ? i = "right" : n.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: s, mirror: i, padding: a } } = this.options, r = this._getLabelSizes(), o = t + a, l = r.widest.width;
    let c, d;
    return n === "left" ? i ? (d = this.right + a, s === "near" ? c = "left" : s === "center" ? (c = "center", d += l / 2) : (c = "right", d += l)) : (d = this.right - o, s === "near" ? c = "right" : s === "center" ? (c = "center", d -= l / 2) : (c = "left", d = this.left)) : n === "right" ? i ? (d = this.left + a, s === "near" ? c = "right" : s === "center" ? (c = "center", d -= l / 2) : (c = "left", d -= l)) : (d = this.left + o, s === "near" ? c = "left" : s === "center" ? (c = "center", d += l / 2) : (c = "right", d = this.right)) : c = "right", {
      textAlign: c,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: s, top: i, width: a, height: r } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(s, i, a, r), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const i = this.ticks.findIndex((a) => a.value === t);
    return i >= 0 ? n.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, s = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, r;
    const o = (l, c, d) => {
      !d.width || !d.color || (s.save(), s.lineWidth = d.width, s.strokeStyle = d.color, s.setLineDash(d.borderDash || []), s.lineDashOffset = d.borderDashOffset, s.beginPath(), s.moveTo(l.x, l.y), s.lineTo(c.x, c.y), s.stroke(), s.restore());
    };
    if (n.display)
      for (a = 0, r = i.length; a < r; ++a) {
        const l = i[a];
        n.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: s, grid: i } } = this, a = s.setContext(this.getContext()), r = s.display ? a.width : 0;
    if (!r)
      return;
    const o = i.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, d, h, u;
    this.isHorizontal() ? (c = Pe(t, this.left, r) - r / 2, d = Pe(t, this.right, o) + o / 2, h = u = l) : (h = Pe(t, this.top, r) - r / 2, u = Pe(t, this.bottom, o) + o / 2, c = d = l), n.save(), n.lineWidth = a.width, n.strokeStyle = a.color, n.beginPath(), n.moveTo(c, h), n.lineTo(d, u), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const s = this.ctx, i = this._computeLabelArea();
    i && is(s, i);
    const a = this.getLabelItems(t);
    for (const r of a) {
      const o = r.options, l = r.font, c = r.label, d = r.textOffset;
      He(s, c, 0, d, l, o);
    }
    i && as(s);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: s, reverse: i } } = this;
    if (!s.display)
      return;
    const a = bt(s.font), r = kt(s.padding), o = s.align;
    let l = a.lineHeight / 2;
    n === "bottom" || n === "center" || H(n) ? (l += r.bottom, tt(s.text) && (l += a.lineHeight * (s.text.length - 1))) : l += r.top;
    const { titleX: c, titleY: d, maxWidth: h, rotation: u } = Yb(this, l, n, o);
    He(t, s.text, 0, 0, a, {
      color: s.color,
      maxWidth: h,
      rotation: u,
      textAlign: Vb(o, n, i),
      textBaseline: "middle",
      translation: [
        c,
        d
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, s = j(t.grid && t.grid.z, -1), i = j(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Ge.prototype.draw ? [
      {
        z: n,
        draw: (a) => {
          this.draw(a);
        }
      }
    ] : [
      {
        z: s,
        draw: (a) => {
          this.drawBackground(), this.drawGrid(a), this.drawTitle();
        }
      },
      {
        z: i,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (a) => {
          this.drawLabels(a);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), s = this.axis + "AxisID", i = [];
    let a, r;
    for (a = 0, r = n.length; a < r; ++a) {
      const o = n[a];
      o[s] === this.id && (!t || o.type === t) && i.push(o);
    }
    return i;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return bt(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class ws {
  constructor(t, n, s) {
    this.type = t, this.scope = n, this.override = s, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let s;
    Xb(n) && (s = this.register(n));
    const i = this.items, a = t.id, r = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in i || (i[a] = t, Gb(t, r, s), this.override && mt.override(t.id, t.overrides)), r;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, s = t.id, i = this.scope;
    s in n && delete n[s], i && s in mt[i] && (delete mt[i][s], this.override && delete je[s]);
  }
}
function Gb(e, t, n) {
  const s = Xt(/* @__PURE__ */ Object.create(null), [
    n ? mt.get(n) : {},
    mt.get(t),
    e.defaults
  ]);
  mt.set(t, s), e.defaultRoutes && Ub(t, e.defaultRoutes), e.descriptors && mt.describe(t, e.descriptors);
}
function Ub(e, t) {
  Object.keys(t).forEach((n) => {
    const s = n.split("."), i = s.pop(), a = [
      e
    ].concat(s).join("."), r = t[n].split("."), o = r.pop(), l = r.join(".");
    mt.route(a, i, l, o);
  });
}
function Xb(e) {
  return "id" in e && "defaults" in e;
}
class qb {
  constructor() {
    this.controllers = new ws(Ht, "datasets", !0), this.elements = new ws(Ot, "elements"), this.plugins = new ws(Object, "plugins"), this.scales = new ws(Ge, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, s) {
    [
      ...n
    ].forEach((i) => {
      const a = s || this._getRegistryForType(i);
      s || a.isForType(i) || a === this.plugins && i.id ? this._exec(t, a, i) : nt(i, (r) => {
        const o = s || this._getRegistryForType(r);
        this._exec(t, o, r);
      });
    });
  }
  _exec(t, n, s) {
    const i = Fa(t);
    et(s["before" + i], [], s), n[t](s), et(s["after" + i], [], s);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const s = this._typedRegistries[n];
      if (s.isForType(t))
        return s;
    }
    return this.plugins;
  }
  _get(t, n, s) {
    const i = n.get(t);
    if (i === void 0)
      throw new Error('"' + t + '" is not a registered ' + s + ".");
    return i;
  }
}
var Gt = /* @__PURE__ */ new qb();
class Kb {
  constructor() {
    this._init = [];
  }
  notify(t, n, s, i) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = i ? this._descriptors(t).filter(i) : this._descriptors(t), r = this._notify(a, t, n, s);
    return n === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), r;
  }
  _notify(t, n, s, i) {
    i = i || {};
    for (const a of t) {
      const r = a.plugin, o = r[s], l = [
        n,
        i,
        a.options
      ];
      if (et(o, l, r) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    U(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const s = t && t.config, i = j(s.options && s.options.plugins, {}), a = Qb(s);
    return i === !1 && !n ? [] : Zb(t, a, i, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], s = this._cache, i = (a, r) => a.filter((o) => !r.some((l) => o.plugin.id === l.plugin.id));
    this._notify(i(n, s), t, "stop"), this._notify(i(s, n), t, "start");
  }
}
function Qb(e) {
  const t = {}, n = [], s = Object.keys(Gt.plugins.items);
  for (let a = 0; a < s.length; a++)
    n.push(Gt.getPlugin(s[a]));
  const i = e.plugins || [];
  for (let a = 0; a < i.length; a++) {
    const r = i[a];
    n.indexOf(r) === -1 && (n.push(r), t[r.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function Jb(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function Zb(e, { plugins: t, localIds: n }, s, i) {
  const a = [], r = e.getContext();
  for (const o of t) {
    const l = o.id, c = Jb(s[l], i);
    c !== null && a.push({
      plugin: o,
      options: ty(e.config, {
        plugin: o,
        local: n[l]
      }, c, r)
    });
  }
  return a;
}
function ty(e, { plugin: t, local: n }, s, i) {
  const a = e.pluginScopeKeys(t), r = e.getOptionScopes(s, a);
  return n && t.defaults && r.push(t.defaults), e.createResolver(r, i, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function la(e, t) {
  const n = mt.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function ey(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function ny(e, t) {
  return e === t ? "_index_" : "_value_";
}
function Mo(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function sy(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function ca(e, ...t) {
  if (Mo(e))
    return e;
  for (const n of t) {
    const s = n.axis || sy(n.position) || e.length > 1 && Mo(e[0].toLowerCase());
    if (s)
      return s;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function Oo(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function iy(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((s) => s.xAxisID === e || s.yAxisID === e);
    if (n.length)
      return Oo(e, "x", n[0]) || Oo(e, "y", n[0]);
  }
  return {};
}
function ay(e, t) {
  const n = je[e.type] || {
    scales: {}
  }, s = t.scales || {}, i = la(e.type, t), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(s).forEach((r) => {
    const o = s[r];
    if (!H(o))
      return console.error(`Invalid scale configuration for scale: ${r}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${r}`);
    const l = ca(r, o, iy(r, e), mt.scales[o.type]), c = ny(l, i), d = n.scales || {};
    a[r] = Fn(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      d[l],
      d[c]
    ]);
  }), e.data.datasets.forEach((r) => {
    const o = r.type || e.type, l = r.indexAxis || la(o, t), d = (je[o] || {}).scales || {};
    Object.keys(d).forEach((h) => {
      const u = ey(h, l), f = r[u + "AxisID"] || u;
      a[f] = a[f] || /* @__PURE__ */ Object.create(null), Fn(a[f], [
        {
          axis: u
        },
        s[f],
        d[h]
      ]);
    });
  }), Object.keys(a).forEach((r) => {
    const o = a[r];
    Fn(o, [
      mt.scales[o.type],
      mt.scale
    ]);
  }), a;
}
function wd(e) {
  const t = e.options || (e.options = {});
  t.plugins = j(t.plugins, {}), t.scales = ay(e, t);
}
function kd(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function ry(e) {
  return e = e || {}, e.data = kd(e.data), wd(e), e;
}
const To = /* @__PURE__ */ new Map(), Cd = /* @__PURE__ */ new Set();
function ks(e, t) {
  let n = To.get(e);
  return n || (n = t(), To.set(e, n), Cd.add(n)), n;
}
const On = (e, t, n) => {
  const s = we(t, n);
  s !== void 0 && e.add(s);
};
class oy {
  constructor(t) {
    this._config = ry(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = kd(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), wd(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return ks(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return ks(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return ks(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, s = this.type;
    return ks(`${s}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const s = this._scopeCache;
    let i = s.get(t);
    return (!i || n) && (i = /* @__PURE__ */ new Map(), s.set(t, i)), i;
  }
  getOptionScopes(t, n, s) {
    const { options: i, type: a } = this, r = this._cachedScopes(t, s), o = r.get(n);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    n.forEach((d) => {
      t && (l.add(t), d.forEach((h) => On(l, t, h))), d.forEach((h) => On(l, i, h)), d.forEach((h) => On(l, je[a] || {}, h)), d.forEach((h) => On(l, mt, h)), d.forEach((h) => On(l, aa, h));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Cd.has(n) && r.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      je[n] || {},
      mt.datasets[n] || {},
      {
        type: n
      },
      mt,
      aa
    ];
  }
  resolveNamedOptions(t, n, s, i = [
    ""
  ]) {
    const a = {
      $shared: !0
    }, { resolver: r, subPrefixes: o } = Po(this._resolverCache, t, i);
    let l = r;
    if (cy(r, n)) {
      a.$shared = !1, s = Lt(s) ? s() : s;
      const c = this.createResolver(t, s, o);
      l = ln(r, s, c);
    }
    for (const c of n)
      a[c] = l[c];
    return a;
  }
  createResolver(t, n, s = [
    ""
  ], i) {
    const { resolver: a } = Po(this._resolverCache, t, s);
    return H(n) ? ln(a, n, void 0, i) : a;
  }
}
function Po(e, t, n) {
  let s = e.get(t);
  s || (s = /* @__PURE__ */ new Map(), e.set(t, s));
  const i = n.join();
  let a = s.get(i);
  return a || (a = {
    resolver: Va(t, n),
    subPrefixes: n.filter((o) => !o.toLowerCase().includes("hover"))
  }, s.set(i, a)), a;
}
const ly = (e) => H(e) && Object.getOwnPropertyNames(e).some((t) => Lt(e[t]));
function cy(e, t) {
  const { isScriptable: n, isIndexable: s } = sd(e);
  for (const i of t) {
    const a = n(i), r = s(i), o = (r || a) && e[i];
    if (a && (Lt(o) || ly(o)) || r && tt(o))
      return !0;
  }
  return !1;
}
var dy = "4.4.2";
const hy = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Ao(e, t) {
  return e === "top" || e === "bottom" || hy.indexOf(e) === -1 && t === "x";
}
function $o(e, t) {
  return function(n, s) {
    return n[e] === s[e] ? n[t] - s[t] : n[e] - s[e];
  };
}
function Do(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), et(n && n.onComplete, [
    e
  ], t);
}
function uy(e) {
  const t = e.chart, n = t.options.animation;
  et(n && n.onProgress, [
    e
  ], t);
}
function Sd(e) {
  return Ua() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Vs = {}, Lo = (e) => {
  const t = Sd(e);
  return Object.values(Vs).filter((n) => n.canvas === t).pop();
};
function fy(e, t, n) {
  const s = Object.keys(e);
  for (const i of s) {
    const a = +i;
    if (a >= t) {
      const r = e[i];
      delete e[i], (n > 0 || a > t) && (e[a + n] = r);
    }
  }
}
function gy(e, t, n, s) {
  return !n || e.type === "mouseout" ? null : s ? t : e;
}
function Cs(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function py(e, t) {
  const { xScale: n, yScale: s } = e;
  return n && s ? {
    left: Cs(n, t, "left"),
    right: Cs(n, t, "right"),
    top: Cs(s, t, "top"),
    bottom: Cs(s, t, "bottom")
  } : t;
}
var fe;
let Ne = (fe = class {
  static register(...t) {
    Gt.add(...t), Eo();
  }
  static unregister(...t) {
    Gt.remove(...t), Eo();
  }
  constructor(t, n) {
    const s = this.config = new oy(n), i = Sd(t), a = Lo(i);
    if (a)
      throw new Error("Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused.");
    const r = s.createResolver(s.chartOptionScopes(), this.getContext());
    this.platform = new (s.platform || Db(i))(), this.platform.updateConfig(s);
    const o = this.platform.acquireContext(i, r.aspectRatio), l = o && o.canvas, c = l && l.height, d = l && l.width;
    if (this.id = _p(), this.ctx = o, this.canvas = l, this.width = d, this.height = c, this._options = r, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Kb(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = Ep((h) => this.update(h), r.resizeDelay || 0), this._dataChanges = [], Vs[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    ee.listen(this, "complete", Do), ee.listen(this, "progress", uy), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: s, height: i, _aspectRatio: a } = this;
    return U(t) ? n && a ? a : i ? s / i : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Gt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : to(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Qr(this.canvas, this.ctx), this;
  }
  stop() {
    return ee.stop(this), this;
  }
  resize(t, n) {
    ee.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const s = this.options, i = this.canvas, a = s.maintainAspectRatio && this.aspectRatio, r = this.platform.getMaximumSize(i, t, n, a), o = s.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = r.width, this.height = r.height, this._aspectRatio = this.aspectRatio, to(this, o, !0) && (this.notifyPlugins("resize", {
      size: r
    }), et(s.onResize, [
      this,
      r
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    nt(n, (s, i) => {
      s.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, s = this.scales, i = Object.keys(s).reduce((r, o) => (r[o] = !1, r), {});
    let a = [];
    n && (a = a.concat(Object.keys(n).map((r) => {
      const o = n[r], l = ca(r, o), c = l === "r", d = l === "x";
      return {
        options: o,
        dposition: c ? "chartArea" : d ? "bottom" : "left",
        dtype: c ? "radialLinear" : d ? "category" : "linear"
      };
    }))), nt(a, (r) => {
      const o = r.options, l = o.id, c = ca(l, o), d = j(o.type, r.dtype);
      (o.position === void 0 || Ao(o.position, c) !== Ao(r.dposition)) && (o.position = r.dposition), i[l] = !0;
      let h = null;
      if (l in s && s[l].type === d)
        h = s[l];
      else {
        const u = Gt.getScale(d);
        h = new u({
          id: l,
          type: d,
          ctx: this.ctx,
          chart: this
        }), s[h.id] = h;
      }
      h.init(o, t);
    }), nt(i, (r, o) => {
      r || delete s[o];
    }), nt(s, (r) => {
      Pt.configure(this, r, r.options), Pt.addBox(this, r);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, s = t.length;
    if (t.sort((i, a) => i.index - a.index), s > n) {
      for (let i = n; i < s; ++i)
        this._destroyDatasetMeta(i);
      t.splice(n, s - n);
    }
    this._sortedMetasets = t.slice(0).sort($o("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((s, i) => {
      n.filter((a) => a === s._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let s, i;
    for (this._removeUnreferencedMetasets(), s = 0, i = n.length; s < i; s++) {
      const a = n[s];
      let r = this.getDatasetMeta(s);
      const o = a.type || this.config.type;
      if (r.type && r.type !== o && (this._destroyDatasetMeta(s), r = this.getDatasetMeta(s)), r.type = o, r.indexAxis = a.indexAxis || la(o, this.options), r.order = a.order || 0, r.index = s, r.label = "" + a.label, r.visible = this.isDatasetVisible(s), r.controller)
        r.controller.updateIndex(s), r.controller.linkScales();
      else {
        const l = Gt.getController(o), { datasetElementType: c, dataElementType: d } = mt.datasets[o];
        Object.assign(l, {
          dataElementType: Gt.getElement(d),
          datasetElementType: c && Gt.getElement(c)
        }), r.controller = new l(this, s), t.push(r.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    nt(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const s = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !s.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let r = 0;
    for (let c = 0, d = this.data.datasets.length; c < d; c++) {
      const { controller: h } = this.getDatasetMeta(c), u = !i && a.indexOf(h) === -1;
      h.buildOrUpdateElements(u), r = Math.max(+h.getMaxOverflow(), r);
    }
    r = this._minPadding = s.layout.autoPadding ? r : 0, this._updateLayout(r), i || nt(a, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort($o("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    nt(this.scales, (t) => {
      Pt.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), s = new Set(t.events);
    (!Vr(n, s) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: s, start: i, count: a } of n) {
      const r = s === "_removeElements" ? -a : a;
      fy(t, i, r);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, s = (a) => new Set(t.filter((r) => r[0] === a).map((r, o) => o + "," + r.splice(1).join(","))), i = s(0);
    for (let a = 1; a < n; a++)
      if (!Vr(i, s(a)))
        return;
    return Array.from(i).map((a) => a.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Pt.update(this, this.width, this.height, t);
    const n = this.chartArea, s = n.width <= 0 || n.height <= 0;
    this._layers = [], nt(this.boxes, (i) => {
      s && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, a) => {
      i._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, s = this.data.datasets.length; n < s; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, s = this.data.datasets.length; n < s; ++n)
        this._updateDataset(n, Lt(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const s = this.getDatasetMeta(t), i = {
      meta: s,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (s.controller._update(n), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (ee.has(this) ? this.attached && !ee.running(this) && ee.start(this) : (this.draw(), Do({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: s, height: i } = this._resizeBeforeDraw;
      this._resize(s, i), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, s = [];
    let i, a;
    for (i = 0, a = n.length; i < a; ++i) {
      const r = n[i];
      (!t || r.visible) && s.push(r);
    }
    return s;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, s = t._clip, i = !s.disabled, a = py(t, this.chartArea), r = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", r) !== !1 && (i && is(n, {
      left: s.left === !1 ? 0 : a.left - s.left,
      right: s.right === !1 ? this.width : a.right + s.right,
      top: s.top === !1 ? 0 : a.top - s.top,
      bottom: s.bottom === !1 ? this.height : a.bottom + s.bottom
    }), t.controller.draw(), i && as(n), r.cancelable = !1, this.notifyPlugins("afterDatasetDraw", r));
  }
  isPointInArea(t) {
    return oe(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, s, i) {
    const a = hb.modes[n];
    return typeof a == "function" ? a(this, t, s, i) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], s = this._metasets;
    let i = s.filter((a) => a && a._dataset === n).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, s.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Me(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const s = this.getDatasetMeta(t);
    return typeof s.hidden == "boolean" ? !s.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const s = this.getDatasetMeta(t);
    s.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, s) {
    const i = s ? "show" : "hide", a = this.getDatasetMeta(t), r = a.controller._resolveAnimations(void 0, i);
    Et(n) ? (a.data[n].hidden = !s, this.update()) : (this.setDatasetVisibility(t, s), r.update(a, {
      visible: s
    }), this.update((o) => o.datasetIndex === t ? i : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), ee.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Qr(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Vs[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, s = (a, r) => {
      n.addEventListener(this, a, r), t[a] = r;
    }, i = (a, r, o) => {
      a.offsetX = r, a.offsetY = o, this._eventHandler(a);
    };
    nt(this.options.events, (a) => s(a, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, s = (l, c) => {
      n.addEventListener(this, l, c), t[l] = c;
    }, i = (l, c) => {
      t[l] && (n.removeEventListener(this, l, c), delete t[l]);
    }, a = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let r;
    const o = () => {
      i("attach", o), this.attached = !0, this.resize(), s("resize", a), s("detach", r);
    };
    r = () => {
      this.attached = !1, i("resize", a), this._stop(), this._resize(0, 0), s("attach", o);
    }, n.isAttached(this.canvas) ? o() : r();
  }
  unbindEvents() {
    nt(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, nt(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, s) {
    const i = s ? "set" : "remove";
    let a, r, o, l;
    for (n === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + i + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      r = t[o];
      const c = r && this.getDatasetMeta(r.datasetIndex).controller;
      c && c[i + "HoverStyle"](r.element, r.datasetIndex, r.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], s = t.map(({ datasetIndex: a, index: r }) => {
      const o = this.getDatasetMeta(a);
      if (!o)
        throw new Error("No dataset found at index " + a);
      return {
        datasetIndex: a,
        element: o.data[r],
        index: r
      };
    });
    !qs(s, n) && (this._active = s, this._lastEvent = null, this._updateHoverStyles(s, n));
  }
  notifyPlugins(t, n, s) {
    return this._plugins.notify(this, t, n, s);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, s) {
    const i = this.options.hover, a = (l, c) => l.filter((d) => !c.some((h) => d.datasetIndex === h.datasetIndex && d.index === h.index)), r = a(n, t), o = s ? t : a(t, n);
    r.length && this.updateHoverStyle(r, i.mode, !1), o.length && i.mode && this.updateHoverStyle(o, i.mode, !0);
  }
  _eventHandler(t, n) {
    const s = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, i = (r) => (r.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", s, i) === !1)
      return;
    const a = this._handleEvent(t, n, s.inChartArea);
    return s.cancelable = !1, this.notifyPlugins("afterEvent", s, i), (a || s.changed) && this.render(), this;
  }
  _handleEvent(t, n, s) {
    const { _active: i = [], options: a } = this, r = n, o = this._getActiveElements(t, i, s, r), l = Sp(t), c = gy(t, this._lastEvent, s, l);
    s && (this._lastEvent = null, et(a.onHover, [
      t,
      o,
      this
    ], this), l && et(a.onClick, [
      t,
      o,
      this
    ], this));
    const d = !qs(o, i);
    return (d || n) && (this._active = o, this._updateHoverStyles(o, i, n)), this._lastEvent = c, d;
  }
  _getActiveElements(t, n, s, i) {
    if (t.type === "mouseout")
      return [];
    if (!s)
      return n;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, i);
  }
}, E(fe, "defaults", mt), E(fe, "instances", Vs), E(fe, "overrides", je), E(fe, "registry", Gt), E(fe, "version", dy), E(fe, "getChart", Lo), fe);
function Eo() {
  return nt(Ne.instances, (e) => e._plugins.invalidate());
}
function my(e, t, n) {
  const { startAngle: s, pixelMargin: i, x: a, y: r, outerRadius: o, innerRadius: l } = t;
  let c = i / o;
  e.beginPath(), e.arc(a, r, o, s - c, n + c), l > i ? (c = i / l, e.arc(a, r, l, n + c, s - c, !0)) : e.arc(a, r, i, n + ht, s - ht), e.closePath(), e.clip();
}
function by(e) {
  return Ha(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function yy(e, t, n, s) {
  const i = by(e.options.borderRadius), a = (n - t) / 2, r = Math.min(a, s * t / 2), o = (l) => {
    const c = (n - Math.min(a, l)) * s / 2;
    return Mt(l, 0, Math.min(a, c));
  };
  return {
    outerStart: o(i.outerStart),
    outerEnd: o(i.outerEnd),
    innerStart: Mt(i.innerStart, 0, r),
    innerEnd: Mt(i.innerEnd, 0, r)
  };
}
function tn(e, t, n, s) {
  return {
    x: n + e * Math.cos(t),
    y: s + e * Math.sin(t)
  };
}
function si(e, t, n, s, i, a) {
  const { x: r, y: o, startAngle: l, pixelMargin: c, innerRadius: d } = t, h = Math.max(t.outerRadius + s + n - c, 0), u = d > 0 ? d + s + n + c : 0;
  let f = 0;
  const g = i - l;
  if (s) {
    const G = d > 0 ? d - s : 0, q = h > 0 ? h - s : 0, Z = (G + q) / 2, wt = Z !== 0 ? g * Z / (Z + s) : g;
    f = (g - wt) / 2;
  }
  const m = Math.max(1e-3, g * h - n / K) / h, p = (g - m) / 2, b = l + p + f, y = i - p - f, { outerStart: v, outerEnd: w, innerStart: x, innerEnd: C } = yy(t, u, h, y - b), O = h - v, M = h - w, A = b + v / O, $ = y - w / M, D = u + x, F = u + C, z = b + x / D, Q = y - C / F;
  if (e.beginPath(), a) {
    const G = (A + $) / 2;
    if (e.arc(r, o, h, A, G), e.arc(r, o, h, G, $), w > 0) {
      const Ct = tn(M, $, r, o);
      e.arc(Ct.x, Ct.y, w, $, y + ht);
    }
    const q = tn(F, y, r, o);
    if (e.lineTo(q.x, q.y), C > 0) {
      const Ct = tn(F, Q, r, o);
      e.arc(Ct.x, Ct.y, C, y + ht, Q + Math.PI);
    }
    const Z = (y - C / u + (b + x / u)) / 2;
    if (e.arc(r, o, u, y - C / u, Z, !0), e.arc(r, o, u, Z, b + x / u, !0), x > 0) {
      const Ct = tn(D, z, r, o);
      e.arc(Ct.x, Ct.y, x, z + Math.PI, b - ht);
    }
    const wt = tn(O, b, r, o);
    if (e.lineTo(wt.x, wt.y), v > 0) {
      const Ct = tn(O, A, r, o);
      e.arc(Ct.x, Ct.y, v, b - ht, A);
    }
  } else {
    e.moveTo(r, o);
    const G = Math.cos(A) * h + r, q = Math.sin(A) * h + o;
    e.lineTo(G, q);
    const Z = Math.cos($) * h + r, wt = Math.sin($) * h + o;
    e.lineTo(Z, wt);
  }
  e.closePath();
}
function _y(e, t, n, s, i) {
  const { fullCircles: a, startAngle: r, circumference: o } = t;
  let l = t.endAngle;
  if (a) {
    si(e, t, n, s, l, i);
    for (let c = 0; c < a; ++c)
      e.fill();
    isNaN(o) || (l = r + (o % ot || ot));
  }
  return si(e, t, n, s, l, i), e.fill(), l;
}
function vy(e, t, n, s, i) {
  const { fullCircles: a, startAngle: r, circumference: o, options: l } = t, { borderWidth: c, borderJoinStyle: d, borderDash: h, borderDashOffset: u } = l, f = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(h || []), e.lineDashOffset = u, f ? (e.lineWidth = c * 2, e.lineJoin = d || "round") : (e.lineWidth = c, e.lineJoin = d || "bevel");
  let g = t.endAngle;
  if (a) {
    si(e, t, n, s, g, i);
    for (let m = 0; m < a; ++m)
      e.stroke();
    isNaN(o) || (g = r + (o % ot || ot));
  }
  f && my(e, t, g), a || (si(e, t, n, s, g, i), e.stroke());
}
class en extends Ot {
  constructor(n) {
    super();
    E(this, "circumference");
    E(this, "endAngle");
    E(this, "fullCircles");
    E(this, "innerRadius");
    E(this, "outerRadius");
    E(this, "pixelMargin");
    E(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, s, i) {
    const a = this.getProps([
      "x",
      "y"
    ], i), { angle: r, distance: o } = Uc(a, {
      x: n,
      y: s
    }), { startAngle: l, endAngle: c, innerRadius: d, outerRadius: h, circumference: u } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], i), f = (this.options.spacing + this.options.borderWidth) / 2, m = j(u, c - l) >= ot || Qn(r, l, c), p = ae(o, d + f, h + f);
    return m && p;
  }
  getCenterPoint(n) {
    const { x: s, y: i, startAngle: a, endAngle: r, innerRadius: o, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: d } = this.options, h = (a + r) / 2, u = (o + l + d + c) / 2;
    return {
      x: s + Math.cos(h) * u,
      y: i + Math.sin(h) * u
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: s, circumference: i } = this, a = (s.offset || 0) / 4, r = (s.spacing || 0) / 2, o = s.circular;
    if (this.pixelMargin = s.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = i > ot ? Math.floor(i / ot) : 0, i === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * a, Math.sin(l) * a);
    const c = 1 - Math.sin(Math.min(K, i || 0)), d = a * c;
    n.fillStyle = s.backgroundColor, n.strokeStyle = s.borderColor, _y(n, this, d, r, o), vy(n, this, d, r, o), n.restore();
  }
}
E(en, "id", "arc"), E(en, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), E(en, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), E(en, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function Md(e, t, n = t) {
  e.lineCap = j(n.borderCapStyle, t.borderCapStyle), e.setLineDash(j(n.borderDash, t.borderDash)), e.lineDashOffset = j(n.borderDashOffset, t.borderDashOffset), e.lineJoin = j(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = j(n.borderWidth, t.borderWidth), e.strokeStyle = j(n.borderColor, t.borderColor);
}
function xy(e, t, n) {
  e.lineTo(n.x, n.y);
}
function wy(e) {
  return e.stepped ? Gp : e.tension || e.cubicInterpolationMode === "monotone" ? Up : xy;
}
function Od(e, t, n = {}) {
  const s = e.length, { start: i = 0, end: a = s - 1 } = n, { start: r, end: o } = t, l = Math.max(i, r), c = Math.min(a, o), d = i < r && a < r || i > o && a > o;
  return {
    count: s,
    start: l,
    loop: t.loop,
    ilen: c < l && !d ? s + c - l : c - l
  };
}
function ky(e, t, n, s) {
  const { points: i, options: a } = t, { count: r, start: o, loop: l, ilen: c } = Od(i, n, s), d = wy(a);
  let { move: h = !0, reverse: u } = s || {}, f, g, m;
  for (f = 0; f <= c; ++f)
    g = i[(o + (u ? c - f : f)) % r], !g.skip && (h ? (e.moveTo(g.x, g.y), h = !1) : d(e, m, g, u, a.stepped), m = g);
  return l && (g = i[(o + (u ? c : 0)) % r], d(e, m, g, u, a.stepped)), !!l;
}
function Cy(e, t, n, s) {
  const i = t.points, { count: a, start: r, ilen: o } = Od(i, n, s), { move: l = !0, reverse: c } = s || {};
  let d = 0, h = 0, u, f, g, m, p, b;
  const y = (w) => (r + (c ? o - w : w)) % a, v = () => {
    m !== p && (e.lineTo(d, p), e.lineTo(d, m), e.lineTo(d, b));
  };
  for (l && (f = i[y(0)], e.moveTo(f.x, f.y)), u = 0; u <= o; ++u) {
    if (f = i[y(u)], f.skip)
      continue;
    const w = f.x, x = f.y, C = w | 0;
    C === g ? (x < m ? m = x : x > p && (p = x), d = (h * d + w) / ++h) : (v(), e.lineTo(w, x), g = C, h = 0, m = p = x), b = x;
  }
  v();
}
function da(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? Cy : ky;
}
function Sy(e) {
  return e.stepped ? Sm : e.tension || e.cubicInterpolationMode === "monotone" ? Mm : Ee;
}
function My(e, t, n, s) {
  let i = t._path;
  i || (i = t._path = new Path2D(), t.path(i, n, s) && i.closePath()), Md(e, t.options), e.stroke(i);
}
function Oy(e, t, n, s) {
  const { segments: i, options: a } = t, r = da(t);
  for (const o of i)
    Md(e, a, o.style), e.beginPath(), r(e, t, o, {
      start: n,
      end: n + s - 1
    }) && e.closePath(), e.stroke();
}
const Ty = typeof Path2D == "function";
function Py(e, t, n, s) {
  Ty && !t.options.segment ? My(e, t, n, s) : Oy(e, t, n, s);
}
class be extends Ot {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const s = this.options;
    if ((s.tension || s.cubicInterpolationMode === "monotone") && !s.stepped && !this._pointsUpdated) {
      const i = s.spanGaps ? this._loop : this._fullLoop;
      bm(this._points, s, t, i, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = Dm(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, s = t.length;
    return s && n[t[s - 1].end];
  }
  interpolate(t, n) {
    const s = this.options, i = t[n], a = this.points, r = fd(this, {
      property: n,
      start: i,
      end: i
    });
    if (!r.length)
      return;
    const o = [], l = Sy(s);
    let c, d;
    for (c = 0, d = r.length; c < d; ++c) {
      const { start: h, end: u } = r[c], f = a[h], g = a[u];
      if (f === g) {
        o.push(f);
        continue;
      }
      const m = Math.abs((i - f[n]) / (g[n] - f[n])), p = l(f, g, m, s.stepped);
      p[n] = t[n], o.push(p);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, n, s) {
    return da(this)(t, this, n, s);
  }
  path(t, n, s) {
    const i = this.segments, a = da(this);
    let r = this._loop;
    n = n || 0, s = s || this.points.length - n;
    for (const o of i)
      r &= a(t, this, o, {
        start: n,
        end: n + s - 1
      });
    return !!r;
  }
  draw(t, n, s, i) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), Py(t, this, s, i), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
E(be, "id", "line"), E(be, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), E(be, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), E(be, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function Io(e, t, n, s) {
  const i = e.options, { [n]: a } = e.getProps([
    n
  ], s);
  return Math.abs(t - a) < i.radius + i.hitRadius;
}
class Hn extends Ot {
  constructor(n) {
    super();
    E(this, "parsed");
    E(this, "skip");
    E(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, s, i) {
    const a = this.options, { x: r, y: o } = this.getProps([
      "x",
      "y"
    ], i);
    return Math.pow(n - r, 2) + Math.pow(s - o, 2) < Math.pow(a.hitRadius + a.radius, 2);
  }
  inXRange(n, s) {
    return Io(this, n, "x", s);
  }
  inYRange(n, s) {
    return Io(this, n, "y", s);
  }
  getCenterPoint(n) {
    const { x: s, y: i } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: s,
      y: i
    };
  }
  size(n) {
    n = n || this.options || {};
    let s = n.radius || 0;
    s = Math.max(s, s && n.hoverRadius || 0);
    const i = s && n.borderWidth || 0;
    return (s + i) * 2;
  }
  draw(n, s) {
    const i = this.options;
    this.skip || i.radius < 0.1 || !oe(this, s, this.size(i) / 2) || (n.strokeStyle = i.borderColor, n.lineWidth = i.borderWidth, n.fillStyle = i.backgroundColor, ra(n, i, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
E(Hn, "id", "point"), /**
* @type {any}
*/
E(Hn, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
E(Hn, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Td(e, t) {
  const { x: n, y: s, base: i, width: a, height: r } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let o, l, c, d, h;
  return e.horizontal ? (h = r / 2, o = Math.min(n, i), l = Math.max(n, i), c = s - h, d = s + h) : (h = a / 2, o = n - h, l = n + h, c = Math.min(s, i), d = Math.max(s, i)), {
    left: o,
    top: c,
    right: l,
    bottom: d
  };
}
function ye(e, t, n, s) {
  return e ? 0 : Mt(t, n, s);
}
function Ay(e, t, n) {
  const s = e.options.borderWidth, i = e.borderSkipped, a = nd(s);
  return {
    t: ye(i.top, a.top, 0, n),
    r: ye(i.right, a.right, 0, t),
    b: ye(i.bottom, a.bottom, 0, n),
    l: ye(i.left, a.left, 0, t)
  };
}
function $y(e, t, n) {
  const { enableBorderRadius: s } = e.getProps([
    "enableBorderRadius"
  ]), i = e.options.borderRadius, a = ve(i), r = Math.min(t, n), o = e.borderSkipped, l = s || H(i);
  return {
    topLeft: ye(!l || o.top || o.left, a.topLeft, 0, r),
    topRight: ye(!l || o.top || o.right, a.topRight, 0, r),
    bottomLeft: ye(!l || o.bottom || o.left, a.bottomLeft, 0, r),
    bottomRight: ye(!l || o.bottom || o.right, a.bottomRight, 0, r)
  };
}
function Dy(e) {
  const t = Td(e), n = t.right - t.left, s = t.bottom - t.top, i = Ay(e, n / 2, s / 2), a = $y(e, n / 2, s / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: s,
      radius: a
    },
    inner: {
      x: t.left + i.l,
      y: t.top + i.t,
      w: n - i.l - i.r,
      h: s - i.t - i.b,
      radius: {
        topLeft: Math.max(0, a.topLeft - Math.max(i.t, i.l)),
        topRight: Math.max(0, a.topRight - Math.max(i.t, i.r)),
        bottomLeft: Math.max(0, a.bottomLeft - Math.max(i.b, i.l)),
        bottomRight: Math.max(0, a.bottomRight - Math.max(i.b, i.r))
      }
    }
  };
}
function zi(e, t, n, s) {
  const i = t === null, a = n === null, o = e && !(i && a) && Td(e, s);
  return o && (i || ae(t, o.left, o.right)) && (a || ae(n, o.top, o.bottom));
}
function Ly(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function Ey(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function ji(e, t, n = {}) {
  const s = e.x !== n.x ? -t : 0, i = e.y !== n.y ? -t : 0, a = (e.x + e.w !== n.x + n.w ? t : 0) - s, r = (e.y + e.h !== n.y + n.h ? t : 0) - i;
  return {
    x: e.x + s,
    y: e.y + i,
    w: e.w + a,
    h: e.h + r,
    radius: e.radius
  };
}
class Vn extends Ot {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: s, backgroundColor: i } } = this, { inner: a, outer: r } = Dy(this), o = Ly(r.radius) ? on : Ey;
    t.save(), (r.w !== a.w || r.h !== a.h) && (t.beginPath(), o(t, ji(r, n, a)), t.clip(), o(t, ji(a, -n, r)), t.fillStyle = s, t.fill("evenodd")), t.beginPath(), o(t, ji(a, n)), t.fillStyle = i, t.fill(), t.restore();
  }
  inRange(t, n, s) {
    return zi(this, t, n, s);
  }
  inXRange(t, n) {
    return zi(this, t, null, n);
  }
  inYRange(t, n) {
    return zi(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: s, base: i, horizontal: a } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: a ? (n + i) / 2 : n,
      y: a ? s : (s + i) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
E(Vn, "id", "bar"), E(Vn, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), E(Vn, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var Iy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: en,
  BarElement: Vn,
  LineElement: be,
  PointElement: Hn
});
const ha = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], Ro = /* @__PURE__ */ ha.map((e) => e.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function Pd(e) {
  return ha[e % ha.length];
}
function Ad(e) {
  return Ro[e % Ro.length];
}
function Ry(e, t) {
  return e.borderColor = Pd(t), e.backgroundColor = Ad(t), ++t;
}
function By(e, t) {
  return e.backgroundColor = e.data.map(() => Pd(t++)), t;
}
function Fy(e, t) {
  return e.backgroundColor = e.data.map(() => Ad(t++)), t;
}
function Wy(e) {
  let t = 0;
  return (n, s) => {
    const i = e.getDatasetMeta(s).controller;
    i instanceof Be ? t = By(n, t) : i instanceof jn ? t = Fy(n, t) : i && (t = Ry(n, t));
  };
}
function Bo(e) {
  let t;
  for (t in e)
    if (e[t].borderColor || e[t].backgroundColor)
      return !0;
  return !1;
}
function Ny(e) {
  return e && (e.borderColor || e.backgroundColor);
}
var zy = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(e, t, n) {
    if (!n.enabled)
      return;
    const { data: { datasets: s }, options: i } = e.config, { elements: a } = i;
    if (!n.forceOverride && (Bo(s) || Ny(i) || a && Bo(a)))
      return;
    const r = Wy(e);
    s.forEach(r);
  }
};
function jy(e, t, n, s, i) {
  const a = i.samples || s;
  if (a >= n)
    return e.slice(t, t + n);
  const r = [], o = (n - 2) / (a - 2);
  let l = 0;
  const c = t + n - 1;
  let d = t, h, u, f, g, m;
  for (r[l++] = e[d], h = 0; h < a - 2; h++) {
    let p = 0, b = 0, y;
    const v = Math.floor((h + 1) * o) + 1 + t, w = Math.min(Math.floor((h + 2) * o) + 1, n) + t, x = w - v;
    for (y = v; y < w; y++)
      p += e[y].x, b += e[y].y;
    p /= x, b /= x;
    const C = Math.floor(h * o) + 1 + t, O = Math.min(Math.floor((h + 1) * o) + 1, n) + t, { x: M, y: A } = e[d];
    for (f = g = -1, y = C; y < O; y++)
      g = 0.5 * Math.abs((M - p) * (e[y].y - A) - (M - e[y].x) * (b - A)), g > f && (f = g, u = e[y], m = y);
    r[l++] = u, d = m;
  }
  return r[l++] = e[c], r;
}
function Hy(e, t, n, s) {
  let i = 0, a = 0, r, o, l, c, d, h, u, f, g, m;
  const p = [], b = t + n - 1, y = e[t].x, w = e[b].x - y;
  for (r = t; r < t + n; ++r) {
    o = e[r], l = (o.x - y) / w * s, c = o.y;
    const x = l | 0;
    if (x === d)
      c < g ? (g = c, h = r) : c > m && (m = c, u = r), i = (a * i + o.x) / ++a;
    else {
      const C = r - 1;
      if (!U(h) && !U(u)) {
        const O = Math.min(h, u), M = Math.max(h, u);
        O !== f && O !== C && p.push({
          ...e[O],
          x: i
        }), M !== f && M !== C && p.push({
          ...e[M],
          x: i
        });
      }
      r > 0 && C !== f && p.push(e[C]), p.push(o), d = x, a = 0, g = m = c, h = u = f = r;
    }
  }
  return p;
}
function $d(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function Fo(e) {
  e.data.datasets.forEach((t) => {
    $d(t);
  });
}
function Vy(e, t) {
  const n = t.length;
  let s = 0, i;
  const { iScale: a } = e, { min: r, max: o, minDefined: l, maxDefined: c } = a.getUserBounds();
  return l && (s = Mt(re(t, a.axis, r).lo, 0, n - 1)), c ? i = Mt(re(t, a.axis, o).hi + 1, s, n) - s : i = n - s, {
    start: s,
    count: i
  };
}
var Yy = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, n) => {
    if (!n.enabled) {
      Fo(e);
      return;
    }
    const s = e.width;
    e.data.datasets.forEach((i, a) => {
      const { _data: r, indexAxis: o } = i, l = e.getDatasetMeta(a), c = r || i.data;
      if (ct([
        o,
        e.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const d = e.scales[l.xAxisID];
      if (d.type !== "linear" && d.type !== "time" || e.options.parsing)
        return;
      let { start: h, count: u } = Vy(l, c);
      const f = n.threshold || 4 * s;
      if (u <= f) {
        $d(i);
        return;
      }
      U(r) && (i._data = c, delete i.data, Object.defineProperty(i, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(m) {
          this._data = m;
        }
      }));
      let g;
      switch (n.algorithm) {
        case "lttb":
          g = jy(c, h, u, s, n);
          break;
        case "min-max":
          g = Hy(c, h, u, s);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      i._decimated = g;
    });
  },
  destroy(e) {
    Fo(e);
  }
};
function Gy(e, t, n) {
  const s = e.segments, i = e.points, a = t.points, r = [];
  for (const o of s) {
    let { start: l, end: c } = o;
    c = Qa(l, c, i);
    const d = ua(n, i[l], i[c], o.loop);
    if (!t.segments) {
      r.push({
        source: o,
        target: d,
        start: i[l],
        end: i[c]
      });
      continue;
    }
    const h = fd(t, d);
    for (const u of h) {
      const f = ua(n, a[u.start], a[u.end], u.loop), g = ud(o, i, f);
      for (const m of g)
        r.push({
          source: m,
          target: u,
          start: {
            [n]: Wo(d, f, "start", Math.max)
          },
          end: {
            [n]: Wo(d, f, "end", Math.min)
          }
        });
    }
  }
  return r;
}
function ua(e, t, n, s) {
  if (s)
    return;
  let i = t[e], a = n[e];
  return e === "angle" && (i = Rt(i), a = Rt(a)), {
    property: e,
    start: i,
    end: a
  };
}
function Uy(e, t) {
  const { x: n = null, y: s = null } = e || {}, i = t.points, a = [];
  return t.segments.forEach(({ start: r, end: o }) => {
    o = Qa(r, o, i);
    const l = i[r], c = i[o];
    s !== null ? (a.push({
      x: l.x,
      y: s
    }), a.push({
      x: c.x,
      y: s
    })) : n !== null && (a.push({
      x: n,
      y: l.y
    }), a.push({
      x: n,
      y: c.y
    }));
  }), a;
}
function Qa(e, t, n) {
  for (; t > e; t--) {
    const s = n[t];
    if (!isNaN(s.x) && !isNaN(s.y))
      break;
  }
  return t;
}
function Wo(e, t, n, s) {
  return e && t ? s(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function Dd(e, t) {
  let n = [], s = !1;
  return tt(e) ? (s = !0, n = e) : n = Uy(e, t), n.length ? new be({
    points: n,
    options: {
      tension: 0
    },
    _loop: s,
    _fullLoop: s
  }) : null;
}
function No(e) {
  return e && e.fill !== !1;
}
function Xy(e, t, n) {
  let i = e[t].fill;
  const a = [
    t
  ];
  let r;
  if (!n)
    return i;
  for (; i !== !1 && a.indexOf(i) === -1; ) {
    if (!pt(i))
      return i;
    if (r = e[i], !r)
      return !1;
    if (r.visible)
      return i;
    a.push(i), i = r.fill;
  }
  return !1;
}
function qy(e, t, n) {
  const s = Zy(e);
  if (H(s))
    return isNaN(s.value) ? !1 : s;
  let i = parseFloat(s);
  return pt(i) && Math.floor(i) === i ? Ky(s[0], t, i, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(s) >= 0 && s;
}
function Ky(e, t, n, s) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= s ? !1 : n;
}
function Qy(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : H(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function Jy(e, t, n) {
  let s;
  return e === "start" ? s = n : e === "end" ? s = t.options.reverse ? t.min : t.max : H(e) ? s = e.value : s = t.getBaseValue(), s;
}
function Zy(e) {
  const t = e.options, n = t.fill;
  let s = j(n && n.target, n);
  return s === void 0 && (s = !!t.backgroundColor), s === !1 || s === null ? !1 : s === !0 ? "origin" : s;
}
function t_(e) {
  const { scale: t, index: n, line: s } = e, i = [], a = s.segments, r = s.points, o = e_(t, n);
  o.push(Dd({
    x: null,
    y: t.bottom
  }, s));
  for (let l = 0; l < a.length; l++) {
    const c = a[l];
    for (let d = c.start; d <= c.end; d++)
      n_(i, r[d], o);
  }
  return new be({
    points: i,
    options: {}
  });
}
function e_(e, t) {
  const n = [], s = e.getMatchingVisibleMetas("line");
  for (let i = 0; i < s.length; i++) {
    const a = s[i];
    if (a.index === t)
      break;
    a.hidden || n.unshift(a.dataset);
  }
  return n;
}
function n_(e, t, n) {
  const s = [];
  for (let i = 0; i < n.length; i++) {
    const a = n[i], { first: r, last: o, point: l } = s_(a, t, "x");
    if (!(!l || r && o)) {
      if (r)
        s.unshift(l);
      else if (e.push(l), !o)
        break;
    }
  }
  e.push(...s);
}
function s_(e, t, n) {
  const s = e.interpolate(t, n);
  if (!s)
    return {};
  const i = s[n], a = e.segments, r = e.points;
  let o = !1, l = !1;
  for (let c = 0; c < a.length; c++) {
    const d = a[c], h = r[d.start][n], u = r[d.end][n];
    if (ae(i, h, u)) {
      o = i === h, l = i === u;
      break;
    }
  }
  return {
    first: o,
    last: l,
    point: s
  };
}
class Ld {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, s) {
    const { x: i, y: a, radius: r } = this;
    return n = n || {
      start: 0,
      end: ot
    }, t.arc(i, a, r, n.end, n.start, !0), !s.bounds;
  }
  interpolate(t) {
    const { x: n, y: s, radius: i } = this, a = t.angle;
    return {
      x: n + Math.cos(a) * i,
      y: s + Math.sin(a) * i,
      angle: a
    };
  }
}
function i_(e) {
  const { chart: t, fill: n, line: s } = e;
  if (pt(n))
    return a_(t, n);
  if (n === "stack")
    return t_(e);
  if (n === "shape")
    return !0;
  const i = r_(e);
  return i instanceof Ld ? i : Dd(i, s);
}
function a_(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function r_(e) {
  return (e.scale || {}).getPointPositionForValue ? l_(e) : o_(e);
}
function o_(e) {
  const { scale: t = {}, fill: n } = e, s = Qy(n, t);
  if (pt(s)) {
    const i = t.isHorizontal();
    return {
      x: i ? s : null,
      y: i ? null : s
    };
  }
  return null;
}
function l_(e) {
  const { scale: t, fill: n } = e, s = t.options, i = t.getLabels().length, a = s.reverse ? t.max : t.min, r = Jy(n, t, a), o = [];
  if (s.grid.circular) {
    const l = t.getPointPositionForValue(0, a);
    return new Ld({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(r)
    });
  }
  for (let l = 0; l < i; ++l)
    o.push(t.getPointPositionForValue(l, r));
  return o;
}
function Hi(e, t, n) {
  const s = i_(t), { line: i, scale: a, axis: r } = t, o = i.options, l = o.fill, c = o.backgroundColor, { above: d = c, below: h = c } = l || {};
  s && i.points.length && (is(e, n), c_(e, {
    line: i,
    target: s,
    above: d,
    below: h,
    area: n,
    scale: a,
    axis: r
  }), as(e));
}
function c_(e, t) {
  const { line: n, target: s, above: i, below: a, area: r, scale: o } = t, l = n._loop ? "angle" : t.axis;
  e.save(), l === "x" && a !== i && (zo(e, s, r.top), jo(e, {
    line: n,
    target: s,
    color: i,
    scale: o,
    property: l
  }), e.restore(), e.save(), zo(e, s, r.bottom)), jo(e, {
    line: n,
    target: s,
    color: a,
    scale: o,
    property: l
  }), e.restore();
}
function zo(e, t, n) {
  const { segments: s, points: i } = t;
  let a = !0, r = !1;
  e.beginPath();
  for (const o of s) {
    const { start: l, end: c } = o, d = i[l], h = i[Qa(l, c, i)];
    a ? (e.moveTo(d.x, d.y), a = !1) : (e.lineTo(d.x, n), e.lineTo(d.x, d.y)), r = !!t.pathSegment(e, o, {
      move: r
    }), r ? e.closePath() : e.lineTo(h.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function jo(e, t) {
  const { line: n, target: s, property: i, color: a, scale: r } = t, o = Gy(n, s, i);
  for (const { source: l, target: c, start: d, end: h } of o) {
    const { style: { backgroundColor: u = a } = {} } = l, f = s !== !0;
    e.save(), e.fillStyle = u, d_(e, r, f && ua(i, d, h)), e.beginPath();
    const g = !!n.pathSegment(e, l);
    let m;
    if (f) {
      g ? e.closePath() : Ho(e, s, h, i);
      const p = !!s.pathSegment(e, c, {
        move: g,
        reverse: !0
      });
      m = g && p, m || Ho(e, s, d, i);
    }
    e.closePath(), e.fill(m ? "evenodd" : "nonzero"), e.restore();
  }
}
function d_(e, t, n) {
  const { top: s, bottom: i } = t.chart.chartArea, { property: a, start: r, end: o } = n || {};
  a === "x" && (e.beginPath(), e.rect(r, s, o - r, i - s), e.clip());
}
function Ho(e, t, n, s) {
  const i = t.interpolate(n, s);
  i && e.lineTo(i.x, i.y);
}
var h_ = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const s = (e.data.datasets || []).length, i = [];
    let a, r, o, l;
    for (r = 0; r < s; ++r)
      a = e.getDatasetMeta(r), o = a.dataset, l = null, o && o.options && o instanceof be && (l = {
        visible: e.isDatasetVisible(r),
        index: r,
        fill: qy(o, r, s),
        chart: e,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: o
      }), a.$filler = l, i.push(l);
    for (r = 0; r < s; ++r)
      l = i[r], !(!l || l.fill === !1) && (l.fill = Xy(i, r, n.propagate));
  },
  beforeDraw(e, t, n) {
    const s = n.drawTime === "beforeDraw", i = e.getSortedVisibleDatasetMetas(), a = e.chartArea;
    for (let r = i.length - 1; r >= 0; --r) {
      const o = i[r].$filler;
      o && (o.line.updateControlPoints(a, o.axis), s && o.fill && Hi(e.ctx, o, a));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const s = e.getSortedVisibleDatasetMetas();
    for (let i = s.length - 1; i >= 0; --i) {
      const a = s[i].$filler;
      No(a) && Hi(e.ctx, a, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const s = t.meta.$filler;
    !No(s) || n.drawTime !== "beforeDatasetDraw" || Hi(e.ctx, s, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const Vo = (e, t) => {
  let { boxHeight: n = t, boxWidth: s = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), s = e.pointStyleWidth || Math.min(s, t)), {
    boxWidth: s,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, u_ = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
let Yo = class extends Ot {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, s) {
    this.maxWidth = t, this.maxHeight = n, this._margins = s, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = et(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((s) => t.filter(s, this.chart.data))), t.sort && (n = n.sort((s, i) => t.sort(s, i, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const s = t.labels, i = bt(s.font), a = i.size, r = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = Vo(s, a);
    let c, d;
    n.font = i.string, this.isHorizontal() ? (c = this.maxWidth, d = this._fitRows(r, a, o, l) + 10) : (d = this.maxHeight, c = this._fitCols(r, i, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(d, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, s, i) {
    const { ctx: a, maxWidth: r, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], d = i + o;
    let h = t;
    a.textAlign = "left", a.textBaseline = "middle";
    let u = -1, f = -d;
    return this.legendItems.forEach((g, m) => {
      const p = s + n / 2 + a.measureText(g.text).width;
      (m === 0 || c[c.length - 1] + p + 2 * o > r) && (h += d, c[c.length - (m > 0 ? 0 : 1)] = 0, f += d, u++), l[m] = {
        left: 0,
        top: f,
        row: u,
        width: p,
        height: i
      }, c[c.length - 1] += p + o;
    }), h;
  }
  _fitCols(t, n, s, i) {
    const { ctx: a, maxHeight: r, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], d = r - t;
    let h = o, u = 0, f = 0, g = 0, m = 0;
    return this.legendItems.forEach((p, b) => {
      const { itemWidth: y, itemHeight: v } = f_(s, n, a, p, i);
      b > 0 && f + v + 2 * o > d && (h += u + o, c.push({
        width: u,
        height: f
      }), g += u + o, m++, u = f = 0), l[b] = {
        left: g,
        top: f,
        col: m,
        width: y,
        height: v
      }, u = Math.max(u, y), f += v + o;
    }), h += u, c.push({
      width: u,
      height: f
    }), h;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: s, labels: { padding: i }, rtl: a } } = this, r = sn(a, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = Tt(s, this.left + i, this.right - this.lineWidths[o]);
      for (const c of n)
        o !== c.row && (o = c.row, l = Tt(s, this.left + i, this.right - this.lineWidths[o])), c.top += this.top + t + i, c.left = r.leftForLtr(r.x(l), c.width), l += c.width + i;
    } else {
      let o = 0, l = Tt(s, this.top + t + i, this.bottom - this.columnSizes[o].height);
      for (const c of n)
        c.col !== o && (o = c.col, l = Tt(s, this.top + t + i, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + i, c.left = r.leftForLtr(r.x(c.left), c.width), l += c.height + i;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      is(t, this), this._draw(), as(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: s, ctx: i } = this, { align: a, labels: r } = t, o = mt.color, l = sn(t.rtl, this.left, this.width), c = bt(r.font), { padding: d } = r, h = c.size, u = h / 2;
    let f;
    this.drawTitle(), i.textAlign = l.textAlign("left"), i.textBaseline = "middle", i.lineWidth = 0.5, i.font = c.string;
    const { boxWidth: g, boxHeight: m, itemHeight: p } = Vo(r, h), b = function(C, O, M) {
      if (isNaN(g) || g <= 0 || isNaN(m) || m < 0)
        return;
      i.save();
      const A = j(M.lineWidth, 1);
      if (i.fillStyle = j(M.fillStyle, o), i.lineCap = j(M.lineCap, "butt"), i.lineDashOffset = j(M.lineDashOffset, 0), i.lineJoin = j(M.lineJoin, "miter"), i.lineWidth = A, i.strokeStyle = j(M.strokeStyle, o), i.setLineDash(j(M.lineDash, [])), r.usePointStyle) {
        const $ = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: M.pointStyle,
          rotation: M.rotation,
          borderWidth: A
        }, D = l.xPlus(C, g / 2), F = O + u;
        ed(i, $, D, F, r.pointStyleWidth && g);
      } else {
        const $ = O + Math.max((h - m) / 2, 0), D = l.leftForLtr(C, g), F = ve(M.borderRadius);
        i.beginPath(), Object.values(F).some((z) => z !== 0) ? on(i, {
          x: D,
          y: $,
          w: g,
          h: m,
          radius: F
        }) : i.rect(D, $, g, m), i.fill(), A !== 0 && i.stroke();
      }
      i.restore();
    }, y = function(C, O, M) {
      He(i, M.text, C, O + p / 2, c, {
        strikethrough: M.hidden,
        textAlign: l.textAlign(M.textAlign)
      });
    }, v = this.isHorizontal(), w = this._computeTitleHeight();
    v ? f = {
      x: Tt(a, this.left + d, this.right - s[0]),
      y: this.top + d + w,
      line: 0
    } : f = {
      x: this.left + d,
      y: Tt(a, this.top + w + d, this.bottom - n[0].height),
      line: 0
    }, cd(this.ctx, t.textDirection);
    const x = p + d;
    this.legendItems.forEach((C, O) => {
      i.strokeStyle = C.fontColor, i.fillStyle = C.fontColor;
      const M = i.measureText(C.text).width, A = l.textAlign(C.textAlign || (C.textAlign = r.textAlign)), $ = g + u + M;
      let D = f.x, F = f.y;
      l.setWidth(this.width), v ? O > 0 && D + $ + d > this.right && (F = f.y += x, f.line++, D = f.x = Tt(a, this.left + d, this.right - s[f.line])) : O > 0 && F + x > this.bottom && (D = f.x = D + n[f.line].width + d, f.line++, F = f.y = Tt(a, this.top + w + d, this.bottom - n[f.line].height));
      const z = l.x(D);
      if (b(z, F, C), D = Ip(A, D + g + u, v ? D + $ : this.right, t.rtl), y(l.x(D), F, C), v)
        f.x += $ + d;
      else if (typeof C.text != "string") {
        const Q = c.lineHeight;
        f.y += Ed(C, Q) + d;
      } else
        f.y += x;
    }), dd(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, s = bt(n.font), i = kt(n.padding);
    if (!n.display)
      return;
    const a = sn(t.rtl, this.left, this.width), r = this.ctx, o = n.position, l = s.size / 2, c = i.top + l;
    let d, h = this.left, u = this.width;
    if (this.isHorizontal())
      u = Math.max(...this.lineWidths), d = this.top + c, h = Tt(t.align, h, this.right - u);
    else {
      const g = this.columnSizes.reduce((m, p) => Math.max(m, p.height), 0);
      d = c + Tt(t.align, this.top, this.bottom - g - t.labels.padding - this._computeTitleHeight());
    }
    const f = Tt(o, h, h + u);
    r.textAlign = a.textAlign(za(o)), r.textBaseline = "middle", r.strokeStyle = n.color, r.fillStyle = n.color, r.font = s.string, He(r, n.text, f, d, s);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = bt(t.font), s = kt(t.padding);
    return t.display ? n.lineHeight + s.height : 0;
  }
  _getLegendItemAt(t, n) {
    let s, i, a;
    if (ae(t, this.left, this.right) && ae(n, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, s = 0; s < a.length; ++s)
        if (i = a[s], ae(t, i.left, i.left + i.width) && ae(n, i.top, i.top + i.height))
          return this.legendItems[s];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!m_(t.type, n))
      return;
    const s = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const i = this._hoveredItem, a = u_(i, s);
      i && !a && et(n.onLeave, [
        t,
        i,
        this
      ], this), this._hoveredItem = s, s && !a && et(n.onHover, [
        t,
        s,
        this
      ], this);
    } else
      s && et(n.onClick, [
        t,
        s,
        this
      ], this);
  }
};
function f_(e, t, n, s, i) {
  const a = g_(s, e, t, n), r = p_(i, s, t.lineHeight);
  return {
    itemWidth: a,
    itemHeight: r
  };
}
function g_(e, t, n, s) {
  let i = e.text;
  return i && typeof i != "string" && (i = i.reduce((a, r) => a.length > r.length ? a : r)), t + n.size / 2 + s.measureText(i).width;
}
function p_(e, t, n) {
  let s = e;
  return typeof t.text != "string" && (s = Ed(t, n)), s;
}
function Ed(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
function m_(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var b_ = {
  id: "legend",
  _element: Yo,
  start(e, t, n) {
    const s = e.legend = new Yo({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Pt.configure(e, s, n), Pt.addBox(e, s);
  },
  stop(e) {
    Pt.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const s = e.legend;
    Pt.configure(e, s, n), s.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const s = t.datasetIndex, i = n.chart;
      i.isDatasetVisible(s) ? (i.hide(s), t.hidden = !0) : (i.show(s), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: s, textAlign: i, color: a, useBorderRadius: r, borderRadius: o } } = e.legend.options;
        return e._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), d = kt(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: a,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (d.width + d.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: s || c.pointStyle,
            rotation: c.rotation,
            textAlign: i || c.textAlign,
            borderRadius: r && (o || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
class Ja extends Ot {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const s = this.options;
    if (this.left = 0, this.top = 0, !s.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const i = tt(s.text) ? s.text.length : 1;
    this._padding = kt(s.padding);
    const a = i * bt(s.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = a : this.width = a;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: s, bottom: i, right: a, options: r } = this, o = r.align;
    let l = 0, c, d, h;
    return this.isHorizontal() ? (d = Tt(o, s, a), h = n + t, c = a - s) : (r.position === "left" ? (d = s + t, h = Tt(o, i, n), l = K * -0.5) : (d = a - t, h = Tt(o, n, i), l = K * 0.5), c = i - n), {
      titleX: d,
      titleY: h,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const s = bt(n.font), a = s.lineHeight / 2 + this._padding.top, { titleX: r, titleY: o, maxWidth: l, rotation: c } = this._drawArgs(a);
    He(t, n.text, 0, 0, s, {
      color: n.color,
      maxWidth: l,
      rotation: c,
      textAlign: za(n.align),
      textBaseline: "middle",
      translation: [
        r,
        o
      ]
    });
  }
}
function y_(e, t) {
  const n = new Ja({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  Pt.configure(e, n, t), Pt.addBox(e, n), e.titleBlock = n;
}
var __ = {
  id: "title",
  _element: Ja,
  start(e, t, n) {
    y_(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    Pt.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const s = e.titleBlock;
    Pt.configure(e, s, n), s.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Ss = /* @__PURE__ */ new WeakMap();
var v_ = {
  id: "subtitle",
  start(e, t, n) {
    const s = new Ja({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Pt.configure(e, s, n), Pt.addBox(e, s), Ss.set(e, s);
  },
  stop(e) {
    Pt.removeBox(e, Ss.get(e)), Ss.delete(e);
  },
  beforeUpdate(e, t, n) {
    const s = Ss.get(e);
    Pt.configure(e, s, n), s.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const En = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, s = /* @__PURE__ */ new Set(), i = 0, a = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const o = e[t].element;
      if (o && o.hasValue()) {
        const l = o.tooltipPosition();
        s.add(l.x), i += l.y, ++a;
      }
    }
    return {
      x: [
        ...s
      ].reduce((o, l) => o + l) / s.size,
      y: i / a
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, s = t.y, i = Number.POSITIVE_INFINITY, a, r, o;
    for (a = 0, r = e.length; a < r; ++a) {
      const l = e[a].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), d = rn(t, c);
        d < i && (i = d, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      n = l.x, s = l.y;
    }
    return {
      x: n,
      y: s
    };
  }
};
function Yt(e, t) {
  return t && (tt(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function ne(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function x_(e, t) {
  const { element: n, datasetIndex: s, index: i } = t, a = e.getDatasetMeta(s).controller, { label: r, value: o } = a.getLabelAndValue(i);
  return {
    chart: e,
    label: r,
    parsed: a.getParsed(i),
    raw: e.data.datasets[s].data[i],
    formattedValue: o,
    dataset: a.getDataset(),
    dataIndex: i,
    datasetIndex: s,
    element: n
  };
}
function Go(e, t) {
  const n = e.chart.ctx, { body: s, footer: i, title: a } = e, { boxWidth: r, boxHeight: o } = t, l = bt(t.bodyFont), c = bt(t.titleFont), d = bt(t.footerFont), h = a.length, u = i.length, f = s.length, g = kt(t.padding);
  let m = g.height, p = 0, b = s.reduce((w, x) => w + x.before.length + x.lines.length + x.after.length, 0);
  if (b += e.beforeBody.length + e.afterBody.length, h && (m += h * c.lineHeight + (h - 1) * t.titleSpacing + t.titleMarginBottom), b) {
    const w = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    m += f * w + (b - f) * l.lineHeight + (b - 1) * t.bodySpacing;
  }
  u && (m += t.footerMarginTop + u * d.lineHeight + (u - 1) * t.footerSpacing);
  let y = 0;
  const v = function(w) {
    p = Math.max(p, n.measureText(w).width + y);
  };
  return n.save(), n.font = c.string, nt(e.title, v), n.font = l.string, nt(e.beforeBody.concat(e.afterBody), v), y = t.displayColors ? r + 2 + t.boxPadding : 0, nt(s, (w) => {
    nt(w.before, v), nt(w.lines, v), nt(w.after, v);
  }), y = 0, n.font = d.string, nt(e.footer, v), n.restore(), p += g.width, {
    width: p,
    height: m
  };
}
function w_(e, t) {
  const { y: n, height: s } = t;
  return n < s / 2 ? "top" : n > e.height - s / 2 ? "bottom" : "center";
}
function k_(e, t, n, s) {
  const { x: i, width: a } = s, r = n.caretSize + n.caretPadding;
  if (e === "left" && i + a + r > t.width || e === "right" && i - a - r < 0)
    return !0;
}
function C_(e, t, n, s) {
  const { x: i, width: a } = n, { width: r, chartArea: { left: o, right: l } } = e;
  let c = "center";
  return s === "center" ? c = i <= (o + l) / 2 ? "left" : "right" : i <= a / 2 ? c = "left" : i >= r - a / 2 && (c = "right"), k_(c, e, t, n) && (c = "center"), c;
}
function Uo(e, t, n) {
  const s = n.yAlign || t.yAlign || w_(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || C_(e, t, n, s),
    yAlign: s
  };
}
function S_(e, t) {
  let { x: n, width: s } = e;
  return t === "right" ? n -= s : t === "center" && (n -= s / 2), n;
}
function M_(e, t, n) {
  let { y: s, height: i } = e;
  return t === "top" ? s += n : t === "bottom" ? s -= i + n : s -= i / 2, s;
}
function Xo(e, t, n, s) {
  const { caretSize: i, caretPadding: a, cornerRadius: r } = e, { xAlign: o, yAlign: l } = n, c = i + a, { topLeft: d, topRight: h, bottomLeft: u, bottomRight: f } = ve(r);
  let g = S_(t, o);
  const m = M_(t, l, c);
  return l === "center" ? o === "left" ? g += c : o === "right" && (g -= c) : o === "left" ? g -= Math.max(d, u) + i : o === "right" && (g += Math.max(h, f) + i), {
    x: Mt(g, 0, s.width - t.width),
    y: Mt(m, 0, s.height - t.height)
  };
}
function Ms(e, t, n) {
  const s = kt(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - s.right : e.x + s.left;
}
function qo(e) {
  return Yt([], ne(e));
}
function O_(e, t, n) {
  return Me(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function Ko(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const Id = {
  beforeTitle: te,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, s = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (s > 0 && t.dataIndex < s)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: te,
  beforeBody: te,
  beforeLabel: te,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return U(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: te,
  afterBody: te,
  beforeFooter: te,
  footer: te,
  afterFooter: te
};
function At(e, t, n, s) {
  const i = e[t].call(n, s);
  return typeof i > "u" ? Id[t].call(n, s) : i;
}
class fa extends Ot {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, s = this.options.setContext(this.getContext()), i = s.enabled && n.options.animation && s.animations, a = new qa(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = O_(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: s } = n, i = At(s, "beforeTitle", this, t), a = At(s, "title", this, t), r = At(s, "afterTitle", this, t);
    let o = [];
    return o = Yt(o, ne(i)), o = Yt(o, ne(a)), o = Yt(o, ne(r)), o;
  }
  getBeforeBody(t, n) {
    return qo(At(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: s } = n, i = [];
    return nt(t, (a) => {
      const r = {
        before: [],
        lines: [],
        after: []
      }, o = Ko(s, a);
      Yt(r.before, ne(At(o, "beforeLabel", this, a))), Yt(r.lines, At(o, "label", this, a)), Yt(r.after, ne(At(o, "afterLabel", this, a))), i.push(r);
    }), i;
  }
  getAfterBody(t, n) {
    return qo(At(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: s } = n, i = At(s, "beforeFooter", this, t), a = At(s, "footer", this, t), r = At(s, "afterFooter", this, t);
    let o = [];
    return o = Yt(o, ne(i)), o = Yt(o, ne(a)), o = Yt(o, ne(r)), o;
  }
  _createItems(t) {
    const n = this._active, s = this.chart.data, i = [], a = [], r = [];
    let o = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      o.push(x_(this.chart, n[l]));
    return t.filter && (o = o.filter((d, h, u) => t.filter(d, h, u, s))), t.itemSort && (o = o.sort((d, h) => t.itemSort(d, h, s))), nt(o, (d) => {
      const h = Ko(t.callbacks, d);
      i.push(At(h, "labelColor", this, d)), a.push(At(h, "labelPointStyle", this, d)), r.push(At(h, "labelTextColor", this, d));
    }), this.labelColors = i, this.labelPointStyles = a, this.labelTextColors = r, this.dataPoints = o, o;
  }
  update(t, n) {
    const s = this.options.setContext(this.getContext()), i = this._active;
    let a, r = [];
    if (!i.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const o = En[s.position].call(this, i, this._eventPosition);
      r = this._createItems(s), this.title = this.getTitle(r, s), this.beforeBody = this.getBeforeBody(r, s), this.body = this.getBody(r, s), this.afterBody = this.getAfterBody(r, s), this.footer = this.getFooter(r, s);
      const l = this._size = Go(this, s), c = Object.assign({}, o, l), d = Uo(this.chart, s, c), h = Xo(s, c, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, a = {
        opacity: 1,
        x: h.x,
        y: h.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = r, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && s.external && s.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, s, i) {
    const a = this.getCaretPosition(t, s, i);
    n.lineTo(a.x1, a.y1), n.lineTo(a.x2, a.y2), n.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, n, s) {
    const { xAlign: i, yAlign: a } = this, { caretSize: r, cornerRadius: o } = s, { topLeft: l, topRight: c, bottomLeft: d, bottomRight: h } = ve(o), { x: u, y: f } = t, { width: g, height: m } = n;
    let p, b, y, v, w, x;
    return a === "center" ? (w = f + m / 2, i === "left" ? (p = u, b = p - r, v = w + r, x = w - r) : (p = u + g, b = p + r, v = w - r, x = w + r), y = p) : (i === "left" ? b = u + Math.max(l, d) + r : i === "right" ? b = u + g - Math.max(c, h) - r : b = this.caretX, a === "top" ? (v = f, w = v - r, p = b - r, y = b + r) : (v = f + m, w = v + r, p = b + r, y = b - r), x = v), {
      x1: p,
      x2: b,
      x3: y,
      y1: v,
      y2: w,
      y3: x
    };
  }
  drawTitle(t, n, s) {
    const i = this.title, a = i.length;
    let r, o, l;
    if (a) {
      const c = sn(s.rtl, this.x, this.width);
      for (t.x = Ms(this, s.titleAlign, s), n.textAlign = c.textAlign(s.titleAlign), n.textBaseline = "middle", r = bt(s.titleFont), o = s.titleSpacing, n.fillStyle = s.titleColor, n.font = r.string, l = 0; l < a; ++l)
        n.fillText(i[l], c.x(t.x), t.y + r.lineHeight / 2), t.y += r.lineHeight + o, l + 1 === a && (t.y += s.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, n, s, i, a) {
    const r = this.labelColors[s], o = this.labelPointStyles[s], { boxHeight: l, boxWidth: c } = a, d = bt(a.bodyFont), h = Ms(this, "left", a), u = i.x(h), f = l < d.lineHeight ? (d.lineHeight - l) / 2 : 0, g = n.y + f;
    if (a.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, p = i.leftForLtr(u, c) + c / 2, b = g + l / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, ra(t, m, p, b), t.strokeStyle = r.borderColor, t.fillStyle = r.backgroundColor, ra(t, m, p, b);
    } else {
      t.lineWidth = H(r.borderWidth) ? Math.max(...Object.values(r.borderWidth)) : r.borderWidth || 1, t.strokeStyle = r.borderColor, t.setLineDash(r.borderDash || []), t.lineDashOffset = r.borderDashOffset || 0;
      const m = i.leftForLtr(u, c), p = i.leftForLtr(i.xPlus(u, 1), c - 2), b = ve(r.borderRadius);
      Object.values(b).some((y) => y !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, on(t, {
        x: m,
        y: g,
        w: c,
        h: l,
        radius: b
      }), t.fill(), t.stroke(), t.fillStyle = r.backgroundColor, t.beginPath(), on(t, {
        x: p,
        y: g + 1,
        w: c - 2,
        h: l - 2,
        radius: b
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(m, g, c, l), t.strokeRect(m, g, c, l), t.fillStyle = r.backgroundColor, t.fillRect(p, g + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[s];
  }
  drawBody(t, n, s) {
    const { body: i } = this, { bodySpacing: a, bodyAlign: r, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: d } = s, h = bt(s.bodyFont);
    let u = h.lineHeight, f = 0;
    const g = sn(s.rtl, this.x, this.width), m = function(M) {
      n.fillText(M, g.x(t.x + f), t.y + u / 2), t.y += u + a;
    }, p = g.textAlign(r);
    let b, y, v, w, x, C, O;
    for (n.textAlign = r, n.textBaseline = "middle", n.font = h.string, t.x = Ms(this, p, s), n.fillStyle = s.bodyColor, nt(this.beforeBody, m), f = o && p !== "right" ? r === "center" ? c / 2 + d : c + 2 + d : 0, w = 0, C = i.length; w < C; ++w) {
      for (b = i[w], y = this.labelTextColors[w], n.fillStyle = y, nt(b.before, m), v = b.lines, o && v.length && (this._drawColorBox(n, t, w, g, s), u = Math.max(h.lineHeight, l)), x = 0, O = v.length; x < O; ++x)
        m(v[x]), u = h.lineHeight;
      nt(b.after, m);
    }
    f = 0, u = h.lineHeight, nt(this.afterBody, m), t.y -= a;
  }
  drawFooter(t, n, s) {
    const i = this.footer, a = i.length;
    let r, o;
    if (a) {
      const l = sn(s.rtl, this.x, this.width);
      for (t.x = Ms(this, s.footerAlign, s), t.y += s.footerMarginTop, n.textAlign = l.textAlign(s.footerAlign), n.textBaseline = "middle", r = bt(s.footerFont), n.fillStyle = s.footerColor, n.font = r.string, o = 0; o < a; ++o)
        n.fillText(i[o], l.x(t.x), t.y + r.lineHeight / 2), t.y += r.lineHeight + s.footerSpacing;
    }
  }
  drawBackground(t, n, s, i) {
    const { xAlign: a, yAlign: r } = this, { x: o, y: l } = t, { width: c, height: d } = s, { topLeft: h, topRight: u, bottomLeft: f, bottomRight: g } = ve(i.cornerRadius);
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, n.lineWidth = i.borderWidth, n.beginPath(), n.moveTo(o + h, l), r === "top" && this.drawCaret(t, n, s, i), n.lineTo(o + c - u, l), n.quadraticCurveTo(o + c, l, o + c, l + u), r === "center" && a === "right" && this.drawCaret(t, n, s, i), n.lineTo(o + c, l + d - g), n.quadraticCurveTo(o + c, l + d, o + c - g, l + d), r === "bottom" && this.drawCaret(t, n, s, i), n.lineTo(o + f, l + d), n.quadraticCurveTo(o, l + d, o, l + d - f), r === "center" && a === "left" && this.drawCaret(t, n, s, i), n.lineTo(o, l + h), n.quadraticCurveTo(o, l, o + h, l), n.closePath(), n.fill(), i.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, s = this.$animations, i = s && s.x, a = s && s.y;
    if (i || a) {
      const r = En[t.position].call(this, this._active, this._eventPosition);
      if (!r)
        return;
      const o = this._size = Go(this, t), l = Object.assign({}, r, this._size), c = Uo(n, t, l), d = Xo(t, l, c, n);
      (i._to !== d.x || a._to !== d.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = r.x, this.caretY = r.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let s = this.opacity;
    if (!s)
      return;
    this._updateAnimationTarget(n);
    const i = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    s = Math.abs(s) < 1e-3 ? 0 : s;
    const r = kt(n.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && o && (t.save(), t.globalAlpha = s, this.drawBackground(a, t, i, n), cd(t, n.textDirection), a.y += r.top, this.drawTitle(a, t, n), this.drawBody(a, t, n), this.drawFooter(a, t, n), dd(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const s = this._active, i = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), a = !qs(s, i), r = this._positionChanged(i, n);
    (a || r) && (this._active = i, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, s = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, a = this._active || [], r = this._getActiveElements(t, a, n, s), o = this._positionChanged(r, t), l = n || !qs(r, a) || o;
    return l && (this._active = r, (i.enabled || i.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(t, n, s, i) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const r = this.chart.getElementsAtEventForMode(t, a.mode, a, s);
    return a.reverse && r.reverse(), r;
  }
  _positionChanged(t, n) {
    const { caretX: s, caretY: i, options: a } = this, r = En[a.position].call(this, t, n);
    return r !== !1 && (s !== r.x || i !== r.y);
  }
}
E(fa, "positioners", En);
var T_ = {
  id: "tooltip",
  _element: fa,
  positioners: En,
  afterInit(e, t, n) {
    n && (e.tooltip = new fa({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Id
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, P_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: zy,
  Decimation: Yy,
  Filler: h_,
  Legend: b_,
  SubTitle: v_,
  Title: __,
  Tooltip: T_
});
const A_ = (e, t, n, s) => (typeof t == "string" ? (n = e.push(t) - 1, s.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function $_(e, t, n, s) {
  const i = e.indexOf(t);
  if (i === -1)
    return A_(e, t, n, s);
  const a = e.lastIndexOf(t);
  return i !== a ? n : i;
}
const D_ = (e, t) => e === null ? null : Mt(Math.round(e), 0, t);
function Qo(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class ga extends Ge {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const s = this.getLabels();
      for (const { index: i, label: a } of n)
        s[i] === a && s.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (U(t))
      return null;
    const s = this.getLabels();
    return n = isFinite(n) && s[n] === t ? n : $_(s, t, j(n, t), this._addedLabels), D_(n, s.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: s, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (s = 0), n || (i = this.getLabels().length - 1)), this.min = s, this.max = i;
  }
  buildTicks() {
    const t = this.min, n = this.max, s = this.options.offset, i = [];
    let a = this.getLabels();
    a = t === 0 && n === a.length - 1 ? a : a.slice(t, n + 1), this._valueRange = Math.max(a.length - (s ? 0 : 1), 1), this._startValue = this.min - (s ? 0.5 : 0);
    for (let r = t; r <= n; r++)
      i.push({
        value: r
      });
    return i;
  }
  getLabelForValue(t) {
    return Qo.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
E(ga, "id", "category"), E(ga, "defaults", {
  ticks: {
    callback: Qo
  }
});
function L_(e, t) {
  const n = [], { bounds: i, step: a, min: r, max: o, precision: l, count: c, maxTicks: d, maxDigits: h, includeBounds: u } = e, f = a || 1, g = d - 1, { min: m, max: p } = t, b = !U(r), y = !U(o), v = !U(c), w = (p - m) / (h + 1);
  let x = Yr((p - m) / g / f) * f, C, O, M, A;
  if (x < 1e-14 && !b && !y)
    return [
      {
        value: m
      },
      {
        value: p
      }
    ];
  A = Math.ceil(p / x) - Math.floor(m / x), A > g && (x = Yr(A * x / g / f) * f), U(l) || (C = Math.pow(10, l), x = Math.ceil(x * C) / C), i === "ticks" ? (O = Math.floor(m / x) * x, M = Math.ceil(p / x) * x) : (O = m, M = p), b && y && a && Tp((o - r) / a, x / 1e3) ? (A = Math.round(Math.min((o - r) / x, d)), x = (o - r) / A, O = r, M = o) : v ? (O = b ? r : O, M = y ? o : M, A = c - 1, x = (M - O) / A) : (A = (M - O) / x, Wn(A, Math.round(A), x / 1e3) ? A = Math.round(A) : A = Math.ceil(A));
  const $ = Math.max(Gr(x), Gr(O));
  C = Math.pow(10, U(l) ? $ : l), O = Math.round(O * C) / C, M = Math.round(M * C) / C;
  let D = 0;
  for (b && (u && O !== r ? (n.push({
    value: r
  }), O < r && D++, Wn(Math.round((O + D * x) * C) / C, r, Jo(r, w, e)) && D++) : O < r && D++); D < A; ++D) {
    const F = Math.round((O + D * x) * C) / C;
    if (y && F > o)
      break;
    n.push({
      value: F
    });
  }
  return y && u && M !== o ? n.length && Wn(n[n.length - 1].value, o, Jo(o, w, e)) ? n[n.length - 1].value = o : n.push({
    value: o
  }) : (!y || M === o) && n.push({
    value: M
  }), n;
}
function Jo(e, t, { horizontal: n, minRotation: s }) {
  const i = St(s), a = (n ? Math.sin(i) : Math.cos(i)) || 1e-3, r = 0.75 * t * ("" + e).length;
  return Math.min(t / a, r);
}
class ii extends Ge {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return U(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: s } = this.getUserBounds();
    let { min: i, max: a } = this;
    const r = (l) => i = n ? i : l, o = (l) => a = s ? a : l;
    if (t) {
      const l = Ut(i), c = Ut(a);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && r(0);
    }
    if (i === a) {
      let l = a === 0 ? 1 : Math.abs(a * 0.05);
      o(a + l), t || r(i - l);
    }
    this.min = i, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: s } = t, i;
    return s ? (i = Math.ceil(this.max / s) - Math.floor(this.min / s) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), n = n || 11), n && (i = Math.min(n, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let s = this.getTickLimit();
    s = Math.max(2, s);
    const i = {
      maxTicks: s,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, a = this._range || this, r = L_(i, a);
    return t.bounds === "ticks" && Gc(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, s = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const i = (s - n) / Math.max(t.length - 1, 1) / 2;
      n -= i, s += i;
    }
    this._startValue = n, this._endValue = s, this._valueRange = s - n;
  }
  getLabelForValue(t) {
    return ss(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class pa extends ii {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = pt(t) ? t : 0, this.max = pt(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, s = St(this.options.ticks.minRotation), i = (t ? Math.sin(s) : Math.cos(s)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, a.lineHeight / i));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
E(pa, "id", "linear"), E(pa, "defaults", {
  ticks: {
    callback: pi.formatters.numeric
  }
});
const Zn = (e) => Math.floor(me(e)), $e = (e, t) => Math.pow(10, Zn(e) + t);
function Zo(e) {
  return e / Math.pow(10, Zn(e)) === 1;
}
function tl(e, t, n) {
  const s = Math.pow(10, n), i = Math.floor(e / s);
  return Math.ceil(t / s) - i;
}
function E_(e, t) {
  const n = t - e;
  let s = Zn(n);
  for (; tl(e, t, s) > 10; )
    s++;
  for (; tl(e, t, s) < 10; )
    s--;
  return Math.min(s, Zn(e));
}
function I_(e, { min: t, max: n }) {
  t = It(e.min, t);
  const s = [], i = Zn(t);
  let a = E_(t, n), r = a < 0 ? Math.pow(10, Math.abs(a)) : 1;
  const o = Math.pow(10, a), l = i > a ? Math.pow(10, i) : 0, c = Math.round((t - l) * r) / r, d = Math.floor((t - l) / o / 10) * o * 10;
  let h = Math.floor((c - d) / Math.pow(10, a)), u = It(e.min, Math.round((l + d + h * Math.pow(10, a)) * r) / r);
  for (; u < n; )
    s.push({
      value: u,
      major: Zo(u),
      significand: h
    }), h >= 10 ? h = h < 15 ? 15 : 20 : h++, h >= 20 && (a++, h = 2, r = a >= 0 ? 1 : r), u = Math.round((l + d + h * Math.pow(10, a)) * r) / r;
  const f = It(e.max, u);
  return s.push({
    value: f,
    major: Zo(f),
    significand: h
  }), s;
}
class ma extends Ge {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const s = ii.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (s === 0) {
      this._zero = !0;
      return;
    }
    return pt(s) && s > 0 ? s : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = pt(t) ? Math.max(0, t) : null, this.max = pt(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !pt(this._userMin) && (this.min = t === $e(this.min, 0) ? $e(this.min, -1) : $e(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let s = this.min, i = this.max;
    const a = (o) => s = t ? s : o, r = (o) => i = n ? i : o;
    s === i && (s <= 0 ? (a(1), r(10)) : (a($e(s, -1)), r($e(i, 1)))), s <= 0 && a($e(i, -1)), i <= 0 && r($e(s, 1)), this.min = s, this.max = i;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, s = I_(n, this);
    return t.bounds === "ticks" && Gc(s, this, "value"), t.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : ss(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = me(t), this._valueRange = me(this.max) - me(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (me(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
E(ma, "id", "logarithmic"), E(ma, "defaults", {
  ticks: {
    callback: pi.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function ba(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = kt(t.backdropPadding);
    return j(t.font && t.font.size, mt.font.size) + n.height;
  }
  return 0;
}
function R_(e, t, n) {
  return n = tt(n) ? n : [
    n
  ], {
    w: Yp(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function el(e, t, n, s, i) {
  return e === s || e === i ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < s || e > i ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function B_(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), s = [], i = [], a = e._pointLabels.length, r = e.options.pointLabels, o = r.centerPointLabels ? K / a : 0;
  for (let l = 0; l < a; l++) {
    const c = r.setContext(e.getPointLabelContext(l));
    i[l] = c.padding;
    const d = e.getPointPosition(l, e.drawingArea + i[l], o), h = bt(c.font), u = R_(e.ctx, h, e._pointLabels[l]);
    s[l] = u;
    const f = Rt(e.getIndexAngle(l) + o), g = Math.round(gi(f)), m = el(g, d.x, u.w, 0, 180), p = el(g, d.y, u.h, 90, 270);
    F_(n, t, f, m, p);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = z_(e, s, i);
}
function F_(e, t, n, s, i) {
  const a = Math.abs(Math.sin(n)), r = Math.abs(Math.cos(n));
  let o = 0, l = 0;
  s.start < t.l ? (o = (t.l - s.start) / a, e.l = Math.min(e.l, t.l - o)) : s.end > t.r && (o = (s.end - t.r) / a, e.r = Math.max(e.r, t.r + o)), i.start < t.t ? (l = (t.t - i.start) / r, e.t = Math.min(e.t, t.t - l)) : i.end > t.b && (l = (i.end - t.b) / r, e.b = Math.max(e.b, t.b + l));
}
function W_(e, t, n) {
  const s = e.drawingArea, { extra: i, additionalAngle: a, padding: r, size: o } = n, l = e.getPointPosition(t, s + i + r, a), c = Math.round(gi(Rt(l.angle + ht))), d = V_(l.y, o.h, c), h = j_(c), u = H_(l.x, o.w, h);
  return {
    visible: !0,
    x: l.x,
    y: d,
    textAlign: h,
    left: u,
    top: d,
    right: u + o.w,
    bottom: d + o.h
  };
}
function N_(e, t) {
  if (!t)
    return !0;
  const { left: n, top: s, right: i, bottom: a } = e;
  return !(oe({
    x: n,
    y: s
  }, t) || oe({
    x: n,
    y: a
  }, t) || oe({
    x: i,
    y: s
  }, t) || oe({
    x: i,
    y: a
  }, t));
}
function z_(e, t, n) {
  const s = [], i = e._pointLabels.length, a = e.options, { centerPointLabels: r, display: o } = a.pointLabels, l = {
    extra: ba(a) / 2,
    additionalAngle: r ? K / i : 0
  };
  let c;
  for (let d = 0; d < i; d++) {
    l.padding = n[d], l.size = t[d];
    const h = W_(e, d, l);
    s.push(h), o === "auto" && (h.visible = N_(h, c), h.visible && (c = h));
  }
  return s;
}
function j_(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function H_(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function V_(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function Y_(e, t, n) {
  const { left: s, top: i, right: a, bottom: r } = n, { backdropColor: o } = t;
  if (!U(o)) {
    const l = ve(t.borderRadius), c = kt(t.backdropPadding);
    e.fillStyle = o;
    const d = s - c.left, h = i - c.top, u = a - s + c.width, f = r - i + c.height;
    Object.values(l).some((g) => g !== 0) ? (e.beginPath(), on(e, {
      x: d,
      y: h,
      w: u,
      h: f,
      radius: l
    }), e.fill()) : e.fillRect(d, h, u, f);
  }
}
function G_(e, t) {
  const { ctx: n, options: { pointLabels: s } } = e;
  for (let i = t - 1; i >= 0; i--) {
    const a = e._pointLabelItems[i];
    if (!a.visible)
      continue;
    const r = s.setContext(e.getPointLabelContext(i));
    Y_(n, r, a);
    const o = bt(r.font), { x: l, y: c, textAlign: d } = a;
    He(n, e._pointLabels[i], l, c + o.lineHeight / 2, o, {
      color: r.color,
      textAlign: d,
      textBaseline: "middle"
    });
  }
}
function Rd(e, t, n, s) {
  const { ctx: i } = e;
  if (n)
    i.arc(e.xCenter, e.yCenter, t, 0, ot);
  else {
    let a = e.getPointPosition(0, t);
    i.moveTo(a.x, a.y);
    for (let r = 1; r < s; r++)
      a = e.getPointPosition(r, t), i.lineTo(a.x, a.y);
  }
}
function U_(e, t, n, s, i) {
  const a = e.ctx, r = t.circular, { color: o, lineWidth: l } = t;
  !r && !s || !o || !l || n < 0 || (a.save(), a.strokeStyle = o, a.lineWidth = l, a.setLineDash(i.dash), a.lineDashOffset = i.dashOffset, a.beginPath(), Rd(e, n, r, s), a.closePath(), a.stroke(), a.restore());
}
function X_(e, t, n) {
  return Me(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class In extends ii {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = kt(ba(this.options) / 2), n = this.width = this.maxWidth - t.width, s = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + s / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, s) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = pt(t) && !isNaN(t) ? t : 0, this.max = pt(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / ba(this.options));
  }
  generateTickLabels(t) {
    ii.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, s) => {
      const i = et(this.options.pointLabels.callback, [
        n,
        s
      ], this);
      return i || i === 0 ? i : "";
    }).filter((n, s) => this.chart.getDataVisibility(s));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? B_(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, s, i) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((s - i) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, s, i));
  }
  getIndexAngle(t) {
    const n = ot / (this._pointLabels.length || 1), s = this.options.startAngle || 0;
    return Rt(t * n + St(s));
  }
  getDistanceFromCenterForValue(t) {
    if (U(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (U(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const s = n[t];
      return X_(this.getContext(), t, s);
    }
  }
  getPointPosition(t, n, s = 0) {
    const i = this.getIndexAngle(t) - ht + s;
    return {
      x: Math.cos(i) * n + this.xCenter,
      y: Math.sin(i) * n + this.yCenter,
      angle: i
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: s, right: i, bottom: a } = this._pointLabelItems[t];
    return {
      left: n,
      top: s,
      right: i,
      bottom: a
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const s = this.ctx;
      s.save(), s.beginPath(), Rd(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), s.closePath(), s.fillStyle = t, s.fill(), s.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: s, grid: i, border: a } = n, r = this._pointLabels.length;
    let o, l, c;
    if (n.pointLabels.display && G_(this, r), i.display && this.ticks.forEach((d, h) => {
      if (h !== 0 || h === 0 && this.min < 0) {
        l = this.getDistanceFromCenterForValue(d.value);
        const u = this.getContext(h), f = i.setContext(u), g = a.setContext(u);
        U_(this, f, l, r, g);
      }
    }), s.display) {
      for (t.save(), o = r - 1; o >= 0; o--) {
        const d = s.setContext(this.getPointLabelContext(o)), { color: h, lineWidth: u } = d;
        !u || !h || (t.lineWidth = u, t.strokeStyle = h, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(o, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, s = n.ticks;
    if (!s.display)
      return;
    const i = this.getIndexAngle(0);
    let a, r;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(i), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && this.min >= 0 && !n.reverse)
        return;
      const c = s.setContext(this.getContext(l)), d = bt(c.font);
      if (a = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = d.string, r = t.measureText(o.label).width, t.fillStyle = c.backdropColor;
        const h = kt(c.backdropPadding);
        t.fillRect(-r / 2 - h.left, -a - d.size / 2 - h.top, r + h.width, d.size + h.height);
      }
      He(t, o.label, 0, -a, d, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
E(In, "id", "radialLinear"), E(In, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: pi.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), E(In, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), E(In, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const bi = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Dt = /* @__PURE__ */ Object.keys(bi);
function nl(e, t) {
  return e - t;
}
function sl(e, t) {
  if (U(t))
    return null;
  const n = e._adapter, { parser: s, round: i, isoWeekday: a } = e._parseOpts;
  let r = t;
  return typeof s == "function" && (r = s(r)), pt(r) || (r = typeof s == "string" ? n.parse(r, s) : n.parse(r)), r === null ? null : (i && (r = i === "week" && (ke(a) || a === !0) ? n.startOf(r, "isoWeek", a) : n.startOf(r, i)), +r);
}
function il(e, t, n, s) {
  const i = Dt.length;
  for (let a = Dt.indexOf(e); a < i - 1; ++a) {
    const r = bi[Dt[a]], o = r.steps ? r.steps : Number.MAX_SAFE_INTEGER;
    if (r.common && Math.ceil((n - t) / (o * r.size)) <= s)
      return Dt[a];
  }
  return Dt[i - 1];
}
function q_(e, t, n, s, i) {
  for (let a = Dt.length - 1; a >= Dt.indexOf(n); a--) {
    const r = Dt[a];
    if (bi[r].common && e._adapter.diff(i, s, r) >= t - 1)
      return r;
  }
  return Dt[n ? Dt.indexOf(n) : 0];
}
function K_(e) {
  for (let t = Dt.indexOf(e) + 1, n = Dt.length; t < n; ++t)
    if (bi[Dt[t]].common)
      return Dt[t];
}
function al(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: s, hi: i } = Na(n, t), a = n[s] >= t ? n[s] : n[i];
    e[a] = !0;
  }
}
function Q_(e, t, n, s) {
  const i = e._adapter, a = +i.startOf(t[0].value, s), r = t[t.length - 1].value;
  let o, l;
  for (o = a; o <= r; o = +i.add(o, 1, s))
    l = n[o], l >= 0 && (t[l].major = !0);
  return t;
}
function rl(e, t, n) {
  const s = [], i = {}, a = t.length;
  let r, o;
  for (r = 0; r < a; ++r)
    o = t[r], i[o] = r, s.push({
      value: o,
      major: !1
    });
  return a === 0 || !n ? s : Q_(e, s, i, n);
}
class ts extends Ge {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const s = t.time || (t.time = {}), i = this._adapter = new md._date(t.adapters.date);
    i.init(n), Fn(s.displayFormats, i.formats()), this._parseOpts = {
      parser: s.parser,
      round: s.round,
      isoWeekday: s.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : sl(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, s = t.time.unit || "day";
    let { min: i, max: a, minDefined: r, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !r && !isNaN(c.min) && (i = Math.min(i, c.min)), !o && !isNaN(c.max) && (a = Math.max(a, c.max));
    }
    (!r || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), i = pt(i) && !isNaN(i) ? i : +n.startOf(Date.now(), s), a = pt(a) && !isNaN(a) ? a : +n.endOf(Date.now(), s) + 1, this.min = Math.min(i, a - 1), this.max = Math.max(i + 1, a);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], s = t[t.length - 1]), {
      min: n,
      max: s
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, s = t.ticks, i = s.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const a = this.min, r = this.max, o = Dp(i, a, r);
    return this._unit = n.unit || (s.autoSkip ? il(n.minUnit, this.min, this.max, this._getLabelCapacity(a)) : q_(this, o.length, n.minUnit, this.min, this.max)), this._majorUnit = !s.major.enabled || this._unit === "year" ? void 0 : K_(this._unit), this.initOffsets(i), t.reverse && o.reverse(), rl(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, s = 0, i, a;
    this.options.offset && t.length && (i = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - i : n = (this.getDecimalForValue(t[1]) - i) / 2, a = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? s = a : s = (a - this.getDecimalForValue(t[t.length - 2])) / 2);
    const r = t.length < 3 ? 0.5 : 0.25;
    n = Mt(n, 0, r), s = Mt(s, 0, r), this._offsets = {
      start: n,
      end: s,
      factor: 1 / (n + 1 + s)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, s = this.max, i = this.options, a = i.time, r = a.unit || il(a.minUnit, n, s, this._getLabelCapacity(n)), o = j(i.ticks.stepSize, 1), l = r === "week" ? a.isoWeekday : !1, c = ke(l) || l === !0, d = {};
    let h = n, u, f;
    if (c && (h = +t.startOf(h, "isoWeek", l)), h = +t.startOf(h, c ? "day" : r), t.diff(s, n, r) > 1e5 * o)
      throw new Error(n + " and " + s + " are too far apart with stepSize of " + o + " " + r);
    const g = i.ticks.source === "data" && this.getDataTimestamps();
    for (u = h, f = 0; u < s; u = +t.add(u, o, r), f++)
      al(d, u, g);
    return (u === s || i.bounds === "ticks" || f === 1) && al(d, u, g), Object.keys(d).sort(nl).map((m) => +m);
  }
  getLabelForValue(t) {
    const n = this._adapter, s = this.options.time;
    return s.tooltipFormat ? n.format(t, s.tooltipFormat) : n.format(t, s.displayFormats.datetime);
  }
  format(t, n) {
    const i = this.options.time.displayFormats, a = this._unit, r = n || i[a];
    return this._adapter.format(t, r);
  }
  _tickFormatFunction(t, n, s, i) {
    const a = this.options, r = a.ticks.callback;
    if (r)
      return et(r, [
        t,
        n,
        s
      ], this);
    const o = a.time.displayFormats, l = this._unit, c = this._majorUnit, d = l && o[l], h = c && o[c], u = s[n], f = c && h && u && u.major;
    return this._adapter.format(t, i || (f ? h : d));
  }
  generateTickLabels(t) {
    let n, s, i;
    for (n = 0, s = t.length; n < s; ++n)
      i = t[n], i.label = this._tickFormatFunction(i.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, s = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + s) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, s = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + s * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, s = this.ctx.measureText(t).width, i = St(this.isHorizontal() ? n.maxRotation : n.minRotation), a = Math.cos(i), r = Math.sin(i), o = this._resolveTickFontOptions(0).size;
    return {
      w: s * a + o * r,
      h: s * r + o * a
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, s = n.displayFormats, i = s[n.unit] || s.millisecond, a = this._tickFormatFunction(t, 0, rl(this, [
      t
    ], this._majorUnit), i), r = this._getLabelSize(a), o = Math.floor(this.isHorizontal() ? this.width / r.w : this.height / r.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, s;
    if (t.length)
      return t;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (n = 0, s = i.length; n < s; ++n)
      t = t.concat(i[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, s;
    if (t.length)
      return t;
    const i = this.getLabels();
    for (n = 0, s = i.length; n < s; ++n)
      t.push(sl(this, i[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return qc(t.sort(nl));
  }
}
E(ts, "id", "time"), E(ts, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Os(e, t, n) {
  let s = 0, i = e.length - 1, a, r, o, l;
  n ? (t >= e[s].pos && t <= e[i].pos && ({ lo: s, hi: i } = re(e, "pos", t)), { pos: a, time: o } = e[s], { pos: r, time: l } = e[i]) : (t >= e[s].time && t <= e[i].time && ({ lo: s, hi: i } = re(e, "time", t)), { time: a, pos: o } = e[s], { time: r, pos: l } = e[i]);
  const c = r - a;
  return c ? o + (l - o) * (t - a) / c : o;
}
class ya extends ts {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Os(n, this.min), this._tableRange = Os(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: s } = this, i = [], a = [];
    let r, o, l, c, d;
    for (r = 0, o = t.length; r < o; ++r)
      c = t[r], c >= n && c <= s && i.push(c);
    if (i.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: s,
          pos: 1
        }
      ];
    for (r = 0, o = i.length; r < o; ++r)
      d = i[r + 1], l = i[r - 1], c = i[r], Math.round((d + l) / 2) !== c && a.push({
        time: c,
        pos: r / (o - 1)
      });
    return a;
  }
  _generate() {
    const t = this.min, n = this.max;
    let s = super.getDataTimestamps();
    return (!s.includes(t) || !s.length) && s.splice(0, 0, t), (!s.includes(n) || s.length === 1) && s.push(n), s.sort((i, a) => i - a);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), s = this.getLabelTimestamps();
    return n.length && s.length ? t = this.normalize(n.concat(s)) : t = n.length ? n : s, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Os(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, s = this.getDecimalForPixel(t) / n.factor - n.end;
    return Os(this._table, s * this._tableRange + this._minPos, !0);
  }
}
E(ya, "id", "timeseries"), E(ya, "defaults", ts.defaults);
var J_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: ga,
  LinearScale: pa,
  LogarithmicScale: ma,
  RadialLinearScale: In,
  TimeScale: ts,
  TimeSeriesScale: ya
});
const Z_ = [
  rb,
  Iy,
  P_,
  J_
];
/*!
* chartjs-plugin-annotation v3.0.1
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2023 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */
const ol = {
  modes: {
    /**
     * Point mode returns all elements that hit test based on the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */
    point(e, t) {
      return Ys(e, t, { intersect: !0 });
    },
    /**
     * Nearest mode returns the element closest to the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */
    nearest(e, t, n) {
      return nv(e, t, n);
    },
    /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    x(e, t, n) {
      return Ys(e, t, { intersect: n.intersect, axis: "x" });
    },
    /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    y(e, t, n) {
      return Ys(e, t, { intersect: n.intersect, axis: "y" });
    }
  }
};
function Za(e, t, n) {
  return (ol.modes[n.mode] || ol.modes.nearest)(e, t, n);
}
function tv(e, t, n) {
  return n !== "x" && n !== "y" ? e.inRange(t.x, t.y, "x", !0) || e.inRange(t.x, t.y, "y", !0) : e.inRange(t.x, t.y, n, !0);
}
function ev(e, t, n) {
  return n === "x" ? { x: e.x, y: t.y } : n === "y" ? { x: t.x, y: e.y } : t;
}
function Ys(e, t, n) {
  return e.visibleElements.filter((s) => n.intersect ? s.inRange(t.x, t.y) : tv(s, t, n.axis));
}
function nv(e, t, n) {
  let s = Number.POSITIVE_INFINITY;
  return Ys(e, t, n).reduce((i, a) => {
    const r = a.getCenterPoint(), o = ev(t, r, n.axis), l = rn(t, o);
    return l < s ? (i = [a], s = l) : l === s && i.push(a), i;
  }, []).sort((i, a) => i._index - a._index).slice(0, 1);
}
const sv = (e, t) => t > e || e.length > t.length && e.slice(0, t.length) === t, Fe = 1e-3, yi = (e, t, n) => Math.min(n, Math.max(t, e));
function iv(e, t, n) {
  for (const s of Object.keys(e))
    e[s] = yi(e[s], t, n);
  return e;
}
function av(e, t, n, s) {
  if (!e || !t || n <= 0)
    return !1;
  const i = s / 2;
  return Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2) <= Math.pow(n + i, 2);
}
function Bd(e, { x: t, y: n, x2: s, y2: i }, a, r) {
  const o = r / 2, l = e.x >= t - o - Fe && e.x <= s + o + Fe, c = e.y >= n - o - Fe && e.y <= i + o + Fe;
  return a === "x" ? l : (a === "y" || l) && c;
}
function hn(e, t) {
  const { centerX: n, centerY: s } = e.getProps(["centerX", "centerY"], t);
  return { x: n, y: s };
}
function rv(e, t, n, s = !0) {
  const i = n.split(".");
  let a = 0;
  for (const r of t.split(".")) {
    const o = i[a++];
    if (parseInt(r, 10) < parseInt(o, 10))
      break;
    if (sv(o, r)) {
      if (s)
        throw new Error(`${e} v${n} is not supported. v${t} or newer is required.`);
      return !1;
    }
  }
  return !0;
}
const Fd = (e) => typeof e == "string" && e.endsWith("%"), Wd = (e) => parseFloat(e) / 100, Nd = (e) => yi(Wd(e), 0, 1), Ts = (e, t) => ({ x: e, y: t, x2: e, y2: t, width: 0, height: 0 }), ov = {
  box: (e) => Ts(e.centerX, e.centerY),
  ellipse: (e) => ({ centerX: e.centerX, centerY: e.centerX, radius: 0, width: 0, height: 0 }),
  label: (e) => Ts(e.centerX, e.centerY),
  line: (e) => Ts(e.x, e.y),
  point: (e) => ({ centerX: e.centerX, centerY: e.centerY, radius: 0, width: 0, height: 0 }),
  polygon: (e) => Ts(e.centerX, e.centerY)
};
function tr(e, t) {
  return t === "start" ? 0 : t === "end" ? e : Fd(t) ? Nd(t) * e : e / 2;
}
function Ce(e, t, n = !0) {
  return typeof t == "number" ? t : Fd(t) ? (n ? Nd(t) : Wd(t)) * e : e;
}
function lv(e, t) {
  const { x: n, width: s } = e, i = t.textAlign;
  return i === "center" ? n + s / 2 : i === "end" || i === "right" ? n + s : n;
}
function er(e, t = "center") {
  return H(e) ? {
    x: j(e.x, t),
    y: j(e.y, t)
  } : (e = j(e, t), {
    x: e,
    y: e
  });
}
function zd(e) {
  return e && (Et(e.xValue) || Et(e.yValue));
}
function os(e, t, n) {
  const s = n.init;
  if (s) {
    if (s === !0)
      return Hd(t, n);
  } else
    return;
  return cv(e, t, n);
}
function jd(e, t, n) {
  let s = !1;
  return t.forEach((i) => {
    Lt(e[i]) ? (s = !0, n[i] = e[i]) : Et(n[i]) && delete n[i];
  }), s;
}
function Hd(e, t) {
  const n = t.type || "line";
  return ov[n](e);
}
function cv(e, t, n) {
  const s = et(n.init, [{ chart: e, properties: t, options: n }]);
  if (s === !0)
    return Hd(t, n);
  if (H(s))
    return s;
}
const Vi = /* @__PURE__ */ new Map(), dv = (e) => isNaN(e) || e <= 0, hv = (e) => e.reduce(function(t, n) {
  return t += n.string, t;
}, "");
function _i(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object HTMLImageElement]" || t === "[object HTMLCanvasElement]";
  }
}
function nr(e, { x: t, y: n }, s) {
  s && (e.translate(t, n), e.rotate(St(s)), e.translate(-t, -n));
}
function Se(e, t) {
  if (t && t.borderWidth)
    return e.lineCap = t.borderCapStyle, e.setLineDash(t.borderDash), e.lineDashOffset = t.borderDashOffset, e.lineJoin = t.borderJoinStyle, e.lineWidth = t.borderWidth, e.strokeStyle = t.borderColor, !0;
}
function un(e, t) {
  e.shadowColor = t.backgroundShadowColor, e.shadowBlur = t.shadowBlur, e.shadowOffsetX = t.shadowOffsetX, e.shadowOffsetY = t.shadowOffsetY;
}
function sr(e, t) {
  const n = t.content;
  if (_i(n))
    return {
      width: Ce(n.width, t.width),
      height: Ce(n.height, t.height)
    };
  const s = t.font, i = tt(s) ? s.map((l) => bt(l)) : [bt(s)], a = t.textStrokeWidth, r = tt(n) ? n : [n], o = r.join() + hv(i) + a + (e._measureText ? "-spriting" : "");
  return Vi.has(o) || Vi.set(o, mv(e, r, i, a)), Vi.get(o);
}
function Vd(e, t, n) {
  const { x: s, y: i, width: a, height: r } = t;
  e.save(), un(e, n);
  const o = Se(e, n);
  e.fillStyle = n.backgroundColor, e.beginPath(), on(e, {
    x: s,
    y: i,
    w: a,
    h: r,
    radius: iv(ve(n.borderRadius), 0, Math.min(a, r) / 2)
  }), e.closePath(), e.fill(), o && (e.shadowColor = n.borderShadowColor, e.stroke()), e.restore();
}
function uv(e, t, n) {
  const s = n.content;
  if (_i(s)) {
    e.save(), e.globalAlpha = _v(n.opacity, s.style.opacity), e.drawImage(s, t.x, t.y, t.width, t.height), e.restore();
    return;
  }
  const i = tt(s) ? s : [s], a = n.font, r = tt(a) ? a.map((h) => bt(h)) : [bt(a)], o = n.color, l = tt(o) ? o : [o], c = lv(t, n), d = t.y + n.textStrokeWidth / 2;
  e.save(), e.textBaseline = "middle", e.textAlign = n.textAlign, fv(e, n) && bv(e, { x: c, y: d }, i, r), yv(e, { x: c, y: d }, i, { fonts: r, colors: l }), e.restore();
}
function fv(e, t) {
  if (t.textStrokeWidth > 0)
    return e.lineJoin = "round", e.miterLimit = 2, e.lineWidth = t.textStrokeWidth, e.strokeStyle = t.textStrokeColor, !0;
}
function gv(e, t, n, s) {
  const { radius: i, options: a } = t, r = a.pointStyle, o = a.rotation;
  let l = (o || 0) * Wa;
  if (_i(r)) {
    e.save(), e.translate(n, s), e.rotate(l), e.drawImage(r, -r.width / 2, -r.height / 2, r.width, r.height), e.restore();
    return;
  }
  dv(i) || pv(e, { x: n, y: s, radius: i, rotation: o, style: r, rad: l });
}
function pv(e, { x: t, y: n, radius: s, rotation: i, style: a, rad: r }) {
  let o, l, c, d;
  switch (e.beginPath(), a) {
    default:
      e.arc(t, n, s, 0, ot), e.closePath();
      break;
    case "triangle":
      e.moveTo(t + Math.sin(r) * s, n - Math.cos(r) * s), r += Js, e.lineTo(t + Math.sin(r) * s, n - Math.cos(r) * s), r += Js, e.lineTo(t + Math.sin(r) * s, n - Math.cos(r) * s), e.closePath();
      break;
    case "rectRounded":
      d = s * 0.516, c = s - d, o = Math.cos(r + zt) * c, l = Math.sin(r + zt) * c, e.arc(t - o, n - l, d, r - K, r - ht), e.arc(t + l, n - o, d, r - ht, r), e.arc(t + o, n + l, d, r, r + ht), e.arc(t - l, n + o, d, r + ht, r + K), e.closePath();
      break;
    case "rect":
      if (!i) {
        c = Math.SQRT1_2 * s, e.rect(t - c, n - c, 2 * c, 2 * c);
        break;
      }
      r += zt;
    case "rectRot":
      o = Math.cos(r) * s, l = Math.sin(r) * s, e.moveTo(t - o, n - l), e.lineTo(t + l, n - o), e.lineTo(t + o, n + l), e.lineTo(t - l, n + o), e.closePath();
      break;
    case "crossRot":
      r += zt;
    case "cross":
      o = Math.cos(r) * s, l = Math.sin(r) * s, e.moveTo(t - o, n - l), e.lineTo(t + o, n + l), e.moveTo(t + l, n - o), e.lineTo(t - l, n + o);
      break;
    case "star":
      o = Math.cos(r) * s, l = Math.sin(r) * s, e.moveTo(t - o, n - l), e.lineTo(t + o, n + l), e.moveTo(t + l, n - o), e.lineTo(t - l, n + o), r += zt, o = Math.cos(r) * s, l = Math.sin(r) * s, e.moveTo(t - o, n - l), e.lineTo(t + o, n + l), e.moveTo(t + l, n - o), e.lineTo(t - l, n + o);
      break;
    case "line":
      o = Math.cos(r) * s, l = Math.sin(r) * s, e.moveTo(t - o, n - l), e.lineTo(t + o, n + l);
      break;
    case "dash":
      e.moveTo(t, n), e.lineTo(t + Math.cos(r) * s, n + Math.sin(r) * s);
      break;
  }
  e.fill();
}
function mv(e, t, n, s) {
  e.save();
  const i = t.length;
  let a = 0, r = s;
  for (let o = 0; o < i; o++) {
    const l = n[Math.min(o, n.length - 1)];
    e.font = l.string;
    const c = t[o];
    a = Math.max(a, e.measureText(c).width + s), r += l.lineHeight;
  }
  return e.restore(), { width: a, height: r };
}
function bv(e, { x: t, y: n }, s, i) {
  e.beginPath();
  let a = 0;
  s.forEach(function(r, o) {
    const l = i[Math.min(o, i.length - 1)], c = l.lineHeight;
    e.font = l.string, e.strokeText(r, t, n + c / 2 + a), a += c;
  }), e.stroke();
}
function yv(e, { x: t, y: n }, s, { fonts: i, colors: a }) {
  let r = 0;
  s.forEach(function(o, l) {
    const c = a[Math.min(l, a.length - 1)], d = i[Math.min(l, i.length - 1)], h = d.lineHeight;
    e.beginPath(), e.font = d.string, e.fillStyle = c, e.fillText(o, t, n + h / 2 + r), r += h, e.fill();
  });
}
function _v(e, t) {
  const n = ke(e) ? e : t;
  return ke(n) ? yi(n, 0, 1) : 1;
}
const ll = {
  xScaleID: { min: "xMin", max: "xMax", start: "left", end: "right", startProp: "x", endProp: "x2" },
  yScaleID: { min: "yMin", max: "yMax", start: "bottom", end: "top", startProp: "y", endProp: "y2" }
};
function dn(e, t, n) {
  return t = typeof t == "number" ? t : e.parse(t), pt(t) ? e.getPixelForValue(t) : n;
}
function Ve(e, t, n) {
  const s = t[n];
  if (s || n === "scaleID")
    return s;
  const i = n.charAt(0), a = Object.values(e).filter((r) => r.axis && r.axis === i);
  return a.length ? a[0].id : i;
}
function Yd(e, t) {
  if (e) {
    const n = e.options.reverse, s = dn(e, t.min, n ? t.end : t.start), i = dn(e, t.max, n ? t.start : t.end);
    return {
      start: s,
      end: i
    };
  }
}
function Gd(e, t) {
  const { chartArea: n, scales: s } = e, i = s[Ve(s, t, "xScaleID")], a = s[Ve(s, t, "yScaleID")];
  let r = n.width / 2, o = n.height / 2;
  return i && (r = dn(i, t.xValue, i.left + i.width / 2)), a && (o = dn(a, t.yValue, a.top + a.height / 2)), { x: r, y: o };
}
function ir(e, t) {
  const n = e.scales, s = n[Ve(n, t, "xScaleID")], i = n[Ve(n, t, "yScaleID")];
  if (!s && !i)
    return {};
  let { left: a, right: r } = s || e.chartArea, { top: o, bottom: l } = i || e.chartArea;
  const c = cl(s, { min: t.xMin, max: t.xMax, start: a, end: r });
  a = c.start, r = c.end;
  const d = cl(i, { min: t.yMin, max: t.yMax, start: l, end: o });
  return o = d.start, l = d.end, {
    x: a,
    y: o,
    x2: r,
    y2: l,
    width: r - a,
    height: l - o,
    centerX: a + (r - a) / 2,
    centerY: o + (l - o) / 2
  };
}
function Ud(e, t) {
  if (!zd(t)) {
    const n = ir(e, t);
    let s = t.radius;
    (!s || isNaN(s)) && (s = Math.min(n.width, n.height) / 2, t.radius = s);
    const i = s * 2, a = n.centerX + t.xAdjust, r = n.centerY + t.yAdjust;
    return {
      x: a - s,
      y: r - s,
      x2: a + s,
      y2: r + s,
      centerX: a,
      centerY: r,
      width: i,
      height: i,
      radius: s
    };
  }
  return xv(e, t);
}
function vv(e, t) {
  const { scales: n, chartArea: s } = e, i = n[t.scaleID], a = { x: s.left, y: s.top, x2: s.right, y2: s.bottom };
  return i ? wv(i, a, t) : kv(n, a, t), a;
}
function Xd(e, t) {
  const n = ir(e, t);
  return n.initProperties = os(e, n, t), n.elements = [{
    type: "label",
    optionScope: "label",
    properties: Mv(e, n, t),
    initProperties: n.initProperties
  }], n;
}
function xv(e, t) {
  const n = Gd(e, t), s = t.radius * 2;
  return {
    x: n.x - t.radius + t.xAdjust,
    y: n.y - t.radius + t.yAdjust,
    x2: n.x + t.radius + t.xAdjust,
    y2: n.y + t.radius + t.yAdjust,
    centerX: n.x + t.xAdjust,
    centerY: n.y + t.yAdjust,
    radius: t.radius,
    width: s,
    height: s
  };
}
function cl(e, t) {
  const n = Yd(e, t) || t;
  return {
    start: Math.min(n.start, n.end),
    end: Math.max(n.start, n.end)
  };
}
function wv(e, t, n) {
  const s = dn(e, n.value, NaN), i = dn(e, n.endValue, s);
  e.isHorizontal() ? (t.x = s, t.x2 = i) : (t.y = s, t.y2 = i);
}
function kv(e, t, n) {
  for (const s of Object.keys(ll)) {
    const i = e[Ve(e, n, s)];
    if (i) {
      const { min: a, max: r, start: o, end: l, startProp: c, endProp: d } = ll[s], h = Yd(i, { min: n[a], max: n[r], start: i[o], end: i[l] });
      t[c] = h.start, t[d] = h.end;
    }
  }
}
function Cv({ properties: e, options: t }, n, s, i) {
  const { x: a, x2: r, width: o } = e;
  return qd({ start: a, end: r, size: o, borderWidth: t.borderWidth }, {
    position: s.x,
    padding: { start: i.left, end: i.right },
    adjust: t.label.xAdjust,
    size: n.width
  });
}
function Sv({ properties: e, options: t }, n, s, i) {
  const { y: a, y2: r, height: o } = e;
  return qd({ start: a, end: r, size: o, borderWidth: t.borderWidth }, {
    position: s.y,
    padding: { start: i.top, end: i.bottom },
    adjust: t.label.yAdjust,
    size: n.height
  });
}
function qd(e, t) {
  const { start: n, end: s, borderWidth: i } = e, { position: a, padding: { start: r, end: o }, adjust: l } = t, c = s - i - n - r - o - t.size;
  return n + i / 2 + l + tr(c, a);
}
function Mv(e, t, n) {
  const s = n.label;
  s.backgroundColor = "transparent", s.callout.display = !1;
  const i = er(s.position), a = kt(s.padding), r = sr(e.ctx, s), o = Cv({ properties: t, options: n }, r, i, a), l = Sv({ properties: t, options: n }, r, i, a), c = r.width + a.width, d = r.height + a.height;
  return {
    x: o,
    y: l,
    x2: o + c,
    y2: l + d,
    width: c,
    height: d,
    centerX: o + c / 2,
    centerY: l + d / 2,
    rotation: s.rotation
  };
}
function Ue(e, t, n) {
  const s = Math.cos(n), i = Math.sin(n), a = t.x, r = t.y;
  return {
    x: a + s * (e.x - a) - i * (e.y - r),
    y: r + i * (e.x - a) + s * (e.y - r)
  };
}
const _a = ["enter", "leave"], ar = _a.concat("click");
function Ov(e, t, n) {
  t.listened = jd(n, ar, t.listeners), t.moveListened = !1, t._getElements = Za, _a.forEach((s) => {
    Lt(n[s]) && (t.moveListened = !0);
  }), (!t.listened || !t.moveListened) && t.annotations.forEach((s) => {
    !t.listened && Lt(s.click) && (t.listened = !0), t.moveListened || _a.forEach((i) => {
      Lt(s[i]) && (t.listened = !0, t.moveListened = !0);
    });
  });
}
function Tv(e, t, n) {
  if (e.listened)
    switch (t.type) {
      case "mousemove":
      case "mouseout":
        return Pv(e, t, n);
      case "click":
        return Av(e, t, n);
    }
}
function Pv(e, t, n) {
  if (!e.moveListened)
    return;
  let s;
  t.type === "mousemove" ? s = Za(e, t, n.interaction) : s = [];
  const i = e.hovered;
  e.hovered = s;
  const a = { state: e, event: t };
  let r = dl(a, "leave", i, s);
  return dl(a, "enter", s, i) || r;
}
function dl({ state: e, event: t }, n, s, i) {
  let a;
  for (const r of s)
    i.indexOf(r) < 0 && (a = Kd(r.options[n] || e.listeners[n], r, t) || a);
  return a;
}
function Av(e, t, n) {
  const s = e.listeners, i = Za(e, t, n.interaction);
  let a;
  for (const r of i)
    a = Kd(r.options.click || s.click, r, t) || a;
  return a;
}
function Kd(e, t, n) {
  return et(e, [t.$context, n]) === !0;
}
const ai = ["afterDraw", "beforeDraw"];
function $v(e, t, n) {
  const s = t.visibleElements;
  t.hooked = jd(n, ai, t.hooks), t.hooked || s.forEach((i) => {
    t.hooked || ai.forEach((a) => {
      Lt(i.options[a]) && (t.hooked = !0);
    });
  });
}
function hl(e, t, n) {
  if (e.hooked) {
    const s = t.options[n] || e.hooks[n];
    return et(s, [t.$context]);
  }
}
function Dv(e, t, n) {
  const s = Bv(e.scales, t, n);
  let i = ul(t, s, "min", "suggestedMin");
  i = ul(t, s, "max", "suggestedMax") || i, i && Lt(t.handleTickRangeOptions) && t.handleTickRangeOptions();
}
function Lv(e, t) {
  for (const n of e)
    Iv(n, t);
}
function ul(e, t, n, s) {
  if (pt(t[n]) && !Ev(e.options, n, s)) {
    const i = e[n] !== t[n];
    return e[n] = t[n], i;
  }
}
function Ev(e, t, n) {
  return Et(e[t]) || Et(e[n]);
}
function Iv(e, t) {
  for (const n of ["scaleID", "xScaleID", "yScaleID"]) {
    const s = Ve(t, e, n);
    s && !t[s] && Rv(e, n) && console.warn(`No scale found with id '${s}' for annotation '${e.id}'`);
  }
}
function Rv(e, t) {
  if (t === "scaleID")
    return !0;
  const n = t.charAt(0);
  for (const s of ["Min", "Max", "Value"])
    if (Et(e[n + s]))
      return !0;
  return !1;
}
function Bv(e, t, n) {
  const s = t.axis, i = t.id, a = s + "ScaleID", r = {
    min: j(t.min, Number.NEGATIVE_INFINITY),
    max: j(t.max, Number.POSITIVE_INFINITY)
  };
  for (const o of n)
    o.scaleID === i ? fl(o, t, ["value", "endValue"], r) : Ve(e, o, a) === i && fl(o, t, [s + "Min", s + "Max", s + "Value"], r);
  return r;
}
function fl(e, t, n, s) {
  for (const i of n) {
    const a = e[i];
    if (Et(a)) {
      const r = t.parse(a);
      s.min = Math.min(s.min, r), s.max = Math.max(s.max, r);
    }
  }
}
class fn extends Ot {
  inRange(t, n, s, i) {
    const { x: a, y: r } = Ue({ x: t, y: n }, this.getCenterPoint(i), St(-this.options.rotation));
    return Bd({ x: a, y: r }, this.getProps(["x", "y", "x2", "y2"], i), s, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return hn(this, t);
  }
  draw(t) {
    t.save(), nr(t, this.getCenterPoint(), this.options.rotation), Vd(t, this, this.options), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    return Xd(t, n);
  }
}
fn.id = "boxAnnotation";
fn.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  label: {
    backgroundColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "black",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: void 0,
    textAlign: "start",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
fn.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
fn.descriptors = {
  label: {
    _fallback: !0
  }
};
const Qd = ["left", "bottom", "top", "right"];
class ls extends Ot {
  inRange(t, n, s, i) {
    const { x: a, y: r } = Ue({ x: t, y: n }, this.getCenterPoint(i), St(-this.rotation));
    return Bd({ x: a, y: r }, this.getProps(["x", "y", "x2", "y2"], i), s, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return hn(this, t);
  }
  draw(t) {
    const n = this.options, s = !Et(this._visible) || this._visible;
    !n.display || !n.content || !s || (t.save(), nr(t, this.getCenterPoint(), this.rotation), Wv(t, this), Vd(t, this, n), uv(t, Gv(this), n), t.restore());
  }
  resolveElementProperties(t, n) {
    let s;
    if (zd(n))
      s = Gd(t, n);
    else {
      const { centerX: o, centerY: l } = ir(t, n);
      s = { x: o, y: l };
    }
    const i = kt(n.padding), a = sr(t.ctx, n), r = Fv(s, a, n, i);
    return {
      initProperties: os(t, r, n),
      pointX: s.x,
      pointY: s.y,
      ...r,
      rotation: n.rotation
    };
  }
}
ls.id = "labelAnnotation";
ls.defaults = {
  adjustScaleRange: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 0,
  callout: {
    borderCapStyle: "butt",
    borderColor: void 0,
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 1,
    display: !1,
    margin: 5,
    position: "auto",
    side: 5,
    start: "50%"
  },
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  init: void 0,
  opacity: void 0,
  padding: 6,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
ls.defaultRoutes = {
  borderColor: "color"
};
function Fv(e, t, n, s) {
  const i = t.width + s.width + n.borderWidth, a = t.height + s.height + n.borderWidth, r = er(n.position, "center"), o = gl(e.x, i, n.xAdjust, r.x), l = gl(e.y, a, n.yAdjust, r.y);
  return {
    x: o,
    y: l,
    x2: o + i,
    y2: l + a,
    width: i,
    height: a,
    centerX: o + i / 2,
    centerY: l + a / 2
  };
}
function gl(e, t, n = 0, s) {
  return e - tr(t, s) + n;
}
function Wv(e, t) {
  const { pointX: n, pointY: s, options: i } = t, a = i.callout, r = a && a.display && Vv(t, a);
  if (!r || Uv(t, a, r))
    return;
  if (e.save(), e.beginPath(), !Se(e, a))
    return e.restore();
  const { separatorStart: l, separatorEnd: c } = Nv(t, r), { sideStart: d, sideEnd: h } = jv(t, r, l);
  (a.margin > 0 || i.borderWidth === 0) && (e.moveTo(l.x, l.y), e.lineTo(c.x, c.y)), e.moveTo(d.x, d.y), e.lineTo(h.x, h.y);
  const u = Ue({ x: n, y: s }, t.getCenterPoint(), St(-t.rotation));
  e.lineTo(u.x, u.y), e.stroke(), e.restore();
}
function Nv(e, t) {
  const { x: n, y: s, x2: i, y2: a } = e, r = zv(e, t);
  let o, l;
  return t === "left" || t === "right" ? (o = { x: n + r, y: s }, l = { x: o.x, y: a }) : (o = { x: n, y: s + r }, l = { x: i, y: o.y }), { separatorStart: o, separatorEnd: l };
}
function zv(e, t) {
  const { width: n, height: s, options: i } = e, a = i.callout.margin + i.borderWidth / 2;
  return t === "right" ? n + a : t === "bottom" ? s + a : -a;
}
function jv(e, t, n) {
  const { y: s, width: i, height: a, options: r } = e, o = r.callout.start, l = Hv(t, r.callout);
  let c, d;
  return t === "left" || t === "right" ? (c = { x: n.x, y: s + Ce(a, o) }, d = { x: c.x + l, y: c.y }) : (c = { x: n.x + Ce(i, o), y: n.y }, d = { x: c.x, y: c.y + l }), { sideStart: c, sideEnd: d };
}
function Hv(e, t) {
  const n = t.side;
  return e === "left" || e === "top" ? -n : n;
}
function Vv(e, t) {
  const n = t.position;
  return Qd.includes(n) ? n : Yv(e, t);
}
function Yv(e, t) {
  const { x: n, y: s, x2: i, y2: a, width: r, height: o, pointX: l, pointY: c, centerX: d, centerY: h, rotation: u } = e, f = { x: d, y: h }, g = t.start, m = Ce(r, g), p = Ce(o, g), b = [n, n + m, n + m, i], y = [s + p, a, s, a], v = [];
  for (let w = 0; w < 4; w++) {
    const x = Ue({ x: b[w], y: y[w] }, f, St(u));
    v.push({
      position: Qd[w],
      distance: rn(x, { x: l, y: c })
    });
  }
  return v.sort((w, x) => w.distance - x.distance)[0].position;
}
function Gv({ x: e, y: t, width: n, height: s, options: i }) {
  const a = i.borderWidth / 2, r = kt(i.padding);
  return {
    x: e + r.left + a,
    y: t + r.top + a,
    width: n - r.left - r.right - i.borderWidth,
    height: s - r.top - r.bottom - i.borderWidth
  };
}
function Uv(e, t, n) {
  const { pointX: s, pointY: i } = e, a = t.margin;
  let r = s, o = i;
  return n === "left" ? r += a : n === "right" ? r -= a : n === "top" ? o += a : n === "bottom" && (o -= a), e.inRange(r, o);
}
const rr = (e, t, n) => ({ x: e.x + n * (t.x - e.x), y: e.y + n * (t.y - e.y) }), va = (e, t, n) => rr(t, n, Math.abs((e - t.y) / (n.y - t.y))).x, pl = (e, t, n) => rr(t, n, Math.abs((e - t.x) / (n.x - t.x))).y, Rn = (e) => e * e, Xv = (e, t, { x: n, y: s, x2: i, y2: a }, r) => r === "y" ? { start: Math.min(s, a), end: Math.max(s, a), value: t } : { start: Math.min(n, i), end: Math.max(n, i), value: e }, ml = (e, t, n, s) => (1 - s) * (1 - s) * e + 2 * (1 - s) * s * t + s * s * n, xa = (e, t, n, s) => ({ x: ml(e.x, t.x, n.x, s), y: ml(e.y, t.y, n.y, s) }), bl = (e, t, n, s) => 2 * (1 - s) * (t - e) + 2 * s * (n - t), yl = (e, t, n, s) => -Math.atan2(bl(e.x, t.x, n.x, s), bl(e.y, t.y, n.y, s)) + 0.5 * K;
class cs extends Ot {
  inRange(t, n, s, i) {
    const a = this.options.borderWidth / 2;
    if (s !== "x" && s !== "y") {
      const r = { mouseX: t, mouseY: n }, { path: o, ctx: l } = this;
      if (o) {
        Se(l, this.options);
        const { chart: d } = this.$context, h = t * d.currentDevicePixelRatio, u = n * d.currentDevicePixelRatio, f = l.isPointInStroke(o, h, u) || wa(this, r, i);
        return l.restore(), f;
      }
      const c = Rn(a);
      return Jv(this, r, c, i) || wa(this, r, i);
    }
    return qv(this, { mouseX: t, mouseY: n }, s, { hBorderWidth: a, useFinalPosition: i });
  }
  getCenterPoint(t) {
    return hn(this, t);
  }
  draw(t) {
    const { x: n, y: s, x2: i, y2: a, cp: r, options: o } = this;
    if (t.save(), !Se(t, o))
      return t.restore();
    un(t, o);
    const l = Math.sqrt(Math.pow(i - n, 2) + Math.pow(a - s, 2));
    if (o.curve && r)
      return r0(t, this, r, l), t.restore();
    const { startOpts: c, endOpts: d, startAdjust: h, endAdjust: u } = Jd(this), f = Math.atan2(a - s, i - n);
    t.translate(n, s), t.rotate(f), t.beginPath(), t.moveTo(0 + h, 0), t.lineTo(l - u, 0), t.shadowColor = o.borderShadowColor, t.stroke(), ka(t, 0, h, c), ka(t, l, -u, d), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    const s = vv(t, n), { x: i, y: a, x2: r, y2: o } = s, l = Kv(s, t.chartArea), c = l ? Qv({ x: i, y: a }, { x: r, y: o }, t.chartArea) : { x: i, y: a, x2: r, y2: o, width: Math.abs(r - i), height: Math.abs(o - a) };
    if (c.centerX = (r + i) / 2, c.centerY = (o + a) / 2, c.initProperties = os(t, c, n), n.curve) {
      const h = { x: c.x, y: c.y }, u = { x: c.x2, y: c.y2 };
      c.cp = a0(c, n, rn(h, u));
    }
    const d = Zv(t, c, n.label);
    return d._visible = l, c.elements = [{
      type: "label",
      optionScope: "label",
      properties: d,
      initProperties: c.initProperties
    }], c;
  }
}
cs.id = "lineAnnotation";
const _l = {
  backgroundColor: void 0,
  backgroundShadowColor: void 0,
  borderColor: void 0,
  borderDash: void 0,
  borderDashOffset: void 0,
  borderShadowColor: void 0,
  borderWidth: void 0,
  display: void 0,
  fill: void 0,
  length: void 0,
  shadowBlur: void 0,
  shadowOffsetX: void 0,
  shadowOffsetY: void 0,
  width: void 0
};
cs.defaults = {
  adjustScaleRange: !0,
  arrowHeads: {
    display: !1,
    end: Object.assign({}, _l),
    fill: !1,
    length: 12,
    start: Object.assign({}, _l),
    width: 6
  },
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 2,
  curve: !1,
  controlPoint: {
    y: "-50%"
  },
  display: !0,
  endValue: void 0,
  init: void 0,
  label: {
    backgroundColor: "rgba(0,0,0,0.8)",
    backgroundShadowColor: "transparent",
    borderCapStyle: "butt",
    borderColor: "black",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderRadius: 6,
    borderShadowColor: "transparent",
    borderWidth: 0,
    callout: Object.assign({}, ls.defaults.callout),
    color: "#fff",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: "center",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  scaleID: void 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  value: void 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
cs.descriptors = {
  arrowHeads: {
    start: {
      _fallback: !0
    },
    end: {
      _fallback: !0
    },
    _fallback: !0
  }
};
cs.defaultRoutes = {
  borderColor: "color"
};
function qv(e, { mouseX: t, mouseY: n }, s, { hBorderWidth: i, useFinalPosition: a }) {
  const r = Xv(t, n, e.getProps(["x", "y", "x2", "y2"], a), s);
  return r.value >= r.start - i && r.value <= r.end + i || wa(e, { mouseX: t, mouseY: n }, a, s);
}
function Kv({ x: e, y: t, x2: n, y2: s }, { top: i, right: a, bottom: r, left: o }) {
  return !(e < o && n < o || e > a && n > a || t < i && s < i || t > r && s > r);
}
function vl({ x: e, y: t }, n, { top: s, right: i, bottom: a, left: r }) {
  return e < r && (t = pl(r, { x: e, y: t }, n), e = r), e > i && (t = pl(i, { x: e, y: t }, n), e = i), t < s && (e = va(s, { x: e, y: t }, n), t = s), t > a && (e = va(a, { x: e, y: t }, n), t = a), { x: e, y: t };
}
function Qv(e, t, n) {
  const { x: s, y: i } = vl(e, t, n), { x: a, y: r } = vl(t, e, n);
  return { x: s, y: i, x2: a, y2: r, width: Math.abs(a - s), height: Math.abs(r - i) };
}
function Jv(e, { mouseX: t, mouseY: n }, s = Fe, i) {
  const { x: a, y: r, x2: o, y2: l } = e.getProps(["x", "y", "x2", "y2"], i), c = o - a, d = l - r, h = Rn(c) + Rn(d), u = h === 0 ? -1 : ((t - a) * c + (n - r) * d) / h;
  let f, g;
  return u < 0 ? (f = a, g = r) : u > 1 ? (f = o, g = l) : (f = a + u * c, g = r + u * d), Rn(t - f) + Rn(n - g) <= s;
}
function wa(e, { mouseX: t, mouseY: n }, s, i) {
  const a = e.label;
  return a.options.display && a.inRange(t, n, i, s);
}
function Zv(e, t, n) {
  const s = n.borderWidth, i = kt(n.padding), a = sr(e.ctx, n), r = a.width + i.width + s, o = a.height + i.height + s;
  return e0(t, n, { width: r, height: o, padding: i }, e.chartArea);
}
function t0(e) {
  const { x: t, y: n, x2: s, y2: i } = e, a = Math.atan2(i - n, s - t);
  return a > K / 2 ? a - K : a < K / -2 ? a + K : a;
}
function e0(e, t, n, s) {
  const { width: i, height: a, padding: r } = n, { xAdjust: o, yAdjust: l } = t, c = { x: e.x, y: e.y }, d = { x: e.x2, y: e.y2 }, h = t.rotation === "auto" ? t0(e) : St(t.rotation), u = n0(i, a, h), f = s0(e, t, { labelSize: u, padding: r }, s), g = e.cp ? xa(c, e.cp, d, f) : rr(c, d, f), m = { size: u.w, min: s.left, max: s.right, padding: r.left }, p = { size: u.h, min: s.top, max: s.bottom, padding: r.top }, b = wl(g.x, m) + o, y = wl(g.y, p) + l;
  return {
    x: b - i / 2,
    y: y - a / 2,
    x2: b + i / 2,
    y2: y + a / 2,
    centerX: b,
    centerY: y,
    pointX: g.x,
    pointY: g.y,
    width: i,
    height: a,
    rotation: gi(h)
  };
}
function n0(e, t, n) {
  const s = Math.cos(n), i = Math.sin(n);
  return {
    w: Math.abs(e * s) + Math.abs(t * i),
    h: Math.abs(e * i) + Math.abs(t * s)
  };
}
function s0(e, t, n, s) {
  let i;
  const a = i0(e, s);
  return t.position === "start" ? i = xl({ w: e.x2 - e.x, h: e.y2 - e.y }, n, t, a) : t.position === "end" ? i = 1 - xl({ w: e.x - e.x2, h: e.y - e.y2 }, n, t, a) : i = tr(1, t.position), i;
}
function xl(e, t, n, s) {
  const { labelSize: i, padding: a } = t, r = e.w * s.dx, o = e.h * s.dy, l = r > 0 && (i.w / 2 + a.left - s.x) / r, c = o > 0 && (i.h / 2 + a.top - s.y) / o;
  return yi(Math.max(l, c), 0, 0.25);
}
function i0(e, t) {
  const { x: n, x2: s, y: i, y2: a } = e, r = Math.min(i, a) - t.top, o = Math.min(n, s) - t.left, l = t.bottom - Math.max(i, a), c = t.right - Math.max(n, s);
  return {
    x: Math.min(o, c),
    y: Math.min(r, l),
    dx: o <= c ? 1 : -1,
    dy: r <= l ? 1 : -1
  };
}
function wl(e, t) {
  const { size: n, min: s, max: i, padding: a } = t, r = n / 2;
  return n > i - s ? (i + s) / 2 : (s >= e - a - r && (e = s + a + r), i <= e + a + r && (e = i - a - r), e);
}
function Jd(e) {
  const t = e.options, n = t.arrowHeads && t.arrowHeads.start, s = t.arrowHeads && t.arrowHeads.end;
  return {
    startOpts: n,
    endOpts: s,
    startAdjust: kl(e, n),
    endAdjust: kl(e, s)
  };
}
function kl(e, t) {
  if (!t || !t.display)
    return 0;
  const { length: n, width: s } = t, i = e.options.borderWidth / 2, a = { x: n, y: s + i };
  return Math.abs(va(0, a, { x: 0, y: i }));
}
function ka(e, t, n, s) {
  if (!s || !s.display)
    return;
  const { length: i, width: a, fill: r, backgroundColor: o, borderColor: l } = s, c = Math.abs(t - i) + n;
  e.beginPath(), un(e, s), Se(e, s), e.moveTo(c, -a), e.lineTo(t + n, 0), e.lineTo(c, a), r === !0 ? (e.fillStyle = o || l, e.closePath(), e.fill(), e.shadowColor = "transparent") : e.shadowColor = s.borderShadowColor, e.stroke();
}
function a0(e, t, n) {
  const { x: s, y: i, x2: a, y2: r, centerX: o, centerY: l } = e, c = Math.atan2(r - i, a - s), d = er(t.controlPoint, 0), h = {
    x: o + Ce(n, d.x, !1),
    y: l + Ce(n, d.y, !1)
  };
  return Ue(h, { x: o, y: l }, c);
}
function Cl(e, { x: t, y: n }, { angle: s, adjust: i }, a) {
  !a || !a.display || (e.save(), e.translate(t, n), e.rotate(s), ka(e, 0, -i, a), e.restore());
}
function r0(e, t, n, s) {
  const { x: i, y: a, x2: r, y2: o, options: l } = t, { startOpts: c, endOpts: d, startAdjust: h, endAdjust: u } = Jd(t), f = { x: i, y: a }, g = { x: r, y: o }, m = yl(f, n, g, 0), p = yl(f, n, g, 1) - K, b = xa(f, n, g, h / s), y = xa(f, n, g, 1 - u / s), v = new Path2D();
  e.beginPath(), v.moveTo(b.x, b.y), v.quadraticCurveTo(n.x, n.y, y.x, y.y), e.shadowColor = l.borderShadowColor, e.stroke(v), t.path = v, t.ctx = e, Cl(e, b, { angle: m, adjust: h }, c), Cl(e, y, { angle: p, adjust: u }, d);
}
class ds extends Ot {
  inRange(t, n, s, i) {
    const a = this.options.rotation, r = this.options.borderWidth;
    if (s !== "x" && s !== "y")
      return o0({ x: t, y: n }, this.getProps(["width", "height", "centerX", "centerY"], i), a, r);
    const { x: o, y: l, x2: c, y2: d } = this.getProps(["x", "y", "x2", "y2"], i), h = r / 2, u = s === "y" ? { start: l, end: d } : { start: o, end: c }, f = Ue({ x: t, y: n }, this.getCenterPoint(i), St(-a));
    return f[s] >= u.start - h - Fe && f[s] <= u.end + h + Fe;
  }
  getCenterPoint(t) {
    return hn(this, t);
  }
  draw(t) {
    const { width: n, height: s, centerX: i, centerY: a, options: r } = this;
    t.save(), nr(t, this.getCenterPoint(), r.rotation), un(t, this.options), t.beginPath(), t.fillStyle = r.backgroundColor;
    const o = Se(t, r);
    t.ellipse(i, a, s / 2, n / 2, K / 2, 0, 2 * K), t.fill(), o && (t.shadowColor = r.borderShadowColor, t.stroke()), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    return Xd(t, n);
  }
}
ds.id = "ellipseAnnotation";
ds.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  label: Object.assign({}, fn.defaults.label),
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
ds.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
ds.descriptors = {
  label: {
    _fallback: !0
  }
};
function o0(e, t, n, s) {
  const { width: i, height: a, centerX: r, centerY: o } = t, l = i / 2, c = a / 2;
  if (l <= 0 || c <= 0)
    return !1;
  const d = St(n || 0), h = s / 2 || 0, u = Math.cos(d), f = Math.sin(d), g = Math.pow(u * (e.x - r) + f * (e.y - o), 2), m = Math.pow(f * (e.x - r) - u * (e.y - o), 2);
  return g / Math.pow(l + h, 2) + m / Math.pow(c + h, 2) <= 1.0001;
}
class vi extends Ot {
  inRange(t, n, s, i) {
    const { x: a, y: r, x2: o, y2: l, width: c } = this.getProps(["x", "y", "x2", "y2", "width"], i), d = this.options.borderWidth;
    if (s !== "x" && s !== "y")
      return av({ x: t, y: n }, this.getCenterPoint(i), c / 2, d);
    const h = d / 2, u = s === "y" ? { start: r, end: l, value: n } : { start: a, end: o, value: t };
    return u.value >= u.start - h && u.value <= u.end + h;
  }
  getCenterPoint(t) {
    return hn(this, t);
  }
  draw(t) {
    const n = this.options, s = n.borderWidth;
    if (n.radius < 0.1)
      return;
    t.save(), t.fillStyle = n.backgroundColor, un(t, n);
    const i = Se(t, n);
    gv(t, this, this.centerX, this.centerY), i && !_i(n.pointStyle) && (t.shadowColor = n.borderShadowColor, t.stroke()), t.restore(), n.borderWidth = s;
  }
  resolveElementProperties(t, n) {
    const s = Ud(t, n);
    return s.initProperties = os(t, s, n), s;
  }
}
vi.id = "pointAnnotation";
vi.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  pointStyle: "circle",
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
vi.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
class xi extends Ot {
  inRange(t, n, s, i) {
    if (s !== "x" && s !== "y")
      return this.options.radius >= 0.1 && this.elements.length > 1 && c0(this.elements, t, n, i);
    const a = Ue({ x: t, y: n }, this.getCenterPoint(i), St(-this.options.rotation)), r = this.elements.map((c) => s === "y" ? c.bY : c.bX), o = Math.min(...r), l = Math.max(...r);
    return a[s] >= o && a[s] <= l;
  }
  getCenterPoint(t) {
    return hn(this, t);
  }
  draw(t) {
    const { elements: n, options: s } = this;
    t.save(), t.beginPath(), t.fillStyle = s.backgroundColor, un(t, s);
    const i = Se(t, s);
    let a = !0;
    for (const r of n)
      a ? (t.moveTo(r.x, r.y), a = !1) : t.lineTo(r.x, r.y);
    t.closePath(), t.fill(), i && (t.shadowColor = s.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, n) {
    const s = Ud(t, n), { sides: i, rotation: a } = n, r = [], o = 2 * K / i;
    let l = a * Wa;
    for (let c = 0; c < i; c++, l += o) {
      const d = l0(s, n, l);
      d.initProperties = os(t, s, n), r.push(d);
    }
    return s.elements = r, s;
  }
}
xi.id = "polygonAnnotation";
xi.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  point: {
    radius: 0
  },
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  sides: 3,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
xi.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function l0({ centerX: e, centerY: t }, { radius: n, borderWidth: s }, i) {
  const a = s / 2, r = Math.sin(i), o = Math.cos(i), l = { x: e + r * n, y: t - o * n };
  return {
    type: "point",
    optionScope: "point",
    properties: {
      x: l.x,
      y: l.y,
      centerX: l.x,
      centerY: l.y,
      bX: e + r * (n + a),
      bY: t - o * (n + a)
    }
  };
}
function c0(e, t, n, s) {
  let i = !1, a = e[e.length - 1].getProps(["bX", "bY"], s);
  for (const r of e) {
    const o = r.getProps(["bX", "bY"], s);
    o.bY > n != a.bY > n && t < (a.bX - o.bX) * (n - o.bY) / (a.bY - o.bY) + o.bX && (i = !i), a = o;
  }
  return i;
}
const xe = {
  box: fn,
  ellipse: ds,
  label: ls,
  line: cs,
  point: vi,
  polygon: xi
};
Object.keys(xe).forEach((e) => {
  mt.describe(`elements.${xe[e].id}`, {
    _fallback: "plugins.annotation.common"
  });
});
const d0 = {
  update: Object.assign
}, h0 = ar.concat(ai), Sl = (e, t) => H(t) ? Sa(e, t) : e, Ca = (e) => e === "color" || e === "font";
function or(e = "line") {
  return xe[e] ? e : (console.warn(`Unknown annotation type: '${e}', defaulting to 'line'`), "line");
}
function u0(e, t, n, s) {
  const i = g0(e, n.animations, s), a = t.annotations, r = b0(t.elements, a);
  for (let o = 0; o < a.length; o++) {
    const l = a[o], c = Zd(r, o, l.type), d = l.setContext(m0(e, c, l)), h = c.resolveElementProperties(e, d);
    h.skip = f0(h), "elements" in h && (p0(c, h.elements, d, i), delete h.elements), Et(c.x) || Object.assign(c, h), Object.assign(c, h.initProperties), h.options = th(d), i.update(c, h);
  }
}
function f0(e) {
  return isNaN(e.x) || isNaN(e.y);
}
function g0(e, t, n) {
  return n === "reset" || n === "none" || n === "resize" ? d0 : new qa(e, t);
}
function p0(e, t, n, s) {
  const i = e.elements || (e.elements = []);
  i.length = t.length;
  for (let a = 0; a < t.length; a++) {
    const r = t[a], o = r.properties, l = Zd(i, a, r.type, r.initProperties), c = n[r.optionScope].override(r);
    o.options = th(c), s.update(l, o);
  }
}
function Zd(e, t, n, s) {
  const i = xe[or(n)];
  let a = e[t];
  return (!a || !(a instanceof i)) && (a = e[t] = new i(), Object.assign(a, s)), a;
}
function th(e) {
  const t = xe[or(e.type)], n = {};
  n.id = e.id, n.type = e.type, n.drawTime = e.drawTime, Object.assign(
    n,
    Sa(e, t.defaults),
    Sa(e, t.defaultRoutes)
  );
  for (const s of h0)
    n[s] = e[s];
  return n;
}
function Sa(e, t) {
  const n = {};
  for (const s of Object.keys(t)) {
    const i = t[s], a = e[s];
    Ca(s) && tt(a) ? n[s] = a.map((r) => Sl(r, i)) : n[s] = Sl(a, i);
  }
  return n;
}
function m0(e, t, n) {
  return t.$context || (t.$context = Object.assign(Object.create(e.getContext()), {
    element: t,
    id: n.id,
    type: "annotation"
  }));
}
function b0(e, t) {
  const n = t.length, s = e.length;
  if (s < n) {
    const i = n - s;
    e.splice(s, 0, ...new Array(i));
  } else
    s > n && e.splice(n, s - n);
  return e;
}
var y0 = "3.0.1";
const ge = /* @__PURE__ */ new Map(), _0 = ar.concat(ai);
var Yn = {
  id: "annotation",
  version: y0,
  beforeRegister() {
    rv("chart.js", "4.0", Ne.version);
  },
  afterRegister() {
    Ne.register(xe);
  },
  afterUnregister() {
    Ne.unregister(xe);
  },
  beforeInit(e) {
    ge.set(e, {
      annotations: [],
      elements: [],
      visibleElements: [],
      listeners: {},
      listened: !1,
      moveListened: !1,
      hooks: {},
      hooked: !1,
      hovered: []
    });
  },
  beforeUpdate(e, t, n) {
    const s = ge.get(e), i = s.annotations = [];
    let a = n.annotations;
    H(a) ? Object.keys(a).forEach((r) => {
      const o = a[r];
      H(o) && (o.id = r, i.push(o));
    }) : tt(a) && i.push(...a), Lv(i, e.scales);
  },
  afterDataLimits(e, t) {
    const n = ge.get(e);
    Dv(e, t.scale, n.annotations.filter((s) => s.display && s.adjustScaleRange));
  },
  afterUpdate(e, t, n) {
    const s = ge.get(e);
    Ov(e, s, n), u0(e, s, n, t.mode), s.visibleElements = s.elements.filter((i) => !i.skip && i.options.display), $v(e, s, n);
  },
  beforeDatasetsDraw(e, t, n) {
    Ps(e, "beforeDatasetsDraw", n.clip);
  },
  afterDatasetsDraw(e, t, n) {
    Ps(e, "afterDatasetsDraw", n.clip);
  },
  beforeDraw(e, t, n) {
    Ps(e, "beforeDraw", n.clip);
  },
  afterDraw(e, t, n) {
    Ps(e, "afterDraw", n.clip);
  },
  beforeEvent(e, t, n) {
    const s = ge.get(e);
    Tv(s, t.event, n) && (t.changed = !0);
  },
  afterDestroy(e) {
    ge.delete(e);
  },
  _getState(e) {
    return ge.get(e);
  },
  defaults: {
    animations: {
      numbers: {
        properties: ["x", "y", "x2", "y2", "width", "height", "centerX", "centerY", "pointX", "pointY", "radius"],
        type: "number"
      }
    },
    clip: !0,
    interaction: {
      mode: void 0,
      axis: void 0,
      intersect: void 0
    },
    common: {
      drawTime: "afterDatasetsDraw",
      init: !1,
      label: {}
    }
  },
  descriptors: {
    _indexable: !1,
    _scriptable: (e) => !_0.includes(e) && e !== "init",
    annotations: {
      _allKeys: !1,
      _fallback: (e, t) => `elements.${xe[or(t.type)].id}`
    },
    interaction: {
      _fallback: !0
    },
    common: {
      label: {
        _indexable: Ca,
        _fallback: !0
      },
      _indexable: Ca
    }
  },
  additionalOptionScopes: [""]
};
function Ps(e, t, n) {
  const { ctx: s, chartArea: i } = e, a = ge.get(e);
  n && is(s, i);
  const r = v0(a.visibleElements, t).sort((o, l) => o.element.options.z - l.element.options.z);
  for (const o of r)
    x0(s, i, a, o);
  n && as(s);
}
function v0(e, t) {
  const n = [];
  for (const s of e)
    if (s.options.drawTime === t && n.push({ element: s, main: !0 }), s.elements && s.elements.length)
      for (const i of s.elements)
        i.options.display && i.options.drawTime === t && n.push({ element: i });
  return n;
}
function x0(e, t, n, s) {
  const i = s.element;
  s.main ? (hl(n, i, "beforeDraw"), i.draw(e, t), hl(n, i, "afterDraw")) : i.draw(e, t);
}
var As = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function lr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function w0() {
  this.__data__ = [], this.size = 0;
}
var k0 = w0;
function C0(e, t) {
  return e === t || e !== e && t !== t;
}
var hs = C0, S0 = hs;
function M0(e, t) {
  for (var n = e.length; n--; )
    if (S0(e[n][0], t))
      return n;
  return -1;
}
var wi = M0, O0 = wi, T0 = Array.prototype, P0 = T0.splice;
function A0(e) {
  var t = this.__data__, n = O0(t, e);
  if (n < 0)
    return !1;
  var s = t.length - 1;
  return n == s ? t.pop() : P0.call(t, n, 1), --this.size, !0;
}
var $0 = A0, D0 = wi;
function L0(e) {
  var t = this.__data__, n = D0(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var E0 = L0, I0 = wi;
function R0(e) {
  return I0(this.__data__, e) > -1;
}
var B0 = R0, F0 = wi;
function W0(e, t) {
  var n = this.__data__, s = F0(n, e);
  return s < 0 ? (++this.size, n.push([e, t])) : n[s][1] = t, this;
}
var N0 = W0, z0 = k0, j0 = $0, H0 = E0, V0 = B0, Y0 = N0;
function gn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
gn.prototype.clear = z0;
gn.prototype.delete = j0;
gn.prototype.get = H0;
gn.prototype.has = V0;
gn.prototype.set = Y0;
var ki = gn, G0 = ki;
function U0() {
  this.__data__ = new G0(), this.size = 0;
}
var X0 = U0;
function q0(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var K0 = q0;
function Q0(e) {
  return this.__data__.get(e);
}
var J0 = Q0;
function Z0(e) {
  return this.__data__.has(e);
}
var t1 = Z0, e1 = typeof As == "object" && As && As.Object === Object && As, eh = e1, n1 = eh, s1 = typeof self == "object" && self && self.Object === Object && self, i1 = n1 || s1 || Function("return this")(), Vt = i1, a1 = Vt, r1 = a1.Symbol, Ci = r1, Ml = Ci, nh = Object.prototype, o1 = nh.hasOwnProperty, l1 = nh.toString, Tn = Ml ? Ml.toStringTag : void 0;
function c1(e) {
  var t = o1.call(e, Tn), n = e[Tn];
  try {
    e[Tn] = void 0;
    var s = !0;
  } catch {
  }
  var i = l1.call(e);
  return s && (t ? e[Tn] = n : delete e[Tn]), i;
}
var d1 = c1, h1 = Object.prototype, u1 = h1.toString;
function f1(e) {
  return u1.call(e);
}
var g1 = f1, Ol = Ci, p1 = d1, m1 = g1, b1 = "[object Null]", y1 = "[object Undefined]", Tl = Ol ? Ol.toStringTag : void 0;
function _1(e) {
  return e == null ? e === void 0 ? y1 : b1 : Tl && Tl in Object(e) ? p1(e) : m1(e);
}
var pn = _1;
function v1(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Kt = v1, x1 = pn, w1 = Kt, k1 = "[object AsyncFunction]", C1 = "[object Function]", S1 = "[object GeneratorFunction]", M1 = "[object Proxy]";
function O1(e) {
  if (!w1(e))
    return !1;
  var t = x1(e);
  return t == C1 || t == S1 || t == k1 || t == M1;
}
var cr = O1, T1 = Vt, P1 = T1["__core-js_shared__"], A1 = P1, Yi = A1, Pl = function() {
  var e = /[^.]+$/.exec(Yi && Yi.keys && Yi.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $1(e) {
  return !!Pl && Pl in e;
}
var D1 = $1, L1 = Function.prototype, E1 = L1.toString;
function I1(e) {
  if (e != null) {
    try {
      return E1.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var sh = I1, R1 = cr, B1 = D1, F1 = Kt, W1 = sh, N1 = /[\\^$.*+?()[\]{}|]/g, z1 = /^\[object .+?Constructor\]$/, j1 = Function.prototype, H1 = Object.prototype, V1 = j1.toString, Y1 = H1.hasOwnProperty, G1 = RegExp(
  "^" + V1.call(Y1).replace(N1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function U1(e) {
  if (!F1(e) || B1(e))
    return !1;
  var t = R1(e) ? G1 : z1;
  return t.test(W1(e));
}
var X1 = U1;
function q1(e, t) {
  return e == null ? void 0 : e[t];
}
var K1 = q1, Q1 = X1, J1 = K1;
function Z1(e, t) {
  var n = J1(e, t);
  return Q1(n) ? n : void 0;
}
var Xe = Z1, tx = Xe, ex = Vt, nx = tx(ex, "Map"), dr = nx, sx = Xe, ix = sx(Object, "create"), Si = ix, Al = Si;
function ax() {
  this.__data__ = Al ? Al(null) : {}, this.size = 0;
}
var rx = ax;
function ox(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var lx = ox, cx = Si, dx = "__lodash_hash_undefined__", hx = Object.prototype, ux = hx.hasOwnProperty;
function fx(e) {
  var t = this.__data__;
  if (cx) {
    var n = t[e];
    return n === dx ? void 0 : n;
  }
  return ux.call(t, e) ? t[e] : void 0;
}
var gx = fx, px = Si, mx = Object.prototype, bx = mx.hasOwnProperty;
function yx(e) {
  var t = this.__data__;
  return px ? t[e] !== void 0 : bx.call(t, e);
}
var _x = yx, vx = Si, xx = "__lodash_hash_undefined__";
function wx(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = vx && t === void 0 ? xx : t, this;
}
var kx = wx, Cx = rx, Sx = lx, Mx = gx, Ox = _x, Tx = kx;
function mn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
mn.prototype.clear = Cx;
mn.prototype.delete = Sx;
mn.prototype.get = Mx;
mn.prototype.has = Ox;
mn.prototype.set = Tx;
var Px = mn, $l = Px, Ax = ki, $x = dr;
function Dx() {
  this.size = 0, this.__data__ = {
    hash: new $l(),
    map: new ($x || Ax)(),
    string: new $l()
  };
}
var Lx = Dx;
function Ex(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Ix = Ex, Rx = Ix;
function Bx(e, t) {
  var n = e.__data__;
  return Rx(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Mi = Bx, Fx = Mi;
function Wx(e) {
  var t = Fx(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Nx = Wx, zx = Mi;
function jx(e) {
  return zx(this, e).get(e);
}
var Hx = jx, Vx = Mi;
function Yx(e) {
  return Vx(this, e).has(e);
}
var Gx = Yx, Ux = Mi;
function Xx(e, t) {
  var n = Ux(this, e), s = n.size;
  return n.set(e, t), this.size += n.size == s ? 0 : 1, this;
}
var qx = Xx, Kx = Lx, Qx = Nx, Jx = Hx, Zx = Gx, tw = qx;
function bn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
bn.prototype.clear = Kx;
bn.prototype.delete = Qx;
bn.prototype.get = Jx;
bn.prototype.has = Zx;
bn.prototype.set = tw;
var hr = bn, ew = ki, nw = dr, sw = hr, iw = 200;
function aw(e, t) {
  var n = this.__data__;
  if (n instanceof ew) {
    var s = n.__data__;
    if (!nw || s.length < iw - 1)
      return s.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new sw(s);
  }
  return n.set(e, t), this.size = n.size, this;
}
var rw = aw, ow = ki, lw = X0, cw = K0, dw = J0, hw = t1, uw = rw;
function yn(e) {
  var t = this.__data__ = new ow(e);
  this.size = t.size;
}
yn.prototype.clear = lw;
yn.prototype.delete = cw;
yn.prototype.get = dw;
yn.prototype.has = hw;
yn.prototype.set = uw;
var ur = yn, fw = Xe, gw = function() {
  try {
    var e = fw(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), ih = gw, Dl = ih;
function pw(e, t, n) {
  t == "__proto__" && Dl ? Dl(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Oi = pw, mw = Oi, bw = hs;
function yw(e, t, n) {
  (n !== void 0 && !bw(e[t], n) || n === void 0 && !(t in e)) && mw(e, t, n);
}
var ah = yw;
function _w(e) {
  return function(t, n, s) {
    for (var i = -1, a = Object(t), r = s(t), o = r.length; o--; ) {
      var l = r[e ? o : ++i];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var vw = _w, xw = vw, ww = xw(), rh = ww, ri = { exports: {} };
ri.exports;
(function(e, t) {
  var n = Vt, s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, a = i && i.exports === s, r = a ? n.Buffer : void 0, o = r ? r.allocUnsafe : void 0;
  function l(c, d) {
    if (d)
      return c.slice();
    var h = c.length, u = o ? o(h) : new c.constructor(h);
    return c.copy(u), u;
  }
  e.exports = l;
})(ri, ri.exports);
var kw = ri.exports, Cw = Vt, Sw = Cw.Uint8Array, oh = Sw, Ll = oh;
function Mw(e) {
  var t = new e.constructor(e.byteLength);
  return new Ll(t).set(new Ll(e)), t;
}
var Ow = Mw, Tw = Ow;
function Pw(e, t) {
  var n = t ? Tw(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Aw = Pw;
function $w(e, t) {
  var n = -1, s = e.length;
  for (t || (t = Array(s)); ++n < s; )
    t[n] = e[n];
  return t;
}
var Dw = $w, Lw = Kt, El = Object.create, Ew = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Lw(t))
      return {};
    if (El)
      return El(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), Iw = Ew;
function Rw(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var lh = Rw, Bw = lh, Fw = Bw(Object.getPrototypeOf, Object), ch = Fw, Ww = Object.prototype;
function Nw(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Ww;
  return e === n;
}
var fr = Nw, zw = Iw, jw = ch, Hw = fr;
function Vw(e) {
  return typeof e.constructor == "function" && !Hw(e) ? zw(jw(e)) : {};
}
var Yw = Vw;
function Gw(e) {
  return e != null && typeof e == "object";
}
var qe = Gw, Uw = pn, Xw = qe, qw = "[object Arguments]";
function Kw(e) {
  return Xw(e) && Uw(e) == qw;
}
var Qw = Kw, Il = Qw, Jw = qe, dh = Object.prototype, Zw = dh.hasOwnProperty, tk = dh.propertyIsEnumerable, ek = Il(/* @__PURE__ */ function() {
  return arguments;
}()) ? Il : function(e) {
  return Jw(e) && Zw.call(e, "callee") && !tk.call(e, "callee");
}, gr = ek, nk = Array.isArray, Qt = nk, sk = 9007199254740991;
function ik(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= sk;
}
var pr = ik, ak = cr, rk = pr;
function ok(e) {
  return e != null && rk(e.length) && !ak(e);
}
var us = ok, lk = us, ck = qe;
function dk(e) {
  return ck(e) && lk(e);
}
var hk = dk, oi = { exports: {} };
function uk() {
  return !1;
}
var fk = uk;
oi.exports;
(function(e, t) {
  var n = Vt, s = fk, i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, r = a && a.exports === i, o = r ? n.Buffer : void 0, l = o ? o.isBuffer : void 0, c = l || s;
  e.exports = c;
})(oi, oi.exports);
var mr = oi.exports, gk = pn, pk = ch, mk = qe, bk = "[object Object]", yk = Function.prototype, _k = Object.prototype, hh = yk.toString, vk = _k.hasOwnProperty, xk = hh.call(Object);
function wk(e) {
  if (!mk(e) || gk(e) != bk)
    return !1;
  var t = pk(e);
  if (t === null)
    return !0;
  var n = vk.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && hh.call(n) == xk;
}
var kk = wk, Ck = pn, Sk = pr, Mk = qe, Ok = "[object Arguments]", Tk = "[object Array]", Pk = "[object Boolean]", Ak = "[object Date]", $k = "[object Error]", Dk = "[object Function]", Lk = "[object Map]", Ek = "[object Number]", Ik = "[object Object]", Rk = "[object RegExp]", Bk = "[object Set]", Fk = "[object String]", Wk = "[object WeakMap]", Nk = "[object ArrayBuffer]", zk = "[object DataView]", jk = "[object Float32Array]", Hk = "[object Float64Array]", Vk = "[object Int8Array]", Yk = "[object Int16Array]", Gk = "[object Int32Array]", Uk = "[object Uint8Array]", Xk = "[object Uint8ClampedArray]", qk = "[object Uint16Array]", Kk = "[object Uint32Array]", dt = {};
dt[jk] = dt[Hk] = dt[Vk] = dt[Yk] = dt[Gk] = dt[Uk] = dt[Xk] = dt[qk] = dt[Kk] = !0;
dt[Ok] = dt[Tk] = dt[Nk] = dt[Pk] = dt[zk] = dt[Ak] = dt[$k] = dt[Dk] = dt[Lk] = dt[Ek] = dt[Ik] = dt[Rk] = dt[Bk] = dt[Fk] = dt[Wk] = !1;
function Qk(e) {
  return Mk(e) && Sk(e.length) && !!dt[Ck(e)];
}
var Jk = Qk;
function Zk(e) {
  return function(t) {
    return e(t);
  };
}
var tC = Zk, li = { exports: {} };
li.exports;
(function(e, t) {
  var n = eh, s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, a = i && i.exports === s, r = a && n.process, o = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || r && r.binding && r.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(li, li.exports);
var eC = li.exports, nC = Jk, sC = tC, Rl = eC, Bl = Rl && Rl.isTypedArray, iC = Bl ? sC(Bl) : nC, br = iC;
function aC(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var uh = aC, rC = Oi, oC = hs, lC = Object.prototype, cC = lC.hasOwnProperty;
function dC(e, t, n) {
  var s = e[t];
  (!(cC.call(e, t) && oC(s, n)) || n === void 0 && !(t in e)) && rC(e, t, n);
}
var hC = dC, uC = hC, fC = Oi;
function gC(e, t, n, s) {
  var i = !n;
  n || (n = {});
  for (var a = -1, r = t.length; ++a < r; ) {
    var o = t[a], l = s ? s(n[o], e[o], o, n, e) : void 0;
    l === void 0 && (l = e[o]), i ? fC(n, o, l) : uC(n, o, l);
  }
  return n;
}
var pC = gC;
function mC(e, t) {
  for (var n = -1, s = Array(e); ++n < e; )
    s[n] = t(n);
  return s;
}
var bC = mC, yC = 9007199254740991, _C = /^(?:0|[1-9]\d*)$/;
function vC(e, t) {
  var n = typeof e;
  return t = t ?? yC, !!t && (n == "number" || n != "symbol" && _C.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var yr = vC, xC = bC, wC = gr, kC = Qt, CC = mr, SC = yr, MC = br, OC = Object.prototype, TC = OC.hasOwnProperty;
function PC(e, t) {
  var n = kC(e), s = !n && wC(e), i = !n && !s && CC(e), a = !n && !s && !i && MC(e), r = n || s || i || a, o = r ? xC(e.length, String) : [], l = o.length;
  for (var c in e)
    (t || TC.call(e, c)) && !(r && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    SC(c, l))) && o.push(c);
  return o;
}
var fh = PC;
function AC(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var $C = AC, DC = Kt, LC = fr, EC = $C, IC = Object.prototype, RC = IC.hasOwnProperty;
function BC(e) {
  if (!DC(e))
    return EC(e);
  var t = LC(e), n = [];
  for (var s in e)
    s == "constructor" && (t || !RC.call(e, s)) || n.push(s);
  return n;
}
var FC = BC, WC = fh, NC = FC, zC = us;
function jC(e) {
  return zC(e) ? WC(e, !0) : NC(e);
}
var gh = jC, HC = pC, VC = gh;
function YC(e) {
  return HC(e, VC(e));
}
var GC = YC, Fl = ah, UC = kw, XC = Aw, qC = Dw, KC = Yw, Wl = gr, Nl = Qt, QC = hk, JC = mr, ZC = cr, tS = Kt, eS = kk, nS = br, zl = uh, sS = GC;
function iS(e, t, n, s, i, a, r) {
  var o = zl(e, n), l = zl(t, n), c = r.get(l);
  if (c) {
    Fl(e, n, c);
    return;
  }
  var d = a ? a(o, l, n + "", e, t, r) : void 0, h = d === void 0;
  if (h) {
    var u = Nl(l), f = !u && JC(l), g = !u && !f && nS(l);
    d = l, u || f || g ? Nl(o) ? d = o : QC(o) ? d = qC(o) : f ? (h = !1, d = UC(l, !0)) : g ? (h = !1, d = XC(l, !0)) : d = [] : eS(l) || Wl(l) ? (d = o, Wl(o) ? d = sS(o) : (!tS(o) || ZC(o)) && (d = KC(l))) : h = !1;
  }
  h && (r.set(l, d), i(d, l, s, a, r), r.delete(l)), Fl(e, n, d);
}
var aS = iS, rS = ur, oS = ah, lS = rh, cS = aS, dS = Kt, hS = gh, uS = uh;
function ph(e, t, n, s, i) {
  e !== t && lS(t, function(a, r) {
    if (i || (i = new rS()), dS(a))
      cS(e, t, r, n, ph, s, i);
    else {
      var o = s ? s(uS(e, r), a, r + "", e, t, i) : void 0;
      o === void 0 && (o = a), oS(e, r, o);
    }
  }, hS);
}
var fS = ph;
function gS(e) {
  return e;
}
var _r = gS;
function pS(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var mS = pS, bS = mS, jl = Math.max;
function yS(e, t, n) {
  return t = jl(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var s = arguments, i = -1, a = jl(s.length - t, 0), r = Array(a); ++i < a; )
      r[i] = s[t + i];
    i = -1;
    for (var o = Array(t + 1); ++i < t; )
      o[i] = s[i];
    return o[t] = n(r), bS(e, this, o);
  };
}
var _S = yS;
function vS(e) {
  return function() {
    return e;
  };
}
var xS = vS, wS = xS, Hl = ih, kS = _r, CS = Hl ? function(e, t) {
  return Hl(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: wS(t),
    writable: !0
  });
} : kS, SS = CS, MS = 800, OS = 16, TS = Date.now;
function PS(e) {
  var t = 0, n = 0;
  return function() {
    var s = TS(), i = OS - (s - n);
    if (n = s, i > 0) {
      if (++t >= MS)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var AS = PS, $S = SS, DS = AS, LS = DS($S), ES = LS, IS = _r, RS = _S, BS = ES;
function FS(e, t) {
  return BS(RS(e, t, IS), e + "");
}
var WS = FS, NS = hs, zS = us, jS = yr, HS = Kt;
function VS(e, t, n) {
  if (!HS(n))
    return !1;
  var s = typeof t;
  return (s == "number" ? zS(n) && jS(t, n.length) : s == "string" && t in n) ? NS(n[t], e) : !1;
}
var YS = VS, GS = WS, US = YS;
function XS(e) {
  return GS(function(t, n) {
    var s = -1, i = n.length, a = i > 1 ? n[i - 1] : void 0, r = i > 2 ? n[2] : void 0;
    for (a = e.length > 3 && typeof a == "function" ? (i--, a) : void 0, r && US(n[0], n[1], r) && (a = i < 3 ? void 0 : a, i = 1), t = Object(t); ++s < i; ) {
      var o = n[s];
      o && e(t, o, s, a);
    }
    return t;
  });
}
var qS = XS, KS = fS, QS = qS, JS = QS(function(e, t, n) {
  KS(e, t, n);
}), ZS = JS;
const J = /* @__PURE__ */ lr(ZS);
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const t2 = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
md._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return t2;
  },
  parse: function(e, t) {
    if (e === null || typeof e > "u")
      return null;
    const n = typeof e;
    return n === "number" || e instanceof Date ? e = eu(e) : n === "string" && (typeof t == "string" ? e = nu(e, t, /* @__PURE__ */ new Date(), this.options) : e = su(e, this.options)), iu(e) ? e.getTime() : null;
  },
  format: function(e, t) {
    return au(e, t, this.options);
  },
  add: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return gu(e, t);
      case "second":
        return fu(e, t);
      case "minute":
        return uu(e, t);
      case "hour":
        return hu(e, t);
      case "day":
        return du(e, t);
      case "week":
        return cu(e, t);
      case "month":
        return lu(e, t);
      case "quarter":
        return ou(e, t);
      case "year":
        return ru(e, t);
      default:
        return e;
    }
  },
  diff: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return ku(e, t);
      case "second":
        return wu(e, t);
      case "minute":
        return xu(e, t);
      case "hour":
        return vu(e, t);
      case "day":
        return _u(e, t);
      case "week":
        return yu(e, t);
      case "month":
        return bu(e, t);
      case "quarter":
        return mu(e, t);
      case "year":
        return pu(e, t);
      default:
        return 0;
    }
  },
  startOf: function(e, t, n) {
    switch (t) {
      case "second":
        return Au(e);
      case "minute":
        return Pu(e);
      case "hour":
        return Tu(e);
      case "day":
        return Ou(e);
      case "week":
        return Ar(e);
      case "isoWeek":
        return Ar(e, { weekStartsOn: +n });
      case "month":
        return Mu(e);
      case "quarter":
        return Su(e);
      case "year":
        return Cu(e);
      default:
        return e;
    }
  },
  endOf: function(e, t) {
    switch (t) {
      case "second":
        return Fu(e);
      case "minute":
        return Bu(e);
      case "hour":
        return Ru(e);
      case "day":
        return Iu(e);
      case "week":
        return Eu(e);
      case "month":
        return Lu(e);
      case "quarter":
        return Du(e);
      case "year":
        return $u(e);
      default:
        return e;
    }
  }
});
const e2 = {
  name: "ChartTitle",
  props: {
    layout: {
      type: String,
      default: "column",
      validator(e) {
        return ["column", "inline"].includes(e);
      }
    },
    title: {
      type: [Number, String],
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  methods: {
    hasProp(e) {
      return this[e] !== null && this[e].toString().length;
    }
  }
}, n2 = {
  key: 0,
  class: "c-chart-title__title"
}, s2 = {
  key: 1,
  class: "c-chart-title__text"
};
function i2(e, t, n, s, i, a) {
  return _(), S("div", {
    class: W(["c-chart-title", { [`c-chart-title--layout-${n.layout}`]: n.layout }])
  }, [
    a.hasProp("title") ? (_(), S("h5", n2, L(n.title), 1)) : rt("", !0),
    a.hasProp("text") ? (_(), S("p", s2, L(n.text), 1)) : rt("", !0)
  ], 2);
}
const a2 = /* @__PURE__ */ X(e2, [["render", i2]]), Vl = {
  line: "line",
  bar: "bar",
  barStacked: "bar",
  horizontalBar: "bar",
  horizontalBarStacked: "bar",
  radar: "radar",
  doughnut: "doughnut",
  pie: "pie",
  polarArea: "polarArea",
  bubble: "bubble",
  scatter: "scatter"
}, r2 = {
  plugins: {
    clickevents: !1,
    legend: {
      display: !1
    },
    tooltip: Lc
  },
  animation: {
    animateScale: !0,
    animateRotate: !0
  },
  borderColor: "#E5EAEF",
  color: "#3E475E",
  // denim-9
  font: {
    family: "'Roboto', sans-serif",
    size: 11,
    style: "normal"
  },
  responsive: !0,
  maintainAspectRatio: !1
}, vr = {
  offset: !1,
  drawTicks: !0,
  drawOnChartArea: !1,
  tickLength: 5,
  zeroLineColor: "#E5EAEF"
}, xr = {
  autoSkipPadding: 0,
  minRotation: 30,
  maxRotation: 30,
  font: {
    size: 11
  }
}, wr = {
  offset: !1,
  drawTicks: !0,
  tickLength: 5
}, kr = {
  minRotation: 0,
  font: {
    size: 11
  },
  precision: 0,
  padding: 4
}, mh = {
  maintainAspectRatio: !1,
  scales: {
    x: {
      grid: vr,
      ticks: xr,
      border: {
        display: !1
      }
    },
    y: {
      grid: wr,
      ticks: kr,
      border: {
        display: !1
      }
    }
  }
}, o2 = J({}, mh, {
  scales: {
    x: {
      stacked: !0,
      border: {
        display: !1
      }
    },
    y: {
      stacked: !0,
      border: {
        display: !1
      }
    }
  }
}), bh = {
  plugins: {
    tooltip: {
      mode: "nearest",
      callbacks: {
        label: kf
      }
    }
  }
}, l2 = J({}, bh, {
  cutout: "75%",
  rotation: 0,
  aspectRatio: 1,
  responsive: !0
}), yh = {
  indexAxis: "y",
  scales: {
    x: {
      ticks: kr,
      grid: wr,
      position: "top",
      border: {
        display: !1
      }
    },
    y: {
      grid: vr,
      ticks: xr,
      border: {
        display: !1
      }
    }
  }
}, c2 = J({}, yh, {
  scales: {
    x: {
      stacked: !0,
      border: {
        display: !1
      }
    },
    y: {
      stacked: !0,
      border: {
        display: !1
      }
    }
  }
}), d2 = {
  plugins: {
    tooltip: {
      mode: "nearest"
    }
  },
  elements: {
    line: {
      tension: 0.5
    }
  },
  scales: {
    x: {
      grid: vr,
      ticks: xr,
      border: {
        display: !1
      }
    },
    y: {
      grid: wr,
      ticks: kr,
      border: {
        display: !1
      }
    }
  }
}, Yl = {
  plugins: {
    tooltip: {
      mode: "nearest",
      callbacks: {
        label(e) {
          return `${e.label}: ${e.formattedValue}`;
        }
      }
    }
  }
}, h2 = {
  bar: mh,
  barStacked: o2,
  doughnut: l2,
  horizontalBar: yh,
  horizontalBarStacked: c2,
  line: d2,
  radar: {},
  pie: bh,
  polarArea: {},
  bubble: Yl,
  scatter: Yl
}, ci = {}, u2 = [
  "backgroundColor",
  "borderColor",
  "pointBackgroundColor"
], Cr = {
  mode: "index",
  fadeOpacity: 0.5,
  callback: null
};
function Gi(e, t, n) {
  let s = document.querySelector("div.hidden-color-parser");
  s || (s = document.createElement("div"), s.classList.add("hidden-color-parser"), Object.assign(s.style, { width: "0px", height: "0px", display: "none" }), document.body.append(s)), s.style.color = String(e);
  const i = window.getComputedStyle(s).color, [a, r, o, l, c] = i.match(
    /(\d+),\s*(\d+),\s*(\d+),?\s*(\d?\.?\d+)?/i
  );
  let d = c;
  return d && t && (d = parseFloat(c, 10) * parseFloat(t, 10)), a ? `rgba(${r}, ${o}, ${l}, ${d || t || 1})` : n || e;
}
function f2(e, t, n) {
  return t.data.datasets[n].data.map(
    (s, i) => e({
      chart: t,
      dataIndex: i,
      dataset: t.data.datasets[n],
      datasetIndex: n,
      hover: !0
    })
  );
}
function Ui(e, t, n, s, i = null) {
  const a = e.data.datasets[t];
  let r = a[`${n}Original`];
  const o = a[n], l = i === null;
  if (!o)
    return;
  r || (r = o, Object.assign(a, {
    [`${n}Original`]: r
  }));
  let c = [];
  if (Array.isArray(r))
    c = r.map(
      (d) => Gi(d, s.fadeOpacity)
    ), l || (c[i] = r[i]);
  else if (typeof r == "function") {
    const d = f2(
      r,
      e,
      t
    );
    c = d.map(
      (h) => Gi(h, s.fadeOpacity)
    ), l || (c[i] = d[i]);
  } else {
    const d = Gi(r, s.fadeOpacity);
    s.mode === "dataset" ? c = d : (c = new Array(a.data.length).fill(d), l || (c[i] = r));
  }
  Object.assign(a, { [n]: c });
}
function g2(e, t) {
  const n = {};
  return e.forEach((s) => {
    const { index: i, datasetIndex: a } = s, r = t.data.labels[i], o = t.data.datasets[a].data[i];
    let l = t.data.datasets[a].label;
    Array.isArray(l) && (l = l[i]), n[r] ?? (n[r] = {});
    const c = {
      label: l,
      value: o,
      dataIndex: i,
      datasetIndex: a
    };
    l === void 0 ? (c.label = r, n[r] = c) : n[r][l] = c;
  }), n;
}
function p2(e, t, n, s = "backgroundColor") {
  const { dataIndex: i, datasetIndex: a } = t;
  if (n.mode === "point") {
    e.data.datasets.forEach((r, o) => {
      Ui(e, o, s, n, o === a ? i : null);
    });
    return;
  }
  if (n.mode === "index") {
    e.data.datasets.forEach((r, o) => {
      Ui(e, o, s, n, i);
    });
    return;
  }
  n.mode === "dataset" && e.data.datasets.forEach((r, o) => {
    o !== a && Ui(e, o, s, n);
  });
}
function m2(e) {
  const { index: t, datasetIndex: n } = e;
  return {
    dataIndex: t,
    datasetIndex: n,
    hover: !0
  };
}
function b2(e) {
  e.data.datasets.forEach((n) => {
    Object.assign(n, {
      backgroundColor: n.backgroundColorOriginal || n.backgroundColor,
      borderColor: n.borderColorOriginal || n.borderColor,
      pointBackgroundColor: n.pointBackgroundColorOriginal || n.pointBackgroundColor
    });
  });
  let t = "active";
  e.config.type === "line" && (t = "default"), e.update(({ datasetIndex: n }) => {
    var s;
    return ((s = e.data.datasets[n]) == null ? void 0 : s.type) === "line" ? "none" : t;
  }), delete ci[e.id];
}
function y2(e, t) {
  typeof e == "function" && e(t);
}
function _2(e, t, n) {
  const s = m2(t);
  u2.forEach((i) => {
    p2(e, s, n, i);
  });
}
function v2(e, t, n) {
  return e.getElementsAtEventForMode(
    t,
    n.mode || Cr.mode,
    { intersect: !0 },
    !0
  );
}
function _h() {
  Object.values(ci).forEach((e) => {
    var t, n;
    document.body.contains(e.canvas) ? (n = (t = e.config) == null ? void 0 : t.data) != null && n.avoid_style_changes_on_click || b2(e) : delete ci[e.id];
  });
}
function x2(e, { event: t }, n) {
  var r, o;
  if (!["mousedown", "click", "mousemove"].includes(t.type))
    return;
  const s = J({}, Cr, n), i = v2(e, t, s);
  if (t.type === "mousemove") {
    !!(i != null && i.length) ? Object.assign(e.canvas.style, { cursor: "pointer" }) : Object.assign(e.canvas.style, { cursor: "unset" });
    return;
  }
  if (_h(), !(i != null && i.length))
    return;
  ci[e.id] = e, t.native.stopPropagation(), (o = (r = e.config) == null ? void 0 : r.data) != null && o.avoid_style_changes_on_click || _2(e, i[0], s), e.update();
  const a = g2(i, e);
  y2(s.callback, a);
}
document.addEventListener("click", _h);
const w2 = {
  id: "clickevents",
  defaults: Cr,
  afterEvent: x2
};
Ne.register(...Z_, w2, Yn);
J(Ne.defaults, r2);
const k2 = {
  name: "Chart",
  components: {
    ChartTitle: a2
  },
  props: {
    type: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(Vl).includes(e);
      }
    },
    data: {
      type: Object,
      required: !0
    },
    options: {
      type: Object,
      default: () => ({})
    },
    plugins: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "column",
      validator(e) {
        return ["column", "inline"].includes(e);
      }
    },
    title: {
      type: [Number, String],
      default: null
    },
    text: {
      type: String,
      default: null
    },
    hardwareAcceleration: {
      type: Boolean
    }
  },
  emits: ["chart:render"],
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartType() {
      return Vl[this.type];
    },
    defaultOptions() {
      return h2[this.type];
    },
    chartOptions() {
      return J({}, this.defaultOptions, this.options);
    }
  },
  watch: {
    data: "renderChart",
    options: {
      deep: !0,
      handler: "renderChart"
    }
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    hasProp(e) {
      return this[e] !== null && this[e].toString().length;
    },
    destroyChart() {
      this.chart && Jh(this.chart).destroy();
    },
    renderChart() {
      this.destroyChart();
      const { chartType: e, chartOptions: t, data: n, plugins: s } = this, i = this.$refs.chartCanvas;
      try {
        i.getContext("2d", {
          willReadFrequently: !this.hardwareAcceleration
        });
      } catch {
      }
      this.chart = new Ne(i, {
        type: e,
        data: n,
        options: t,
        plugins: s
      }), this.$emit("chart:render", this.chart);
    }
  }
}, C2 = { class: "u__flex-column" }, S2 = {
  class: "u__flex-auto",
  style: { position: "relative" }
}, M2 = { ref: "chartCanvas" };
function O2(e, t, n, s, i, a) {
  const r = R("ChartTitle");
  return _(), S("div", C2, [
    a.hasProp("title") || a.hasProp("text") ? (_(), I(r, {
      key: 0,
      layout: n.layout,
      title: n.title,
      text: n.text
    }, null, 8, ["layout", "title", "text"])) : rt("", !0),
    jt(e.$slots, "beforeChart"),
    k("div", S2, [
      k("canvas", M2, null, 512)
    ]),
    jt(e.$slots, "afterChart")
  ]);
}
const ut = /* @__PURE__ */ X(k2, [["render", O2]]), T2 = {
  name: "DataTable",
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    columnStyle: {
      type: Object,
      default: () => ({})
    },
    headingStyle: {
      type: Object,
      default: () => ({})
    },
    interactionEnabled: {
      type: Boolean
    },
    rowBorderDisabled: {
      type: Boolean
    },
    selectionEnabled: {
      type: Boolean
    },
    rowHoverStyle: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["chart-clicked"],
  setup() {
    const { showTooltip: e, hideTooltip: t } = Ea();
    return {
      showTooltip: e,
      hideTooltip: t
    };
  },
  data() {
    return {
      currentRowHoverIndex: null,
      currentRowClickedAtIndex: null
    };
  },
  computed: {
    noPadding() {
      return this.columns.some(({ heading: e }) => e) ? {} : { padding: 0 };
    },
    rows() {
      const e = {};
      return this.columns.forEach((t, n) => {
        t.rows.forEach((s, i) => {
          e[i] ?? (e[i] = {});
          const a = t.key || t.heading || `column_${n}`;
          e[i][a] = {
            leftRow: n === 0,
            style: { ...this.columnStyle, ...t.style },
            source: s,
            value: typeof s == "string" ? s : s.value
          };
        });
      }), e;
    }
  },
  watch: {
    currentRowHoverIndex: "isHoverMatchingCurrentClick"
  },
  methods: {
    isHoverMatchingCurrentClick() {
      this.currentRowClickedAtIndex && this.currentRowClickedAtIndex === this.currentRowHoverIndex && (this.currentRowClickedAtIndex = null);
    },
    onRowClick(e, t) {
      this.setRowClickedAt(t), this.interactionEnabled && this.$emit("chart-clicked", e);
    },
    setRowHoveredAt(e) {
      this.currentRowHoverIndex = e;
    },
    setRowClickedAt(e) {
      this.currentRowClickedAtIndex = e;
    },
    isSelectionClassEnabled(e) {
      return e === this.currentRowClickedAtIndex && this.selectionEnabled;
    },
    currentHoverStyle(e) {
      return e === this.currentRowHoverIndex ? this.rowHoverStyle : null;
    }
  }
}, P2 = { class: "c-datatable" }, A2 = { class: "c-datatable__row" }, $2 = ["onClick", "onMouseenter"], D2 = ["onMouseenter"];
function L2(e, t, n, s, i, a) {
  return _(), S("div", P2, [
    k("div", A2, [
      (_(!0), S(st, null, _t(n.columns, (r, o) => (_(), S("div", {
        key: r.heading,
        class: W([{ "c-datatable__column--left": o === 0 }, "c-datatable__column c-datatable__column--heading"]),
        style: vt([
          a.noPadding,
          n.columnStyle,
          n.headingStyle,
          r.style,
          r.headingStyle
        ])
      }, [
        jt(e.$slots, "heading", { column: r }, () => [
          Ye(L(r.heading), 1)
        ])
      ], 6))), 128))
    ]),
    (_(!0), S(st, null, _t(a.rows, (r, o) => (_(), S("div", {
      key: o,
      class: W(["c-datatable__row", {
        "c-datatable__row--bordered": !n.rowBorderDisabled,
        "c-datatable__row--interaction": n.interactionEnabled,
        "c-datatable__row--interaction-clicked": a.isSelectionClassEnabled(o)
      }]),
      style: vt(a.currentHoverStyle(o)),
      onClick: (l) => a.onRowClick(r, o),
      onMouseenter: (l) => n.interactionEnabled && a.setRowHoveredAt(o),
      onMouseleave: t[1] || (t[1] = (l) => n.interactionEnabled && a.setRowHoveredAt(null))
    }, [
      jt(e.$slots, "row", {
        row: r,
        rowIndex: o,
        hoverStyle: a.currentHoverStyle(o),
        showTooltip: s.showTooltip,
        hideTooltip: s.hideTooltip
      }, () => [
        (_(!0), S(st, null, _t(r, (l, c) => (_(), S("div", {
          key: c,
          class: W(["c-datatable__column", {
            "c-datatable__column--left c-datatable__column--bold": l.leftRow
          }]),
          style: vt(l.style)
        }, [
          jt(e.$slots, "beforeCell", { row: l }),
          l.leftRow ? jt(e.$slots, "beforeRow", {
            key: 0,
            row: l
          }) : rt("", !0),
          jt(e.$slots, "cell", {
            cell: l,
            hoverStyle: a.currentHoverStyle(o),
            showTooltip: s.showTooltip,
            hideTooltip: s.hideTooltip
          }, () => [
            k("span", {
              onMouseenter: (d) => s.showTooltip(d, { text: l.source.tooltip }),
              onMouseleave: t[0] || (t[0] = (...d) => s.hideTooltip && s.hideTooltip(...d))
            }, L(l.value), 41, D2)
          ])
        ], 6))), 128))
      ])
    ], 46, $2))), 128))
  ]);
}
const ft = /* @__PURE__ */ X(T2, [["render", L2]]), E2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, I2 = /* @__PURE__ */ k("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#1890ff",
  transform: "rotate(180 12 12)"
}, null, -1), R2 = /* @__PURE__ */ k("path", {
  fill: "#fff",
  d: "M10.957 9.407h2.087v8.87h-2.087z"
}, null, -1), B2 = /* @__PURE__ */ k("circle", {
  cx: "12.001",
  cy: "6.71",
  r: "1.043",
  fill: "#fff"
}, null, -1), F2 = [
  I2,
  R2,
  B2
];
function W2(e, t) {
  return _(), S("svg", E2, [...F2]);
}
const vh = { render: W2 }, N2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, z2 = /* @__PURE__ */ k("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#FF7875",
  transform: "rotate(180 12 12)"
}, null, -1), j2 = /* @__PURE__ */ k("path", {
  fill: "#fff",
  d: "M10.957 5.707h2.087v8.87h-2.087z"
}, null, -1), H2 = /* @__PURE__ */ k("circle", {
  cx: "12.001",
  cy: "17.25",
  r: "1.043",
  fill: "#fff"
}, null, -1), V2 = [
  z2,
  j2,
  H2
];
function Y2(e, t) {
  return _(), S("svg", N2, [...V2]);
}
const xh = { render: Y2 }, G2 = {
  blue: vh,
  red: xh
}, U2 = {
  name: "EmptyState",
  components: {
    BlueStateIcon: vh,
    RedStateIcon: xh
  },
  i18n: {
    messages: {
      "en-AU": {
        noDataMessage: "No data found. Try expanding your date range, keywords or filters."
      },
      "en-US": {
        noDataMessage: "No data found. Try expanding your date range, keywords or filters."
      },
      "en-GB": {
        noDataMessage: "No data found. Try expanding your date range, keywords or filters."
      },
      es: {
        noDataMessage: "Datos no encontrados. Intente ampliar su rango de fechas, palabras clave o filtros."
      },
      "fr-CA": {
        noDataMessage: "Aucun médiaAucune donnée disponible. Essayez d'élargir votre plage de dates, vos mots clés ou vos filtres."
      },
      fr: {
        noDataMessage: "Aucune donnée disponible. Essayez d'élargir votre plage de dates, vos mots clés ou vos filtres."
      },
      "zh-CN": {
        noDataMessage: "没有找到数据。尝试扩大您的日期范围、关键字或过滤器。"
      }
    }
  },
  props: {
    message: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  computed: {
    iconComponent() {
      return G2[this.color];
    },
    emptyStateMessage() {
      return this.message || this.$t("noDataMessage");
    }
  }
}, X2 = { class: "c-empty-state" }, q2 = { class: "c-empty-state__message" };
function K2(e, t, n, s, i, a) {
  return _(), S("div", X2, [
    (_(), I(es(a.iconComponent), { class: "c-empty-state__icon" })),
    k("span", q2, L(a.emptyStateMessage), 1)
  ]);
}
const wh = /* @__PURE__ */ X(U2, [["render", K2]]), Q2 = {
  name: "LegendItem",
  props: {
    label: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "#eee"
    },
    description: {
      type: String,
      default: ""
    },
    indicatorStyle: {
      type: String,
      default: "square",
      validator(e) {
        return ["line", "square", "circle"].includes(e);
      }
    },
    rightLabel: {
      type: String,
      default: ""
    }
  }
}, J2 = { class: "c-legend-item__label-text" }, Z2 = {
  key: 0,
  class: "c-legend-item__label-description"
}, tM = {
  key: 1,
  class: "c-legend-item__label-right"
};
function eM(e, t, n, s, i, a) {
  return _(), S("div", {
    class: W(["c-legend-item", `c-legend-item--${n.indicatorStyle}`])
  }, [
    k("div", {
      style: vt({ backgroundColor: n.color, borderColor: n.color }),
      class: W([`c-legend-item__indicator--${n.indicatorStyle}`, "c-legend-item__indicator"])
    }, null, 6),
    k("div", {
      class: W([{ "c-legend-item__label-spaced": n.rightLabel }, "c-legend-item__label"])
    }, [
      k("div", J2, L(n.label), 1),
      n.description ? (_(), S("div", Z2, L(n.description), 1)) : rt("", !0),
      n.rightLabel ? (_(), S("div", tM, L(n.rightLabel), 1)) : rt("", !0)
    ], 2)
  ], 2);
}
const nM = /* @__PURE__ */ X(Q2, [["render", eM]]), Gl = 16, Xi = 8, Ul = 8, sM = {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Legend",
  components: {
    LegendItem: nM
  },
  i18n: {
    messages: {
      "en-AU": {
        legendMore: "And {length} more"
      },
      "en-US": {
        legendMore: "And {length} more"
      },
      "en-GB": {
        legendMore: "And {length} more"
      },
      es: {
        legendMore: "y {length} más"
      },
      "fr-CA": {
        legendMore: "Et {length} plus"
      },
      fr: {
        legendMore: "Et {length} plus"
      },
      "zh-CN": {
        legendMore: "还有 {length} 个"
      }
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "inline",
      validator(e) {
        return ["inline", "column"].includes(e);
      }
    },
    maxRowsPerColumn: {
      type: [String, Number],
      default: null
    },
    maxColumnsPerRow: {
      type: [String, Number],
      default: null
    },
    legendColumnStyle: {
      type: Object,
      default: () => ({})
    },
    legendItemStyle: {
      type: Object,
      default: () => ({})
    },
    legendLimit: {
      type: Number,
      default: null
    },
    legendByline: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      moreItemStyle: { width: "100%", marginRight: 0 }
    };
  },
  computed: {
    visibleLegendItems() {
      return this.legendLimit ? this.items.slice(0, this.legendLimit) : this.items;
    },
    hiddenLegendItems() {
      return this.legendLimit ? this.items.slice(this.legendLimit) : [];
    },
    legendItems() {
      const e = !!this.hiddenLegendItems.length;
      let t = this.isLayoutColumn ? this.maxRowsPerColumn : this.maxColumnsPerRow;
      t ?? (t = this.visibleLegendItems.length + (e ? 1 : 0));
      const n = Array.from(this.visibleLegendItems);
      return e && n.push({ isMoreItem: !0 }), n.reduce((s, i, a) => {
        const r = Math.floor(a / t);
        return s[r] ?? (s[r] = []), s[r].push(i), s;
      }, []);
    },
    isLayoutColumn() {
      return this.layout === "column";
    },
    itemsLength() {
      return this.hiddenLegendItems.length ? this.visibleLegendItems.length + 1 : this.visibleLegendItems.length;
    },
    numberOfRows() {
      return this.maxRowsPerColumn ? this.itemsLength < this.maxRowsPerColumn ? this.itemsLength : this.maxRowsPerColumn : this.itemsLength;
    },
    columnStyle() {
      const e = (Gl + Ul) * Number(this.numberOfRows), t = this.numberOfRows <= this.maxRowsPerColumn ? 100 / Math.ceil(this.itemsLength / this.maxRowsPerColumn) : null;
      return this.isLayoutColumn ? {
        height: `${e}px`,
        width: `${t}%`
      } : {};
    },
    legendStyle() {
      const e = this.maxColumnsPerRow && this.itemsLength >= this.maxColumnsPerRow ? 100 / this.maxColumnsPerRow : null;
      return {
        margin: `0 ${Xi}px ${Ul}px ${Xi}px`,
        width: `calc(${e}% - ${2 * Xi}px)`,
        height: `${Gl}px`
      };
    },
    centerLegendItem() {
      return !this.maxColumnsPerRow || this.itemsLength === 1;
    }
  }
}, iM = { class: "c-legend" }, aM = { class: "c-legend__content" }, rM = { class: "c-legend__more-tooltip" };
function oM(e, t, n, s, i, a) {
  const r = R("LegendItem");
  return _(), S("div", iM, [
    k("div", aM, [
      (_(!0), S(st, null, _t(a.legendItems, (o, l) => (_(), S("div", {
        key: l,
        style: vt([a.columnStyle, n.legendColumnStyle]),
        class: W({
          [`c-legend--layout-${n.layout}`]: n.layout,
          [`c-legend--layout-${n.layout}--justify-center`]: n.layout && a.centerLegendItem
        })
      }, [
        (_(!0), S(st, null, _t(o, ({
          label: c,
          color: d,
          description: h,
          indicatorStyle: u,
          rightLabel: f,
          isMoreItem: g
        }, m) => (_(), S(st, null, [
          g ? (_(), S("div", {
            key: `moreItem-${m}`,
            style: vt([a.legendStyle, n.legendItemStyle]),
            class: "c-legend__more"
          }, [
            Ye(L(e.$t("legendMore", { length: a.hiddenLegendItems.length })) + " ", 1),
            k("div", rM, [
              (_(!0), S(st, null, _t(a.hiddenLegendItems, (p, b) => (_(), I(r, {
                key: `${p.label}-${b}`,
                label: p.label,
                description: p.description,
                color: p.color,
                "indicator-style": p.IndicatorStyle,
                "right-label": p.rightLabel,
                style: vt([a.legendStyle, n.legendItemStyle, i.moreItemStyle])
              }, null, 8, ["label", "description", "color", "indicator-style", "right-label", "style"]))), 128))
            ])
          ], 4)) : (_(), I(r, B({
            key: `${c}-${m}`
          }, {
            label: c,
            color: d,
            description: h,
            indicatorStyle: u,
            rightLabel: f
          }, {
            style: [a.legendStyle, n.legendItemStyle]
          }), null, 16, ["style"]))
        ], 64))), 256))
      ], 6))), 128)),
      n.legendByline ? (_(), S("div", {
        key: 0,
        class: W(["c-legend__byline", {
          [`c-legend__byline-${n.layout}`]: n.layout
        }])
      }, L(n.legendByline), 3)) : rt("", !0)
    ])
  ]);
}
const kh = /* @__PURE__ */ X(sM, [["render", oM]]), lM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ButtonGroup: Pc,
  Chart: ut,
  DataTable: ft,
  EmptyState: wh,
  Legend: kh,
  OutreachCoverageCard: Nc,
  PlatformAvatar: hi,
  SocialEngageCard: Nf
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var Xl = function() {
  if (typeof window < "u") {
    if (window.devicePixelRatio)
      return window.devicePixelRatio;
    var e = window.screen;
    if (e)
      return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
  }
  return 1;
}(), Gn = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: function(e) {
    var t = [], n;
    for (e = [].concat(e); e.length; )
      n = e.pop(), typeof n == "string" ? t.unshift.apply(t, n.split(`
`)) : Array.isArray(n) ? e.push.apply(e, n) : U(e) || t.unshift("" + n);
    return t;
  },
  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: function(e, t, n) {
    var s = [].concat(t), i = s.length, a = e.font, r = 0, o;
    for (e.font = n.string, o = 0; o < i; ++o)
      r = Math.max(e.measureText(s[o]).width, r);
    return e.font = a, {
      height: i * n.lineHeight,
      width: r
    };
  },
  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: function(e, t, n) {
    return Math.max(e, Math.min(t, n));
  },
  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: function(e, t) {
    var n = e.slice(), s = [], i, a, r, o;
    for (i = 0, r = t.length; i < r; ++i)
      o = t[i], a = n.indexOf(o), a === -1 ? s.push([o, 1]) : n.splice(a, 1);
    for (i = 0, r = n.length; i < r; ++i)
      s.push([n[i], -1]);
    return s;
  },
  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: function(e) {
    return Math.round(e * Xl) / Xl;
  }
};
function qi(e, t) {
  var n = t.x, s = t.y;
  if (n === null)
    return { x: 0, y: -1 };
  if (s === null)
    return { x: 1, y: 0 };
  var i = e.x - n, a = e.y - s, r = Math.sqrt(i * i + a * a);
  return {
    x: r ? i / r : 0,
    y: r ? a / r : -1
  };
}
function cM(e, t, n, s, i) {
  switch (i) {
    case "center":
      n = s = 0;
      break;
    case "bottom":
      n = 0, s = 1;
      break;
    case "right":
      n = 1, s = 0;
      break;
    case "left":
      n = -1, s = 0;
      break;
    case "top":
      n = 0, s = -1;
      break;
    case "start":
      n = -n, s = -s;
      break;
    case "end":
      break;
    default:
      i *= Math.PI / 180, n = Math.cos(i), s = Math.sin(i);
      break;
  }
  return {
    x: e,
    y: t,
    vx: n,
    vy: s
  };
}
var dM = 0, Ch = 1, Sh = 2, Mh = 4, Oh = 8;
function $s(e, t, n) {
  var s = dM;
  return e < n.left ? s |= Ch : e > n.right && (s |= Sh), t < n.top ? s |= Oh : t > n.bottom && (s |= Mh), s;
}
function hM(e, t) {
  for (var n = e.x0, s = e.y0, i = e.x1, a = e.y1, r = $s(n, s, t), o = $s(i, a, t), l, c, d; !(!(r | o) || r & o); )
    l = r || o, l & Oh ? (c = n + (i - n) * (t.top - s) / (a - s), d = t.top) : l & Mh ? (c = n + (i - n) * (t.bottom - s) / (a - s), d = t.bottom) : l & Sh ? (d = s + (a - s) * (t.right - n) / (i - n), c = t.right) : l & Ch && (d = s + (a - s) * (t.left - n) / (i - n), c = t.left), l === r ? (n = c, s = d, r = $s(n, s, t)) : (i = c, a = d, o = $s(i, a, t));
  return {
    x0: n,
    x1: i,
    y0: s,
    y1: a
  };
}
function Ds(e, t) {
  var n = t.anchor, s = e, i, a;
  return t.clamp && (s = hM(s, t.area)), n === "start" ? (i = s.x0, a = s.y0) : n === "end" ? (i = s.x1, a = s.y1) : (i = (s.x0 + s.x1) / 2, a = (s.y0 + s.y1) / 2), cM(i, a, e.vx, e.vy, t.align);
}
var Ls = {
  arc: function(e, t) {
    var n = (e.startAngle + e.endAngle) / 2, s = Math.cos(n), i = Math.sin(n), a = e.innerRadius, r = e.outerRadius;
    return Ds({
      x0: e.x + s * a,
      y0: e.y + i * a,
      x1: e.x + s * r,
      y1: e.y + i * r,
      vx: s,
      vy: i
    }, t);
  },
  point: function(e, t) {
    var n = qi(e, t.origin), s = n.x * e.options.radius, i = n.y * e.options.radius;
    return Ds({
      x0: e.x - s,
      y0: e.y - i,
      x1: e.x + s,
      y1: e.y + i,
      vx: n.x,
      vy: n.y
    }, t);
  },
  bar: function(e, t) {
    var n = qi(e, t.origin), s = e.x, i = e.y, a = 0, r = 0;
    return e.horizontal ? (s = Math.min(e.x, e.base), a = Math.abs(e.base - e.x)) : (i = Math.min(e.y, e.base), r = Math.abs(e.base - e.y)), Ds({
      x0: s,
      y0: i + r,
      x1: s + a,
      y1: i,
      vx: n.x,
      vy: n.y
    }, t);
  },
  fallback: function(e, t) {
    var n = qi(e, t.origin);
    return Ds({
      x0: e.x,
      y0: e.y,
      x1: e.x + (e.width || 0),
      y1: e.y + (e.height || 0),
      vx: n.x,
      vy: n.y
    }, t);
  }
}, le = Gn.rasterize;
function uM(e) {
  var t = e.borderWidth || 0, n = e.padding, s = e.size.height, i = e.size.width, a = -i / 2, r = -s / 2;
  return {
    frame: {
      x: a - n.left - t,
      y: r - n.top - t,
      w: i + n.width + t * 2,
      h: s + n.height + t * 2
    },
    text: {
      x: a,
      y: r,
      w: i,
      h: s
    }
  };
}
function fM(e, t) {
  var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
  if (!n)
    return null;
  if (n.xCenter !== void 0 && n.yCenter !== void 0)
    return { x: n.xCenter, y: n.yCenter };
  var s = n.getBasePixel();
  return e.horizontal ? { x: s, y: null } : { x: null, y: s };
}
function gM(e) {
  return e instanceof en ? Ls.arc : e instanceof Hn ? Ls.point : e instanceof Vn ? Ls.bar : Ls.fallback;
}
function pM(e, t, n, s, i, a) {
  var r = Math.PI / 2;
  if (a) {
    var o = Math.min(a, i / 2, s / 2), l = t + o, c = n + o, d = t + s - o, h = n + i - o;
    e.moveTo(t, c), l < d && c < h ? (e.arc(l, c, o, -Math.PI, -r), e.arc(d, c, o, -r, 0), e.arc(d, h, o, 0, r), e.arc(l, h, o, r, Math.PI)) : l < d ? (e.moveTo(l, n), e.arc(d, c, o, -r, r), e.arc(l, c, o, r, Math.PI + r)) : c < h ? (e.arc(l, c, o, -Math.PI, 0), e.arc(l, h, o, 0, Math.PI)) : e.arc(l, c, o, -Math.PI, Math.PI), e.closePath(), e.moveTo(t, n);
  } else
    e.rect(t, n, s, i);
}
function mM(e, t, n) {
  var s = n.backgroundColor, i = n.borderColor, a = n.borderWidth;
  !s && (!i || !a) || (e.beginPath(), pM(
    e,
    le(t.x) + a / 2,
    le(t.y) + a / 2,
    le(t.w) - a,
    le(t.h) - a,
    n.borderRadius
  ), e.closePath(), s && (e.fillStyle = s, e.fill()), i && a && (e.strokeStyle = i, e.lineWidth = a, e.lineJoin = "miter", e.stroke()));
}
function bM(e, t, n) {
  var s = n.lineHeight, i = e.w, a = e.x, r = e.y + s / 2;
  return t === "center" ? a += i / 2 : (t === "end" || t === "right") && (a += i), {
    h: s,
    w: i,
    x: a,
    y: r
  };
}
function yM(e, t, n) {
  var s = e.shadowBlur, i = n.stroked, a = le(n.x), r = le(n.y), o = le(n.w);
  i && e.strokeText(t, a, r, o), n.filled && (s && i && (e.shadowBlur = 0), e.fillText(t, a, r, o), s && i && (e.shadowBlur = s));
}
function _M(e, t, n, s) {
  var i = s.textAlign, a = s.color, r = !!a, o = s.font, l = t.length, c = s.textStrokeColor, d = s.textStrokeWidth, h = c && d, u;
  if (!(!l || !r && !h))
    for (n = bM(n, i, o), e.font = o.string, e.textAlign = i, e.textBaseline = "middle", e.shadowBlur = s.textShadowBlur, e.shadowColor = s.textShadowColor, r && (e.fillStyle = a), h && (e.lineJoin = "round", e.lineWidth = d, e.strokeStyle = c), u = 0, l = t.length; u < l; ++u)
      yM(e, t[u], {
        stroked: h,
        filled: r,
        w: n.w,
        x: n.x,
        y: n.y + n.h * u
      });
}
var Th = function(e, t, n, s) {
  var i = this;
  i._config = e, i._index = s, i._model = null, i._rects = null, i._ctx = t, i._el = n;
};
Xt(Th.prototype, {
  /**
   * @private
   */
  _modelize: function(e, t, n, s) {
    var i = this, a = i._index, r = bt(ct([n.font, {}], s, a)), o = ct([n.color, mt.color], s, a);
    return {
      align: ct([n.align, "center"], s, a),
      anchor: ct([n.anchor, "center"], s, a),
      area: s.chart.chartArea,
      backgroundColor: ct([n.backgroundColor, null], s, a),
      borderColor: ct([n.borderColor, null], s, a),
      borderRadius: ct([n.borderRadius, 0], s, a),
      borderWidth: ct([n.borderWidth, 0], s, a),
      clamp: ct([n.clamp, !1], s, a),
      clip: ct([n.clip, !1], s, a),
      color: o,
      display: e,
      font: r,
      lines: t,
      offset: ct([n.offset, 4], s, a),
      opacity: ct([n.opacity, 1], s, a),
      origin: fM(i._el, s),
      padding: kt(ct([n.padding, 4], s, a)),
      positioner: gM(i._el),
      rotation: ct([n.rotation, 0], s, a) * (Math.PI / 180),
      size: Gn.textSize(i._ctx, t, r),
      textAlign: ct([n.textAlign, "start"], s, a),
      textShadowBlur: ct([n.textShadowBlur, 0], s, a),
      textShadowColor: ct([n.textShadowColor, o], s, a),
      textStrokeColor: ct([n.textStrokeColor, o], s, a),
      textStrokeWidth: ct([n.textStrokeWidth, 0], s, a)
    };
  },
  update: function(e) {
    var t = this, n = null, s = null, i = t._index, a = t._config, r, o, l, c = ct([a.display, !0], e, i);
    c && (r = e.dataset.data[i], o = j(et(a.formatter, [r, e]), r), l = U(o) ? [] : Gn.toTextLines(o), l.length && (n = t._modelize(c, l, a, e), s = uM(n))), t._model = n, t._rects = s;
  },
  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },
  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },
  visible: function() {
    return this._model && this._model.opacity;
  },
  model: function() {
    return this._model;
  },
  draw: function(e, t) {
    var n = this, s = e.ctx, i = n._model, a = n._rects, r;
    this.visible() && (s.save(), i.clip && (r = i.area, s.beginPath(), s.rect(
      r.left,
      r.top,
      r.right - r.left,
      r.bottom - r.top
    ), s.clip()), s.globalAlpha = Gn.bound(0, i.opacity, 1), s.translate(le(t.x), le(t.y)), s.rotate(i.rotation), mM(s, a.frame, i), _M(s, i.lines, a.text, i), s.restore());
  }
});
var vM = Number.MIN_SAFE_INTEGER || -9007199254740991, xM = Number.MAX_SAFE_INTEGER || 9007199254740991;
function Pn(e, t, n) {
  var s = Math.cos(n), i = Math.sin(n), a = t.x, r = t.y;
  return {
    x: a + s * (e.x - a) - i * (e.y - r),
    y: r + i * (e.x - a) + s * (e.y - r)
  };
}
function ql(e, t) {
  var n = xM, s = vM, i = t.origin, a, r, o, l, c;
  for (a = 0; a < e.length; ++a)
    r = e[a], o = r.x - i.x, l = r.y - i.y, c = t.vx * o + t.vy * l, n = Math.min(n, c), s = Math.max(s, c);
  return {
    min: n,
    max: s
  };
}
function Es(e, t) {
  var n = t.x - e.x, s = t.y - e.y, i = Math.sqrt(n * n + s * s);
  return {
    vx: (t.x - e.x) / i,
    vy: (t.y - e.y) / i,
    origin: e,
    ln: i
  };
}
var Ph = function() {
  this._rotation = 0, this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};
Xt(Ph.prototype, {
  center: function() {
    var e = this._rect;
    return {
      x: e.x + e.w / 2,
      y: e.y + e.h / 2
    };
  },
  update: function(e, t, n) {
    this._rotation = n, this._rect = {
      x: t.x + e.x,
      y: t.y + e.y,
      w: t.w,
      h: t.h
    };
  },
  contains: function(e) {
    var t = this, n = 1, s = t._rect;
    return e = Pn(e, t.center(), -t._rotation), !(e.x < s.x - n || e.y < s.y - n || e.x > s.x + s.w + n * 2 || e.y > s.y + s.h + n * 2);
  },
  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: function(e) {
    var t = this._points(), n = e._points(), s = [
      Es(t[0], t[1]),
      Es(t[0], t[3])
    ], i, a, r;
    for (this._rotation !== e._rotation && s.push(
      Es(n[0], n[1]),
      Es(n[0], n[3])
    ), i = 0; i < s.length; ++i)
      if (a = ql(t, s[i]), r = ql(n, s[i]), a.max < r.min || r.max < a.min)
        return !1;
    return !0;
  },
  /**
   * @private
   */
  _points: function() {
    var e = this, t = e._rect, n = e._rotation, s = e.center();
    return [
      Pn({ x: t.x, y: t.y }, s, n),
      Pn({ x: t.x + t.w, y: t.y }, s, n),
      Pn({ x: t.x + t.w, y: t.y + t.h }, s, n),
      Pn({ x: t.x, y: t.y + t.h }, s, n)
    ];
  }
});
function Ah(e, t, n) {
  var s = t.positioner(e, t), i = s.vx, a = s.vy;
  if (!i && !a)
    return { x: s.x, y: s.y };
  var r = n.w, o = n.h, l = t.rotation, c = Math.abs(r / 2 * Math.cos(l)) + Math.abs(o / 2 * Math.sin(l)), d = Math.abs(r / 2 * Math.sin(l)) + Math.abs(o / 2 * Math.cos(l)), h = 1 / Math.max(Math.abs(i), Math.abs(a));
  return c *= i * h, d *= a * h, c += t.offset * i, d += t.offset * a, {
    x: s.x + c,
    y: s.y + d
  };
}
function wM(e, t) {
  var n, s, i, a;
  for (n = e.length - 1; n >= 0; --n)
    for (i = e[n].$layout, s = n - 1; s >= 0 && i._visible; --s)
      a = e[s].$layout, a._visible && i._box.intersects(a._box) && t(i, a);
  return e;
}
function kM(e) {
  var t, n, s, i, a, r, o;
  for (t = 0, n = e.length; t < n; ++t)
    s = e[t], i = s.$layout, i._visible && (o = new Proxy(s._el, { get: (l, c) => l.getProps([c], !0)[c] }), a = s.geometry(), r = Ah(o, s.model(), a), i._box.update(r, a, s.rotation()));
  return wM(e, function(l, c) {
    var d = l._hidable, h = c._hidable;
    d && h || h ? c._visible = !1 : d && (l._visible = !1);
  });
}
var Un = {
  prepare: function(e) {
    var t = [], n, s, i, a, r;
    for (n = 0, i = e.length; n < i; ++n)
      for (s = 0, a = e[n].length; s < a; ++s)
        r = e[n][s], t.push(r), r.$layout = {
          _box: new Ph(),
          _hidable: !1,
          _visible: !0,
          _set: n,
          _idx: r._index
        };
    return t.sort(function(o, l) {
      var c = o.$layout, d = l.$layout;
      return c._idx === d._idx ? d._set - c._set : d._idx - c._idx;
    }), this.update(t), t;
  },
  update: function(e) {
    var t = !1, n, s, i, a, r;
    for (n = 0, s = e.length; n < s; ++n)
      i = e[n], a = i.model(), r = i.$layout, r._hidable = a && a.display === "auto", r._visible = i.visible(), t |= r._hidable;
    t && kM(e);
  },
  lookup: function(e, t) {
    var n, s;
    for (n = e.length - 1; n >= 0; --n)
      if (s = e[n].$layout, s && s._visible && s._box.contains(t))
        return e[n];
    return null;
  },
  draw: function(e, t) {
    var n, s, i, a, r, o;
    for (n = 0, s = t.length; n < s; ++n)
      i = t[n], a = i.$layout, a._visible && (r = i.geometry(), o = Ah(i._el, i.model(), r), a._box.update(o, r, i.rotation()), i.draw(e, o));
  }
}, CM = function(e) {
  if (U(e))
    return null;
  var t = e, n, s, i;
  if (H(e))
    if (!U(e.label))
      t = e.label;
    else if (!U(e.r))
      t = e.r;
    else
      for (t = "", n = Object.keys(e), i = 0, s = n.length; i < s; ++i)
        t += (i !== 0 ? ", " : "") + n[i] + ": " + e[n[i]];
  return "" + t;
}, SM = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: !1,
  clip: !1,
  color: void 0,
  display: !0,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter: CM,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
}, $t = "$datalabels", $h = "$default";
function MM(e, t) {
  var n = e.datalabels, s = {}, i = [], a, r;
  return n === !1 ? null : (n === !0 && (n = {}), t = Xt({}, [t, n]), a = t.labels || {}, r = Object.keys(a), delete t.labels, r.length ? r.forEach(function(o) {
    a[o] && i.push(Xt({}, [
      t,
      a[o],
      { _key: o }
    ]));
  }) : i.push(t), s = i.reduce(function(o, l) {
    return nt(l.listeners || {}, function(c, d) {
      o[d] = o[d] || {}, o[d][l._key || $h] = c;
    }), delete l.listeners, o;
  }, {}), {
    labels: i,
    listeners: s
  });
}
function Ma(e, t, n, s) {
  if (t) {
    var i = n.$context, a = n.$groups, r;
    t[a._set] && (r = t[a._set][a._key], r && et(r, [i, s]) === !0 && (e[$t]._dirty = !0, n.update(i)));
  }
}
function OM(e, t, n, s, i) {
  var a, r;
  !n && !s || (n ? s ? n !== s && (r = a = !0) : r = !0 : a = !0, r && Ma(e, t.leave, n, i), a && Ma(e, t.enter, s, i));
}
function TM(e, t) {
  var n = e[$t], s = n._listeners, i, a;
  if (!(!s.enter && !s.leave)) {
    if (t.type === "mousemove")
      a = Un.lookup(n._labels, t);
    else if (t.type !== "mouseout")
      return;
    i = n._hovered, n._hovered = a, OM(e, s, i, a, t);
  }
}
function PM(e, t) {
  var n = e[$t], s = n._listeners.click, i = s && Un.lookup(n._labels, t);
  i && Ma(e, s, i, t);
}
var Sr = {
  id: "datalabels",
  defaults: SM,
  beforeInit: function(e) {
    e[$t] = {
      _actives: []
    };
  },
  beforeUpdate: function(e) {
    var t = e[$t];
    t._listened = !1, t._listeners = {}, t._datasets = [], t._labels = [];
  },
  afterDatasetUpdate: function(e, t, n) {
    var s = t.index, i = e[$t], a = i._datasets[s] = [], r = e.isDatasetVisible(s), o = e.data.datasets[s], l = MM(o, n), c = t.meta.data || [], d = e.ctx, h, u, f, g, m, p, b, y;
    for (d.save(), h = 0, f = c.length; h < f; ++h)
      if (b = c[h], b[$t] = [], r && b && e.getDataVisibility(h) && !b.skip)
        for (u = 0, g = l.labels.length; u < g; ++u)
          m = l.labels[u], p = m._key, y = new Th(m, d, b, h), y.$groups = {
            _set: s,
            _key: p || $h
          }, y.$context = {
            active: !1,
            chart: e,
            dataIndex: h,
            dataset: o,
            datasetIndex: s
          }, y.update(y.$context), b[$t].push(y), a.push(y);
    d.restore(), Xt(i._listeners, l.listeners, {
      merger: function(v, w, x) {
        w[v] = w[v] || {}, w[v][t.index] = x[v], i._listened = !0;
      }
    });
  },
  afterUpdate: function(e) {
    e[$t]._labels = Un.prepare(e[$t]._datasets);
  },
  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: function(e) {
    Un.draw(e, e[$t]._labels);
  },
  beforeEvent: function(e, t) {
    if (e[$t]._listened) {
      var n = t.event;
      switch (n.type) {
        case "mousemove":
        case "mouseout":
          TM(e, n);
          break;
        case "click":
          PM(e, n);
          break;
      }
    }
  },
  afterEvent: function(e) {
    var t = e[$t], n = t._actives, s = t._actives = e.getActiveElements(), i = Gn.arrayDiff(n, s), a, r, o, l, c, d, h;
    for (a = 0, r = i.length; a < r; ++a)
      if (c = i[a], c[1])
        for (h = c[0].element[$t] || [], o = 0, l = h.length; o < l; ++o)
          d = h[o], d.$context.active = c[1] === 1, d.update(d.$context);
    (t._dirty || i.length) && (Un.update(t._labels), e.render()), delete t._dirty;
  }
};
function AM(e) {
  return (t) => {
    const s = (e ? Math[e] : Math.trunc)(t);
    return s === 0 ? 0 : s;
  };
}
function $M(e, t) {
  return +Bt(e) - +Bt(t);
}
function DM(e, t, n) {
  const s = $M(e, t) / wg;
  return AM(n == null ? void 0 : n.roundingMethod)(s);
}
function LM(e) {
  if (Fc(e))
    return e;
  let t;
  return /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(e) ? (t = new Date(e), t.setTime(
    t.getTime() + t.getTimezoneOffset() * 60 * 1e3
  )) : t = e, Number.isInteger(t) && t.toString().length > 10 && (t = Math.floor(t / 1e3)), Number.isInteger(t) ? new Date(t * 1e3) : new Date(t);
}
function Dh(e, t = {}, n = null) {
  return new Intl.DateTimeFormat(
    n || window.navigator.language,
    t
  ).format(LM(e));
}
const Nt = {
  hour: "hour",
  day: "day",
  week: "week",
  month: "month",
  quarter: "quarter",
  year: "year"
};
function Lh(e) {
  const { data: t = yt({}), options: n = yt({}) } = Oc(e), s = P(
    () => n.value.time_zone || "Australia/Sydney"
  ), i = P(() => {
    var f;
    if (!((f = t.value.labels) != null && f.length))
      return Nt.day;
    const d = n.value.interval || Nt.day, h = t.value.labels.map((g) => new Date(g)), u = DM(
      Math.max(...h),
      Math.min(...h)
    );
    return d === Nt.day ? u < 48 ? Nt.hour : Nt.day : d;
  });
  function a(d) {
    return `Q${Math.floor(d.getMonth() / 3) + 1} ${d.getFullYear()}`;
  }
  function r(d = 0) {
    const h = i.value, u = { timeZone: s.value }, f = {
      [Nt.hour]: {
        ...u,
        ...d % 24 === 0 ? { day: "2-digit", month: "2-digit" } : {},
        hour: "numeric",
        hourCycle: "h12"
      },
      [Nt.week]: {
        ...u,
        day: "2-digit",
        month: "short"
      },
      [Nt.month]: {
        ...u,
        month: "short",
        year: "numeric"
      },
      [Nt.quarter]: null,
      // Special case handled separately
      [Nt.year]: {
        ...u,
        year: "numeric"
      },
      // Default format for Day and fallback
      default: {
        ...u,
        day: "2-digit",
        month: "short",
        hourCycle: "h12"
      }
    };
    return f[h] || f.default;
  }
  function o(d, h) {
    return i.value === Nt.quarter ? a(d) : Dh(d, h);
  }
  function l(d, h) {
    var m;
    if (!((m = t.value.labels) != null && m.length))
      return "";
    const u = t.value.labels[d];
    if (!u)
      return "";
    const f = new Date(u), g = r(h);
    return o(f, g);
  }
  function c(d) {
    const h = new Date(d[0].label), u = r();
    return u && (u.year = "numeric", i.value === Nt.hour && (u.day = "2-digit", u.month = "short")), o(h, u);
  }
  return {
    dateFormatter: l,
    tooltipDateFormatter: c
  };
}
const EM = 25, IM = 14, RM = 16;
function xt(e, t = {
  /**
   * Set to true if the chart is a histogram
   * This will format the labels as dates
   * and use the tooltipDateFormatter for the tooltip title
   */
  isHistogram: !1,
  /**
   * Optional callback for the value axis
   */
  valueCallback: null,
  /**
   * Optional callback for the label axis
   */
  labelCallback: null,
  /**
   * Optional callback for the label axis color
   */
  labelColorCallback: null,
  /**
   * Optional callback for the value axis color
   */
  valueColorCallback: null,
  /**
   * Extra axis options
   */
  valueScaleOptions: {},
  /**
   * Extra axis options
   */
  labelScaleOptions: {},
  /**
   * Optional callbacks for the tooltip plugin
   */
  tooltipCallbacks: {},
  /**
   * Optional filter for the tooltip plugin
   */
  tooltipFilter: null,
  /**
   * Optional callback for the datalabel formatter
   */
  dataLabelCallback: null,
  /**
   * Set to true if the label axis should be bold
   */
  boldLabels: !1,
  /**
   * Set mode for the click events plugin
   * For pie/doughnut charts, this is overridden to "point"
   * For histogram charts, this is overridden to "nearest"
   */
  clickEventsMode: "index",
  /**
   * Set to true if the borders should be collapsed on pie/doughnut charts
   */
  collapseBorders: !1
}) {
  const {
    chartType: n = yt(""),
    data: s = yt({}),
    interactionEnabled: i = yt(!1),
    truncateLabels: a = yt(!1),
    truncateLabelsAt: r = yt(null),
    legend: o = yt([]),
    showTotal: l = yt(!1),
    size: c = yt(null),
    showDataLabels: d = yt(!1),
    dataLabelColor: h = yt("white")
  } = Oc(e), { dateFormatter: u, tooltipDateFormatter: f } = Lh(e), { emit: g } = Da(), m = P(() => ["line"].includes(n.value)), p = P(
    () => ["horizontalBar", "horizontalBarStacked"].includes(n.value)
  ), b = P(() => n.value === "radar"), y = P(
    () => ["pie", "doughnut"].includes(n.value)
  ), v = P(
    () => ["barStacked", "horizontalBarStacked"].includes(n.value)
  ), w = P(() => e.chartType === "table"), x = P(() => d.value ? [Sr] : []), C = P(() => r.value ? r.value : y.value ? IM : EM), O = P(() => y.value ? RM : 0);
  function M(at, Ft) {
    return t.labelCallback ? t.labelCallback(at, Ft) : t.isHistogram ? u(at, Ft) : an(
      this.getLabelForValue(at),
      C.value,
      O.value
    );
  }
  function A(at) {
    return t.valueCallback ? t.valueCallback(at) : m.value ? Xn(at) : at.toLocaleString();
  }
  const $ = P(() => t.isHistogram ? {
    title: f,
    ...t.tooltipCallbacks
  } : t.tooltipCallbacks ? t.tooltipCallbacks : {}), D = P(() => ({
    position: p.value ? "left" : "bottom",
    ticks: {
      minRotation: 0,
      font: {
        size: 12,
        weight: t.boldLabels ? 500 : null
      },
      beginAtZero: !0,
      callback: M,
      color: t.labelColorCallback
    },
    grid: {
      display: m.value
    },
    ...t.labelScaleOptions
  })), F = P(() => ({
    id: "volume",
    ticks: {
      font: {
        size: 11
      },
      beginAtZero: !0,
      callback: A,
      color: t.valueColorCallback
    },
    grid: {
      border: {
        display: !1
      },
      drawOnChartArea: !0,
      color: "#E5EAEF",
      zeroLineColor: "#E5EAEF",
      display: !0
    },
    ...t.valueScaleOptions
  })), z = P(
    () => p.value ? F.value : D.value
  ), Q = P(
    () => p.value ? D.value : F.value
  ), G = P(() => {
    var at;
    return !((at = s.value.datasets) != null && at.length) || !l.value ? 0 : s.value.datasets[0].data.reduce((Ft, Qe) => Ft + Qe, 0);
  }), q = P(() => m.value ? {
    line: {
      borderWidth: 2
    },
    point: {
      radius: 0,
      hitRadius: 20
    }
  } : y.value ? {
    center: l.value ? {
      text: String(G.value.toLocaleString()),
      defaultStaticText: "Total:"
    } : null,
    arc: t.collapseBorders ? { borderWidth: 0 } : null
  } : {}), Z = P(() => y.value || b.value ? "point" : t.isHistogram ? "nearest" : t.clickEventsMode), wt = P(() => p.value ? "y" : y.value ? "nearest" : "index"), Ct = P(() => ({
    indexAxis: p.value ? "y" : "x",
    plugins: {
      clickevents: i.value && {
        mode: Z.value,
        callback: (at) => {
          g("chart-clicked", at);
        }
      },
      ...d.value && {
        datalabels: {
          display: d.value,
          anchor: "center",
          labels: {
            value: {
              color: h.value
            }
          },
          formatter: t.dataLabelCallback || Xn
        }
      },
      tooltip: {
        mode: wt.value,
        filter: t.tooltipFilter,
        callbacks: $.value
      }
    },
    scales: {
      x: z.value,
      y: Q.value
    },
    elements: q.value
  })), de = P(() => ({
    ...Ct.value,
    scales: {
      r: {
        ticks: {
          callback: Ac
        }
      }
    }
  })), Ke = P(() => ({
    ...Ct.value,
    scales: null
  })), he = P(() => b.value ? de.value : y.value ? Ke.value : Ct.value), Oe = P(
    () => {
      var at, Ft;
      return !!((Ft = (at = e.data) == null ? void 0 : at.columns) != null && Ft.length && e.data.columns[0].rows.length);
    }
  ), Jt = P(
    () => {
      var at;
      return e.chartType === "table" && Oe.value || ((at = s == null ? void 0 : s.value.datasets) == null ? void 0 : at.some((Ft) => {
        var Qe;
        return (Qe = Ft.data) == null ? void 0 : Qe.length;
      }));
    }
  ), Te = P(
    () => o.value.map(({ color: at, label: Ft, description: Qe, rightLabel: Pr }) => {
      let Ai = Pr ? `${Ft}:` : Ft;
      return a.value && (Ai = an(
        Ai,
        C.value,
        O.value
      )), {
        color: at,
        label: ui(Ai),
        description: Qe,
        rightLabel: Pr
      };
    })
  ), Zt = P(() => {
    if (!y.value)
      return {};
    const at = {
      minWidth: 0,
      minHeight: 0,
      flex: "1 1 50%"
    };
    return c.value && (at.alignSelf = "center", at.maxWidth = `${c.value}px`, at.maxHeight = `${c.value}px`), at;
  }), Xh = P(() => {
    const at = ["c-chart-layout__chart", "u__flex-auto"];
    return y.value && at.push("c-pie-with-legend__chart"), at;
  }), qh = P(() => y.value ? "c-pie-with-legend" : p.value ? "c-horizontal-bar-layout" : w.value ? "c-table-layout" : "");
  return {
    chartClass: Xh,
    chartLayoutClass: qh,
    chartLegend: Te,
    chartStyle: Zt,
    defaultOptions: he,
    hasDatasets: Jt,
    isHorizontal: p,
    isRadar: b,
    isStacked: v,
    isTable: w,
    plugins: x
  };
}
function Eh() {
  const e = {
    ISK: "kr",
    ZAR: "R",
    BTC: "₿"
  };
  function t({ number: n, locale: s, currencyCode: i } = {}) {
    const a = new Intl.NumberFormat(s, {
      style: "currency",
      currency: i,
      minimumFractionDigits: 0,
      numberingSystem: "latn"
    }).format(n), r = a.match(
      new RegExp(Object.keys(e).join("|"))
    );
    if (r) {
      const o = e[r[0]];
      if (o)
        return a.replace(r[0], o);
    }
    return a;
  }
  return {
    numberToCurrency: t
  };
}
const lt = {
  data: {
    type: Object,
    default: () => ({})
  },
  hasData: {
    type: Boolean
  },
  interactionEnabled: {
    type: Boolean
  },
  emptyStateColor: {
    type: String,
    default: "blue",
    validator(e) {
      return ["blue", "red"].includes(e);
    }
  },
  legendPosition: {
    type: String,
    default: "bottom",
    validator(e) {
      return ["top", "bottom", "left", "right"].includes(e);
    }
  },
  options: {
    type: Object,
    default: () => ({})
  },
  text: {
    type: String,
    default: ""
  },
  title: {
    type: [Number, String],
    default: ""
  },
  showTotal: {
    type: Boolean
  }
}, gt = {
  legend: {
    type: Array,
    default: () => []
  },
  legendColumnStyle: {
    type: Object,
    default: () => ({})
  },
  legendItemStyle: {
    type: Object,
    default: () => ({})
  },
  legendLayout: {
    type: String,
    default: "column",
    validator(e) {
      return ["column", "inline"].includes(e);
    }
  },
  legendLimit: {
    type: Number,
    default: null
  },
  legendStyle: {
    type: Object,
    default: () => ({})
  },
  legendByline: {
    type: String,
    default: null
  },
  legendContainerClass: {
    type: String,
    default: "c-legend-container"
  },
  maxColumnsPerRow: {
    type: Number,
    default: null
  },
  maxRowsPerColumn: {
    type: Number,
    default: null
  },
  currencyCode: {
    type: String,
    default: "AUD"
  },
  locale: {
    type: String,
    default: "en-AU"
  }
}, BM = {
  name: "ChartWithLegendLayout",
  components: {
    EmptyState: wh,
    // eslint-disable-next-line vue/no-reserved-component-names
    Legend: kh
  },
  props: {
    ...lt,
    ...gt
  }
};
function FM(e, t, n, s, i, a) {
  const r = R("Legend"), o = R("EmptyState");
  return _(), S("div", {
    class: W(["c-chart-layout", {
      "u__flex-column": e.legend.length && e.legendPosition === "bottom",
      "u__flex-column-reverse": e.legend.length && e.legendPosition === "top",
      "u__flex-row-reverse": e.legend.length && e.legendPosition === "left",
      "u__flex-row": e.legend.length && e.legendPosition === "right"
    }])
  }, [
    e.hasData ? (_(), S(st, { key: 0 }, [
      jt(e.$slots, "chart"),
      k("div", {
        class: W(e.legendContainerClass)
      }, [
        jt(e.$slots, "before-legend"),
        e.legend.length ? (_(), I(r, {
          key: 0,
          items: e.legend,
          layout: e.legendLayout,
          "max-rows-per-column": e.maxRowsPerColumn,
          "max-columns-per-row": e.maxColumnsPerRow,
          style: vt(e.legendStyle),
          "legend-column-style": e.legendColumnStyle,
          "legend-item-style": e.legendItemStyle,
          "legend-limit": e.legendLimit,
          "legend-byline": e.legendByline,
          class: "c-chart-layout__legend"
        }, null, 8, ["items", "layout", "max-rows-per-column", "max-columns-per-row", "style", "legend-column-style", "legend-item-style", "legend-limit", "legend-byline"])) : rt("", !0)
      ], 2)
    ], 64)) : (_(), I(o, {
      key: 1,
      color: e.emptyStateColor
    }, null, 8, ["color"]))
  ], 2);
}
const V = /* @__PURE__ */ X(BM, [["render", FM]]), WM = /* @__PURE__ */ Object.assign({
  name: "AdvertisingValueEquivalency"
}, {
  __name: "AdvertisingValueEquivalency",
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "horizontalBar"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, { numberToCurrency: i } = Eh();
    function a(p) {
      return p > 0 ? i({
        number: p,
        locale: n.locale,
        currencyCode: n.currencyCode
      }) : p.toLocaleString();
    }
    function r(p) {
      return p.dataset.data[p.dataIndex] !== 0;
    }
    function o(p) {
      return i({
        number: p.raw,
        locale: n.locale,
        currencyCode: n.currencyCode
      });
    }
    const l = P(
      () => ["barStacked", "horizontalBarStacked"].includes(n.chartType)
    ), { chartClass: c, chartLayoutClass: d, defaultOptions: h, hasDatasets: u, isTable: f } = xt(n, {
      isHistogram: l.value,
      boldLabels: !0,
      valueCallback: a,
      tooltipFilter: r,
      tooltipCallbacks: {
        label: o
      }
    }), g = P(
      () => J({}, h.value, n.options)
    ), m = P(() => {
      if (!f.value)
        return [];
      const p = n.data.columns.map((b) => {
        var y;
        return {
          ...b,
          rows: b.header === ((y = n.data.columns[1]) == null ? void 0 : y.header) ? b.rows.map(a) : b.rows
        };
      });
      return {
        ...n.data,
        columns: p
      };
    });
    return (p, b) => (_(), I(T(V), B({ class: T(d) }, p.$props, { "has-data": T(u) }), {
      chart: N(() => [
        T(f) ? (_(), I(T(ft), ce(B({ key: 0 }, m.value)), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: p.data,
          options: g.value,
          title: p.title,
          text: p.text,
          class: W(T(c)),
          onChartClicked: b[0] || (b[0] = (y) => s("chart-clicked", y)),
          "onChart:render": b[1] || (b[1] = (y) => s("chart:render", y))
        }, null, 8, ["type", "data", "options", "title", "text", "class"]))
      ]),
      _: 1
    }, 16, ["class", "has-data"]));
  }
});
function NM(e, t, n, s) {
  for (var i = -1, a = e == null ? 0 : e.length; ++i < a; ) {
    var r = e[i];
    t(s, r, n(r), e);
  }
  return s;
}
var zM = NM, jM = lh, HM = jM(Object.keys, Object), VM = HM, YM = fr, GM = VM, UM = Object.prototype, XM = UM.hasOwnProperty;
function qM(e) {
  if (!YM(e))
    return GM(e);
  var t = [];
  for (var n in Object(e))
    XM.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var KM = qM, QM = fh, JM = KM, ZM = us;
function tO(e) {
  return ZM(e) ? QM(e) : JM(e);
}
var Mr = tO, eO = rh, nO = Mr;
function sO(e, t) {
  return e && eO(e, t, nO);
}
var iO = sO, aO = us;
function rO(e, t) {
  return function(n, s) {
    if (n == null)
      return n;
    if (!aO(n))
      return e(n, s);
    for (var i = n.length, a = t ? i : -1, r = Object(n); (t ? a-- : ++a < i) && s(r[a], a, r) !== !1; )
      ;
    return n;
  };
}
var oO = rO, lO = iO, cO = oO, dO = cO(lO), hO = dO, uO = hO;
function fO(e, t, n, s) {
  return uO(e, function(i, a, r) {
    t(s, i, n(i), r);
  }), s;
}
var gO = fO, pO = "__lodash_hash_undefined__";
function mO(e) {
  return this.__data__.set(e, pO), this;
}
var bO = mO;
function yO(e) {
  return this.__data__.has(e);
}
var _O = yO, vO = hr, xO = bO, wO = _O;
function di(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new vO(); ++t < n; )
    this.add(e[t]);
}
di.prototype.add = di.prototype.push = xO;
di.prototype.has = wO;
var kO = di;
function CO(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length; ++n < s; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var SO = CO;
function MO(e, t) {
  return e.has(t);
}
var OO = MO, TO = kO, PO = SO, AO = OO, $O = 1, DO = 2;
function LO(e, t, n, s, i, a) {
  var r = n & $O, o = e.length, l = t.length;
  if (o != l && !(r && l > o))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var h = -1, u = !0, f = n & DO ? new TO() : void 0;
  for (a.set(e, t), a.set(t, e); ++h < o; ) {
    var g = e[h], m = t[h];
    if (s)
      var p = r ? s(m, g, h, t, e, a) : s(g, m, h, e, t, a);
    if (p !== void 0) {
      if (p)
        continue;
      u = !1;
      break;
    }
    if (f) {
      if (!PO(t, function(b, y) {
        if (!AO(f, y) && (g === b || i(g, b, n, s, a)))
          return f.push(y);
      })) {
        u = !1;
        break;
      }
    } else if (!(g === m || i(g, m, n, s, a))) {
      u = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), u;
}
var Ih = LO;
function EO(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(s, i) {
    n[++t] = [i, s];
  }), n;
}
var IO = EO;
function RO(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(s) {
    n[++t] = s;
  }), n;
}
var BO = RO, Kl = Ci, Ql = oh, FO = hs, WO = Ih, NO = IO, zO = BO, jO = 1, HO = 2, VO = "[object Boolean]", YO = "[object Date]", GO = "[object Error]", UO = "[object Map]", XO = "[object Number]", qO = "[object RegExp]", KO = "[object Set]", QO = "[object String]", JO = "[object Symbol]", ZO = "[object ArrayBuffer]", tT = "[object DataView]", Jl = Kl ? Kl.prototype : void 0, Ki = Jl ? Jl.valueOf : void 0;
function eT(e, t, n, s, i, a, r) {
  switch (n) {
    case tT:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ZO:
      return !(e.byteLength != t.byteLength || !a(new Ql(e), new Ql(t)));
    case VO:
    case YO:
    case XO:
      return FO(+e, +t);
    case GO:
      return e.name == t.name && e.message == t.message;
    case qO:
    case QO:
      return e == t + "";
    case UO:
      var o = NO;
    case KO:
      var l = s & jO;
      if (o || (o = zO), e.size != t.size && !l)
        return !1;
      var c = r.get(e);
      if (c)
        return c == t;
      s |= HO, r.set(e, t);
      var d = WO(o(e), o(t), s, i, a, r);
      return r.delete(e), d;
    case JO:
      if (Ki)
        return Ki.call(e) == Ki.call(t);
  }
  return !1;
}
var nT = eT;
function sT(e, t) {
  for (var n = -1, s = t.length, i = e.length; ++n < s; )
    e[i + n] = t[n];
  return e;
}
var iT = sT, aT = iT, rT = Qt;
function oT(e, t, n) {
  var s = t(e);
  return rT(e) ? s : aT(s, n(e));
}
var lT = oT;
function cT(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length, i = 0, a = []; ++n < s; ) {
    var r = e[n];
    t(r, n, e) && (a[i++] = r);
  }
  return a;
}
var dT = cT;
function hT() {
  return [];
}
var uT = hT, fT = dT, gT = uT, pT = Object.prototype, mT = pT.propertyIsEnumerable, Zl = Object.getOwnPropertySymbols, bT = Zl ? function(e) {
  return e == null ? [] : (e = Object(e), fT(Zl(e), function(t) {
    return mT.call(e, t);
  }));
} : gT, yT = bT, _T = lT, vT = yT, xT = Mr;
function wT(e) {
  return _T(e, xT, vT);
}
var kT = wT, tc = kT, CT = 1, ST = Object.prototype, MT = ST.hasOwnProperty;
function OT(e, t, n, s, i, a) {
  var r = n & CT, o = tc(e), l = o.length, c = tc(t), d = c.length;
  if (l != d && !r)
    return !1;
  for (var h = l; h--; ) {
    var u = o[h];
    if (!(r ? u in t : MT.call(t, u)))
      return !1;
  }
  var f = a.get(e), g = a.get(t);
  if (f && g)
    return f == t && g == e;
  var m = !0;
  a.set(e, t), a.set(t, e);
  for (var p = r; ++h < l; ) {
    u = o[h];
    var b = e[u], y = t[u];
    if (s)
      var v = r ? s(y, b, u, t, e, a) : s(b, y, u, e, t, a);
    if (!(v === void 0 ? b === y || i(b, y, n, s, a) : v)) {
      m = !1;
      break;
    }
    p || (p = u == "constructor");
  }
  if (m && !p) {
    var w = e.constructor, x = t.constructor;
    w != x && "constructor" in e && "constructor" in t && !(typeof w == "function" && w instanceof w && typeof x == "function" && x instanceof x) && (m = !1);
  }
  return a.delete(e), a.delete(t), m;
}
var TT = OT, PT = Xe, AT = Vt, $T = PT(AT, "DataView"), DT = $T, LT = Xe, ET = Vt, IT = LT(ET, "Promise"), RT = IT, BT = Xe, FT = Vt, WT = BT(FT, "Set"), NT = WT, zT = Xe, jT = Vt, HT = zT(jT, "WeakMap"), VT = HT, Oa = DT, Ta = dr, Pa = RT, Aa = NT, $a = VT, Rh = pn, _n = sh, ec = "[object Map]", YT = "[object Object]", nc = "[object Promise]", sc = "[object Set]", ic = "[object WeakMap]", ac = "[object DataView]", GT = _n(Oa), UT = _n(Ta), XT = _n(Pa), qT = _n(Aa), KT = _n($a), Ie = Rh;
(Oa && Ie(new Oa(new ArrayBuffer(1))) != ac || Ta && Ie(new Ta()) != ec || Pa && Ie(Pa.resolve()) != nc || Aa && Ie(new Aa()) != sc || $a && Ie(new $a()) != ic) && (Ie = function(e) {
  var t = Rh(e), n = t == YT ? e.constructor : void 0, s = n ? _n(n) : "";
  if (s)
    switch (s) {
      case GT:
        return ac;
      case UT:
        return ec;
      case XT:
        return nc;
      case qT:
        return sc;
      case KT:
        return ic;
    }
  return t;
});
var QT = Ie, Qi = ur, JT = Ih, ZT = nT, tP = TT, rc = QT, oc = Qt, lc = mr, eP = br, nP = 1, cc = "[object Arguments]", dc = "[object Array]", Is = "[object Object]", sP = Object.prototype, hc = sP.hasOwnProperty;
function iP(e, t, n, s, i, a) {
  var r = oc(e), o = oc(t), l = r ? dc : rc(e), c = o ? dc : rc(t);
  l = l == cc ? Is : l, c = c == cc ? Is : c;
  var d = l == Is, h = c == Is, u = l == c;
  if (u && lc(e)) {
    if (!lc(t))
      return !1;
    r = !0, d = !1;
  }
  if (u && !d)
    return a || (a = new Qi()), r || eP(e) ? JT(e, t, n, s, i, a) : ZT(e, t, l, n, s, i, a);
  if (!(n & nP)) {
    var f = d && hc.call(e, "__wrapped__"), g = h && hc.call(t, "__wrapped__");
    if (f || g) {
      var m = f ? e.value() : e, p = g ? t.value() : t;
      return a || (a = new Qi()), i(m, p, n, s, a);
    }
  }
  return u ? (a || (a = new Qi()), tP(e, t, n, s, i, a)) : !1;
}
var aP = iP, rP = aP, uc = qe;
function Bh(e, t, n, s, i) {
  return e === t ? !0 : e == null || t == null || !uc(e) && !uc(t) ? e !== e && t !== t : rP(e, t, n, s, Bh, i);
}
var Fh = Bh, oP = ur, lP = Fh, cP = 1, dP = 2;
function hP(e, t, n, s) {
  var i = n.length, a = i, r = !s;
  if (e == null)
    return !a;
  for (e = Object(e); i--; ) {
    var o = n[i];
    if (r && o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++i < a; ) {
    o = n[i];
    var l = o[0], c = e[l], d = o[1];
    if (r && o[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var h = new oP();
      if (s)
        var u = s(c, d, l, e, t, h);
      if (!(u === void 0 ? lP(d, c, cP | dP, s, h) : u))
        return !1;
    }
  }
  return !0;
}
var uP = hP, fP = Kt;
function gP(e) {
  return e === e && !fP(e);
}
var Wh = gP, pP = Wh, mP = Mr;
function bP(e) {
  for (var t = mP(e), n = t.length; n--; ) {
    var s = t[n], i = e[s];
    t[n] = [s, i, pP(i)];
  }
  return t;
}
var yP = bP;
function _P(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var Nh = _P, vP = uP, xP = yP, wP = Nh;
function kP(e) {
  var t = xP(e);
  return t.length == 1 && t[0][2] ? wP(t[0][0], t[0][1]) : function(n) {
    return n === e || vP(n, e, t);
  };
}
var CP = kP, SP = pn, MP = qe, OP = "[object Symbol]";
function TP(e) {
  return typeof e == "symbol" || MP(e) && SP(e) == OP;
}
var Ti = TP, PP = Qt, AP = Ti, $P = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, DP = /^\w*$/;
function LP(e, t) {
  if (PP(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || AP(e) ? !0 : DP.test(e) || !$P.test(e) || t != null && e in Object(t);
}
var Or = LP, zh = hr, EP = "Expected a function";
function Tr(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(EP);
  var n = function() {
    var s = arguments, i = t ? t.apply(this, s) : s[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var r = e.apply(this, s);
    return n.cache = a.set(i, r) || a, r;
  };
  return n.cache = new (Tr.Cache || zh)(), n;
}
Tr.Cache = zh;
var IP = Tr, RP = IP, BP = 500;
function FP(e) {
  var t = RP(e, function(s) {
    return n.size === BP && n.clear(), s;
  }), n = t.cache;
  return t;
}
var WP = FP, NP = WP, zP = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, jP = /\\(\\)?/g, HP = NP(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(zP, function(n, s, i, a) {
    t.push(i ? a.replace(jP, "$1") : s || n);
  }), t;
}), VP = HP;
function YP(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length, i = Array(s); ++n < s; )
    i[n] = t(e[n], n, e);
  return i;
}
var GP = YP, fc = Ci, UP = GP, XP = Qt, qP = Ti, KP = 1 / 0, gc = fc ? fc.prototype : void 0, pc = gc ? gc.toString : void 0;
function jh(e) {
  if (typeof e == "string")
    return e;
  if (XP(e))
    return UP(e, jh) + "";
  if (qP(e))
    return pc ? pc.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -KP ? "-0" : t;
}
var QP = jh, JP = QP;
function ZP(e) {
  return e == null ? "" : JP(e);
}
var tA = ZP, eA = Qt, nA = Or, sA = VP, iA = tA;
function aA(e, t) {
  return eA(e) ? e : nA(e, t) ? [e] : sA(iA(e));
}
var Hh = aA, rA = Ti, oA = 1 / 0;
function lA(e) {
  if (typeof e == "string" || rA(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -oA ? "-0" : t;
}
var Pi = lA, cA = Hh, dA = Pi;
function hA(e, t) {
  t = cA(t, e);
  for (var n = 0, s = t.length; e != null && n < s; )
    e = e[dA(t[n++])];
  return n && n == s ? e : void 0;
}
var Vh = hA, uA = Vh;
function fA(e, t, n) {
  var s = e == null ? void 0 : uA(e, t);
  return s === void 0 ? n : s;
}
var gA = fA;
function pA(e, t) {
  return e != null && t in Object(e);
}
var mA = pA, bA = Hh, yA = gr, _A = Qt, vA = yr, xA = pr, wA = Pi;
function kA(e, t, n) {
  t = bA(t, e);
  for (var s = -1, i = t.length, a = !1; ++s < i; ) {
    var r = wA(t[s]);
    if (!(a = e != null && n(e, r)))
      break;
    e = e[r];
  }
  return a || ++s != i ? a : (i = e == null ? 0 : e.length, !!i && xA(i) && vA(r, i) && (_A(e) || yA(e)));
}
var CA = kA, SA = mA, MA = CA;
function OA(e, t) {
  return e != null && MA(e, t, SA);
}
var TA = OA, PA = Fh, AA = gA, $A = TA, DA = Or, LA = Wh, EA = Nh, IA = Pi, RA = 1, BA = 2;
function FA(e, t) {
  return DA(e) && LA(t) ? EA(IA(e), t) : function(n) {
    var s = AA(n, e);
    return s === void 0 && s === t ? $A(n, e) : PA(t, s, RA | BA);
  };
}
var WA = FA;
function NA(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var zA = NA, jA = Vh;
function HA(e) {
  return function(t) {
    return jA(t, e);
  };
}
var VA = HA, YA = zA, GA = VA, UA = Or, XA = Pi;
function qA(e) {
  return UA(e) ? YA(XA(e)) : GA(e);
}
var KA = qA, QA = CP, JA = WA, ZA = _r, t$ = Qt, e$ = KA;
function n$(e) {
  return typeof e == "function" ? e : e == null ? ZA : typeof e == "object" ? t$(e) ? JA(e[0], e[1]) : QA(e) : e$(e);
}
var s$ = n$, i$ = zM, a$ = gO, r$ = s$, o$ = Qt;
function l$(e, t) {
  return function(n, s) {
    var i = o$(n) ? i$ : a$, a = t ? t() : {};
    return i(n, e, r$(s), a);
  };
}
var c$ = l$, d$ = Oi, h$ = c$, u$ = Object.prototype, f$ = u$.hasOwnProperty, g$ = h$(function(e, t, n) {
  f$.call(e, n) ? e[n].push(t) : d$(e, n, [t]);
}), p$ = g$;
const m$ = /* @__PURE__ */ lr(p$), b$ = 520, Yh = 225, Gs = 20, mc = 3, Bn = Gs / 2, Ji = 295, se = 5, bc = 20, Zi = 20, ta = 2, ea = Bn + se, An = Yh / 2, yc = 110, y$ = 1.5;
function _$(e, t, n, s) {
  return {
    x: Math.round(Math.cos(n * (Math.PI / 180)) * s + e),
    y: Math.round(Math.sin(n * (Math.PI / 180)) * s + t)
  };
}
const v$ = {
  name: "BroadcastTimeByMediaType",
  components: {
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    interactionEnabled: {
      type: Boolean
    }
  },
  emits: ["chart-clicked"],
  data() {
    return {
      SVG_WIDTH: b$,
      SVG_HEIGHT: Yh,
      SVG_LINE_STROKE_WIDTH: ta,
      SVG_MAIN_LINE_WIDTH: Ji,
      SVG_HORIZONTAL_POSITION: An,
      SVG_START_POSITION: ea,
      linePositions: {}
    };
  },
  computed: {
    hasData() {
      return !!this.data.length;
    },
    sortedData() {
      return this.data.slice().sort((e, t) => e.value < t.value);
    },
    groupedData() {
      return m$(this.sortedData, "value");
    },
    sortedGroupedData() {
      return Object.values(this.groupedData).sort(
        (e, t) => e[0].value > t[0].value ? 1 : -1
      );
    }
  },
  mounted() {
    this.drawSquares(), this.drawLines(), this.drawLabels(), this.autoFit();
  },
  methods: {
    drawSquares() {
      const { sortedGroupedData: e } = this;
      e.forEach((t) => {
        const { color: n, value: s } = t[0], i = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "rect"
        ), a = s / 24 * Ji + ea - Bn, r = An - Bn;
        i.setAttribute("id", `${s}-square`), i.setAttribute("x", a), i.setAttribute("y", r), i.setAttribute("rx", mc), i.setAttribute("ry", mc), i.setAttribute("height", Gs), i.setAttribute("width", Gs), i.setAttribute("stroke", n), i.setAttribute("fill", n), this.interactionEnabled && i.addEventListener(
          "click",
          (o) => this.onClick(t[0], o)
        ), this.$refs.elementsGroup.append(i);
      });
    },
    drawLines() {
      const { sortedGroupedData: e } = this;
      let t = 0;
      e.forEach((n, s) => {
        n.forEach((i, a) => {
          var x, C;
          const { label: r, color: o, value: l } = i, c = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "line"
          ), d = t % 2 !== 0, h = Zi * (t - Math.round(t / 2)), u = d ? bc - t : -bc + t, f = l / 24 * Ji + ea, g = An + (d ? se + Bn : se * -1 - Bn), m = f, p = d ? An + yc - h - Zi : An - yc + h + Zi;
          let { x: b, y } = _$(
            m,
            p,
            u * (Math.PI / 180),
            Math.abs(Math.max(p, g) - Math.min(p, g) - Gs) / 2
          ), v = b;
          const w = (C = (x = e[s - 1]) == null ? void 0 : x[0]) == null ? void 0 : C.value;
          l - w <= y$ ? v += t * se * 2 : v += a * se * 2, this.linePositions[r] = {
            x1: f,
            y1: g,
            x2: v,
            y2: y,
            angle: u
          }, c.setAttribute("id", `${r}-line`), c.setAttribute("x1", f), c.setAttribute("y1", g), c.setAttribute("x2", v), c.setAttribute("y2", y), c.setAttribute("stroke", o), c.setAttribute("stroke-width", 1), this.interactionEnabled && c.addEventListener(
            "click",
            (O) => this.onClick(i, O)
          ), this.$refs.elementsGroup.append(c), t += 1;
        });
      });
    },
    drawLabels() {
      const { sortedGroupedData: e, linePositions: t } = this;
      let n = 0;
      e.forEach((s) => {
        s.forEach((i) => {
          const { label: a, color: r, value: o } = i, l = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "text"
          ), c = n % 2 !== 0, d = t[a].x2, h = c ? t[a].y2 + se + se * 2 : t[a].y2 + se - se * 2, u = o % 1;
          let f = o > 12 ? o - 12 : o;
          f < 1 && (f += 12);
          const g = `${f - u}${u ? ":30" : ":00"}${o < 12 ? "am" : "pm"}`;
          l.setAttribute("id", `${a}-text`), l.setAttribute("x", d), l.setAttribute("y", h), l.setAttribute("fill", r), l.setAttribute(
            "class",
            "c-broadcast-time-by-media-type__axis-label c-broadcast-time-by-media-type__axis-label--chart"
          ), l.innerHTML = `${a}: ${g}`, this.interactionEnabled && l.addEventListener(
            "click",
            (m) => this.onClick(i, m)
          ), this.$refs.elementsGroup.append(l), n += 1;
        });
      });
    },
    autoFit() {
      if (!this.$refs.chart)
        return;
      let e = 0, t = 0, n = 0, s = 0;
      Array.from(this.$refs.chart.children).forEach((r) => {
        const { x: o, y: l, width: c, height: d } = r.getBBox();
        t = Math.min(o, t), e = Math.min(l, e), n = Math.max(l + d, n), s = Math.max(o + c, s);
      });
      const i = s - t + ta, a = n - e + ta;
      this.$refs.chart.setAttribute("viewBox", `0 0 ${i} ${a}`);
    },
    onClick(e, t) {
      t.stopPropagation();
      const { elementsGroup: n, use: s } = this.$refs, i = /* @__PURE__ */ new Set([
        n.children.namedItem(`${e.value}-square`),
        n.children.namedItem(`${e.label}-line`),
        n.children.namedItem(`${e.label}-text`)
      ]);
      s.setAttribute("xlink:href", `#${e.value}-square`), n.children.forEach((a) => {
        if (i.has(a)) {
          Object.assign(a.style, { opacity: 1 });
          return;
        }
        Object.assign(a.style, { opacity: 0.5 });
      }), this.$emit("chart-clicked", e);
    },
    reset() {
      if (!this.interactionEnabled)
        return;
      const { elementsGroup: e, use: t } = this.$refs;
      t.setAttribute("xlink:href", ""), e.children.forEach((n) => {
        Object.assign(n.style, { opacity: 1 });
      });
    }
  }
}, x$ = ["viewBox"], w$ = ["x1", "y1", "x2", "y2", "stroke-width"], k$ = ["x1", "y1", "x2", "y2", "stroke-width"], C$ = ["x1", "y1", "x2", "y2", "stroke-width"], S$ = ["x", "y"], M$ = { ref: "elementsGroup" }, O$ = {
  ref: "use",
  "xlink:href": ""
};
function T$(e, t, n, s, i, a) {
  const r = R("ChartWithLegendLayout");
  return _(), I(r, B(e.$props, {
    "has-data": a.hasData,
    class: "c-broadcast-time-by-media-type u__flex-column"
  }), {
    chart: N(() => [
      (_(), S("svg", {
        ref: "chart",
        class: "u__flex-auto c-broadcast-time-by-media-type__svg",
        viewBox: `0 0 ${i.SVG_WIDTH} ${i.SVG_HEIGHT}`,
        xmlns: "http://www.w3.org/2000/svg",
        onClick: t[0] || (t[0] = (...o) => a.reset && a.reset(...o))
      }, [
        k("line", {
          id: "left-end",
          x1: i.SVG_START_POSITION,
          y1: i.SVG_HORIZONTAL_POSITION - 8,
          x2: i.SVG_START_POSITION,
          y2: i.SVG_HORIZONTAL_POSITION + 8,
          stroke: "#444",
          "stroke-width": i.SVG_LINE_STROKE_WIDTH
        }, null, 8, w$),
        k("line", {
          id: "centre-line",
          x1: i.SVG_START_POSITION,
          y1: i.SVG_HORIZONTAL_POSITION,
          x2: i.SVG_MAIN_LINE_WIDTH + i.SVG_START_POSITION,
          y2: i.SVG_HORIZONTAL_POSITION,
          stroke: "#444",
          "stroke-width": i.SVG_LINE_STROKE_WIDTH
        }, null, 8, k$),
        k("line", {
          id: "right-end",
          x1: i.SVG_MAIN_LINE_WIDTH + i.SVG_START_POSITION,
          y1: i.SVG_HORIZONTAL_POSITION - 8,
          x2: i.SVG_MAIN_LINE_WIDTH + i.SVG_START_POSITION,
          y2: i.SVG_HORIZONTAL_POSITION + 8,
          stroke: "#444",
          "stroke-width": i.SVG_LINE_STROKE_WIDTH
        }, null, 8, C$),
        k("text", {
          id: "time",
          x: i.SVG_MAIN_LINE_WIDTH + i.SVG_START_POSITION + 8,
          y: i.SVG_HORIZONTAL_POSITION + 4,
          class: "c-broadcast-time-by-media-type__axis-label c-broadcast-time-by-media-type__axis-label--default"
        }, " 11:59pm ", 8, S$),
        k("g", M$, null, 512),
        k("use", O$, null, 512)
      ], 8, x$))
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const P$ = /* @__PURE__ */ X(v$, [["render", T$]]), A$ = "16px", $$ = "500", D$ = "Roboto, sans-serif", L$ = "middle", E$ = "#3E475E";
function _c(e, t, n) {
  const s = typeof t == "string" && t.length ? t : A$, i = typeof n == "string" && n.length ? n : $$;
  e.font = `${i} ${s} ${D$}`, e.textBaseline = L$, e.fillStyle = E$;
}
function na(e, t) {
  const n = e.measureText(t);
  return {
    width: n.width,
    height: n.actualBoundingBoxAscent + n.actualBoundingBoxDescent
  };
}
const vn = {
  id: "centerlabel",
  afterDraw(e) {
    const { ctx: t, height: n, options: s, width: i } = e;
    if (s.elements.center) {
      const {
        fontSize: a,
        fontWeight: r,
        staticText: o,
        defaultStaticText: l,
        subTitle: c,
        subTitleFontSize: d,
        text: h
      } = s.elements.center;
      t.restore(), _c(t, a, r);
      const u = typeof o == "string" || o === null || o === !1 ? o : l, { width: f, height: g } = na(
        t,
        h
      ), m = Math.round((i - f) / 2), p = g / 2;
      let y = n / 2 + 1;
      if (!!u != !!c && (y += u ? p : -p), t.fillText(h, m, y), u) {
        const { width: v, height: w } = na(t, u), x = Math.round((i - v) / 2), C = y - p - w;
        t.fillText(u, x, C);
      }
      if (c) {
        _c(t, d, r);
        const { width: v, height: w } = na(
          t,
          c
        ), x = Math.round((i - v) / 2), C = y + p + w;
        t.fillText(c, x, C);
      }
      t.save();
    }
  }
}, I$ = /* @__PURE__ */ Object.assign({
  name: "CoverageByMediaType"
}, {
  __name: "CoverageByMediaType",
  props: {
    ...lt,
    ...gt,
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, i = P(
      () => ["line", "barStacked", "horizontalBarStacked"].includes(n.chartType)
    ), {
      chartClass: a,
      chartLayoutClass: r,
      chartStyle: o,
      chartLegend: l,
      defaultOptions: c,
      hasDatasets: d,
      isTable: h
    } = xt(
      qt({
        ...n
      }),
      {
        isHistogram: i.value
      }
    ), u = [vn], f = P(
      () => J({}, c.value, n.options)
    ), g = P(() => n.chartType === "table" ? [] : l.value), m = P(() => {
      const { data: b, options: y, truncateLabels: v, size: w, legend: x, ...C } = n;
      return C;
    }), p = (b) => {
      s("chart-clicked", b);
    };
    return (b, y) => (_(), I(T(V), B(m.value, {
      legend: g.value,
      "has-data": T(d),
      class: T(r)
    }), {
      chart: N(() => [
        T(h) ? (_(), I(ft, B({ key: 0 }, b.data, { class: "c-coverage-by-media-type__table u__flex-auto" }), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: b.data,
          options: f.value,
          plugins: u,
          style: vt(T(o)),
          class: W(T(a)),
          onChartClicked: p,
          "onChart:render": y[0] || (y[0] = (v) => s("chart:render", v))
        }, null, 8, ["type", "data", "options", "style", "class"]))
      ]),
      _: 1
    }, 16, ["legend", "has-data", "class"]));
  }
}), R$ = {
  name: "CoverageVolumeTimeline",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  i18n: {
    messages: {
      "en-AU": {
        coverageVolume: "Coverage Volume",
        stockPrice: "Stock Price"
      },
      "en-US": {
        coverageVolume: "Coverage Volume",
        stockPrice: "Stock Price"
      },
      "en-GB": {
        coverageVolume: "Coverage Volume",
        stockPrice: "Stock Price"
      },
      es: {
        coverageVolume: "Volumen de cobertura",
        stockPrice: "Precio de mercado"
      },
      "fr-CA": {
        coverageVolume: "Volume de couverture",
        stockPrice: "Prix ​​de l'action"
      },
      fr: {
        coverageVolume: "Volume de couverture",
        stockPrice: "Prix ​​de l'action"
      },
      "zh-CN": {
        coverageVolume: "覆盖量",
        stockPrice: "股票价格"
      }
    }
  },
  props: {
    ...lt,
    ...gt,
    rangeLabel: {
      type: String,
      default: ""
    },
    chartType: {
      type: String,
      default: "barStacked"
    },
    clustered: {
      type: Boolean
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const t = P(() => e.clustered ? "bar" : e.chartType);
    return {
      ...xt(
        qt({
          ...e,
          chartType: t.value
        }),
        {
          isHistogram: t.value !== "radar"
        }
      ),
      chartTypeComputed: t
    };
  },
  computed: {
    hasStockPriceData() {
      var e, t;
      return (t = (e = this.data) == null ? void 0 : e.datasets) == null ? void 0 : t.some(
        (n) => (n == null ? void 0 : n.yAxisID) === "stock_price"
      );
    },
    hasOverlayedLineData() {
      var e, t;
      return (t = (e = this.data) == null ? void 0 : e.datasets) == null ? void 0 : t.some(
        (n) => (n == null ? void 0 : n.yAxisID) === "overlayed_line"
      );
    },
    hasOverlayedLine() {
      return this.hasStockPriceData || this.hasOverlayedLineData;
    },
    overlayLineAxisLabel() {
      var t, n;
      if (this.hasStockPriceData)
        return this.$t("stockPrice");
      const e = (n = (t = this.data) == null ? void 0 : t.datasets) == null ? void 0 : n.find(
        (s) => (s == null ? void 0 : s.yAxisID) === "overlayed_line"
      );
      return e == null ? void 0 : e.label;
    },
    chartDataFormatted() {
      var t;
      let e = ((t = this.data) == null ? void 0 : t.datasets) || [];
      return e = e.map((n) => {
        const { yAxisID: s, ...i } = n, a = this.isHorizontal ? "xAxisID" : "yAxisID";
        return {
          ...i,
          [a]: s
        };
      }), {
        ...this.data,
        datasets: e
      };
    },
    stockPriceScale() {
      return this.hasStockPriceData ? {
        stock_price: {
          id: "stock_price",
          type: "linear",
          position: "right",
          grid: {
            display: !1
          },
          border: {
            display: !1
          },
          ticks: {
            callback(e) {
              return e.toFixed(2);
            }
          }
        }
      } : {};
    },
    overlayedLineScale() {
      return this.hasOverlayedLineData ? {
        overlayed_line: {
          id: "overlayed_line",
          type: "linear",
          position: this.isHorizontal ? "top" : "right",
          grid: {
            display: !1
          },
          border: {
            display: !1
          },
          ticks: {
            callback: Ac
          }
        }
      } : {};
    },
    componentOptions() {
      const {
        stockPriceScale: e,
        overlayedLineScale: t,
        isStacked: n,
        isHorizontal: s,
        isRadar: i
      } = this;
      return i ? {} : {
        scales: {
          x: {
            ...this.defaultOptions.scales.x,
            display: !s
          },
          y: {
            ...this.defaultOptions.scales.y,
            display: s
          },
          volume: {
            id: "volume",
            type: "linear",
            position: s ? "bottom" : "left",
            ticks: {
              callback: Xn
            },
            border: {
              display: !1
            },
            stacked: n
          },
          ...e,
          ...t
        }
      };
    },
    chartOptions() {
      return J(
        {},
        this.defaultOptions,
        this.componentOptions,
        this.options
      );
    }
  }
}, B$ = {
  key: 0,
  class: "c-coverage-volume-timeline__time-range"
}, F$ = {
  key: 1,
  class: "c-coverage-volume-timeline__axis-label-container"
}, W$ = {
  key: 0,
  class: "c-coverage-volume-timeline__axis-label"
}, N$ = { class: "c-coverage-volume-timeline__axis-label" }, z$ = { class: "c-coverage-volume-timeline__axis-label-container" }, j$ = { class: "c-coverage-volume-timeline__axis-label" };
function H$(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": e.hasDatasets,
    class: [e.chartLayoutClass, "c-coverage-volume-timeline"]
  }), {
    chart: N(() => [
      Y(r, {
        type: s.chartTypeComputed,
        data: a.chartDataFormatted,
        options: a.chartOptions,
        title: e.title,
        text: e.text,
        class: W(e.chartClass),
        "onChart:render": t[0] || (t[0] = (l) => e.$emit("chart:render", l))
      }, Zh({
        beforeChart: N(() => [
          n.rangeLabel ? (_(), S("div", B$, L(n.rangeLabel), 1)) : rt("", !0),
          a.hasOverlayedLine ? (_(), S("div", F$, [
            e.isHorizontal ? rt("", !0) : (_(), S("span", W$, L(e.$t("coverageVolume")), 1)),
            k("span", N$, L(a.overlayLineAxisLabel), 1)
          ])) : rt("", !0)
        ]),
        _: 2
      }, [
        e.isHorizontal && a.hasOverlayedLine ? {
          name: "afterChart",
          fn: N(() => [
            k("div", z$, [
              k("span", j$, L(e.$t("coverageVolume")), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["type", "data", "options", "title", "text", "class"])
    ]),
    _: 1
  }, 16, ["has-data", "class"]);
}
const Gh = /* @__PURE__ */ X(R$, [["render", H$]]), V$ = {
  name: "CoverageVolumeTimelineAndPotentialAudienceReach",
  components: {
    ChartWithLegendLayout: V,
    CoverageVolumeTimeline: Gh,
    DataTable: ft
  },
  props: {
    ...lt,
    ...gt,
    visualisationType: {
      type: String,
      default: "chart"
    },
    rangeLabel: {
      type: String,
      default: ""
    },
    chartType: {
      type: String,
      default: "barStacked"
    }
  },
  emits: ["chart-clicked"],
  computed: {
    hasTableData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  }
}, Y$ = { class: "c-coverage-volume-and-potential-reach" };
function G$(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout"), l = R("CoverageVolumeTimeline");
  return _(), S("div", Y$, [
    [n.visualisationType, n.chartType].includes("table") ? (_(), I(o, B({ key: 0 }, e.$props, {
      "has-data": a.hasTableData,
      class: "c-coverage-volume-and-potential-reach__table"
    }), {
      chart: N(() => [
        Y(r, B(e.data, { class: "c-coverage-volume-and-potential-reach__table u__flex-auto" }), null, 16)
      ]),
      _: 1
    }, 16, ["has-data"])) : (_(), I(l, B({ key: 1 }, e.$props, {
      class: "c-coverage-volume-and-potential-reach__chart u__flex-auto",
      onChartClicked: t[0] || (t[0] = (c) => e.$emit("chart-clicked", c))
    }), null, 16))
  ]);
}
const U$ = /* @__PURE__ */ X(V$, [["render", G$]]), X$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}, q$ = /* @__PURE__ */ k("path", {
  fill: "#FF7875",
  d: "M6 11 1 1h10z"
}, null, -1), K$ = [
  q$
];
function Q$(e, t) {
  return _(), S("svg", X$, [...K$]);
}
const J$ = { render: Q$ }, Z$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}, tD = /* @__PURE__ */ k("path", {
  fill: "#71D688",
  d: "m6 1 5 10H1z"
}, null, -1), eD = [
  tD
];
function nD(e, t) {
  return _(), S("svg", Z$, [...eD]);
}
const sD = { render: nD };
function iD() {
  function e(t, n, s, i, a = 0.4, r = 0.4) {
    const o = t.createLinearGradient(
      0,
      n.bottom,
      0,
      n.top
    );
    return o.addColorStop(1, Zs(s).alpha(a).rgbString()), o.addColorStop(0, Zs(i).alpha(r).rgbString()), o;
  }
  return {
    createLinearGradient: e
  };
}
const aD = { class: "c-coverage-volume-and-stock-price__time-range-container" }, rD = { class: "c-coverage-volume-and-stock-price__time-range-container__header" }, oD = {
  key: 0,
  class: "c-coverage-volume-and-stock-price__time-range-container__title"
}, lD = { class: "c-coverage-volume-and-stock-price__time-range-container__value" }, cD = {
  key: 0,
  class: "c-coverage-volume-and-stock-price__time-range-container__header"
}, dD = { class: "c-coverage-volume-and-stock-price__time-range-container__title" }, hD = { class: "c-coverage-volume-and-stock-price__time-range-container__stats" }, uD = {
  key: 0,
  class: "c-coverage-volume-and-stock-price__time-range-container__value"
}, fD = { class: "c-coverage-volume-and-stock-price__details" }, gD = { class: "c-coverage-volume-and-stock-price__axis-label-container" }, pD = { class: "c-coverage-volume-and-stock-price__axis-label" }, mD = { class: "c-coverage-volume-and-stock-price__axis-label" }, bD = {
  __name: "CoverageVolumeAndStockPrice",
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "line"
    },
    mentionAxisLabel: {
      type: String,
      default: "Mentions"
    },
    mentionHeading: {
      type: String,
      default: "Total Mentions"
    },
    mentionCount: {
      type: String,
      default: ""
    },
    stockPriceHeading: {
      type: String,
      default: ""
    },
    stockPriceValue: {
      type: String,
      default: ""
    },
    stockPriceChange: {
      type: Object,
      default: () => ({
        value: "",
        percentage: "",
        direction: ""
      })
    }
  },
  emits: ["chart:render"],
  setup(e, { emit: t }) {
    const n = {
      up: sD,
      down: J$
    }, s = e, i = t, { createLinearGradient: a } = iD(), { numberToCurrency: r } = Eh(), { currencyCode: o, locale: l } = s, { chartClass: c, chartLayoutClass: d, hasDatasets: h, defaultOptions: u } = xt(s, {
      clickEventsMode: "point",
      isHistogram: !0,
      tooltipCallbacks: {
        label: (p) => {
          let b = p.dataset.label || "";
          return p.dataset.yAxisID === "stock_price" ? (b && (b += ": "), p.parsed.y !== null && (b += r({
            number: p.parsed.y,
            locale: l,
            currencyCode: o,
            minimumFractionDigits: 2
          })), b) : (b += `: ${p.formattedValue}`, b);
        }
      }
    }), f = (p) => n[p], g = P(() => {
      const p = { ...s.data };
      return p.datasets = p.datasets.map((b) => ({
        ...b,
        backgroundColor: (y) => {
          const { chart: v } = y, { ctx: w, chartArea: x } = v;
          if (x)
            return a(w, x, b.borderColor, "#fff");
        },
        backgroundColorOriginal: b.backgroundColor
      })), p;
    }), m = P(() => {
      const p = {
        scales: {
          y: {
            display: !1,
            grid: {
              display: !1
            }
          },
          volume: u.value.scales.y,
          stock_price: {
            id: "stock_price",
            type: "linear",
            position: "right",
            grid: {
              display: !1
            },
            border: {
              display: !1
            },
            ticks: {
              callback(b) {
                return r({
                  number: b,
                  locale: l,
                  currencyCode: o,
                  minimumFractionDigits: 2
                });
              }
            },
            tooltip: {
              callbacks: {
                label(b) {
                  return r({
                    number: b.raw,
                    locale: l,
                    currencyCode: o,
                    minimumFractionDigits: 2
                  });
                }
              }
            }
          }
        },
        clip: { left: 5, top: 5, right: 5, bottom: 5 }
      };
      return J({}, u.value, p, s.options);
    });
    return (p, b) => (_(), I(T(V), B(p.$props, {
      "has-data": T(h),
      class: [T(d), "c-coverage-volume-and-stock-price"]
    }), {
      chart: N(() => [
        Y(T(ut), {
          type: e.chartType,
          data: g.value,
          options: m.value,
          title: p.title,
          text: p.text,
          class: W(T(c)),
          "onChart:render": b[0] || (b[0] = (y) => i("chart:render", y))
        }, {
          beforeChart: N(() => [
            k("div", aD, [
              k("div", rD, [
                e.mentionHeading ? (_(), S("div", oD, L(e.mentionHeading), 1)) : rt("", !0),
                k("div", lD, L(e.mentionCount), 1)
              ]),
              e.stockPriceHeading ? (_(), S("div", cD, [
                k("div", dD, L(e.stockPriceHeading), 1),
                k("div", hD, [
                  e.stockPriceValue ? (_(), S("div", uD, L(e.stockPriceValue), 1)) : rt("", !0),
                  k("span", fD, [
                    k("span", {
                      class: W(["c-coverage-volume-and-stock-price__change", {
                        "c-coverage-volume-and-stock-price__change--positive": e.stockPriceChange.direction === "up",
                        "c-coverage-volume-and-stock-price__change--negative": e.stockPriceChange.direction === "down"
                      }])
                    }, [
                      (_(), I(es(f(e.stockPriceChange.direction)), { class: "c-coverage-volume-and-stock-price__arrow" })),
                      Ye(" " + L(e.stockPriceChange.value) + " (" + L(e.stockPriceChange.percentage) + "%) ", 1)
                    ], 2)
                  ])
                ])
              ])) : rt("", !0)
            ]),
            k("div", gD, [
              k("span", pD, L(e.mentionAxisLabel), 1),
              k("span", mD, L(T(o)), 1)
            ])
          ]),
          _: 1
        }, 8, ["type", "data", "options", "title", "text", "class"])
      ]),
      _: 1
    }, 16, ["has-data", "class"]));
  }
}, yD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}, _D = /* @__PURE__ */ k("path", {
  fill: "#FF7875",
  d: "M6 11 1 1h10z"
}, null, -1), vD = [
  _D
];
function xD(e, t) {
  return _(), S("svg", yD, [...vD]);
}
const wD = { render: xD }, kD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}, CD = /* @__PURE__ */ k("path", {
  fill: "#71D688",
  d: "m6 1 5 10H1z"
}, null, -1), SD = [
  CD
];
function MD(e, t) {
  return _(), S("svg", kD, [...SD]);
}
const OD = { render: MD }, TD = {
  up: OD,
  down: wD
}, PD = {
  name: "DataTableWithChange",
  components: {
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["chart-clicked"],
  computed: {
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  },
  methods: {
    changeIcon(e) {
      return TD[e];
    },
    changeClass(e) {
      return `c-datatable-with-change__change-${e}`;
    }
  }
}, AD = ["onMouseenter", "onMouseleave"], $D = { class: "c-datatable-with-change__change-value" };
function DD(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-datatable-with-change"
  }), {
    chart: N(() => [
      Y(r, B({ ...e.$attrs, ...n.data }, {
        class: "c-table-layout__table u__flex-auto",
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l))
      }), {
        beforeRow: N(({ row: l }) => [
          l.source.color ? (_(), S("div", {
            key: 0,
            class: "c-datatable-with-change__color-dot",
            style: vt({
              background: l.source.color
            })
          }, null, 4)) : rt("", !0)
        ]),
        cell: N(({ cell: l, hoverStyle: c, showTooltip: d, hideTooltip: h }) => [
          k("span", {
            class: W(["c-datatable-with-change__value", { "c-datatable-with-change__left-row": l.leftRow }]),
            style: vt(c)
          }, [
            k("span", {
              onMouseenter: (u) => d(u, { text: l.source.tooltip }),
              onMouseleave: h
            }, L(l.value), 41, AD)
          ], 6),
          l.source.delta ? (_(), S("span", {
            key: 0,
            class: W([a.changeClass(l.source.delta.direction), "c-datatable-with-change__change"])
          }, [
            (_(), I(es(a.changeIcon(l.source.delta.direction)), { class: "c-datatable-with-change__change-icon" })),
            k("span", $D, L(l.source.delta.value), 1)
          ], 2)) : rt("", !0)
        ]),
        _: 1
      }, 16)
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const LD = /* @__PURE__ */ X(PD, [["render", DD]]), ED = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "11",
  fill: "none"
}, ID = /* @__PURE__ */ k("path", {
  fill: "#F5242E",
  d: "m4.69 11 3.823-4.5H.868z"
}, null, -1), RD = /* @__PURE__ */ k("path", {
  fill: "#F5242E",
  d: "M3.587 0v7h2.207V0z"
}, null, -1), BD = [
  ID,
  RD
];
function FD(e, t) {
  return _(), S("svg", ED, [...BD]);
}
const WD = { render: FD }, ND = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "3",
  fill: "none"
}, zD = /* @__PURE__ */ k("path", {
  fill: "#89909F",
  d: "M0 0h9v3H0z"
}, null, -1), jD = [
  zD
];
function HD(e, t) {
  return _(), S("svg", ND, [...jD]);
}
const VD = { render: HD }, YD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "11",
  fill: "none"
}, GD = /* @__PURE__ */ k("path", {
  fill: "#71D688",
  d: "m4.69 0 3.823 4.5H.868z"
}, null, -1), UD = /* @__PURE__ */ k("path", {
  fill: "#71D688",
  d: "M3.587 11V4h2.207v7z"
}, null, -1), XD = [
  GD,
  UD
];
function qD(e, t) {
  return _(), S("svg", YD, [...XD]);
}
const KD = { render: qD }, QD = {
  up: KD,
  neutral: VD,
  down: WD
}, JD = {
  name: "DataTableWithChangeAcrossPeriods",
  components: {
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["chart-clicked"],
  computed: {
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  },
  methods: {
    changeIcon(e) {
      return QD[e];
    },
    changeClass(e) {
      return `c-datatable-with-change-across-periods__change-${e}`;
    }
  }
}, ZD = ["onMouseenter", "onMouseleave"];
function tL(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-datatable-with-change-across-periods"
  }), {
    chart: N(() => [
      Y(r, B({ ...e.$attrs, ...n.data }, {
        class: "c-table-layout__table u__flex-auto",
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l))
      }), {
        cell: N(({ cell: l, hoverStyle: c, showTooltip: d, hideTooltip: h }) => [
          k("span", {
            class: W(["c-datatable-with-change-across-periods__value", {
              "c-datatable-with-change-across-periods__left-row": l.leftRow
            }]),
            style: vt(c)
          }, [
            k("span", {
              onMouseenter: (u) => d(u, { text: l.source.tooltip }),
              onMouseleave: h
            }, L(l.value), 41, ZD)
          ], 6),
          l.source.direction ? (_(), S("span", {
            key: 0,
            class: W([a.changeClass(l.source.direction), "c-datatable-with-change-across-periods__change"])
          }, [
            (_(), I(es(a.changeIcon(l.source.direction)), { class: "c-datatable-with-change-across-periods__change-icon" }))
          ], 2)) : rt("", !0)
        ]),
        _: 1
      }, 16)
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const eL = /* @__PURE__ */ X(JD, [["render", tL]]), nL = {
  name: "DesktopVsMobileReadership",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    ...gt,
    total: {
      type: Number,
      default: 0
    },
    legendTitle: {
      type: String,
      default: "Total Readership"
    },
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const {
      chartStyle: t,
      chartLegend: n,
      defaultOptions: s,
      hasDatasets: i,
      chartClass: a,
      chartLayoutClass: r
    } = xt(
      qt({
        ...e,
        showTotal: !1,
        size: 300,
        truncateLabels: !0
      })
    );
    return {
      chartStyle: t,
      formatNumber: Xn,
      chartLegend: n,
      defaultOptions: s,
      hasDatasets: i,
      chartClass: a,
      chartLayoutClass: r
    };
  },
  data() {
    return {
      plugins: [vn]
    };
  },
  computed: {
    chartOptions() {
      const { defaultOptions: e } = this;
      return J({}, e, this.options);
    }
  }
}, sL = { class: "c-chart-layout__legend-title" }, iL = { class: "c-chart-layout__legend-subheading" };
function aL(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    legend: s.chartLegend,
    "has-data": s.hasDatasets,
    class: [s.chartLayoutClass, "c-desktop-vs-mobile-readership"],
    "legend-container-class": "c-desktop-vs-mobile-readership-legend"
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: e.data,
        options: a.chartOptions,
        plugins: i.plugins,
        style: vt(s.chartStyle),
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l)),
        "onChart:render": t[1] || (t[1] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["type", "data", "options", "plugins", "style", "class"])
    ]),
    "before-legend": N(() => [
      k("div", {
        class: W(["c-chart-layout__legend-container-title", {
          [`c-chart-layout__legend-container-title--${e.legendPosition}`]: !0
        }])
      }, [
        k("div", sL, L(n.legendTitle), 1),
        k("div", iL, L(s.formatNumber(n.total)), 1)
      ], 2)
    ]),
    _: 1
  }, 16, ["legend", "has-data", "class"]);
}
const rL = /* @__PURE__ */ X(nL, [["render", aL], ["__scopeId", "data-v-f7a4c01a"]]), oL = {
  __name: "DomainAuthority",
  props: {
    ...lt,
    ...gt,
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, {
      chartClass: i,
      chartLayoutClass: a,
      chartLegend: r,
      chartStyle: o,
      defaultOptions: l,
      hasDatasets: c,
      isTable: d
    } = xt(n), h = P(
      () => J({}, l.value, n.options)
    ), u = [vn];
    return (f, g) => (_(), I(T(V), B(f.$props, {
      legend: T(r),
      "has-data": T(c),
      class: T(a)
    }), {
      chart: N(() => [
        T(d) ? (_(), I(T(ft), ce(B({ key: 0 }, f.data)), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: f.data,
          options: h.value,
          plugins: u,
          style: vt(T(o)),
          class: W(T(i)),
          onChartClicked: g[0] || (g[0] = (m) => s("chart-clicked", m)),
          "onChart:render": g[1] || (g[1] = (m) => s("chart:render", m))
        }, null, 8, ["type", "data", "options", "style", "class"]))
      ]),
      _: 1
    }, 16, ["legend", "has-data", "class"]));
  }
}, lL = {
  name: "EmojiCount",
  components: {
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    },
    interactionEnabled: {
      type: Boolean
    },
    selectionEnabled: {
      type: Boolean
    }
  },
  emits: ["chart-clicked"],
  computed: {
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  }
}, cL = { class: "c-emoji-count__row" }, dL = { class: "c-datatable__column c-datatable__column--auto c-datatable__column--left" }, hL = { class: "c-emoji-count__emoji" }, uL = { class: "c-datatable__column c-emoji-count__total-column" }, fL = { class: "c-emoji-count__emoji-total" };
function gL(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-emoji-count"
  }), {
    chart: N(() => [
      Y(r, B(n.data, {
        "interaction-enabled": n.interactionEnabled,
        "selection-enabled": n.selectionEnabled,
        class: "c-emoji-count u__flex-auto",
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l))
      }), {
        row: N(({ row: l }) => [
          k("div", cL, [
            k("div", dL, [
              k("div", hL, L(l.emoji.value), 1)
            ]),
            k("div", uL, [
              k("span", fL, L(l.total.value), 1)
            ])
          ])
        ]),
        _: 1
      }, 16, ["interaction-enabled", "selection-enabled"])
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const pL = /* @__PURE__ */ X(lL, [["render", gL]]);
function mL(e, t, n, s) {
  function i(a) {
    return a instanceof n ? a : new n(function(r) {
      r(a);
    });
  }
  return new (n || (n = Promise))(function(a, r) {
    function o(d) {
      try {
        c(s.next(d));
      } catch (h) {
        r(h);
      }
    }
    function l(d) {
      try {
        c(s.throw(d));
      } catch (h) {
        r(h);
      }
    }
    function c(d) {
      d.done ? a(d.value) : i(d.value).then(o, l);
    }
    c((s = s.apply(e, t || [])).next());
  });
}
function bL(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yL = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor)
      return !1;
    var s, i, a;
    if (Array.isArray(t)) {
      if (s = t.length, s != n.length)
        return !1;
      for (i = s; i-- !== 0; )
        if (!e(t[i], n[i]))
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === n.toString();
    if (a = Object.keys(t), s = a.length, s !== Object.keys(n).length)
      return !1;
    for (i = s; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, a[i]))
        return !1;
    for (i = s; i-- !== 0; ) {
      var r = a[i];
      if (!e(t[r], n[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}, _L = /* @__PURE__ */ bL(yL);
const vc = "__googleMapsScriptId";
var nn;
(function(e) {
  e[e.INITIALIZED = 0] = "INITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE";
})(nn || (nn = {}));
class Re {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: t, authReferrerPolicy: n, channel: s, client: i, id: a = vc, language: r, libraries: o = [], mapIds: l, nonce: c, region: d, retries: h = 3, url: u = "https://maps.googleapis.com/maps/api/js", version: f }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = t, this.authReferrerPolicy = n, this.channel = s, this.client = i, this.id = a || vc, this.language = r, this.libraries = o, this.mapIds = l, this.nonce = c, this.region = d, this.retries = h, this.url = u, this.version = f, Re.instance) {
      if (!_L(this.options, Re.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Re.instance.options)}`);
      return Re.instance;
    }
    Re.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? nn.FAILURE : this.done ? nn.SUCCESS : this.loading ? nn.LOADING : nn.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let t = this.url;
    return t += "?callback=__googleMapsCallback&loading=async", this.apiKey && (t += `&key=${this.apiKey}`), this.channel && (t += `&channel=${this.channel}`), this.client && (t += `&client=${this.client}`), this.libraries.length > 0 && (t += `&libraries=${this.libraries.join(",")}`), this.language && (t += `&language=${this.language}`), this.region && (t += `&region=${this.region}`), this.version && (t += `&v=${this.version}`), this.mapIds && (t += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (t += `&auth_referrer_policy=${this.authReferrerPolicy}`), t;
  }
  deleteScript() {
    const t = document.getElementById(this.id);
    t && t.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((t, n) => {
      this.loadCallback((s) => {
        s ? n(s.error) : t(window.google);
      });
    });
  }
  importLibrary(t) {
    return this.execute(), google.maps.importLibrary(t);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(t) {
    this.callbacks.push(t), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var t, n;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const s = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(s).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (a) => !s[a] && delete s[a]
    ), !((n = (t = window == null ? void 0 : window.google) === null || t === void 0 ? void 0 : t.maps) === null || n === void 0) && n.importLibrary || ((a) => {
      let r, o, l, c = "The Google Maps JavaScript API", d = "google", h = "importLibrary", u = "__ib__", f = document, g = window;
      g = g[d] || (g[d] = {});
      const m = g.maps || (g.maps = {}), p = /* @__PURE__ */ new Set(), b = new URLSearchParams(), y = () => (
        // @ts-ignore
        r || (r = new Promise((v, w) => mL(this, void 0, void 0, function* () {
          var x;
          yield o = f.createElement("script"), o.id = this.id, b.set("libraries", [...p] + "");
          for (l in a)
            b.set(l.replace(/[A-Z]/g, (C) => "_" + C[0].toLowerCase()), a[l]);
          b.set("callback", d + ".maps." + u), o.src = this.url + "?" + b, m[u] = v, o.onerror = () => r = w(Error(c + " could not load.")), o.nonce = this.nonce || ((x = f.querySelector("script[nonce]")) === null || x === void 0 ? void 0 : x.nonce) || "", f.head.append(o);
        })))
      );
      m[h] ? console.warn(c + " only loads once. Ignoring:", a) : m[h] = (v, ...w) => p.add(v) && y().then(() => m[h](v, ...w));
    })(s);
    const i = this.libraries.map((a) => this.importLibrary(a));
    i.length || i.push(this.importLibrary("core")), Promise.all(i).then(() => this.callback(), (a) => {
      const r = new ErrorEvent("error", { error: a });
      this.loadErrorCallback(r);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(t) {
    if (this.errors.push(t), this.errors.length <= this.retries) {
      const n = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${n} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, n);
    } else
      this.onerrorEvent = t, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((t) => {
      t(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), this.done)
      this.callback();
    else {
      if (window.google && window.google.maps && window.google.maps.version) {
        console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), this.callback();
        return;
      }
      this.loading || (this.loading = !0, this.setScript());
    }
  }
}
const vL = new Re({
  apiKey: "AIzaSyDTtkNriGSmxM0rRVkS8ybYIKe018GAgpk",
  version: "3.54",
  libraries: ["visualization"]
}), xL = {
  bottomLeft: { lat: -90, lng: -180 },
  topRight: { lat: 90, lng: 180 },
  zoom: 3
}, wL = { lat: -30, lng: 145 }, xc = 6;
function kL(e = {}) {
  const t = yt(null), n = yt(null), s = yt(!1), i = yt(e.locations), a = P(() => {
    var c, d;
    if (!((d = (c = window.google) == null ? void 0 : c.maps) != null && d.LatLngBounds))
      return null;
    const l = new window.google.maps.LatLngBounds();
    return i.value.forEach((h) => {
      l.extend(
        new window.google.maps.LatLng(h.latitude, h.longitude)
      );
    }), l;
  });
  function r() {
    var l, c;
    (c = (l = window.google) == null ? void 0 : l.maps) != null && c.LatLngBounds && (e.restrictMapToBounds === !0 && n.value.setOptions({ restriction: { latLngBounds: a } }), n.value.fitBounds(a.value), n.value.setCenter(a.value.getCenter()));
  }
  function o() {
    t.value && (n.value = new window.google.maps.Map(t.value, {
      zoom: xL.zoom,
      center: wL,
      disableDefaultUI: !0,
      disableDoubleClickZoom: !0,
      scrollwheel: !1,
      styles: [
        {
          stylers: [
            {
              saturation: -100
            }
          ]
        }
      ],
      ...e.options
    }), window.addEventListener("resize", r), n.value.addListener("bounds_changed", () => {
      n.value.getZoom() > xc && n.value.setZoom(xc);
    }), r(), s.value = !0);
  }
  return Us(i, () => {
    r();
  }), Tc(async () => {
    var l, c;
    (c = (l = window.google) == null ? void 0 : l.maps) != null && c.Map || await vL.load(), o();
  }), tu(() => {
    window.removeEventListener("resize", r);
  }), {
    mapReady: s,
    mapRef: t,
    mapObj: n,
    initMap: o,
    fitBounds: r
  };
}
const Rs = 0.8, Bs = 0.35, CL = /* @__PURE__ */ Object.assign({
  name: "GeographicSpreadMap"
}, {
  __name: "GeographicSpreadMap",
  props: {
    ...lt,
    ...gt
  },
  emits: ["chart-clicked"],
  setup(e, { emit: t }) {
    const n = e, s = t, i = P(
      () => n.data.map.datasets.filter(
        (y) => y.latitude && y.longitude
      )
    ), { mapObj: a, mapReady: r, mapRef: o } = kL({
      locations: i,
      options: { zoomControl: !0 }
    }), l = yt([]), c = yt(!1), d = P(() => {
      var y, v, w;
      return !!((w = (v = (y = n.data) == null ? void 0 : y.map) == null ? void 0 : v.datasets) != null && w.length);
    }), h = P(() => i.value.length ? Math.max(...i.value.map(({ total: y }) => y)) : 0);
    function u() {
      l.value.forEach((y) => {
        y.setMap(null);
      }), l.value = [];
    }
    function f(y) {
      const v = new window.google.maps.Circle({
        map: a.value,
        strokeColor: y.color,
        strokeOpacity: Rs,
        strokeWeight: 1,
        fillColor: y.color,
        fillOpacity: Bs,
        center: { lat: Number(y.latitude), lng: Number(y.longitude) },
        radius: 2e5 * Math.sqrt(y.total / h.value)
      });
      l.value.push(v), n.interactionEnabled && v.addListener("click", () => {
        c.value = !0, l.value.forEach((w) => {
          if (w === v) {
            w.setOptions({
              fillOpacity: Bs,
              strokeOpacity: Rs
            });
            return;
          }
          w.setOptions({
            fillOpacity: Bs / 2,
            strokeOpacity: Rs / 2
          });
        }), s("chart-clicked", y);
      });
    }
    function g() {
      u(), i.value.forEach((y) => f(y));
    }
    function m() {
      c.value = !1, l.value.forEach((y) => {
        y.setOptions({
          fillOpacity: Bs,
          strokeOpacity: Rs
        });
      });
    }
    function p(y) {
      c.value && y.stopPropagation();
    }
    function b() {
      r.value && (a.value.addListener("click", m), g());
    }
    return Us(i, b), Us(r, b), Tc(b), (y, v) => (_(), I(T(V), B(n, {
      "has-data": d.value,
      class: "c-geographic-spread-map"
    }), {
      chart: N(() => [
        k("div", {
          ref_key: "mapRef",
          ref: o,
          class: "c-geographic-spread-map__map",
          onClick: p
        }, null, 512)
      ]),
      _: 1
    }, 16, ["has-data"]));
  }
}), SL = /* @__PURE__ */ Object.assign({
  name: "GeographicSpread"
}, {
  __name: "GeographicSpread",
  props: {
    ...lt,
    ...gt,
    visualisationType: {
      type: String,
      default: "map"
    },
    truncateLabels: {
      type: Boolean
    },
    chartType: {
      type: String,
      default: "horizontalBar"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    var b, y;
    const n = e, s = t, i = P(() => n.chartType ? n.chartType : "horizontalBar"), a = P(() => i.value === "map"), r = P(() => i.value === "table"), o = P(
      () => ["barStacked", "horizontalBarStacked"].includes(i.value)
    ), { chartClass: l, chartLayoutClass: c, defaultOptions: d, chartLegend: h } = xt(
      qt({
        ...n,
        data: ((y = (b = n.data) == null ? void 0 : b.chart) == null ? void 0 : y.datasets) || []
      }),
      {
        isHistogram: o.value,
        boldLabels: !0,
        collapseBorders: !0
      }
    ), u = P(
      () => J({}, d.value, n.options)
    ), f = P(
      () => {
        var v, w, x, C;
        return !!((C = (x = (w = (v = n.data) == null ? void 0 : v.chart) == null ? void 0 : w.datasets) == null ? void 0 : x.datasets) != null && C.some(
          (O) => {
            var M;
            return (M = O.data) == null ? void 0 : M.length;
          }
        ));
      }
    ), g = P(
      () => {
        var v, w;
        return !!((w = (v = n.data) == null ? void 0 : v.columns) != null && w.length && n.data.columns[0].rows.length);
      }
    ), m = P(() => f.value || g.value), p = P(() => a.value || r.value ? [] : h.value);
    return (v, w) => (_(), S("div", null, [
      a.value ? (_(), I(CL, B({ key: 0 }, n, {
        onChartClicked: w[0] || (w[0] = (x) => s("chart-clicked", x))
      }), null, 16)) : (_(), I(T(V), B({ key: 1 }, n, {
        legend: p.value,
        "has-data": m.value,
        class: [T(c), "c-geographic-spread"]
      }), {
        chart: N(() => [
          r.value ? (_(), I(T(ft), ce(B({ key: 0 }, v.data)), null, 16)) : (_(), I(T(ut), {
            key: 1,
            type: i.value,
            data: v.data.chart.datasets,
            options: u.value,
            class: W(T(l)),
            onChartClicked: w[1] || (w[1] = (x) => s("chart-clicked", x)),
            "onChart:render": w[2] || (w[2] = (x) => s("chart:render", x))
          }, null, 8, ["type", "data", "options", "class"]))
        ]),
        _: 1
      }, 16, ["legend", "has-data", "class"]))
    ]));
  }
}), ML = /* @__PURE__ */ X(SL, [["__scopeId", "data-v-e0106abf"]]), wc = 14, OL = {
  name: "KeyInsights",
  components: {
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    },
    visualisationType: {
      type: String,
      default: "leading_media_outlets"
    }
  },
  computed: {
    truncateLabelsAt() {
      return this.visualisationType === "coverage_by_media_type" ? 60 : wc;
    },
    labelMaxLength() {
      return 16;
    },
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.rows) != null && t.length);
    },
    isSentimentBreakdown() {
      return this.visualisationType === "sentiment_breakdown";
    },
    numberOfColumns() {
      var e, t;
      return ((t = (e = this.data) == null ? void 0 : e.rows[0]) == null ? void 0 : t.length) ?? 0;
    }
  },
  methods: {
    formattedLabel(e, t) {
      if (t === 0)
        return e.length <= this.labelMaxLength ? `${e}:` : an(
          e,
          this.truncateLabelsAt,
          this.labelMaxLength
        );
      const n = this.numberOfColumns > 2 ? wc : this.truncateLabelAt;
      return an(e, n, this.labelMaxLength);
    },
    isNumeric(e) {
      return e > 0 && this.visualisationType === "coverage_by_media_type";
    },
    isText(e) {
      return e > 0 && this.visualisationType === "leading_media_outlets";
    },
    isPadded(e) {
      return e === 0 && this.visualisationType === "leading_media_outlets";
    },
    formatSentiment(e, t) {
      return t > 0 && e.value > 4 ? `${e.value}%` : null;
    }
  }
}, TL = {
  key: 0,
  class: "c-key-insights__table"
}, PL = { key: 0 }, AL = { key: 1 }, $L = {
  key: 1,
  class: "c-key-insights__table"
}, DL = { class: "c-key-insights__table-row" };
function LL(e, t, n, s, i, a) {
  const r = R("ChartWithLegendLayout");
  return _(), I(r, B(e.$props, {
    "has-data": a.hasData,
    class: "c-key-insights"
  }), {
    chart: N(() => [
      a.isSentimentBreakdown ? (_(), S("div", TL, [
        (_(!0), S(st, null, _t(n.data.rows, (o, l) => (_(), S("div", {
          key: l,
          class: "c-key-insights__table-row"
        }, [
          (_(!0), S(st, null, _t(o, (c, d) => (_(), S("div", {
            key: d,
            class: W(["c-key-insights__table-col", {
              "c-key-insights__table-col-left": d === 0,
              "c-key-insights__table-col-sentiment": d > 0
            }]),
            style: vt({
              backgroundColor: c.backgroundColor || "none",
              width: `${c.value}%` || "auto"
            })
          }, [
            d === 0 ? (_(), S("span", PL, L(a.formattedLabel(c, d)), 1)) : (_(), S("span", AL, L(a.formatSentiment(c, d)), 1))
          ], 6))), 128))
        ]))), 128))
      ])) : (_(), S("div", $L, [
        k("div", DL, [
          k("div", {
            class: W(["c-key-insights__table-col c-key-insights__table-col-left", {
              "c-key-insights__table-col-padded": n.visualisationType === "leading_media_outlets"
            }])
          }, null, 2),
          (_(!0), S(st, null, _t(n.data.headings, (o, l) => (_(), S("div", {
            key: l,
            class: W(["c-key-insights__table-col c-key-insights__table-col-heading", {
              "c-key-insights__table-col-numeric": n.visualisationType === "coverage_by_media_type",
              "c-key-insights__table-col-text": n.visualisationType === "leading_media_outlets"
            }])
          }, [
            k("span", {
              style: vt({ backgroundColor: o.backgroundColor }),
              class: "c-key-insights__table-heading"
            }, L(o.label), 5)
          ], 2))), 128))
        ]),
        (_(!0), S(st, null, _t(n.data.rows, (o, l) => (_(), S("div", {
          key: l,
          class: "c-key-insights__table-row"
        }, [
          (_(!0), S(st, null, _t(o, (c, d) => (_(), S("div", {
            key: d,
            class: W(["c-key-insights__table-col", {
              "c-key-insights__table-col-left": d === 0,
              "c-key-insights__table-col-numeric": a.isNumeric(d),
              "c-key-insights__table-col-text": a.isText(d),
              "c-key-insights__table-col-padded": a.isPadded(d)
            }])
          }, L(a.formattedLabel(c, d)), 3))), 128))
        ]))), 128))
      ]))
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const EL = /* @__PURE__ */ X(OL, [["render", LL]]), IL = {
  __name: "KeyMessages",
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "horizontalBar"
    },
    showDataLabels: {
      type: Boolean
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, {
      defaultOptions: i,
      hasDatasets: a,
      chartClass: r,
      chartLayoutClass: o,
      isTable: l,
      plugins: c
    } = xt(n, { clickEventsMode: "point" }), d = P(
      () => J({}, i.value, n.options)
    );
    return (h, u) => (_(), I(T(V), B(h.$props, {
      "has-data": T(a),
      class: T(o)
    }), {
      chart: N(() => [
        T(l) ? (_(), I(ft, ce(B({ key: 0 }, h.data)), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: h.data,
          options: d.value,
          title: h.title,
          text: h.text,
          class: W(T(r)),
          plugins: T(c),
          onChartClicked: u[0] || (u[0] = (f) => s("chart-clicked", f)),
          "onChart:render": u[1] || (u[1] = (f) => s("chart:render", f))
        }, null, 8, ["type", "data", "options", "title", "text", "class", "plugins"]))
      ]),
      _: 1
    }, 16, ["has-data", "class"]));
  }
}, RL = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ionicon",
  viewBox: "0 0 512 512"
}, BL = /* @__PURE__ */ k("path", { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48m108.25 138.29-134.4 160a16 16 0 0 1-12 5.71h-.27a16 16 0 0 1-11.89-5.3l-57.6-64a16 16 0 1 1 23.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0 1 24.5 20.58" }, null, -1), FL = [
  BL
];
function WL(e, t) {
  return _(), S("svg", RL, [...FL]);
}
const NL = { render: WL }, zL = {
  name: "KeyPlatformInfluencers",
  components: {
    PlatformAvatar: hi,
    IconCheckMarkCircle: NL,
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    interactionEnabled: {
      type: Boolean
    }
  },
  emits: ["chart-clicked"],
  computed: {
    platformType() {
      var e;
      return (e = this.data) == null ? void 0 : e.platform;
    },
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  }
}, jL = { class: "c-key-platform-influencers__row" }, HL = { class: "c-datatable__column c-datatable__column--auto c-datatable__column--left" }, VL = { class: "c-key-platform-influencers__platform-profile" }, YL = { class: "c-key-platform-influencers__column" }, GL = { class: "c-key-platform-influencers__influencer-name" }, UL = { class: "c-key-platform-influencers__influencer-username" }, XL = { class: "c-datatable__column c-key-platform-influencers__follower-column" }, qL = { class: "c-key-platform-influencers__platform-followers" };
function KL(e, t, n, s, i, a) {
  const r = R("PlatformAvatar"), o = R("IconCheckMarkCircle"), l = R("DataTable"), c = R("ChartWithLegendLayout");
  return _(), I(c, B(e.$props, { "has-data": a.hasData }), {
    chart: N(() => [
      Y(l, B(n.data, {
        "interaction-enabled": n.interactionEnabled,
        class: "c-key-platform-influencers",
        onChartClicked: t[0] || (t[0] = (d) => e.$emit("chart-clicked", d))
      }), {
        row: N(({ row: d }) => [
          k("div", jL, [
            k("div", HL, [
              k("div", VL, [
                Y(r, {
                  platform: a.platformType,
                  "avatar-url": d.influencer.source.logo
                }, null, 8, ["platform", "avatar-url"]),
                k("div", YL, [
                  k("div", GL, [
                    Ye(L(d.influencer.source.name) + " ", 1),
                    d.influencer.source.verified ? (_(), I(o, { key: 0 })) : rt("", !0)
                  ]),
                  k("div", UL, L(d.influencer.source.username), 1)
                ])
              ])
            ]),
            k("div", XL, [
              k("span", qL, L(d.followers.source), 1)
            ])
          ])
        ]),
        _: 1
      }, 16, ["interaction-enabled"])
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const QL = /* @__PURE__ */ X(zL, [["render", KL]]), JL = {
  name: "KeyQueries",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    ...gt,
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const {
      chartStyle: t,
      chartLegend: n,
      defaultOptions: s,
      hasDatasets: i,
      chartClass: a,
      chartLayoutClass: r
    } = xt(
      qt({
        ...e
      })
    );
    return {
      chartStyle: t,
      chartLegend: n,
      defaultOptions: s,
      hasDatasets: i,
      chartClass: a,
      chartLayoutClass: r
    };
  },
  data() {
    return {
      plugins: [vn]
    };
  },
  computed: {
    chartOptions() {
      return J({}, this.defaultOptions, this.options);
    }
  }
};
function ZL(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    legend: s.chartLegend,
    "has-data": s.hasDatasets,
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: e.data,
        options: a.chartOptions,
        plugins: i.plugins,
        style: vt(s.chartStyle),
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l)),
        "onChart:render": t[1] || (t[1] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["type", "data", "options", "plugins", "style", "class"])
    ]),
    _: 1
  }, 16, ["legend", "has-data", "class"]);
}
const tE = /* @__PURE__ */ X(JL, [["render", ZL]]), eE = {
  name: "KeyQueriesTimeline",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "line"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const {
      defaultOptions: t,
      hasDatasets: n,
      chartLegend: s,
      chartClass: i,
      chartLayoutClass: a
    } = xt(e, {
      isHistogram: !0
    });
    return {
      defaultOptions: t,
      hasDatasets: n,
      chartLegend: s,
      chartClass: i,
      chartLayoutClass: a
    };
  },
  computed: {
    chartOptions() {
      const { defaultOptions: e } = this;
      return J({}, e, this.options);
    }
  }
};
function nE(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": s.hasDatasets,
    legend: s.chartLegend,
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: e.data,
        options: a.chartOptions,
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l)),
        "onChart:render": t[1] || (t[1] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["type", "data", "options", "class"])
    ]),
    _: 1
  }, 16, ["has-data", "legend", "class"]);
}
const sE = /* @__PURE__ */ X(eE, [["render", nE]]), iE = {
  name: "LeadingMediaOutlets",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "horizontalBar"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const t = (l) => l.dataset.data[l.dataIndex] !== 0, n = (l) => l.length ? e.legend[l[0].dataIndex].label : !1, s = (l) => {
      const c = l.chart.data.datasets[l.datasetIndex].meta[l.dataIndex];
      return La(c, l.raw);
    }, { defaultOptions: i, hasDatasets: a, chartClass: r, chartLayoutClass: o } = xt(e, {
      clickEventsMode: "point",
      tooltipFilter: t,
      tooltipCallbacks: {
        title: n,
        label: s
      }
    });
    return {
      defaultOptions: i,
      hasDatasets: a,
      chartClass: r,
      chartLayoutClass: o
    };
  },
  data() {
    return {
      plugins: [Sr],
      truncateLabelsAt: 25
    };
  },
  computed: {
    chartData() {
      var t;
      if (!((t = this.data) != null && t.datasets))
        return {};
      const e = JSON.parse(JSON.stringify(this.data));
      return e.datasets.forEach(
        (n) => Object.assign(n, {
          barPercentage: 0.95,
          categoryPercentage: 0.95,
          label: n.meta,
          backgroundColor: ({ dataIndex: s }) => s >= this.legend.length ? "#efefef" : this.legend[s].color
        })
      ), e;
    },
    chartOptions() {
      const { truncateLabelsAt: e, defaultOptions: t } = this, s = J(
        {},
        {
          layout: {
            padding: {
              left: 145
            }
          },
          plugins: {
            datalabels: {
              align: "start",
              anchor: "start",
              clamp: !0,
              color: "#1A2162",
              font: {
                size: 11
              },
              clip: !1,
              offset: 8,
              formatter(i, { dataset: a, dataIndex: r }) {
                return an(
                  a.meta[r],
                  e
                );
              }
            }
          },
          scales: {
            y: {
              ticks: {
                display: !1
              }
            }
          }
        },
        this.options
      );
      return J({}, t, s);
    }
  }
};
function aE(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": s.hasDatasets,
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: a.chartData,
        options: a.chartOptions,
        plugins: i.plugins,
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l)),
        "onChart:render": t[1] || (t[1] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["type", "data", "options", "plugins", "class"])
    ]),
    _: 1
  }, 16, ["has-data", "class"]);
}
const rE = /* @__PURE__ */ X(iE, [["render", aE]]), oE = {
  name: "LeadingSources",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V,
    DataTable: ft
  },
  props: {
    ...lt,
    ...gt,
    truncateLabelsAt: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "horizontalBar"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const {
      hasDatasets: t,
      defaultOptions: n,
      chartClass: s,
      chartLayoutClass: i,
      isTable: a
    } = xt(e);
    return {
      hasDatasets: t,
      defaultOptions: n,
      chartClass: s,
      chartLayoutClass: i,
      isTable: a
    };
  },
  computed: {
    chartOptions() {
      const { defaultOptions: e } = this;
      return J({}, e, this.options);
    }
  }
};
function lE(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("Chart"), l = R("ChartWithLegendLayout");
  return _(), I(l, B(e.$props, {
    "has-data": s.hasDatasets,
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      s.isTable ? (_(), I(r, ce(B({ key: 0 }, e.data)), null, 16)) : (_(), I(o, {
        key: 1,
        type: n.chartType,
        data: e.data,
        options: a.chartOptions,
        title: e.title,
        text: e.text,
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (c) => e.$emit("chart-clicked", c)),
        "onChart:render": t[1] || (t[1] = (c) => e.$emit("chart:render", c))
      }, null, 8, ["type", "data", "options", "title", "text", "class"]))
    ]),
    _: 1
  }, 16, ["has-data", "class"]);
}
const cE = /* @__PURE__ */ X(oE, [["render", lE]]), dE = {
  name: "MediaVolumeTable",
  components: {
    ChartWithLegendLayout: V,
    DataTable: ft
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  }
};
function hE(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-media-volume-table"
  }), {
    chart: N(() => [
      Y(r, B(n.data, { class: "c-media-volume-table__table u__flex-auto" }), null, 16)
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const uE = /* @__PURE__ */ X(dE, [["render", hE]]), fE = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}, gE = /* @__PURE__ */ k("path", {
  fill: "#FF7875",
  d: "M6 11 1 1h10z"
}, null, -1), pE = [
  gE
];
function mE(e, t) {
  return _(), S("svg", fE, [...pE]);
}
const bE = { render: mE }, yE = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}, _E = /* @__PURE__ */ k("path", {
  fill: "#71D688",
  d: "m6 1 5 10H1z"
}, null, -1), vE = [
  _E
];
function xE(e, t) {
  return _(), S("svg", yE, [...vE]);
}
const wE = { render: xE }, kE = {
  up: wE,
  down: bE
}, CE = {
  name: "MentionBenchmarkTimeline",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    ...gt,
    rangeLabel: {
      type: String,
      default: ""
    },
    mentionCount: {
      type: [Number, String],
      default: 0
    },
    mentionHeading: {
      type: String,
      default: "Total Mentions"
    },
    change: {
      type: Object,
      default: () => ({})
    },
    chartType: {
      type: String,
      default: "line"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const { tooltipDateFormatter: t } = Lh(e);
    function n(h) {
      return kE[h];
    }
    const s = (h) => `<span>${t([{ label: h[0].raw.date }])}</span>`, i = (h) => {
      const u = h;
      return `<span>${e.mentionHeading}: ${u.formattedValue}</span>`;
    }, {
      defaultOptions: a,
      hasDatasets: r,
      chartLegend: o,
      chartClass: l,
      chartLayoutClass: c
    } = xt(e, {
      isHistogram: !0,
      clickEventsMode: "point",
      tooltipCallbacks: {
        title: s,
        label: i
      }
    }), d = P(
      () => J({}, a.value, e.options)
    );
    return {
      defaultOptions: a,
      hasDatasets: r,
      chartLegend: o,
      changeIcon: n,
      chartOptions: d,
      chartClass: l,
      chartLayoutClass: c
    };
  }
}, SE = { class: "c-mention-benchmark-timeline" }, ME = { class: "c-mention-benchmark-timeline__header" }, OE = { class: "c-mention-benchmark-timeline__title" }, TE = { class: "c-mention-benchmark-timeline__stats" }, PE = { class: "c-mention-benchmark-timeline__value" }, AE = { class: "c-mention-benchmark-timeline__details" }, $E = { class: "c-mention-benchmark-timeline__period" };
function DE(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": s.hasDatasets,
    legend: s.chartLegend,
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: e.data,
        options: s.chartOptions,
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l)),
        "onChart:render": t[1] || (t[1] = (l) => e.$emit("chart:render", l))
      }, {
        beforeChart: N(() => [
          k("div", SE, [
            k("div", ME, [
              k("h2", OE, L(n.mentionHeading), 1),
              k("div", TE, [
                k("span", PE, L(n.mentionCount), 1),
                k("span", AE, [
                  k("span", {
                    class: W(["c-mention-benchmark-timeline__change", {
                      "c-mention-benchmark-timeline__change--positive": n.change.direction === "up",
                      "c-mention-benchmark-timeline__change--negative": n.change.direction === "down"
                    }])
                  }, [
                    (_(), I(es(s.changeIcon(n.change.direction)), { class: "c-mention-benchmark-timeline__arrow" })),
                    Ye(" " + L(n.change.value) + " (" + L(n.change.percentage) + "%) ", 1)
                  ], 2),
                  k("span", $E, L(n.rangeLabel), 1)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["type", "data", "options", "class"])
    ]),
    _: 1
  }, 16, ["has-data", "legend", "class"]);
}
const LE = /* @__PURE__ */ X(CE, [["render", DE], ["__scopeId", "data-v-623bd146"]]);
var EE = Vt, IE = function() {
  return EE.Date.now();
}, RE = IE, BE = /\s/;
function FE(e) {
  for (var t = e.length; t-- && BE.test(e.charAt(t)); )
    ;
  return t;
}
var WE = FE, NE = WE, zE = /^\s+/;
function jE(e) {
  return e && e.slice(0, NE(e) + 1).replace(zE, "");
}
var HE = jE, VE = HE, kc = Kt, YE = Ti, Cc = NaN, GE = /^[-+]0x[0-9a-f]+$/i, UE = /^0b[01]+$/i, XE = /^0o[0-7]+$/i, qE = parseInt;
function KE(e) {
  if (typeof e == "number")
    return e;
  if (YE(e))
    return Cc;
  if (kc(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = kc(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = VE(e);
  var n = UE.test(e);
  return n || XE.test(e) ? qE(e.slice(2), n ? 2 : 8) : GE.test(e) ? Cc : +e;
}
var QE = KE, JE = Kt, sa = RE, Sc = QE, ZE = "Expected a function", tI = Math.max, eI = Math.min;
function nI(e, t, n) {
  var s, i, a, r, o, l, c = 0, d = !1, h = !1, u = !0;
  if (typeof e != "function")
    throw new TypeError(ZE);
  t = Sc(t) || 0, JE(n) && (d = !!n.leading, h = "maxWait" in n, a = h ? tI(Sc(n.maxWait) || 0, t) : a, u = "trailing" in n ? !!n.trailing : u);
  function f(C) {
    var O = s, M = i;
    return s = i = void 0, c = C, r = e.apply(M, O), r;
  }
  function g(C) {
    return c = C, o = setTimeout(b, t), d ? f(C) : r;
  }
  function m(C) {
    var O = C - l, M = C - c, A = t - O;
    return h ? eI(A, a - M) : A;
  }
  function p(C) {
    var O = C - l, M = C - c;
    return l === void 0 || O >= t || O < 0 || h && M >= a;
  }
  function b() {
    var C = sa();
    if (p(C))
      return y(C);
    o = setTimeout(b, m(C));
  }
  function y(C) {
    return o = void 0, u && s ? f(C) : (s = i = void 0, r);
  }
  function v() {
    o !== void 0 && clearTimeout(o), c = 0, s = l = i = o = void 0;
  }
  function w() {
    return o === void 0 ? r : y(sa());
  }
  function x() {
    var C = sa(), O = p(C);
    if (s = arguments, i = this, l = C, O) {
      if (o === void 0)
        return g(l);
      if (h)
        return clearTimeout(o), o = setTimeout(b, t), f(l);
    }
    return o === void 0 && (o = setTimeout(b, t)), r;
  }
  return x.cancel = v, x.flush = w, x;
}
var sI = nI;
const Uh = /* @__PURE__ */ lr(sI), $n = 60;
function iI() {
  const e = [];
  function t(p = "", b = 0, y = 12) {
    const v = b > 0 ? `+${b}` : "";
    let w = p;
    return p.length > y ? w = `${p.substring(0, y)}...${v}` : w = `${p}...${v}`, w;
  }
  function n(p, b) {
    const y = Number(p.y), v = Number(p.y2), w = Number(b.y), x = Number(b.y2), C = (M, A, $, D) => M >= $ && M <= D || A >= $ && A <= D, O = C(y, v, w, x) || C(w, x, y, v);
    return O ? {
      isOverlapping: O,
      overlapsOnTheTop: y < w,
      overlapsOnTheBottom: v > x
    } : !1;
  }
  function s(p, b) {
    const y = Number(p.x), v = Number(p.x2), w = Number(b.x), x = Number(b.x2), C = (M, A, $, D) => M < D && A > $, O = C(y, v, w, x) || C(w, x, y, v);
    return O ? {
      isOverlapping: O,
      overlapsOnTheLeft: y < w,
      overlapsOnTheRight: v > x
    } : !1;
  }
  function i({ element: p, chart: b }, y) {
    return p.x2 + y >= b.chartArea.right;
  }
  function a({ element: p, chart: b }, y) {
    return p.x + y <= b.chartArea.left;
  }
  function r({ element: p, chart: b }, y) {
    return p.y - y <= b.chartArea.top;
  }
  function o(p, b) {
    return Math.min(p.y2, b.y2) - Math.max(p.y, b.y);
  }
  function l(p) {
    var b;
    return (b = Yn == null ? void 0 : Yn._getState(p)) == null ? void 0 : b.elements.filter(
      (y) => {
        var v;
        return ((v = y == null ? void 0 : y.options) == null ? void 0 : v.type) === "label";
      }
    );
  }
  function c(p, b = {}) {
    const y = e[p] || {};
    e.splice(p, 1, {
      ...y,
      ...b,
      init: !0
    });
  }
  function d(p) {
    var D, F, z, Q, G;
    const { chart: b } = p, y = l(b), v = p == null ? void 0 : p.element;
    if (!((D = v == null ? void 0 : v.options) != null && D.display))
      return;
    const w = y.findIndex(
      (q) => {
        var Z, wt;
        return ((Z = q == null ? void 0 : q.options) == null ? void 0 : Z.id) === ((wt = v == null ? void 0 : v.options) == null ? void 0 : wt.id);
      }
    ), x = (F = v == null ? void 0 : v.options) == null ? void 0 : F.xAdjust, C = typeof ((z = v == null ? void 0 : v.options) == null ? void 0 : z.xAdjust) == "number", O = (Q = v == null ? void 0 : v.options) == null ? void 0 : Q.yAdjust, M = typeof ((G = v == null ? void 0 : v.options) == null ? void 0 : G.yAdjust) == "number", A = e[w - 1], $ = A == null ? void 0 : A.init;
    return {
      currentElement: v,
      currentElementIndex: w,
      hasXAdjustment: C,
      xAdjustment: x,
      hasYAdjustment: M,
      yAdjustment: O,
      previousElement: A,
      hasPreviousElement: $
    };
  }
  function h(p, b = 0) {
    return {
      x: p.x + b,
      x2: p.x2 + b,
      centerX: p.centerX + b
    };
  }
  function u(p, b = 0) {
    return {
      y: p.y + b,
      y2: p.y2 + b,
      centerY: p.centerY + b
    };
  }
  function f(p) {
    const b = d(p);
    if (!b)
      return;
    const { currentElement: y, currentElementIndex: v, xAdjustment: w } = b;
    let x = w || 0;
    return i(p, x) ? x = -$n : a(p, x) && (x = $n), x !== w && c(
      v,
      h(y, x)
    ), x;
  }
  function g(p) {
    const b = d(p);
    if (!b)
      return;
    const {
      currentElement: y,
      currentElementIndex: v,
      previousElement: w,
      hasPreviousElement: x,
      hasYAdjustment: C,
      yAdjustment: O
    } = b;
    let M = C ? O : $n, A = u(y);
    const $ = h(y);
    if (C || (r(p, M) || (M *= -1), A = u(y, M)), x) {
      const D = n(
        A,
        w
      ), F = s(
        $,
        w
      );
      if (D && F) {
        let z = o(A, w);
        const Q = 4;
        D.overlapsOnTheTop ? z = -z - Q : z += Q, M += z, r(p, M) && (A = u(
          A,
          $n
        ), z = o(A, w), M = $n + z);
      }
    }
    return M !== O && c(v, A), M;
  }
  function m({ content: p, xValue: b, yValue: y, ...v }) {
    return {
      type: "label",
      backgroundColor: "rgba(240, 245, 255, 0.70)",
      borderRadius: 4,
      borderWidth: 1,
      borderColor: "#D6E4FF",
      callout: {
        display: !0,
        borderColor: "#9ca1a6",
        borderDash: [5, 5],
        borderWidth: 2,
        margin: 0,
        opacity: 0.3
      },
      content: p,
      color: "#061279",
      font: {
        size: 12
      },
      position: {
        x: "center",
        y: "center"
      },
      xValue: b,
      yValue: y,
      xAdjust: f,
      yAdjust: g,
      ...v
    };
  }
  return {
    getAnnotationLabel: t,
    mapAnnotation: m
  };
}
const aI = { class: "c-outreach-coverage-timeline-layout" }, rI = {
  key: 0,
  class: "c-outreach-coverage-timeline-layout__releases"
}, oI = {
  name: "OutreachCoverageTimeline",
  i18n: {
    messages: {
      de: {
        mediaItems: "Medienelemente",
        mediaRelease: "Medienrelease",
        pitch: "Tonhöhe"
      },
      "en-AU": {
        mediaItems: "Media Items",
        mediaRelease: "Media Release",
        pitch: "Pitch"
      },
      "en-US": {
        mediaItems: "Media Items",
        mediaRelease: "Media Release",
        pitch: "Pitch"
      },
      "en-GB": {
        mediaItems: "Media Items",
        mediaRelease: "Media Release",
        pitch: "Pitch"
      },
      es: {
        mediaItems: "Artículos multimedia",
        mediaRelease: "Publicación de medios",
        pitch: "Paso"
      },
      "fr-CA": {
        mediaItems: "Éléments multimédias",
        mediaRelease: "Publication de médias",
        pitch: "Argumentaire/pitch"
      },
      fr: {
        mediaItems: "Éléments multimédias",
        mediaRelease: "Publication de médias",
        pitch: "Argumentaire/pitch"
      },
      it: {
        mediaItems: "Elementi multimediali",
        mediaRelease: "Comunicato stampa",
        pitch: "Pece"
      },
      "zh-CN": {
        mediaItems: "媒体项目",
        mediaRelease: "媒体发布",
        pitch: "沥青"
      }
    }
  }
}, lI = /* @__PURE__ */ Object.assign(oI, {
  name: "OutreachCoverageTimeline"
}, {
  props: {
    ...lt,
    ...gt,
    includeCountInLegend: {
      type: Boolean
    },
    chartType: {
      type: String,
      default: "line"
    }
  },
  emits: {
    "chart-clicked": [],
    "chart:render": []
  },
  setup(e, { emit: t }) {
    const n = e, s = t, i = Da();
    function a($) {
      return i.ctx.$t($);
    }
    const r = yt([Yn]);
    function o($) {
      const D = (z) => new Date(z).setHours(0, 0, 0, 0), F = (z) => new Date(z).setMinutes(0, 0, 0);
      return n.data.labels.findIndex((z) => {
        const Q = D(z);
        return Q === D($) || Q === F($);
      });
    }
    const l = Uh(($) => {
      s("chart-clicked", {
        action: "outreachClicked",
        value: $
      });
    }, 100), c = P(
      () => n.data.mediaReleases.reduce(($, D) => {
        const F = o(D.sentAt), z = n.data.labels[F];
        return $[z] || ($[z] = []), $[z].push(D), $;
      }, {})
    );
    function d($ = "", D = []) {
      let F = `<div style="margin-top: 16px; margin-bottom: 8px; font-weight: 700">${$}</div>`;
      return F += '<ul style="list-style-position: inside; padding-inline: 8px;">', F += D.map((z) => `<li>${z.name}</li>`).join(""), F += "</ul>", F;
    }
    function h($) {
      const D = $, F = D.label;
      let z = `${D.formattedValue} ${a("mediaItems")}`;
      ["horizontalBarStacked", "barStacked"].includes(n.chartType) && (z = `${D.dataset.label}: ${D.formattedValue}`);
      let Q = `<div style="display: inline-block;">${z}</div>`;
      if (D.datasetIndex < this.dataPoints.length - 1)
        return Q;
      const G = c.value[F] ?? [], q = G.filter(
        (wt) => wt.mediaReleaseType === "media_release"
      ), Z = G.filter(
        (wt) => wt.mediaReleaseType === "pitch"
      );
      return q.length > 0 && (Q += d(a("mediaRelease"), q)), Z.length > 0 && (Q += d(a("pitch"), Z)), Q;
    }
    function u($) {
      const F = $[0].label;
      return `<div style="margin-bottom: 8px">${Wc(new Date(F), "MMM dd, yyyy")}</div>`;
    }
    const {
      defaultOptions: f,
      hasDatasets: g,
      chartLegend: m,
      chartClass: p,
      chartLayoutClass: b,
      isHorizontal: y,
      isStacked: v
    } = xt(n, {
      isHistogram: !0,
      tooltipCallbacks: {
        title: u,
        label: h
      }
    });
    function w($) {
      const D = Math.floor($);
      return v.value ? n.data.datasets.reduce(
        (F, z) => F + (z.data[D] || 0),
        0
      ) : n.data.datasets[0].data[D];
    }
    const { getAnnotationLabel: x, mapAnnotation: C } = iI(), O = P(() => {
      const $ = {};
      return Object.keys(c.value).forEach((D, F) => {
        const z = c.value[D], Q = z[0], G = z.length - 1, q = o(D), Z = w(q);
        $[`annotation${F}`] = C({
          content: x(Q.name, G),
          xValue: y.value ? Z : q,
          yValue: y.value ? q : Z,
          click: () => l(z.map((wt) => wt.id))
        });
      }), $;
    }), M = P(() => {
      const $ = {
        pointRadius: 2,
        pointHoverRadius: 4,
        pointBackgroundColor: "#2E54EA",
        plugins: {
          ...f.value.plugins,
          annotation: {
            annotations: O.value
          }
        }
      }, D = J(
        {},
        $,
        n.options
      );
      return J({}, f.value, D);
    }), A = P(() => n.includeCountInLegend ? m.value : n.legend.map(({ color: $, label: D }) => ({
      color: $,
      label: ui(D)
    })));
    return ($, D) => {
      var F;
      return _(), S("div", aI, [
        Y(T(V), B($.$props, {
          "has-data": T(g),
          legend: A.value,
          class: T(b)
        }), {
          chart: N(() => [
            Y(T(ut), {
              type: e.chartType,
              data: $.data,
              options: M.value,
              plugins: r.value,
              class: W(T(p)),
              onChartClicked: D[0] || (D[0] = (z) => s("chart-clicked", z)),
              "onChart:render": D[1] || (D[1] = (z) => s("chart:render", z))
            }, null, 8, ["type", "data", "options", "plugins", "class"])
          ]),
          _: 1
        }, 16, ["has-data", "legend", "class"]),
        (F = $.data) != null && F.reportView ? (_(), S("div", rI, [
          (_(!0), S(st, null, _t(c.value, (z, Q) => (_(), I(T(Nc), {
            key: Q,
            "sent-at": Q,
            items: c.value[Q],
            onReleaseClick: T(l)
          }, null, 8, ["sent-at", "items", "onReleaseClick"]))), 128))
        ])) : rt("", !0)
      ]);
    };
  }
}), cI = { class: "c-outreach-performance-table__row" }, dI = ["href"], hI = ["onClick"], uI = ["onClick"], fI = /* @__PURE__ */ Object.assign({
  name: "OutreachPerformanceTable"
}, {
  __name: "OutreachPerformanceTable",
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["chart-clicked"],
  setup(e, { emit: t }) {
    const n = e, s = t, i = P(
      () => {
        var o, l;
        return !!((l = (o = n.data) == null ? void 0 : o.columns) != null && l.length && n.data.columns[0].rows.length);
      }
    );
    function a(o) {
      s("chart-clicked", o.media_outreach.source);
    }
    function r(o) {
      var l;
      return [
        {
          id: "name",
          value: {
            name: o.media_outreach.source.name,
            url: (l = o.media_outreach.source) == null ? void 0 : l.url
          },
          classNames: [
            "c-datatable__column",
            "c-datatable__column--left",
            "c-outreach-performance-table__column",
            "c-outreach-performance-table__release-title"
          ],
          onClick: a
        },
        {
          id: "opens",
          value: o.opens.source,
          classNames: [
            "c-datatable__column",
            "c-outreach-performance-table__column",
            "c-outreach-performance-table__release-stat"
          ]
        },
        {
          id: "clicks",
          value: o.clicks.source,
          classNames: [
            "c-datatable__column",
            "c-outreach-performance-table__column",
            "c-outreach-performance-table__release-stat"
          ]
        }
      ];
    }
    return (o, l) => (_(), I(T(V), B(o.$props, { "has-data": i.value }), {
      chart: N(() => [
        Y(T(ft), B(e.data, { class: "c-outreach-performance-table" }), {
          row: N(({ row: c }) => [
            k("div", cI, [
              (_(!0), S(st, null, _t(r(c), (d) => (_(), S(st, {
                key: d.id
              }, [
                d.id === "name" ? (_(), S(st, { key: 0 }, [
                  d.value.url ? (_(), S("a", {
                    key: 0,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    href: d.value.url,
                    class: W(d.classNames)
                  }, L(d.value.name), 11, dI)) : (_(), S("div", {
                    key: 1,
                    class: W(d.classNames),
                    onClick: (h) => {
                      var u;
                      return (u = d.onClick) == null ? void 0 : u.call(d, c);
                    }
                  }, L(d.value.name), 11, hI))
                ], 64)) : (_(), S("div", {
                  key: 1,
                  class: W(d.classNames),
                  onClick: (h) => {
                    var u;
                    return (u = d.onClick) == null ? void 0 : u.call(d, c);
                  }
                }, L(d.value), 11, uI))
              ], 64))), 128))
            ])
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }, 16, ["has-data"]));
  }
}), gI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}, pI = /* @__PURE__ */ k("path", {
  fill: "#A2A8B4",
  "fill-rule": "evenodd",
  d: "M3.2 13.2V2.8H3a.6.6 0 0 1 0-1.2h10a.6.6 0 1 1 0 1.2h-.2v10.4h.2a.6.6 0 1 1 0 1.2h-2.8a.6.6 0 0 1-.6-.6v-2a.6.6 0 0 0-.6-.6H7a.6.6 0 0 0-.6.6v2a.6.6 0 0 1-.6.6H3a.6.6 0 1 1 0-1.2zm2.4-8.8c0-.221.18-.4.4-.4h.8c.221 0 .4.179.4.4v.8a.4.4 0 0 1-.4.4H6a.4.4 0 0 1-.4-.4zM6 7.2a.4.4 0 0 0-.4.4v.8c0 .22.18.4.4.4h.8a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4zm2.8-2.8c0-.221.18-.4.4-.4h.8c.221 0 .4.179.4.4v.8a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4zm.4 2.8a.4.4 0 0 0-.4.4v.8c0 .22.18.4.4.4h.8a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4z",
  "clip-rule": "evenodd"
}, null, -1), mI = [
  pI
];
function bI(e, t) {
  return _(), S("svg", gI, [...mI]);
}
const yI = { render: bI }, _I = { class: "c-outreach-top-engaged-contacts-table__row" }, vI = ["onClick"], xI = ["href"], wI = {
  key: 2,
  class: "c-outreach-top-engaged-contacts-table__contact-description"
}, kI = {
  key: 3,
  class: "c-outreach-top-engaged-contacts-table__contact-outlet"
}, CI = { class: "c-outreach-top-engaged-contacts-table__contact-outlet-name" }, SI = ["onClick"], MI = /* @__PURE__ */ Object.assign({
  name: "OutreachTopEngagedContactsTable"
}, {
  __name: "OutreachTopEngagedContactsTable",
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["chart-clicked"],
  setup(e, { emit: t }) {
    const n = ["influencer", "outlet"], s = e, i = t, a = P(
      () => {
        var d, h;
        return !!((h = (d = s.data) == null ? void 0 : d.columns) != null && h.length && s.data.columns[0].rows.length);
      }
    );
    function r(d) {
      i("chart-clicked", d.contacts.source);
    }
    function o(d) {
      return n.includes(d.contacts.source.type);
    }
    function l(d) {
      const { type: h } = d.contacts.source;
      return h === "media_release_adhoc_recipient" ? "Custom recipient." : h === "private_influencer" ? "Private contact." : "";
    }
    function c(d) {
      const h = [
        {
          id: "contacts",
          value: d.contacts.source,
          classNames: [
            "c-datatable__column",
            "c-datatable__column--left",
            "c-outreach-top-engaged-contacts-table__column",
            "c-outreach-top-engaged-contacts-table__contact"
          ],
          onClick: o(d) ? r : void 0
        }
      ];
      return d.opens && h.push({
        id: "opens",
        value: d.opens.source,
        classNames: [
          "c-datatable__column",
          "c-outreach-top-engaged-contacts-table__column",
          "c-outreach-top-engaged-contacts-table__contact-stat"
        ]
      }), d.clicks && h.push({
        id: "clicks",
        value: d.clicks.source,
        classNames: [
          "c-datatable__column",
          "c-outreach-top-engaged-contacts-table__column",
          "c-outreach-top-engaged-contacts-table__contact-stat"
        ]
      }), h;
    }
    return (d, h) => (_(), I(T(V), B(d.$props, { "has-data": a.value }), {
      chart: N(() => [
        Y(T(ft), B(e.data, { class: "c-outreach-top-engaged-contacts-table" }), {
          row: N(({ row: u }) => [
            k("div", _I, [
              (_(!0), S(st, null, _t(c(u), (f) => (_(), S(st, {
                key: f.id
              }, [
                f.id === "contacts" ? (_(), S("div", {
                  key: 0,
                  class: W(f.classNames),
                  onClick: (g) => {
                    var m;
                    return (m = f.onClick) == null ? void 0 : m.call(f, u);
                  }
                }, [
                  f.value.url ? (_(), S("a", {
                    key: 0,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    href: f.value.url,
                    class: "c-outreach-top-engaged-contacts-table__contact-name c-outreach-top-engaged-contacts-table__contact-name-link"
                  }, L(f.value.name), 9, xI)) : (_(), S("div", {
                    key: 1,
                    class: W(["c-outreach-top-engaged-contacts-table__contact-name", {
                      "c-outreach-top-engaged-contacts-table__contact-name-link": o(u)
                    }])
                  }, L(f.value.name), 3)),
                  l(u) ? (_(), S("div", wI, L(l(u)), 1)) : rt("", !0),
                  f.value.outlet ? (_(), S("div", kI, [
                    Y(T(yI), { class: "c-outreach-top-engaged-contacts-table__contact-outlet-icon" }),
                    k("div", CI, L(f.value.outlet), 1)
                  ])) : rt("", !0)
                ], 10, vI)) : (_(), S("div", {
                  key: 1,
                  class: W(f.classNames),
                  onClick: (g) => {
                    var m;
                    return (m = f.onClick) == null ? void 0 : m.call(f, u);
                  }
                }, L(f.value), 11, SI))
              ], 64))), 128))
            ])
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }, 16, ["has-data"]));
  }
}), OI = /* @__PURE__ */ Object.assign({
  name: "PotentialAudienceReach"
}, {
  __name: "PotentialAudienceReach",
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "bar"
    },
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, i = P(
      () => ["barStacked", "horizontalBarStacked"].includes(n.chartType)
    ), {
      chartClass: a,
      chartLayoutClass: r,
      chartLegend: o,
      chartStyle: l,
      defaultOptions: c,
      hasDatasets: d,
      isTable: h
    } = xt(
      qt({
        ...n
      }),
      {
        isHistogram: i.value
      }
    ), u = [vn], f = P(
      () => J({}, c.value, n.options)
    ), g = P(() => n.chartType === "table" ? [] : o.value), m = P(() => {
      const { data: b, options: y, truncateLabels: v, size: w, legend: x, ...C } = n;
      return C;
    }), p = (b) => {
      s("chart-clicked", b);
    };
    return (b, y) => (_(), I(T(V), B(m.value, {
      "has-data": T(d),
      legend: g.value,
      class: T(r)
    }), {
      chart: N(() => [
        T(h) ? (_(), I(ft, B({ key: 0 }, b.data, { class: "c-potential-audience-reach__table u__flex-auto" }), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: b.data,
          options: f.value,
          title: b.title,
          text: b.text,
          style: vt(T(l)),
          plugins: u,
          class: W(T(a)),
          onChartClicked: p,
          "onChart:render": y[0] || (y[0] = (v) => s("chart:render", v))
        }, null, 8, ["type", "data", "options", "title", "text", "style", "class"]))
      ]),
      _: 1
    }, 16, ["has-data", "legend", "class"]));
  }
}), TI = {
  name: "ProgressPie",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    progress: {
      type: Number,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    units: {
      type: String,
      default: ""
    },
    trackColor: {
      type: String,
      default: "#C3D5EF"
    },
    color: {
      type: String,
      default: "#73A0DA"
    },
    exceededColor: {
      type: String,
      default: "#F84E4E"
    },
    fontSize: {
      type: String,
      default: ""
    },
    fontWeight: {
      type: String,
      default: ""
    },
    decimalPlaces: {
      type: Number,
      default: 0
    },
    subTitle: {
      type: String,
      default: ""
    },
    subTitleFontSize: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const {
      chartClass: t,
      chartLayoutClass: n,
      chartStyle: s,
      defaultOptions: i,
      hasDatasets: a
    } = xt(
      qt({
        ...e
      })
    );
    return {
      chartClass: t,
      chartLayoutClass: n,
      chartStyle: s,
      defaultOptions: i,
      hasDatasets: a
    };
  },
  data() {
    return {
      plugins: [vn]
    };
  },
  computed: {
    chartData() {
      const e = Math.min(this.progress, this.max);
      return {
        datasets: [
          {
            backgroundColor: [
              this.progress > this.max ? this.exceededColor : this.color,
              this.trackColor
            ],
            borderWidth: 0,
            data: [e, this.max - e]
          }
        ]
      };
    },
    chartOptions() {
      const { defaultOptions: e } = this, t = {
        hover: !1,
        elements: {
          center: {
            text: `${this.progress.toFixed(this.decimalPlaces)}${this.units}`,
            staticText: this.title || !1,
            fontSize: this.fontSize,
            fontWeight: this.fontWeight,
            subTitle: this.subTitle,
            subTitleFontSize: this.subTitleFontSize
          }
        }
      }, n = J({}, t, this.options);
      return J({}, e, n);
    }
  }
};
function PI(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": "",
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: a.chartData,
        options: a.chartOptions,
        size: n.size,
        plugins: i.plugins,
        style: vt(s.chartStyle),
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l)),
        "onChart:render": t[1] || (t[1] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["type", "data", "options", "size", "plugins", "style", "class"])
    ]),
    _: 1
  }, 16, ["class"]);
}
const AI = /* @__PURE__ */ X(TI, [["render", PI]]), $I = {
  __name: "ReactScoreBreakdown",
  props: {
    ...lt,
    ...gt,
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "pie"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, {
      chartClass: i,
      chartLayoutClass: a,
      chartLegend: r,
      chartStyle: o,
      defaultOptions: l,
      hasDatasets: c,
      isTable: d
    } = xt(
      qt({
        ...n
      })
    ), h = P(
      () => J({}, l.value, n.options)
    );
    return (u, f) => (_(), I(T(V), B(u.$props, {
      legend: T(r),
      "has-data": T(c),
      class: T(a)
    }), {
      chart: N(() => [
        T(d) ? (_(), I(T(ft), ce(B({ key: 0 }, u.data)), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: u.data,
          options: h.value,
          style: vt(T(o)),
          class: W(T(i)),
          onChartClicked: f[0] || (f[0] = (g) => s("chart-clicked", g)),
          "onChart:render": f[1] || (f[1] = (g) => s("chart:render", g))
        }, null, 8, ["type", "data", "options", "style", "class"]))
      ]),
      _: 1
    }, 16, ["legend", "has-data", "class"]));
  }
}, DI = /* @__PURE__ */ Object.assign({
  name: "SentimentBenchmark"
}, {
  __name: "SentimentBenchmark",
  props: {
    ...lt,
    ...gt,
    truncateLabels: Boolean,
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "horizontalBarStacked"
    },
    showDataLabels: {
      type: Boolean
    },
    dataLabelColor: {
      type: String,
      default: "black"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, {
      chartClass: i,
      chartLayoutClass: a,
      chartStyle: r,
      chartLegend: o,
      defaultOptions: l,
      hasDatasets: c,
      plugins: d
    } = xt(n, {
      clickEventsMode: "point",
      dataLabelCallback: (f) => f < 2 ? "" : f,
      labelColorCallback: (f) => {
        var g, m;
        return ((m = (g = n.data) == null ? void 0 : g.colors) == null ? void 0 : m[f.tick.value]) || "";
      },
      tooltipCallbacks: {
        label: (f) => `${f.dataset.label || ""}: ${f.parsed.x || 0}%`
      },
      valueCallback: (f) => f === 0 ? f : f === 100 ? `${f} (%)` : "",
      valueScaleOptions: {
        min: 0,
        max: 100
      }
    }), h = P(
      () => J({}, l.value, n.options)
    ), u = (f) => s("chart-clicked", f);
    return (f, g) => (_(), I(T(V), B(f.$props, {
      legend: T(o),
      "has-data": T(c),
      class: T(a)
    }), {
      chart: N(() => [
        Y(T(ut), {
          type: e.chartType,
          data: f.data,
          options: h.value,
          style: vt(T(r)),
          class: W(T(i)),
          plugins: T(d),
          onChartClicked: u,
          "onChart:render": g[0] || (g[0] = (m) => s("chart:render", m))
        }, null, 8, ["type", "data", "options", "style", "class", "plugins"])
      ]),
      _: 1
    }, 16, ["legend", "has-data", "class"]));
  }
}), LI = /* @__PURE__ */ Object.assign({
  name: "SentimentBreakdown"
}, {
  __name: "SentimentBreakdown",
  props: {
    ...lt,
    ...gt,
    truncateLabels: {
      type: Boolean
    },
    size: {
      type: Number,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, {
      chartClass: i,
      chartLayoutClass: a,
      chartStyle: r,
      chartLegend: o,
      defaultOptions: l,
      hasDatasets: c,
      isTable: d
    } = xt(
      qt({
        ...n
      })
    ), h = P(
      () => J({}, l.value, n.options)
    ), u = (f) => {
      s("chart-clicked", f);
    };
    return (f, g) => (_(), I(T(V), B(f.$props, {
      legend: T(o),
      "has-data": T(c),
      class: T(a)
    }), {
      chart: N(() => [
        T(d) ? (_(), I(ft, ce(B({ key: 0 }, f.data)), null, 16)) : (_(), I(T(ut), {
          key: 1,
          type: e.chartType,
          data: f.data,
          options: h.value,
          style: vt(T(r)),
          class: W(T(i)),
          onChartClicked: u,
          "onChart:render": g[0] || (g[0] = (m) => s("chart:render", m))
        }, null, 8, ["type", "data", "options", "style", "class"]))
      ]),
      _: 1
    }, 16, ["legend", "has-data", "class"]));
  }
}), EI = /* @__PURE__ */ Object.assign({
  name: "SentimentTimeline"
}, {
  __name: "SentimentTimeline",
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "line"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e, { emit: t }) {
    const n = e, s = t, {
      chartClass: i,
      chartLayoutClass: a,
      defaultOptions: r,
      hasDatasets: o,
      chartLegend: l
    } = xt(n, {
      isHistogram: !0
    }), c = P(
      () => J({}, r.value, n.options)
    );
    return (d, h) => (_(), I(T(V), B(n, {
      "has-data": T(o),
      legend: T(l),
      class: T(a)
    }), {
      chart: N(() => [
        Y(T(ut), {
          type: e.chartType,
          data: d.data,
          options: c.value,
          class: W(T(i)),
          onChartClicked: h[0] || (h[0] = (u) => s("chart-clicked", u)),
          "onChart:render": h[1] || (h[1] = (u) => s("chart:render", u))
        }, null, 8, ["type", "data", "options", "class"])
      ]),
      _: 1
    }, 16, ["has-data", "legend", "class"]));
  }
}), II = {
  name: "ShareOfVoice",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V,
    DataTable: ft
  },
  props: {
    ...lt,
    ...gt,
    visualisationType: {
      type: String,
      default: "chart"
    },
    truncateLabels: {
      type: Boolean
    },
    chartType: {
      type: String,
      default: "pie"
    },
    size: {
      type: Number,
      default: null
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    const t = P(
      () => e.visualisationType === "barchart" ? "horizontalBar" : e.chartType
    ), {
      chartClass: n,
      chartLayoutClass: s,
      chartLegend: i,
      chartStyle: a,
      defaultOptions: r,
      hasDatasets: o,
      isTable: l
    } = xt(
      qt({
        ...e,
        chartType: t.value
      })
    );
    return {
      chartClass: n,
      chartLayoutClass: s,
      chartLegend: i,
      chartStyle: a,
      defaultOptions: r,
      hasDatasets: o,
      isTable: l,
      chartTypeComputed: t
    };
  },
  computed: {
    chartOptions() {
      return J({}, this.defaultOptions, this.options);
    },
    hasTableData() {
      var e, t;
      return (t = (e = this.data) == null ? void 0 : e.columns) == null ? void 0 : t.length;
    }
  }
}, RI = { class: "c-share-of-voice__table" }, BI = { class: "c-share-of-voice__table--header-row" };
function FI(e, t, n, s, i, a) {
  const r = R("ChartWithLegendLayout"), o = R("DataTable"), l = R("Chart");
  return ["table", "key_insight"].includes(n.visualisationType) ? (_(), I(r, B({ key: 0 }, e.$props, {
    "has-data": a.hasTableData,
    class: "c-share-of-voice"
  }), {
    chart: N(() => [
      k("div", RI, [
        (_(!0), S(st, null, _t(e.data.columns, (c, d) => (_(), S("div", {
          key: d,
          class: W(["c-share-of-voice__table-column", {
            "c-share-of-voice__table-column--left": c.left,
            "c-share-of-voice__table-column--center": c.center,
            "c-share-of-voice__table-column--right": c.right
          }])
        }, [
          k("div", BI, L(c.title), 1),
          (_(!0), S(st, null, _t(c.rows, (h, u) => (_(), S("div", {
            key: u,
            class: W(`c-share-of-voice__table-row${c.left ? "--left" : ""}`)
          }, L(h), 3))), 128))
        ], 2))), 128))
      ])
    ]),
    _: 1
  }, 16, ["has-data"])) : (_(), I(r, B({ key: 1 }, e.$props, {
    legend: s.chartLegend,
    "has-data": s.hasDatasets,
    class: s.chartLayoutClass
  }), {
    chart: N(() => [
      s.isTable ? (_(), I(o, ce(B({ key: 0 }, e.data)), null, 16)) : (_(), I(l, {
        key: 1,
        type: s.chartTypeComputed,
        data: e.data,
        options: a.chartOptions,
        style: vt(s.chartStyle),
        class: W(s.chartClass),
        onChartClicked: t[0] || (t[0] = (c) => e.$emit("chart-clicked", c)),
        "onChart:render": t[1] || (t[1] = (c) => e.$emit("chart:render", c))
      }, null, 8, ["type", "data", "options", "style", "class"]))
    ]),
    _: 1
  }, 16, ["legend", "has-data", "class"]));
}
const WI = /* @__PURE__ */ X(II, [["render", FI]]), NI = {
  name: "ShareOfVoiceTimeline",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V,
    DataTable: ft
  },
  props: {
    ...lt,
    ...gt,
    includeCountInLegend: {
      type: Boolean
    },
    chartType: {
      type: String,
      default: "line"
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    return xt(e, {
      isHistogram: !0
    });
  },
  computed: {
    chartOptions() {
      return J({}, this.defaultOptions, this.options);
    },
    formattedLegend() {
      return this.includeCountInLegend ? this.chartLegend : this.legend.map(({ color: e, label: t }) => ({
        color: e,
        label: ui(t)
      }));
    }
  }
};
function zI(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("Chart"), l = R("ChartWithLegendLayout");
  return _(), I(l, B(e.$props, {
    "has-data": e.hasDatasets,
    legend: a.formattedLegend,
    class: e.chartLayoutClass
  }), {
    chart: N(() => [
      e.isTable ? (_(), I(r, ce(B({ key: 0 }, e.data)), null, 16)) : (_(), I(o, {
        key: 1,
        type: n.chartType,
        data: e.data,
        options: a.chartOptions,
        class: W(e.chartClass),
        onChartClicked: t[0] || (t[0] = (c) => e.$emit("chart-clicked", c)),
        "onChart:render": t[1] || (t[1] = (c) => e.$emit("chart:render", c))
      }, null, 8, ["type", "data", "options", "class"]))
    ]),
    _: 1
  }, 16, ["has-data", "legend", "class"]);
}
const jI = /* @__PURE__ */ X(NI, [["render", zI]]), HI = {
  name: "SpokespeoplePresence",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    ...lt,
    ...gt,
    chartType: {
      type: String,
      default: "barStacked"
    },
    truncateLabelsAt: {
      type: Number,
      default: 20
    }
  },
  emits: ["chart-clicked", "chart:render"],
  setup(e) {
    return xt(e);
  },
  data() {
    return {
      plugins: [Sr]
    };
  },
  computed: {
    chartOptions() {
      const { legend: e, defaultOptions: t } = this;
      return J({}, t, {
        plugins: {
          datalabels: {
            anchor: "end",
            align(s) {
              const { dataIndex: i } = s;
              return s.dataset.data[i] <= 10 ? "top" : "bottom";
            },
            clamp: !0,
            color: "#3E4860",
            formatter(s) {
              return `${s}%`;
            },
            font: {
              size: 11
            }
          },
          tooltip: {
            callbacks: {
              title(s) {
                return s[0].label;
              },
              label(s) {
                const { label: i } = e[s.datasetIndex];
                return `${i}: ${s.raw}%`;
              }
            }
          }
        },
        scales: {
          y: {
            ticks: {
              font: {
                size: 11
              },
              min: 0,
              max: 100,
              stepSize: 25,
              callback: (s) => `${s}%`
            }
          }
        }
      }, this.options);
    }
  }
};
function VI(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": e.hasDatasets,
    class: e.chartLayoutClass
  }), {
    chart: N(() => [
      Y(r, {
        type: n.chartType,
        data: e.data,
        options: a.chartOptions,
        plugins: i.plugins,
        class: W(e.chartClass),
        "onChart:render": t[0] || (t[0] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["type", "data", "options", "plugins", "class"])
    ]),
    _: 1
  }, 16, ["has-data", "class"]);
}
const YI = /* @__PURE__ */ X(HI, [["render", VI]]), GI = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ionicon",
  viewBox: "0 0 512 512"
}, UI = /* @__PURE__ */ k("path", { d: "M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256m131.83 176H204.18a27.71 27.71 0 0 1-22-10.67 30.22 30.22 0 0 1-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 0 1-5.32 25.78A27.68 27.68 0 0 1 467.83 432M147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91m65.66 31.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 0 0 4.79 23.36A25.32 25.32 0 0 0 41.72 400h111a8 8 0 0 0 7.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 0 0-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89" }, null, -1), XI = [
  UI
];
function qI(e, t) {
  return _(), S("svg", GI, [...XI]);
}
const KI = { render: qI }, QI = { key: 0 }, JI = { key: 1 }, ZI = { class: "c-top-articles-table__row" }, tR = ["onMouseenter"], eR = {
  key: 0,
  class: "c-top-articles-table__stat__icon c-top-articles-table__stat__icon-ave"
}, nR = { key: 1 }, sR = ["href"], iR = ["onClick"], aR = {
  key: 2,
  class: "c-top-articles-table__source"
}, rR = ["src"], oR = /* @__PURE__ */ k("div", { class: "c-top-articles-table__source-bullet" }, null, -1), lR = "$", cR = /* @__PURE__ */ Object.assign({
  name: "TopArticlesTable"
}, {
  __name: "TopArticlesTable",
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["chart-clicked"],
  setup(e, { emit: t }) {
    const n = {
      AVE: "advertisement_rate",
      AUDIENCE: "audience"
    }, s = e, i = t, a = P(() => {
      var x;
      return (x = s.data) == null ? void 0 : x.columns[0];
    }), r = P(
      () => {
        var x;
        return (x = s.data) == null ? void 0 : x.columns.find((C) => C.type === n.AVE);
      }
    ), o = P(
      () => {
        var x;
        return (x = s.data) == null ? void 0 : x.columns.find((C) => C.type === n.AUDIENCE);
      }
    ), l = P(() => {
      var x, C;
      return (x = s.data) != null && x.sortBy ? (C = s.data) == null ? void 0 : C.sortBy : r.value ? n.AVE : n.AUDIENCE;
    }), c = yt(l.value);
    Us(c, () => {
      i("chart-clicked", {
        action: "statChanged",
        value: c.value
      });
    });
    const d = P(
      () => {
        var x;
        return ((x = s.data) == null ? void 0 : x.currencySymbol) || lR;
      }
    ), h = P(
      () => {
        var x, C;
        return !!((C = (x = s.data) == null ? void 0 : x.columns) != null && C.length && s.data.columns[0].rows.length);
      }
    ), u = P(() => {
      const x = [
        {
          label: o.value.heading,
          value: n.AUDIENCE
        }
      ];
      return r.value && x.unshift({
        label: r.value.heading,
        value: n.AVE
      }), x;
    }), f = P(
      () => u.value.find((x) => x.value === c.value)
    ), g = P(() => {
      const { data: x } = s;
      let C = o.value;
      return c.value === n.AVE && r.value && (C = r.value), {
        ...x,
        columns: [a.value, C]
      };
    });
    function m(x) {
      i("chart-clicked", {
        action: "articleClicked",
        value: x.articles.source
      });
    }
    function p(x) {
      const C = {
        id: "articles",
        value: x.articles.source,
        classNames: ["c-datatable__column", "c-top-articles-table__title"],
        onClick: m
      }, O = c.value === n.AVE ? x.ave.source : x.audience.source, M = {
        id: c.value,
        value: O.value,
        tooltip: O.tooltip,
        classNames: ["c-datatable__column", "c-top-articles-table__stat"]
      };
      return [C, M];
    }
    const { showTooltip: b, hideTooltip: y } = Ea();
    function v(x, C) {
      const O = {
        size: 14,
        family: "Roboto, sans-serif"
      };
      b(x, {
        text: C.body,
        title: C == null ? void 0 : C.title,
        offsetY: 35,
        options: {
          maxWidth: 350,
          padding: {
            y: 12,
            x: 12
          },
          bodyFont: {
            ...O,
            color: "#707889"
          },
          titleFont: {
            ...O,
            color: "#3E475E"
          }
        }
      });
    }
    const w = P(() => {
      var x;
      return {
        "--top-articles-table-spacing": (x = s.data) != null && x.reportView ? "8px" : "16px"
      };
    });
    return (x, C) => (_(), I(T(V), B(x.$props, { "has-data": h.value }), {
      chart: N(() => [
        Y(T(ft), B(g.value, {
          class: "c-top-articles-table",
          style: w.value
        }), {
          heading: N(({ column: O }) => {
            var M;
            return [
              O.key === "articles" ? (_(), S("div", QI, L(O.heading), 1)) : (M = e.data) != null && M.reportView || u.value.length === 1 ? (_(), S("div", JI, L(f.value.label), 1)) : (_(), I(T(Pc), {
                key: 2,
                modelValue: c.value,
                "onUpdate:modelValue": C[0] || (C[0] = (A) => c.value = A),
                options: u.value
              }, null, 8, ["modelValue", "options"]))
            ];
          }),
          row: N(({ row: O }) => [
            k("div", ZI, [
              (_(!0), S(st, null, _t(p(O), (M) => (_(), S(st, {
                key: M.id
              }, [
                M.id !== "articles" ? (_(), S("div", {
                  key: 0,
                  class: W(M.classNames)
                }, [
                  k("div", {
                    class: "c-top-articles-table__stat-wrapper",
                    onMouseleave: C[1] || (C[1] = (...A) => T(y) && T(y)(...A)),
                    onMouseenter: (A) => v(A, M.tooltip)
                  }, [
                    c.value === n.AVE ? (_(), S("div", eR, L(d.value), 1)) : (_(), I(T(KI), {
                      key: 1,
                      class: "c-top-articles-table__stat__icon c-top-articles-table__stat__icon-audience"
                    })),
                    k("span", null, L(M.value), 1)
                  ], 40, tR)
                ], 2)) : (_(), S("div", nR, [
                  M.value.url ? (_(), S("a", {
                    key: 0,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    href: M.value.url,
                    class: W(M.classNames)
                  }, L(M.value.title), 11, sR)) : (_(), S("div", {
                    key: 1,
                    class: W(M.classNames),
                    onClick: (A) => {
                      var $;
                      return ($ = M.onClick) == null ? void 0 : $.call(M, O);
                    }
                  }, L(M.value.title), 11, iR)),
                  M.value.source ? (_(), S("div", aR, [
                    k("img", {
                      class: "c-top-articles-table__source-logo",
                      src: M.value.source.logo
                    }, null, 8, rR),
                    k("div", null, L(M.value.source.name), 1),
                    M.value.medium ? (_(), S(st, { key: 0 }, [
                      oR,
                      Ye(" " + L(M.value.medium), 1)
                    ], 64)) : rt("", !0)
                  ])) : rt("", !0)
                ]))
              ], 64))), 128))
            ])
          ]),
          _: 1
        }, 16, ["style"])
      ]),
      _: 1
    }, 16, ["has-data"]));
  }
}), dR = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ionicon",
  viewBox: "0 0 512 512"
}, hR = /* @__PURE__ */ k("path", { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48m108.25 138.29-134.4 160a16 16 0 0 1-12 5.71h-.27a16 16 0 0 1-11.89-5.3l-57.6-64a16 16 0 1 1 23.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0 1 24.5 20.58" }, null, -1), uR = [
  hR
];
function fR(e, t) {
  return _(), S("svg", dR, [...uR]);
}
const gR = { render: fR }, pR = {
  name: "TopFacebookPages",
  components: {
    PlatformAvatar: hi,
    IconCheckMarkCircle: gR,
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    interactionEnabled: {
      type: Boolean
    }
  },
  emits: ["chart-clicked"],
  computed: {
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  }
}, mR = { class: "c-top-facebook-pages__row" }, bR = { class: "c-datatable__column c-datatable__column--auto c-datatable__column--left" }, yR = { class: "c-top-facebook-pages__facebook-page-profile" }, _R = { class: "c-top-facebook-pages__column" }, vR = { class: "c-top-facebook-pages__facebook-page-name" }, xR = { class: "c-top-facebook-pages__facebook-page-username" }, wR = { class: "c-datatable__column c-top-facebook-pages__follower-column" }, kR = { class: "c-top-facebook-pages__facebook-page-followers" };
function CR(e, t, n, s, i, a) {
  const r = R("PlatformAvatar"), o = R("IconCheckMarkCircle"), l = R("DataTable"), c = R("ChartWithLegendLayout");
  return _(), I(c, B(e.$props, { "has-data": a.hasData }), {
    chart: N(() => [
      Y(l, B(n.data, {
        "interaction-enabled": n.interactionEnabled,
        class: "c-top-facebook-pages",
        onChartClicked: t[0] || (t[0] = (d) => e.$emit("chart-clicked", d))
      }), {
        row: N(({ row: d }) => [
          k("div", mR, [
            k("div", bR, [
              k("div", yR, [
                Y(r, {
                  platform: "facebook",
                  username: d.page.source.username
                }, null, 8, ["username"]),
                k("div", _R, [
                  k("div", vR, [
                    Ye(L(d.page.source.name) + " ", 1),
                    d.page.source.verified ? (_(), I(o, { key: 0 })) : rt("", !0)
                  ]),
                  k("div", xR, L(d.page.source.username), 1)
                ])
              ])
            ]),
            k("div", wR, [
              k("span", kR, L(d.likes.source), 1)
            ])
          ])
        ]),
        _: 1
      }, 16, ["interaction-enabled"])
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const SR = /* @__PURE__ */ X(pR, [["render", CR]]), MR = {
  name: "TopIssues",
  components: {
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["chart-clicked"],
  computed: {
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.columns) != null && t.length && this.data.columns[0].rows.length);
    }
  },
  methods: {
    addIndexOffset(e) {
      return Number(e) + 1;
    }
  }
}, OR = { class: "c-datatable__column c-datatable__column--left c-top-issues__column" }, TR = { class: "c-datatable__number" }, PR = { class: "c-datatable__text" };
function AR(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-datatable"
  }), {
    chart: N(() => [
      Y(r, B({ ...e.$attrs, ...n.data }, {
        class: "c-datatable__table",
        onChartClicked: t[0] || (t[0] = (l) => e.$emit("chart-clicked", l))
      }), {
        row: N(({ row: l, rowIndex: c }) => [
          k("div", OR, [
            k("span", TR, L(a.addIndexOffset(c)), 1),
            k("span", PR, L(l.column_0.source), 1)
          ])
        ]),
        _: 1
      }, 16)
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const $R = /* @__PURE__ */ X(MR, [["render", AR]]), DR = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ionicon",
  viewBox: "0 0 512 512"
}, LR = /* @__PURE__ */ k("path", { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48m108.25 138.29-134.4 160a16 16 0 0 1-12 5.71h-.27a16 16 0 0 1-11.89-5.3l-57.6-64a16 16 0 1 1 23.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0 1 24.5 20.58" }, null, -1), ER = [
  LR
];
function IR(e, t) {
  return _(), S("svg", DR, [...ER]);
}
const RR = { render: IR }, BR = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}, FR = /* @__PURE__ */ k("path", { d: "M176 224c26.51 0 48-21.49 48-48 0-26.509-21.49-48-48-48-26.509 0-48 21.491-48 48 0 26.51 21.491 48 48 48M272 320l-48-64-96 128h384L368 192z" }, null, -1), WR = /* @__PURE__ */ k("path", { d: "M576 0H64C28.704 0 0 28.704 0 64v384c0 35.296 28.704 64 64 64h512c35.296 0 64-28.704 64-64V64c0-35.296-28.704-64-64-64M64 448V64h512l.064 384z" }, null, -1), NR = [
  FR,
  WR
];
function zR(e, t) {
  return _(), S("svg", BR, [...NR]);
}
const jR = { render: zR }, HR = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 788 512"
}, VR = /* @__PURE__ */ k("path", { d: "M557.269 393.914c-19.651-7.019-51.761-7.37-65.974-12.809-9.825-3.86-25.442-8.071-30.53-14.213s-5.088-50.006-5.088-50.006 12.282-11.581 17.37-24.565c5.089-12.809 8.423-48.252 8.423-48.252s11.58 4.912 16.142-18.249c3.86-20.002 11.23-30.53 9.3-45.269-2.106-14.739-10.177-11.23-10.177-11.23s10.177-14.914 10.177-65.623C506.912 51.411 467.433 0 393.563 0c-73.695 0-113.525 51.586-113.525 103.698 0 50.709 10.002 65.623 10.002 65.623s-8.247-3.509-10.177 11.23c-2.106 14.739 5.264 25.267 9.299 45.269 4.562 23.337 16.143 18.249 16.143 18.249s3.334 35.268 8.422 48.252 17.371 24.565 17.371 24.565 0 43.865-5.088 50.006c-5.089 6.142-20.705 10.353-30.531 14.037-14.037 5.44-46.147 6.142-65.974 13.16-19.652 7.019-80.362 38.953-80.362 117.911h488.313c.175-79.134-60.535-111.068-80.187-118.086" }, null, -1), YR = /* @__PURE__ */ k("path", { d: "M190.377 308.463s41.936-1.403 58.605-16.318c-27.197-41.233-12.458-89.31-18.073-134.229-5.615-44.743-31.057-71.588-81.941-71.588h-.702c-49.13 0-75.624 26.67-81.24 71.588-5.614 44.743 10.002 98.26-17.896 134.229 16.669 15.09 58.78 14.564 58.78 14.564s1.754 25.266-1.755 29.477-13.862 8.247-21.056 9.651c-15.44 3.334-31.758 7.896-45.444 12.633C25.968 363.208 0 388.65 0 423.742h140.897c3.86-14.037 30.355-39.128 56.148-52.288 15.791-8.071 31.407-7.544 43.339-9.124 0 0 6.667-10.527-15.265-14.563 0 0-30.18-7.545-33.689-11.756-3.334-3.86-1.053-27.548-1.053-27.548m407.073 0s-41.935-1.403-58.604-16.318c27.197-41.233 12.458-89.31 18.072-134.229 5.615-44.743 31.057-71.588 81.942-71.588h.701c49.13 0 75.625 26.67 81.24 71.588 5.614 44.743-10.002 98.26 17.897 134.229-16.669 15.09-58.78 14.564-58.78 14.564s-1.755 25.266 1.754 29.477 13.862 8.247 21.056 9.651c15.441 3.334 31.759 7.896 45.445 12.633 13.686 4.738 39.654 30.18 39.654 65.272H646.931c-3.86-14.037-30.355-39.128-56.148-52.288-15.792-8.071-31.408-7.544-43.339-9.124 0 0-6.668-10.527 15.265-14.563 0 0 30.179-7.545 33.689-11.756 3.333-3.86 1.052-27.548 1.052-27.548" }, null, -1), GR = [
  VR,
  YR
];
function UR(e, t) {
  return _(), S("svg", HR, [...GR]);
}
const XR = { render: UR }, qR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none"
}, KR = /* @__PURE__ */ k("path", {
  fill: "#89909F",
  d: "M3.75 4h5.5v1.2h-5.5zm0 2.4H7.6v1.2H3.75z"
}, null, -1), QR = /* @__PURE__ */ k("path", {
  fill: "#89909F",
  d: "M10.9 1H2.1C1.493 1 1 1.538 1 2.2V13l2.933-2.4H10.9c.607 0 1.1-.538 1.1-1.2V2.2c0-.662-.493-1.2-1.1-1.2m0 8.4H3.567L2.1 10.6V2.2h8.8z"
}, null, -1), JR = [
  KR,
  QR
];
function ZR(e, t) {
  return _(), S("svg", qR, [...JR]);
}
const t5 = { render: ZR }, e5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none"
}, n5 = /* @__PURE__ */ k("path", {
  fill: "#89909F",
  d: "M8.934 1C7.886 1 6.991 1.855 6.5 2.444 6.007 1.855 5.114 1 4.066 1 2.261 1 1 2.44 1 4.502c0 2.272 1.566 3.74 3.08 5.16.715.672 1.455 1.366 2.023 2.135a.48.48 0 0 0 .382.203h.029a.48.48 0 0 0 .382-.203c.569-.77 1.308-1.463 2.023-2.134C10.434 8.243 12 6.775 12 4.503 12 2.44 10.74 1 8.934 1"
}, null, -1), s5 = [
  n5
];
function i5(e, t) {
  return _(), S("svg", e5, [...s5]);
}
const a5 = { render: i5 }, r5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "13",
  fill: "none"
}, o5 = /* @__PURE__ */ k("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ k("path", {
    fill: "#89909F",
    d: "M12 4.09 8.53 7.183V4.818H3.634v4.727L2 11V4.818c0-.386.172-.756.478-1.028a1.74 1.74 0 0 1 1.155-.426H8.53V1z"
  })
], -1), l5 = /* @__PURE__ */ k("defs", null, [
  /* @__PURE__ */ k("clipPath", { id: "a" }, [
    /* @__PURE__ */ k("path", {
      fill: "#fff",
      d: "M0 0h14v13H0z"
    })
  ])
], -1), c5 = [
  o5,
  l5
];
function d5(e, t) {
  return _(), S("svg", r5, [...c5]);
}
const h5 = { render: d5 }, u5 = {
  name: "TopPlatformPosts",
  components: {
    ChartWithLegendLayout: V,
    DataTable: ft,
    IconPeople: XR,
    IconPlatformLike: a5,
    IconPlatformComment: t5,
    IconPlatformShare: h5,
    IconImage: jR,
    PlatformAvatar: hi,
    IconCheckMarkCircle: RR
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["chart-clicked"],
  computed: {
    platformType() {
      var e;
      return (e = this.data) == null ? void 0 : e.platform;
    },
    tableData() {
      return {
        columns: [
          {
            rows: this.data.top_platform_posts
          }
        ]
      };
    },
    hasData() {
      var e, t;
      return !!((t = (e = this.data) == null ? void 0 : e.top_platform_posts) != null && t.length);
    }
  }
}, f5 = { class: "c-top-platform-posts__row" }, g5 = { class: "c-top-platform-posts__rank" }, p5 = { class: "c-top-platform-posts__post-container" }, m5 = { class: "c-top-platform-posts__post-details" }, b5 = ["onClick"], y5 = { class: "c-top-platform-posts__post-avatar" }, _5 = { class: "c-top-platform-posts__post-username" }, v5 = {
  key: 0,
  class: "c-top-platform-posts__post-verified"
}, x5 = { class: "c-top-platform-posts__post-stats" }, w5 = { class: "c-top-platform-posts__post-stat" }, k5 = { class: "c-top-platform-posts__post-stats" }, C5 = {
  key: 0,
  class: "c-top-platform-posts__post-attachment"
}, S5 = { class: "c-top-platform-posts__post-stat" }, M5 = { class: "c-top-platform-posts__post-stat" }, O5 = { class: "c-top-platform-posts__post-stat" }, T5 = ["onClick"], P5 = { class: "c-top-platform-posts__post-body" };
function A5(e, t, n, s, i, a) {
  const r = R("PlatformAvatar"), o = R("IconCheckMarkCircle"), l = R("IconPeople"), c = R("IconImage"), d = R("IconPlatformLike"), h = R("IconPlatformComment"), u = R("IconPlatformShare"), f = R("DataTable"), g = R("ChartWithLegendLayout");
  return _(), I(g, B(e.$props, { "has-data": a.hasData }), {
    chart: N(() => [
      Y(f, B(a.tableData, { class: "c-top-platform-posts" }), {
        row: N(({ row: m }) => [
          k("div", f5, [
            k("div", g5, L(m.column_0.source.index), 1),
            k("div", p5, [
              k("div", m5, [
                k("div", {
                  class: "c-top-platform-posts__post-profile",
                  onClick: (p) => e.$emit("chart-clicked", {
                    attribute: "username",
                    data: m.column_0.source
                  })
                }, [
                  k("div", y5, [
                    Y(r, {
                      platform: a.platformType,
                      username: m.column_0.source.username,
                      "avatar-url": m.column_0.source.author_avatar_image
                    }, null, 8, ["platform", "username", "avatar-url"])
                  ]),
                  k("div", _5, [
                    k("span", null, L(m.column_0.source.username), 1),
                    m.column_0.source.verified ? (_(), S("div", v5, [
                      Y(o)
                    ])) : rt("", !0)
                  ]),
                  k("div", x5, [
                    k("div", w5, [
                      Y(l),
                      k("span", null, L(m.column_0.source.follower_count), 1)
                    ])
                  ])
                ], 8, b5),
                k("div", k5, [
                  m.column_0.source.has_assets ? (_(), S("div", C5, [
                    Y(c)
                  ])) : rt("", !0),
                  k("div", S5, [
                    Y(d),
                    k("span", null, L(m.column_0.source.like_count), 1)
                  ]),
                  k("div", M5, [
                    Y(h),
                    k("span", null, L(m.column_0.source.comment_count), 1)
                  ]),
                  k("div", O5, [
                    Y(u),
                    k("span", null, L(m.column_0.source.share_count), 1)
                  ])
                ])
              ]),
              k("div", {
                class: "c-top-platform-posts__post-content",
                onClick: (p) => e.$emit("chart-clicked", {
                  attribute: "url",
                  data: m.column_0.source
                })
              }, [
                k("div", P5, [
                  k("span", null, L(m.column_0.source.body), 1)
                ])
              ], 8, T5)
            ])
          ])
        ]),
        _: 1
      }, 16)
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const $5 = /* @__PURE__ */ X(u5, [["render", A5]]), D5 = {
  name: "TopSources",
  components: {
    DataTable: ft,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      truncateRowsAt: 28,
      rowMaxLength: 30
    };
  },
  computed: {
    hasData() {
      var e, t;
      return (t = (e = this.data) == null ? void 0 : e.datasets) == null ? void 0 : t.some((n) => {
        var s;
        return (s = n.columns) == null ? void 0 : s.length;
      });
    },
    tableData() {
      return this.data.datasets.map((e) => ({
        columns: e.columns.map(({ heading: n, rows: s }) => ({
          heading: n,
          rows: s.map(
            (i, a) => `${a + 1}. ${an(i, this.truncateRowsAt, this.rowMaxLength)}`
          ),
          style: {
            padding: "2px 0",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "14px"
          },
          headingStyle: {
            padding: "8px 0",
            fontSize: "14px",
            fontWeight: "500"
          }
        }))
      }));
    }
  }
};
function L5(e, t, n, s, i, a) {
  const r = R("DataTable"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-top-sources"
  }), {
    chart: N(() => [
      (_(!0), S(st, null, _t(a.tableData, (l, c) => (_(), S("div", {
        key: c,
        class: "c-top-sources__media-type"
      }, [
        Y(r, B(l, { class: "c-top-sources__table" }), null, 16)
      ]))), 128))
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const E5 = /* @__PURE__ */ X(D5, [["render", L5]]), I5 = {
  name: "VolumeOfCoverageByPosition",
  components: {
    Chart: ut,
    ChartWithLegendLayout: V
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    medium: {
      type: String,
      required: !0,
      validator(e) {
        return ["Print", "Online"].includes(e);
      }
    },
    options: {
      type: Object,
      default: () => ({})
    },
    legend: {
      type: Array,
      default: () => []
    },
    title: {
      type: [Number, String],
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    legendLayout: {
      type: String,
      default: "inline",
      validator(e) {
        return ["column", "inline"].includes(e);
      }
    },
    interactionEnabled: {
      type: Boolean
    }
  },
  emits: ["chart-clicked", "chart:render"],
  computed: {
    timezone() {
      return this.options.time_zone || "Australia/Sydney";
    },
    hasData() {
      var e, t;
      return (t = (e = this.data) == null ? void 0 : e.datasets) == null ? void 0 : t.some((n) => {
        var s;
        return (s = n.data) == null ? void 0 : s.length;
      });
    },
    chartOptions() {
      const { dateFormatter: e, numberFormatter: t } = this, n = {
        plugins: {
          clickevents: this.interactionEnabled && {
            mode: "index",
            callback: (s) => {
              this.$emit("chart-clicked", s);
            }
          },
          tooltip: {
            callbacks: {
              title(s) {
                return e(s[0].label);
              }
            },
            itemSort(s, i) {
              return i.datasetIndex - s.datasetIndex;
            }
          }
        },
        scales: {
          x: {
            ticks: {
              callback(s) {
                return e(this.getLabelForValue(s));
              }
            }
          },
          y: {
            position: "left",
            ticks: {
              callback(s) {
                return t(s);
              }
            }
          }
        }
      };
      return J({}, n, this.options);
    }
  },
  methods: {
    dateFormatter(e) {
      var t;
      return (t = this.data.labels) != null && t.length ? Dh(new Date(e), {
        day: "2-digit",
        month: "short",
        hour12: !0,
        hourCycle: "h12",
        timeZone: this.timezone
      }) : "";
    },
    numberFormatter(e) {
      return e.toLocaleString();
    }
  }
};
function R5(e, t, n, s, i, a) {
  const r = R("Chart"), o = R("ChartWithLegendLayout");
  return _(), I(o, B(e.$props, {
    "has-data": a.hasData,
    class: "c-volume-of-coverage-by-position"
  }), {
    chart: N(() => [
      Y(r, {
        type: "barStacked",
        data: n.data,
        options: a.chartOptions,
        title: n.title,
        text: n.text,
        class: "c-chart-layout__chart u__flex-auto",
        "onChart:render": t[0] || (t[0] = (l) => e.$emit("chart:render", l))
      }, null, 8, ["data", "options", "title", "text"])
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const B5 = /* @__PURE__ */ X(I5, [["render", R5]]), F5 = (e) => {
  if (!e || e.length === 0)
    return [];
  const t = Math.min(...e), n = Math.max(...e);
  return t === n ? e.map(() => 1) : e.map((s) => (s - t) / (n - t));
}, W5 = 10, N5 = {
  name: "WordCloud",
  components: {
    ChartWithLegendLayout: V
  },
  props: {
    words: {
      type: Array,
      required: !0,
      validator(e) {
        return e.length === 0 || Array.isArray(e[0]) || typeof e[0] == "object";
      }
    },
    legend: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    },
    wordColor: {
      type: String,
      default: "#131B62"
    },
    activeWordColor: {
      type: String,
      default: "#FF7875"
    },
    clickDisabled: {
      type: Boolean
    }
  },
  emits: ["word-clicked", "chart-clicked"],
  data() {
    return {
      placedWords: [],
      wordCloudWidth: 0,
      wordCloudHeight: 0,
      cloudWords: []
    };
  },
  computed: {
    cloudOptions() {
      const { wordCloud: e } = this.$refs;
      if (!e)
        return {};
      const t = {
        width: this.wordCloudWidth,
        height: this.wordCloudHeight,
        center: {
          x: this.wordCloudWidth / 2,
          y: this.wordCloudHeight / 2
        },
        removeOverflowing: !0,
        weights: 0
      };
      return Object.assign(t, this.options);
    },
    wordClassName() {
      return `c-word-cloud-${this._uid}-word`;
    },
    activeWordClassName() {
      return `${this.wordClassName}__active`;
    },
    styleText() {
      return `
        .${this.wordClassName}:hover { color:${this.activeWordColor} !important; }
        .${this.activeWordClassName} { color:${this.activeWordColor} !important; }
      `;
    }
  },
  watch: {
    words: {
      immediate: !0,
      handler() {
        this.cloudWords = this.words.slice(0), this.drawWordCloud();
      }
    },
    styleText: {
      immediate: !0,
      async handler() {
        if (await this.$nextTick(), !this.$el)
          return;
        let e = this.$el.querySelector("style");
        e || (e = document.createElement("style"), this.$el.appendChild(e)), e.innerText = this.styleText;
      }
    }
  },
  mounted() {
    this.drawWordCloud(), this.handleResize = Uh(() => this.drawWordCloud(), 300), this.attachEvents();
  },
  beforeUnmount() {
    this.detachEvents();
  },
  methods: {
    attachEvents() {
      window.addEventListener("resize", this.handleResize, !1), window.addEventListener("click", this.removeActiveState, !1);
    },
    detachEvents() {
      window.removeEventListener("resize", this.handleResize, !1), window.removeEventListener("click", this.removeActiveState, !1);
    },
    // Pairwise overlap detection
    overlapping(e, t) {
      const n = Math.abs(
        2 * e.offsetLeft + e.offsetWidth - 2 * t.offsetLeft - t.offsetWidth
      ), s = Math.abs(
        2 * e.offsetTop + e.offsetHeight - 2 * t.offsetTop - t.offsetHeight
      );
      return n < e.offsetWidth + t.offsetWidth && s < e.offsetHeight + t.offsetHeight;
    },
    // Check elements for overlap one by one, stop and return false as soon as an overlap is found
    hitTest(e, t) {
      for (let n = 0; n < t.length; n += 1)
        if (this.overlapping(e, t[n]))
          return !0;
      return !1;
    },
    processWords(e, t = null) {
      const n = Array.isArray(e[0]) ? e[t] : e;
      if (!n)
        return [];
      const s = t !== null && this.legend[t] ? {
        color: this.legend[t].color,
        streamId: this.legend[t].stream_id
      } : null, i = n.map((r) => r.weight), a = F5(i);
      return n.map((r, o) => ({
        ...r,
        weight: a[o],
        color: (s == null ? void 0 : s.color) || this.wordColor,
        streamId: (s == null ? void 0 : s.streamId) || r.stream_id
      }));
    },
    drawWordCloud() {
      const { wordCloud: e } = this.$refs;
      if (!e)
        return;
      this.wordCloudWidth = e.offsetWidth, this.wordCloudHeight = e.offsetHeight, e.innerHTML = "";
      const t = Array.isArray(this.words[0]);
      let n = [];
      t ? this.words.forEach((i, a) => {
        n = [
          ...n,
          ...this.processWords(i, a)
        ];
      }) : n = this.processWords(this.words);
      const s = /* @__PURE__ */ new Map();
      n.forEach((i) => {
        const a = i.word.toLowerCase();
        (!s.has(a) || s.get(a).weight < i.weight) && s.set(a, i);
      }), this.cloudWords = Array.from(s.values()), this.cloudWords.sort((i, a) => a.weight - i.weight), this.cloudWords.forEach(this.drawWord);
    },
    drawWord(e, t) {
      const n = Math.round(e.weight * (W5 - 1)) + 1;
      let s = 6.28 * Math.random(), i = 0;
      const a = document.createElement("a");
      a.innerText = e.word, this.clickDisabled || (a.classList.add(this.wordClassName), a.onclick = this.performSearchForTerm(a).bind(this)), a.classList.add("c-word-cloud__word"), a.classList.add(`w${n}`), this.$refs.wordCloud.appendChild(a), this.cloudOptions.weights && (a.style.fontSize = this.cloudOptions.weights[n - 1]), a.style.color = e.color || this.wordColor;
      const r = a.offsetWidth, o = a.offsetHeight;
      let l = this.cloudOptions.center.x - r / 2, c = this.cloudOptions.center.y - o / 2;
      const d = a.style;
      d.position = "absolute", d.left = `${l}px`, d.top = `${c}px`;
      const h = this.cloudOptions.width / this.cloudOptions.height, u = 2;
      for (; this.hitTest(a, this.placedWords); )
        i += u, s += (t % 2 === 0 ? 1 : -1) * u, l = this.cloudOptions.center.x - r / 2 + i * Math.cos(s) * h, c = this.cloudOptions.center.y + i * Math.sin(s) - o / 2, d.left = `${l}px`, d.top = `${c}px`;
      if (this.cloudOptions.removeOverflowing && (l < 0 || c < 0 || l + r > this.cloudOptions.width || c + o > this.cloudOptions.height)) {
        a.remove();
        return;
      }
      this.placedWords.push(a);
    },
    removeActiveState() {
      this.placedWords.forEach((e) => {
        e.classList.remove(this.activeWordClassName);
      });
    },
    performSearchForTerm(e) {
      return (t) => {
        t.stopPropagation(), document.body.click();
        const n = t.target.innerText, s = this.cloudWords.find(
          ({ word: i }) => i === n
        );
        e.classList.add(this.activeWordClassName), this.$emit("word-clicked", n), this.$emit("chart-clicked", s);
      };
    }
  }
}, z5 = {
  ref: "wordCloud",
  class: "c-word-cloud"
};
function j5(e, t, n, s, i, a) {
  const r = R("ChartWithLegendLayout");
  return _(), I(r, B(e.$props, {
    "has-data": !!n.words.length
  }), {
    chart: N(() => [
      k("div", z5, null, 512)
    ]),
    _: 1
  }, 16, ["has-data"]);
}
const H5 = /* @__PURE__ */ X(N5, [["render", j5]]), V5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AdvertisingValueEquivalency: WM,
  BroadcastTimeByMediaType: P$,
  CoverageByMediaType: I$,
  CoverageVolumeAndPotentialAudienceReach: U$,
  CoverageVolumeAndStockPrice: bD,
  CoverageVolumeTimeline: Gh,
  DataTableWithChange: LD,
  DataTableWithChangeAcrossPeriods: eL,
  DesktopVsMobileReadership: rL,
  DomainAuthority: oL,
  EmojiCount: pL,
  GeographicSpread: ML,
  KeyInsights: EL,
  KeyMessages: IL,
  KeyPlatformInfluencers: QL,
  KeyQueries: tE,
  KeyQueriesTimeline: sE,
  LeadingMediaOutlets: rE,
  LeadingSources: cE,
  MediaVolumeTable: uE,
  MentionBenchmarkTimeline: LE,
  OutreachCoverageTimeline: lI,
  OutreachPerformanceTable: fI,
  OutreachTopEngagedContactsTable: MI,
  PotentialAudienceReach: OI,
  ProgressPie: AI,
  ReactScoreBreakdown: $I,
  SentimentBenchmark: DI,
  SentimentBreakdown: LI,
  SentimentTimeline: EI,
  ShareOfVoice: WI,
  ShareOfVoiceTimeline: jI,
  SpokespeoplePresence: YI,
  TopArticlesTable: cR,
  TopFacebookPages: SR,
  TopIssues: $R,
  TopPlatformPosts: $5,
  TopSources: E5,
  VolumeOfCoverageByPosition: B5,
  WordCloud: H5
}, Symbol.toStringTag, { value: "Module" })), Y5 = {
  "@googlemaps/js-api-loader": "^1.16.2",
  "chart.js": "^4.4.2",
  "chartjs-adapter-date-fns": "^3.0.0",
  "chartjs-plugin-annotation": "^3.0.1",
  "chartjs-plugin-datalabels": "^2.2.0",
  "date-fns-tz": "^3.1.3",
  lodash: "^4.17.21"
}, G5 = {
  "@chromatic-com/storybook": "^1.2.26",
  "@rushstack/eslint-patch": "^1.3.3",
  "@storybook/addon-essentials": "^8.0.5",
  "@storybook/addon-interactions": "^8.0.5",
  "@storybook/addon-links": "^8.0.5",
  "@storybook/blocks": "^8.0.5",
  "@storybook/test": "^8.0.5",
  "@storybook/vue3": "^8.0.5",
  "@storybook/vue3-vite": "^8.0.5",
  "@streemau/eslint-config-streem": "^10.2.2",
  "@vitejs/plugin-vue": "^5.0.4",
  "@vue/eslint-config-prettier": "^8.0.0",
  "@vue/test-utils": "^2.4.5",
  cypress: "^13.7.0",
  "date-fns": "^3.6.0",
  eslint: "^9.20.1",
  "http-server": "^14.1.1",
  jsdom: "^24.0.0",
  lefthook: "^1.6.10",
  prettier: "^3.0.3",
  "release-it": "^17.1.1",
  sass: "^1.74.1",
  "start-server-and-test": "^2.0.3",
  storybook: "^8.0.5",
  stylelint: "^16.0.2",
  "stylelint-config-standard-scss": "^12.0.0",
  "stylelint-config-standard-vue": "^1.0.0",
  "stylelint-scss": "^6.0.0",
  vite: "^5.1.6",
  "vite-svg-loader": "^5.1.0",
  vitest: "^1.4.0",
  vue: "^3.4.23",
  "vue-i18n": "^9.10.2"
}, U5 = "dist/charts.umd.cjs", X5 = "dist/charts.js", q5 = [
  "README.md",
  "src/",
  "dist/"
], K5 = {
  ".": {
    import: "./dist/charts.js",
    require: "./dist/charts.umd.cjs"
  },
  "./dist/charts.css": {
    import: "./dist/charts.css",
    require: "./dist/charts.css"
  }
}, Q5 = "@streemau/charts", J5 = {
  build: "vite build",
  dev: "vite",
  format: "prettier --write src/",
  lint: "eslint '**/*.{js,ts,vue}' --fix",
  preview: "vite preview",
  release: "release-it",
  "build:watch": "npm run build -- --watch",
  cdn: "http-server ./dist -c-1 -p 7654",
  "cdn:watch": "sh ./scripts/cdn.sh",
  "storybook:build": "storybook build",
  "storybook:serve": "storybook dev -p 6006",
  stylelint: 'npx stylelint "**/*.{scss,vue}"',
  "stylelint:fix": "npm run stylelint -- --fix",
  "test:e2e": "start-server-and-test preview http://localhost:4173 'cypress run --e2e'",
  "test:e2e:dev": "start-server-and-test 'vite dev --port 4173' http://localhost:4173 'cypress open --e2e'",
  "test:unit": "vitest"
}, Z5 = "module", t4 = "4.18.5", e4 = {
  dependencies: Y5,
  devDependencies: G5,
  main: U5,
  module: X5,
  files: q5,
  exports: K5,
  name: Q5,
  scripts: J5,
  type: Z5,
  version: t4
}, { version: n4 } = e4;
function Mc(e, t) {
  Object.keys(t).forEach((n) => {
    e.component(n, t[n]);
  });
}
function s4(e) {
  Mc(e, lM), Mc(e, V5);
}
const c4 = {
  version: n4,
  install: s4
};
export {
  WM as AdvertisingValueEquivalency,
  P$ as BroadcastTimeByMediaType,
  Pc as ButtonGroup,
  ut as Chart,
  I$ as CoverageByMediaType,
  U$ as CoverageVolumeAndPotentialAudienceReach,
  bD as CoverageVolumeAndStockPrice,
  Gh as CoverageVolumeTimeline,
  ft as DataTable,
  LD as DataTableWithChange,
  eL as DataTableWithChangeAcrossPeriods,
  rL as DesktopVsMobileReadership,
  oL as DomainAuthority,
  pL as EmojiCount,
  wh as EmptyState,
  ML as GeographicSpread,
  EL as KeyInsights,
  IL as KeyMessages,
  QL as KeyPlatformInfluencers,
  tE as KeyQueries,
  sE as KeyQueriesTimeline,
  rE as LeadingMediaOutlets,
  cE as LeadingSources,
  kh as Legend,
  uE as MediaVolumeTable,
  LE as MentionBenchmarkTimeline,
  Nc as OutreachCoverageCard,
  lI as OutreachCoverageTimeline,
  fI as OutreachPerformanceTable,
  MI as OutreachTopEngagedContactsTable,
  hi as PlatformAvatar,
  OI as PotentialAudienceReach,
  AI as ProgressPie,
  $I as ReactScoreBreakdown,
  DI as SentimentBenchmark,
  LI as SentimentBreakdown,
  EI as SentimentTimeline,
  WI as ShareOfVoice,
  jI as ShareOfVoiceTimeline,
  Nf as SocialEngageCard,
  YI as SpokespeoplePresence,
  cR as TopArticlesTable,
  SR as TopFacebookPages,
  $R as TopIssues,
  $5 as TopPlatformPosts,
  E5 as TopSources,
  B5 as VolumeOfCoverageByPosition,
  H5 as WordCloud,
  c4 as default,
  s4 as install
};
